/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export enum Action {
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Delete = 'DELETE',
  Delivry = 'DELIVRY',
  Paid = 'PAID',
  Update = 'UPDATE',
  View = 'VIEW'
}

export type ActionOrder = {
  __typename?: 'ActionOrder';
  Creator: User;
  Order: Order;
  action: Action;
  createdAt: Scalars['DateTimeISO']['output'];
  creatorId: Scalars['Int']['output'];
  fieldsEdited: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ActionOrderAvgAggregate = {
  __typename?: 'ActionOrderAvgAggregate';
  creatorId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type ActionOrderAvgOrderByAggregateInput = {
  creatorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ActionOrderCountAggregate = {
  __typename?: 'ActionOrderCountAggregate';
  _all: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  creatorId: Scalars['Int']['output'];
  fieldsEdited: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ActionOrderCountOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creatorId?: InputMaybe<SortOrder>;
  fieldsEdited?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActionOrderCreateInput = {
  Creator: UserCreateNestedOneWithoutActionOrdersInput;
  Order: OrderCreateNestedOneWithoutActionOrdersInput;
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreateManyCreatorInput = {
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreateManyCreatorInputEnvelope = {
  data: Array<ActionOrderCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionOrderCreateManyInput = {
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  creatorId: Scalars['Int']['input'];
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreateManyOrderInput = {
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  creatorId: Scalars['Int']['input'];
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreateManyOrderInputEnvelope = {
  data: Array<ActionOrderCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionOrderCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionOrderCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActionOrderCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActionOrderCreateManyCreatorInputEnvelope>;
};

export type ActionOrderCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ActionOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ActionOrderCreateManyOrderInputEnvelope>;
};

export type ActionOrderCreateOrConnectWithoutCreatorInput = {
  create: ActionOrderCreateWithoutCreatorInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderCreateOrConnectWithoutOrderInput = {
  create: ActionOrderCreateWithoutOrderInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderCreateWithoutCreatorInput = {
  Order: OrderCreateNestedOneWithoutActionOrdersInput;
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreateWithoutOrderInput = {
  Creator: UserCreateNestedOneWithoutActionOrdersInput;
  action?: InputMaybe<Action>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fieldsEdited?: InputMaybe<ActionOrderCreatefieldsEditedInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionOrderCreatefieldsEditedInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActionOrderGroupBy = {
  __typename?: 'ActionOrderGroupBy';
  _avg?: Maybe<ActionOrderAvgAggregate>;
  _count?: Maybe<ActionOrderCountAggregate>;
  _max?: Maybe<ActionOrderMaxAggregate>;
  _min?: Maybe<ActionOrderMinAggregate>;
  _sum?: Maybe<ActionOrderSumAggregate>;
  action: Action;
  createdAt: Scalars['DateTimeISO']['output'];
  creatorId: Scalars['Int']['output'];
  fieldsEdited?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ActionOrderListRelationFilter = {
  every?: InputMaybe<ActionOrderWhereInput>;
  none?: InputMaybe<ActionOrderWhereInput>;
  some?: InputMaybe<ActionOrderWhereInput>;
};

export type ActionOrderMaxAggregate = {
  __typename?: 'ActionOrderMaxAggregate';
  action?: Maybe<Action>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionOrderMaxOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creatorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActionOrderMinAggregate = {
  __typename?: 'ActionOrderMinAggregate';
  action?: Maybe<Action>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionOrderMinOrderByAggregateInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creatorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActionOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ActionOrderOrderByRelevanceFieldEnum {
  FieldsEdited = 'fieldsEdited'
}

export type ActionOrderOrderByRelevanceInput = {
  fields: Array<ActionOrderOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ActionOrderOrderByWithAggregationInput = {
  _avg?: InputMaybe<ActionOrderAvgOrderByAggregateInput>;
  _count?: InputMaybe<ActionOrderCountOrderByAggregateInput>;
  _max?: InputMaybe<ActionOrderMaxOrderByAggregateInput>;
  _min?: InputMaybe<ActionOrderMinOrderByAggregateInput>;
  _sum?: InputMaybe<ActionOrderSumOrderByAggregateInput>;
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creatorId?: InputMaybe<SortOrder>;
  fieldsEdited?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ActionOrderOrderByWithRelationAndSearchRelevanceInput = {
  Creator?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<ActionOrderOrderByRelevanceInput>;
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creatorId?: InputMaybe<SortOrder>;
  fieldsEdited?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ActionOrderScalarFieldEnum {
  Action = 'action',
  CreatedAt = 'createdAt',
  CreatorId = 'creatorId',
  FieldsEdited = 'fieldsEdited',
  Id = 'id',
  OrderId = 'orderId',
  UpdatedAt = 'updatedAt'
}

export type ActionOrderScalarWhereInput = {
  AND?: InputMaybe<Array<ActionOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActionOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<ActionOrderScalarWhereInput>>;
  action?: InputMaybe<EnumActionFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<IntFilter>;
  fieldsEdited?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActionOrderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ActionOrderScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ActionOrderScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ActionOrderScalarWhereWithAggregatesInput>>;
  action?: InputMaybe<EnumActionWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  creatorId?: InputMaybe<IntWithAggregatesFilter>;
  fieldsEdited?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ActionOrderSumAggregate = {
  __typename?: 'ActionOrderSumAggregate';
  creatorId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type ActionOrderSumOrderByAggregateInput = {
  creatorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ActionOrderUpdateInput = {
  Creator?: InputMaybe<UserUpdateOneRequiredWithoutActionOrdersNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutActionOrdersNestedInput>;
  action?: InputMaybe<EnumActionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fieldsEdited?: InputMaybe<ActionOrderUpdatefieldsEditedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActionOrderUpdateManyMutationInput = {
  action?: InputMaybe<EnumActionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fieldsEdited?: InputMaybe<ActionOrderUpdatefieldsEditedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActionOrderUpdateManyWithWhereWithoutCreatorInput = {
  data: ActionOrderUpdateManyMutationInput;
  where: ActionOrderScalarWhereInput;
};

export type ActionOrderUpdateManyWithWhereWithoutOrderInput = {
  data: ActionOrderUpdateManyMutationInput;
  where: ActionOrderScalarWhereInput;
};

export type ActionOrderUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionOrderCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActionOrderCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActionOrderCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionOrderUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<ActionOrderUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<ActionOrderUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ActionOrderUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ActionOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ActionOrderCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionOrderUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ActionOrderUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ActionOrderUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ActionOrderUpdateWithWhereUniqueWithoutCreatorInput = {
  data: ActionOrderUpdateWithoutCreatorInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderUpdateWithWhereUniqueWithoutOrderInput = {
  data: ActionOrderUpdateWithoutOrderInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderUpdateWithoutCreatorInput = {
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutActionOrdersNestedInput>;
  action?: InputMaybe<EnumActionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fieldsEdited?: InputMaybe<ActionOrderUpdatefieldsEditedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActionOrderUpdateWithoutOrderInput = {
  Creator?: InputMaybe<UserUpdateOneRequiredWithoutActionOrdersNestedInput>;
  action?: InputMaybe<EnumActionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fieldsEdited?: InputMaybe<ActionOrderUpdatefieldsEditedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ActionOrderUpdatefieldsEditedInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActionOrderUpsertWithWhereUniqueWithoutCreatorInput = {
  create: ActionOrderCreateWithoutCreatorInput;
  update: ActionOrderUpdateWithoutCreatorInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderUpsertWithWhereUniqueWithoutOrderInput = {
  create: ActionOrderCreateWithoutOrderInput;
  update: ActionOrderUpdateWithoutOrderInput;
  where: ActionOrderWhereUniqueInput;
};

export type ActionOrderWhereInput = {
  AND?: InputMaybe<Array<ActionOrderWhereInput>>;
  Creator?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<ActionOrderWhereInput>>;
  OR?: InputMaybe<Array<ActionOrderWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  action?: InputMaybe<EnumActionFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<IntFilter>;
  fieldsEdited?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ActionOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<ActionOrderWhereInput>>;
  Creator?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<ActionOrderWhereInput>>;
  OR?: InputMaybe<Array<ActionOrderWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  action?: InputMaybe<EnumActionFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<IntFilter>;
  fieldsEdited?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ActionTransaction {
  Asking = 'ASKING',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Pending = 'PENDING',
  Prime = 'PRIME'
}

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type AggregateActionOrder = {
  __typename?: 'AggregateActionOrder';
  _avg?: Maybe<ActionOrderAvgAggregate>;
  _count?: Maybe<ActionOrderCountAggregate>;
  _max?: Maybe<ActionOrderMaxAggregate>;
  _min?: Maybe<ActionOrderMinAggregate>;
  _sum?: Maybe<ActionOrderSumAggregate>;
};

export type AggregateAskDeliveryMan = {
  __typename?: 'AggregateAskDeliveryMan';
  _avg?: Maybe<AskDeliveryManAvgAggregate>;
  _count?: Maybe<AskDeliveryManCountAggregate>;
  _max?: Maybe<AskDeliveryManMaxAggregate>;
  _min?: Maybe<AskDeliveryManMinAggregate>;
  _sum?: Maybe<AskDeliveryManSumAggregate>;
};

export type AggregateCategory = {
  __typename?: 'AggregateCategory';
  _avg?: Maybe<CategoryAvgAggregate>;
  _count?: Maybe<CategoryCountAggregate>;
  _max?: Maybe<CategoryMaxAggregate>;
  _min?: Maybe<CategoryMinAggregate>;
  _sum?: Maybe<CategorySumAggregate>;
};

export type AggregateChat = {
  __typename?: 'AggregateChat';
  _avg?: Maybe<ChatAvgAggregate>;
  _count?: Maybe<ChatCountAggregate>;
  _max?: Maybe<ChatMaxAggregate>;
  _min?: Maybe<ChatMinAggregate>;
  _sum?: Maybe<ChatSumAggregate>;
};

export type AggregateChatMessage = {
  __typename?: 'AggregateChatMessage';
  _avg?: Maybe<ChatMessageAvgAggregate>;
  _count?: Maybe<ChatMessageCountAggregate>;
  _max?: Maybe<ChatMessageMaxAggregate>;
  _min?: Maybe<ChatMessageMinAggregate>;
  _sum?: Maybe<ChatMessageSumAggregate>;
};

export type AggregateCountry = {
  __typename?: 'AggregateCountry';
  _avg?: Maybe<CountryAvgAggregate>;
  _count?: Maybe<CountryCountAggregate>;
  _max?: Maybe<CountryMaxAggregate>;
  _min?: Maybe<CountryMinAggregate>;
  _sum?: Maybe<CountrySumAggregate>;
};

export type AggregateCraftmanWallet = {
  __typename?: 'AggregateCraftmanWallet';
  _avg?: Maybe<CraftmanWalletAvgAggregate>;
  _count?: Maybe<CraftmanWalletCountAggregate>;
  _max?: Maybe<CraftmanWalletMaxAggregate>;
  _min?: Maybe<CraftmanWalletMinAggregate>;
  _sum?: Maybe<CraftmanWalletSumAggregate>;
};

export type AggregateEmail = {
  __typename?: 'AggregateEmail';
  _avg?: Maybe<EmailAvgAggregate>;
  _count?: Maybe<EmailCountAggregate>;
  _max?: Maybe<EmailMaxAggregate>;
  _min?: Maybe<EmailMinAggregate>;
  _sum?: Maybe<EmailSumAggregate>;
};

export type AggregateExchangeCurrency = {
  __typename?: 'AggregateExchangeCurrency';
  _avg?: Maybe<ExchangeCurrencyAvgAggregate>;
  _count?: Maybe<ExchangeCurrencyCountAggregate>;
  _max?: Maybe<ExchangeCurrencyMaxAggregate>;
  _min?: Maybe<ExchangeCurrencyMinAggregate>;
  _sum?: Maybe<ExchangeCurrencySumAggregate>;
};

export type AggregateFaq = {
  __typename?: 'AggregateFaq';
  _avg?: Maybe<FaqAvgAggregate>;
  _count?: Maybe<FaqCountAggregate>;
  _max?: Maybe<FaqMaxAggregate>;
  _min?: Maybe<FaqMinAggregate>;
  _sum?: Maybe<FaqSumAggregate>;
};

export type AggregateFavorites = {
  __typename?: 'AggregateFavorites';
  _avg?: Maybe<FavoritesAvgAggregate>;
  _count?: Maybe<FavoritesCountAggregate>;
  _max?: Maybe<FavoritesMaxAggregate>;
  _min?: Maybe<FavoritesMinAggregate>;
  _sum?: Maybe<FavoritesSumAggregate>;
};

export type AggregateFile = {
  __typename?: 'AggregateFile';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
};

export type AggregateItemType = {
  __typename?: 'AggregateItemType';
  _avg?: Maybe<ItemTypeAvgAggregate>;
  _count?: Maybe<ItemTypeCountAggregate>;
  _max?: Maybe<ItemTypeMaxAggregate>;
  _min?: Maybe<ItemTypeMinAggregate>;
  _sum?: Maybe<ItemTypeSumAggregate>;
};

export type AggregateMaterialType = {
  __typename?: 'AggregateMaterialType';
  _avg?: Maybe<MaterialTypeAvgAggregate>;
  _count?: Maybe<MaterialTypeCountAggregate>;
  _max?: Maybe<MaterialTypeMaxAggregate>;
  _min?: Maybe<MaterialTypeMinAggregate>;
  _sum?: Maybe<MaterialTypeSumAggregate>;
};

export type AggregateNoticeOrder = {
  __typename?: 'AggregateNoticeOrder';
  _avg?: Maybe<NoticeOrderAvgAggregate>;
  _count?: Maybe<NoticeOrderCountAggregate>;
  _max?: Maybe<NoticeOrderMaxAggregate>;
  _min?: Maybe<NoticeOrderMinAggregate>;
  _sum?: Maybe<NoticeOrderSumAggregate>;
};

export type AggregateNotification = {
  __typename?: 'AggregateNotification';
  _avg?: Maybe<NotificationAvgAggregate>;
  _count?: Maybe<NotificationCountAggregate>;
  _max?: Maybe<NotificationMaxAggregate>;
  _min?: Maybe<NotificationMinAggregate>;
  _sum?: Maybe<NotificationSumAggregate>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
};

export type AggregateOrderPrice = {
  __typename?: 'AggregateOrderPrice';
  _avg?: Maybe<OrderPriceAvgAggregate>;
  _count?: Maybe<OrderPriceCountAggregate>;
  _max?: Maybe<OrderPriceMaxAggregate>;
  _min?: Maybe<OrderPriceMinAggregate>;
  _sum?: Maybe<OrderPriceSumAggregate>;
};

export type AggregateOrderSize = {
  __typename?: 'AggregateOrderSize';
  _avg?: Maybe<OrderSizeAvgAggregate>;
  _count?: Maybe<OrderSizeCountAggregate>;
  _max?: Maybe<OrderSizeMaxAggregate>;
  _min?: Maybe<OrderSizeMinAggregate>;
  _sum?: Maybe<OrderSizeSumAggregate>;
};

export type AggregatePaimentHistory = {
  __typename?: 'AggregatePaimentHistory';
  _avg?: Maybe<PaimentHistoryAvgAggregate>;
  _count?: Maybe<PaimentHistoryCountAggregate>;
  _max?: Maybe<PaimentHistoryMaxAggregate>;
  _min?: Maybe<PaimentHistoryMinAggregate>;
  _sum?: Maybe<PaimentHistorySumAggregate>;
};

export type AggregatePromptEngineer = {
  __typename?: 'AggregatePromptEngineer';
  _avg?: Maybe<PromptEngineerAvgAggregate>;
  _count?: Maybe<PromptEngineerCountAggregate>;
  _max?: Maybe<PromptEngineerMaxAggregate>;
  _min?: Maybe<PromptEngineerMinAggregate>;
  _sum?: Maybe<PromptEngineerSumAggregate>;
};

export type AggregatePushTokens = {
  __typename?: 'AggregatePushTokens';
  _avg?: Maybe<PushTokensAvgAggregate>;
  _count?: Maybe<PushTokensCountAggregate>;
  _max?: Maybe<PushTokensMaxAggregate>;
  _min?: Maybe<PushTokensMinAggregate>;
  _sum?: Maybe<PushTokensSumAggregate>;
};

export type AggregateSegmentation = {
  __typename?: 'AggregateSegmentation';
  _avg?: Maybe<SegmentationAvgAggregate>;
  _count?: Maybe<SegmentationCountAggregate>;
  _max?: Maybe<SegmentationMaxAggregate>;
  _min?: Maybe<SegmentationMinAggregate>;
  _sum?: Maybe<SegmentationSumAggregate>;
};

export type AggregateTransporter = {
  __typename?: 'AggregateTransporter';
  _avg?: Maybe<TransporterAvgAggregate>;
  _count?: Maybe<TransporterCountAggregate>;
  _max?: Maybe<TransporterMaxAggregate>;
  _min?: Maybe<TransporterMinAggregate>;
  _sum?: Maybe<TransporterSumAggregate>;
};

export type AggregateTransporterPrice = {
  __typename?: 'AggregateTransporterPrice';
  _avg?: Maybe<TransporterPriceAvgAggregate>;
  _count?: Maybe<TransporterPriceCountAggregate>;
  _max?: Maybe<TransporterPriceMaxAggregate>;
  _min?: Maybe<TransporterPriceMinAggregate>;
  _sum?: Maybe<TransporterPriceSumAggregate>;
};

export type AggregateTransporterZone = {
  __typename?: 'AggregateTransporterZone';
  _avg?: Maybe<TransporterZoneAvgAggregate>;
  _count?: Maybe<TransporterZoneCountAggregate>;
  _max?: Maybe<TransporterZoneMaxAggregate>;
  _min?: Maybe<TransporterZoneMinAggregate>;
  _sum?: Maybe<TransporterZoneSumAggregate>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _avg?: Maybe<UserAvgAggregate>;
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _sum?: Maybe<UserSumAggregate>;
};

export type AggregateUserAddress = {
  __typename?: 'AggregateUserAddress';
  _avg?: Maybe<UserAddressAvgAggregate>;
  _count?: Maybe<UserAddressCountAggregate>;
  _max?: Maybe<UserAddressMaxAggregate>;
  _min?: Maybe<UserAddressMinAggregate>;
  _sum?: Maybe<UserAddressSumAggregate>;
};

export type AggregateUserPrompt = {
  __typename?: 'AggregateUserPrompt';
  _avg?: Maybe<UserPromptAvgAggregate>;
  _count?: Maybe<UserPromptCountAggregate>;
  _max?: Maybe<UserPromptMaxAggregate>;
  _min?: Maybe<UserPromptMinAggregate>;
  _sum?: Maybe<UserPromptSumAggregate>;
};

export type AggregateUserRestPassword = {
  __typename?: 'AggregateUserRestPassword';
  _avg?: Maybe<UserRestPasswordAvgAggregate>;
  _count?: Maybe<UserRestPasswordCountAggregate>;
  _max?: Maybe<UserRestPasswordMaxAggregate>;
  _min?: Maybe<UserRestPasswordMinAggregate>;
  _sum?: Maybe<UserRestPasswordSumAggregate>;
};

export type AggregateUserStory = {
  __typename?: 'AggregateUserStory';
  _avg?: Maybe<UserStoryAvgAggregate>;
  _count?: Maybe<UserStoryCountAggregate>;
  _max?: Maybe<UserStoryMaxAggregate>;
  _min?: Maybe<UserStoryMinAggregate>;
  _sum?: Maybe<UserStorySumAggregate>;
};

export type AggregateValidOrderEvidence = {
  __typename?: 'AggregateValidOrderEvidence';
  _avg?: Maybe<ValidOrderEvidenceAvgAggregate>;
  _count?: Maybe<ValidOrderEvidenceCountAggregate>;
  _max?: Maybe<ValidOrderEvidenceMaxAggregate>;
  _min?: Maybe<ValidOrderEvidenceMinAggregate>;
  _sum?: Maybe<ValidOrderEvidenceSumAggregate>;
};

export type AskDeliveryMan = {
  __typename?: 'AskDeliveryMan';
  ChatMessage: Array<ChatMessage>;
  Craftman: User;
  Customer: User;
  Order: Order;
  _count?: Maybe<AskDeliveryManCount>;
  address: Scalars['String']['output'];
  codeTracking?: Maybe<Scalars['String']['output']>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  delivryDate: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  photos: Array<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type AskDeliveryManChatMessageArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type AskDeliveryManPhotosArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};

export type AskDeliveryManAvgAggregate = {
  __typename?: 'AskDeliveryManAvgAggregate';
  craftmanId?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type AskDeliveryManAvgOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type AskDeliveryManCount = {
  __typename?: 'AskDeliveryManCount';
  ChatMessage: Scalars['Int']['output'];
  photos: Scalars['Int']['output'];
};


export type AskDeliveryManCountChatMessageArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type AskDeliveryManCountPhotosArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type AskDeliveryManCountAggregate = {
  __typename?: 'AskDeliveryManCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  codeTracking: Scalars['Int']['output'];
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  delivryDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AskDeliveryManCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  codeTracking?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AskDeliveryManCreateInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutAskDeliveryManInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanAskDeliveryManInput;
  Customer: UserCreateNestedOneWithoutCustomerAskDeliveryManInput;
  Order: OrderCreateNestedOneWithoutAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutAskDeliveryManInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateManyCraftmanInput = {
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateManyCraftmanInputEnvelope = {
  data: Array<AskDeliveryManCreateManyCraftmanInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AskDeliveryManCreateManyCustomerInput = {
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateManyCustomerInputEnvelope = {
  data: Array<AskDeliveryManCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AskDeliveryManCreateManyInput = {
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateManyOrderInput = {
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateManyOrderInputEnvelope = {
  data: Array<AskDeliveryManCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AskDeliveryManCreateNestedManyWithoutCraftmanInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyCraftmanInputEnvelope>;
};

export type AskDeliveryManCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyCustomerInputEnvelope>;
};

export type AskDeliveryManCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutOrderInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyOrderInputEnvelope>;
};

export type AskDeliveryManCreateNestedOneWithoutChatMessageInput = {
  connect?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AskDeliveryManCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<AskDeliveryManCreateWithoutChatMessageInput>;
};

export type AskDeliveryManCreateNestedOneWithoutPhotosInput = {
  connect?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AskDeliveryManCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<AskDeliveryManCreateWithoutPhotosInput>;
};

export type AskDeliveryManCreateOrConnectWithoutChatMessageInput = {
  create: AskDeliveryManCreateWithoutChatMessageInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManCreateOrConnectWithoutCraftmanInput = {
  create: AskDeliveryManCreateWithoutCraftmanInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManCreateOrConnectWithoutCustomerInput = {
  create: AskDeliveryManCreateWithoutCustomerInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManCreateOrConnectWithoutOrderInput = {
  create: AskDeliveryManCreateWithoutOrderInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManCreateOrConnectWithoutPhotosInput = {
  create: AskDeliveryManCreateWithoutPhotosInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManCreateWithoutChatMessageInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanAskDeliveryManInput;
  Customer: UserCreateNestedOneWithoutCustomerAskDeliveryManInput;
  Order: OrderCreateNestedOneWithoutAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutAskDeliveryManInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateWithoutCraftmanInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutAskDeliveryManInput>;
  Customer: UserCreateNestedOneWithoutCustomerAskDeliveryManInput;
  Order: OrderCreateNestedOneWithoutAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutAskDeliveryManInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutAskDeliveryManInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanAskDeliveryManInput;
  Order: OrderCreateNestedOneWithoutAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutAskDeliveryManInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutAskDeliveryManInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanAskDeliveryManInput;
  Customer: UserCreateNestedOneWithoutCustomerAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutAskDeliveryManInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManCreateWithoutPhotosInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutAskDeliveryManInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanAskDeliveryManInput;
  Customer: UserCreateNestedOneWithoutCustomerAskDeliveryManInput;
  Order: OrderCreateNestedOneWithoutAskDeliveryManInput;
  address: Scalars['String']['input'];
  codeTracking?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AskDeliveryManGroupBy = {
  __typename?: 'AskDeliveryManGroupBy';
  _avg?: Maybe<AskDeliveryManAvgAggregate>;
  _count?: Maybe<AskDeliveryManCountAggregate>;
  _max?: Maybe<AskDeliveryManMaxAggregate>;
  _min?: Maybe<AskDeliveryManMinAggregate>;
  _sum?: Maybe<AskDeliveryManSumAggregate>;
  address: Scalars['String']['output'];
  codeTracking?: Maybe<Scalars['String']['output']>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  delivryDate: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AskDeliveryManListRelationFilter = {
  every?: InputMaybe<AskDeliveryManWhereInput>;
  none?: InputMaybe<AskDeliveryManWhereInput>;
  some?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManMaxAggregate = {
  __typename?: 'AskDeliveryManMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  codeTracking?: Maybe<Scalars['String']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AskDeliveryManMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  codeTracking?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AskDeliveryManMinAggregate = {
  __typename?: 'AskDeliveryManMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  codeTracking?: Maybe<Scalars['String']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AskDeliveryManMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  codeTracking?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AskDeliveryManNullableRelationFilter = {
  is?: InputMaybe<AskDeliveryManWhereInput>;
  isNot?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AskDeliveryManOrderByRelevanceFieldEnum {
  Address = 'address',
  CodeTracking = 'codeTracking',
  PhoneNumber = 'phoneNumber'
}

export type AskDeliveryManOrderByRelevanceInput = {
  fields: Array<AskDeliveryManOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AskDeliveryManOrderByWithAggregationInput = {
  _avg?: InputMaybe<AskDeliveryManAvgOrderByAggregateInput>;
  _count?: InputMaybe<AskDeliveryManCountOrderByAggregateInput>;
  _max?: InputMaybe<AskDeliveryManMaxOrderByAggregateInput>;
  _min?: InputMaybe<AskDeliveryManMinOrderByAggregateInput>;
  _sum?: InputMaybe<AskDeliveryManSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrder>;
  codeTracking?: InputMaybe<SortOrderInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AskDeliveryManOrderByWithRelationAndSearchRelevanceInput = {
  ChatMessage?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  Craftman?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<AskDeliveryManOrderByRelevanceInput>;
  address?: InputMaybe<SortOrder>;
  codeTracking?: InputMaybe<SortOrderInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  photos?: InputMaybe<FileOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AskDeliveryManScalarFieldEnum {
  Address = 'address',
  CodeTracking = 'codeTracking',
  CraftmanId = 'craftmanId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DelivryDate = 'delivryDate',
  Id = 'id',
  OrderId = 'orderId',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt'
}

export type AskDeliveryManScalarWhereInput = {
  AND?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  NOT?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  OR?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  address?: InputMaybe<StringFilter>;
  codeTracking?: InputMaybe<StringNullableFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  delivryDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AskDeliveryManScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AskDeliveryManScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AskDeliveryManScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AskDeliveryManScalarWhereWithAggregatesInput>>;
  address?: InputMaybe<StringWithAggregatesFilter>;
  codeTracking?: InputMaybe<StringNullableWithAggregatesFilter>;
  craftmanId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  delivryDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AskDeliveryManSumAggregate = {
  __typename?: 'AskDeliveryManSumAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type AskDeliveryManSumOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type AskDeliveryManUpdateInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutAskDeliveryManNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutAskDeliveryManNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateManyMutationInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateManyWithWhereWithoutCraftmanInput = {
  data: AskDeliveryManUpdateManyMutationInput;
  where: AskDeliveryManScalarWhereInput;
};

export type AskDeliveryManUpdateManyWithWhereWithoutCustomerInput = {
  data: AskDeliveryManUpdateManyMutationInput;
  where: AskDeliveryManScalarWhereInput;
};

export type AskDeliveryManUpdateManyWithWhereWithoutOrderInput = {
  data: AskDeliveryManUpdateManyMutationInput;
  where: AskDeliveryManScalarWhereInput;
};

export type AskDeliveryManUpdateManyWithoutCraftmanNestedInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyCraftmanInputEnvelope>;
  delete?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  set?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  update?: InputMaybe<Array<AskDeliveryManUpdateWithWhereUniqueWithoutCraftmanInput>>;
  updateMany?: InputMaybe<Array<AskDeliveryManUpdateManyWithWhereWithoutCraftmanInput>>;
  upsert?: InputMaybe<Array<AskDeliveryManUpsertWithWhereUniqueWithoutCraftmanInput>>;
};

export type AskDeliveryManUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  set?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  update?: InputMaybe<Array<AskDeliveryManUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<AskDeliveryManUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<AskDeliveryManUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type AskDeliveryManUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AskDeliveryManCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<AskDeliveryManCreateWithoutOrderInput>>;
  createMany?: InputMaybe<AskDeliveryManCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AskDeliveryManScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  set?: InputMaybe<Array<AskDeliveryManWhereUniqueInput>>;
  update?: InputMaybe<Array<AskDeliveryManUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<AskDeliveryManUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<AskDeliveryManUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type AskDeliveryManUpdateOneWithoutChatMessageNestedInput = {
  connect?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AskDeliveryManCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<AskDeliveryManCreateWithoutChatMessageInput>;
  delete?: InputMaybe<AskDeliveryManWhereInput>;
  disconnect?: InputMaybe<AskDeliveryManWhereInput>;
  update?: InputMaybe<AskDeliveryManUpdateToOneWithWhereWithoutChatMessageInput>;
  upsert?: InputMaybe<AskDeliveryManUpsertWithoutChatMessageInput>;
};

export type AskDeliveryManUpdateOneWithoutPhotosNestedInput = {
  connect?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AskDeliveryManCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<AskDeliveryManCreateWithoutPhotosInput>;
  delete?: InputMaybe<AskDeliveryManWhereInput>;
  disconnect?: InputMaybe<AskDeliveryManWhereInput>;
  update?: InputMaybe<AskDeliveryManUpdateToOneWithWhereWithoutPhotosInput>;
  upsert?: InputMaybe<AskDeliveryManUpsertWithoutPhotosInput>;
};

export type AskDeliveryManUpdateToOneWithWhereWithoutChatMessageInput = {
  data: AskDeliveryManUpdateWithoutChatMessageInput;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManUpdateToOneWithWhereWithoutPhotosInput = {
  data: AskDeliveryManUpdateWithoutPhotosInput;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManUpdateWithWhereUniqueWithoutCraftmanInput = {
  data: AskDeliveryManUpdateWithoutCraftmanInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpdateWithWhereUniqueWithoutCustomerInput = {
  data: AskDeliveryManUpdateWithoutCustomerInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpdateWithWhereUniqueWithoutOrderInput = {
  data: AskDeliveryManUpdateWithoutOrderInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpdateWithoutChatMessageInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutAskDeliveryManNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateWithoutCraftmanInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutAskDeliveryManNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutAskDeliveryManNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutAskDeliveryManNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutAskDeliveryManNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutAskDeliveryManNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutAskDeliveryManNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpdateWithoutPhotosInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutAskDeliveryManNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  codeTracking?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AskDeliveryManUpsertWithWhereUniqueWithoutCraftmanInput = {
  create: AskDeliveryManCreateWithoutCraftmanInput;
  update: AskDeliveryManUpdateWithoutCraftmanInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpsertWithWhereUniqueWithoutCustomerInput = {
  create: AskDeliveryManCreateWithoutCustomerInput;
  update: AskDeliveryManUpdateWithoutCustomerInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpsertWithWhereUniqueWithoutOrderInput = {
  create: AskDeliveryManCreateWithoutOrderInput;
  update: AskDeliveryManUpdateWithoutOrderInput;
  where: AskDeliveryManWhereUniqueInput;
};

export type AskDeliveryManUpsertWithoutChatMessageInput = {
  create: AskDeliveryManCreateWithoutChatMessageInput;
  update: AskDeliveryManUpdateWithoutChatMessageInput;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManUpsertWithoutPhotosInput = {
  create: AskDeliveryManCreateWithoutPhotosInput;
  update: AskDeliveryManUpdateWithoutPhotosInput;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};

export type AskDeliveryManWhereInput = {
  AND?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  OR?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  address?: InputMaybe<StringFilter>;
  codeTracking?: InputMaybe<StringNullableFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  delivryDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  photos?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AskDeliveryManWhereUniqueInput = {
  AND?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  OR?: InputMaybe<Array<AskDeliveryManWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  address?: InputMaybe<StringFilter>;
  codeTracking?: InputMaybe<StringNullableFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  delivryDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  photos?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token: Scalars['String']['output'];
  user: User;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type Category = {
  __typename?: 'Category';
  Countries: Array<Country>;
  ItemTypes: Array<ItemType>;
  MaterialTypes: Array<MaterialType>;
  Orders: Array<Order>;
  Segmentation: Segmentation;
  Users: Array<User>;
  _count?: Maybe<CategoryCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  isVisible: Scalars['Boolean']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  segmentationId: Scalars['Int']['output'];
};


export type CategoryCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type CategoryItemTypesArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type CategoryMaterialTypesArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type CategoryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type CategoryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type CategoryAvgAggregate = {
  __typename?: 'CategoryAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
  segmentationId?: Maybe<Scalars['Float']['output']>;
};

export type CategoryAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryCount = {
  __typename?: 'CategoryCount';
  Countries: Scalars['Int']['output'];
  ItemTypes: Scalars['Int']['output'];
  MaterialTypes: Scalars['Int']['output'];
  Orders: Scalars['Int']['output'];
  Users: Scalars['Int']['output'];
};


export type CategoryCountCountriesArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type CategoryCountItemTypesArgs = {
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type CategoryCountMaterialTypesArgs = {
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type CategoryCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type CategoryCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type CategoryCountAggregate = {
  __typename?: 'CategoryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isVisible: Scalars['Int']['output'];
  name_en: Scalars['Int']['output'];
  name_fr: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
  segmentationId: Scalars['Int']['output'];
};

export type CategoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryCreateInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  segmentationId: Scalars['Int']['input'];
};

export type CategoryCreateManySegmentationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateManySegmentationInputEnvelope = {
  data: Array<CategoryCreateManySegmentationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryCreateNestedManyWithoutCountriesInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutCountriesInput>>;
};

export type CategoryCreateNestedManyWithoutOrdersInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutOrdersInput>>;
};

export type CategoryCreateNestedManyWithoutSegmentationInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutSegmentationInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutSegmentationInput>>;
  createMany?: InputMaybe<CategoryCreateManySegmentationInputEnvelope>;
};

export type CategoryCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutUsersInput>>;
};

export type CategoryCreateNestedOneWithoutItemTypesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutItemTypesInput>;
  create?: InputMaybe<CategoryCreateWithoutItemTypesInput>;
};

export type CategoryCreateNestedOneWithoutMaterialTypesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutMaterialTypesInput>;
  create?: InputMaybe<CategoryCreateWithoutMaterialTypesInput>;
};

export type CategoryCreateOrConnectWithoutCountriesInput = {
  create: CategoryCreateWithoutCountriesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutItemTypesInput = {
  create: CategoryCreateWithoutItemTypesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutMaterialTypesInput = {
  create: CategoryCreateWithoutMaterialTypesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutOrdersInput = {
  create: CategoryCreateWithoutOrdersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutSegmentationInput = {
  create: CategoryCreateWithoutSegmentationInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutUsersInput = {
  create: CategoryCreateWithoutUsersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutCountriesInput = {
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateWithoutItemTypesInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateWithoutMaterialTypesInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateWithoutOrdersInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateWithoutSegmentationInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCategoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryCreateWithoutUsersInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutCategoriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCategoryInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCategoryInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCategoriesInput>;
  Segmentation: SegmentationCreateNestedOneWithoutCategoryInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryGroupBy = {
  __typename?: 'CategoryGroupBy';
  _avg?: Maybe<CategoryAvgAggregate>;
  _count?: Maybe<CategoryCountAggregate>;
  _max?: Maybe<CategoryMaxAggregate>;
  _min?: Maybe<CategoryMinAggregate>;
  _sum?: Maybe<CategorySumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  isVisible: Scalars['Boolean']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  segmentationId: Scalars['Int']['output'];
};

export type CategoryListRelationFilter = {
  every?: InputMaybe<CategoryWhereInput>;
  none?: InputMaybe<CategoryWhereInput>;
  some?: InputMaybe<CategoryWhereInput>;
};

export type CategoryMaxAggregate = {
  __typename?: 'CategoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  segmentationId?: Maybe<Scalars['Int']['output']>;
};

export type CategoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryMinAggregate = {
  __typename?: 'CategoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  segmentationId?: Maybe<Scalars['Int']['output']>;
};

export type CategoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum CategoryOrderByRelevanceFieldEnum {
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type CategoryOrderByRelevanceInput = {
  fields: Array<CategoryOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type CategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationAndSearchRelevanceInput = {
  Countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  ItemTypes?: InputMaybe<ItemTypeOrderByRelationAggregateInput>;
  MaterialTypes?: InputMaybe<MaterialTypeOrderByRelationAggregateInput>;
  Orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  Segmentation?: InputMaybe<SegmentationOrderByWithRelationAndSearchRelevanceInput>;
  Users?: InputMaybe<UserOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<CategoryOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsVisible = 'isVisible',
  NameEn = 'name_en',
  NameFr = 'name_fr',
  OldId = 'oldID',
  SegmentationId = 'segmentationId'
}

export type CategoryScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isVisible?: InputMaybe<BoolFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  segmentationId?: InputMaybe<IntFilter>;
};

export type CategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isVisible?: InputMaybe<BoolWithAggregatesFilter>;
  name_en?: InputMaybe<StringWithAggregatesFilter>;
  name_fr?: InputMaybe<StringWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
  segmentationId?: InputMaybe<IntWithAggregatesFilter>;
};

export type CategorySumAggregate = {
  __typename?: 'CategorySumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  segmentationId?: Maybe<Scalars['Int']['output']>;
};

export type CategorySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  segmentationId?: InputMaybe<SortOrder>;
};

export type CategoryUpdateInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateManyWithWhereWithoutCountriesInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithWhereWithoutOrdersInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithWhereWithoutSegmentationInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithWhereWithoutUsersInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithoutCountriesNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutCountriesInput>>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutCountriesInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutCountriesInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutCountriesInput>>;
};

export type CategoryUpdateManyWithoutOrdersNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutOrdersInput>>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutOrdersInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutOrdersInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutOrdersInput>>;
};

export type CategoryUpdateManyWithoutSegmentationNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutSegmentationInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutSegmentationInput>>;
  createMany?: InputMaybe<CategoryCreateManySegmentationInputEnvelope>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutSegmentationInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutSegmentationInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutSegmentationInput>>;
};

export type CategoryUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type CategoryUpdateOneRequiredWithoutItemTypesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutItemTypesInput>;
  create?: InputMaybe<CategoryCreateWithoutItemTypesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutItemTypesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutItemTypesInput>;
};

export type CategoryUpdateOneRequiredWithoutMaterialTypesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutMaterialTypesInput>;
  create?: InputMaybe<CategoryCreateWithoutMaterialTypesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutMaterialTypesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutMaterialTypesInput>;
};

export type CategoryUpdateToOneWithWhereWithoutItemTypesInput = {
  data: CategoryUpdateWithoutItemTypesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutMaterialTypesInput = {
  data: CategoryUpdateWithoutMaterialTypesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateWithWhereUniqueWithoutCountriesInput = {
  data: CategoryUpdateWithoutCountriesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithWhereUniqueWithoutOrdersInput = {
  data: CategoryUpdateWithoutOrdersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithWhereUniqueWithoutSegmentationInput = {
  data: CategoryUpdateWithoutSegmentationInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithWhereUniqueWithoutUsersInput = {
  data: CategoryUpdateWithoutUsersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithoutCountriesInput = {
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutItemTypesInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutMaterialTypesInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutOrdersInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutSegmentationInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCategoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutUsersInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutCategoriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCategoryNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCategoryNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCategoriesNestedInput>;
  Segmentation?: InputMaybe<SegmentationUpdateOneRequiredWithoutCategoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CategoryUpsertWithWhereUniqueWithoutCountriesInput = {
  create: CategoryCreateWithoutCountriesInput;
  update: CategoryUpdateWithoutCountriesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithWhereUniqueWithoutOrdersInput = {
  create: CategoryCreateWithoutOrdersInput;
  update: CategoryUpdateWithoutOrdersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithWhereUniqueWithoutSegmentationInput = {
  create: CategoryCreateWithoutSegmentationInput;
  update: CategoryUpdateWithoutSegmentationInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithWhereUniqueWithoutUsersInput = {
  create: CategoryCreateWithoutUsersInput;
  update: CategoryUpdateWithoutUsersInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithoutItemTypesInput = {
  create: CategoryCreateWithoutItemTypesInput;
  update: CategoryUpdateWithoutItemTypesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutMaterialTypesInput = {
  create: CategoryCreateWithoutMaterialTypesInput;
  update: CategoryUpdateWithoutMaterialTypesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Segmentation?: InputMaybe<SegmentationRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isVisible?: InputMaybe<BoolFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  segmentationId?: InputMaybe<IntFilter>;
};

export type CategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Segmentation?: InputMaybe<SegmentationRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVisible?: InputMaybe<BoolFilter>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_fr?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<IntNullableFilter>;
  segmentationId?: InputMaybe<IntFilter>;
};

export type Chat = {
  __typename?: 'Chat';
  ChatMessages: Array<ChatMessage>;
  Order: Order;
  _count?: Maybe<ChatCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type ChatChatMessagesArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatAvgAggregate = {
  __typename?: 'ChatAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type ChatAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ChatCount = {
  __typename?: 'ChatCount';
  ChatMessages: Scalars['Int']['output'];
};


export type ChatCountChatMessagesArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatCountAggregate = {
  __typename?: 'ChatCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ChatCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ChatCreateInput = {
  ChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutChatInput>;
  Order: OrderCreateNestedOneWithoutChatsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatCreateManyOrderInputEnvelope = {
  data: Array<ChatCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatCreateManyOrderInputEnvelope>;
};

export type ChatCreateNestedOneWithoutChatMessagesInput = {
  connect?: InputMaybe<ChatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatCreateOrConnectWithoutChatMessagesInput>;
  create?: InputMaybe<ChatCreateWithoutChatMessagesInput>;
};

export type ChatCreateOrConnectWithoutChatMessagesInput = {
  create: ChatCreateWithoutChatMessagesInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateOrConnectWithoutOrderInput = {
  create: ChatCreateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateWithoutChatMessagesInput = {
  Order: OrderCreateNestedOneWithoutChatsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatCreateWithoutOrderInput = {
  ChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutChatInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatGroupBy = {
  __typename?: 'ChatGroupBy';
  _avg?: Maybe<ChatAvgAggregate>;
  _count?: Maybe<ChatCountAggregate>;
  _max?: Maybe<ChatMaxAggregate>;
  _min?: Maybe<ChatMinAggregate>;
  _sum?: Maybe<ChatSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ChatListRelationFilter = {
  every?: InputMaybe<ChatWhereInput>;
  none?: InputMaybe<ChatWhereInput>;
  some?: InputMaybe<ChatWhereInput>;
};

export type ChatMaxAggregate = {
  __typename?: 'ChatMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ChatMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  AskDeliveryMan?: Maybe<AskDeliveryMan>;
  Chat?: Maybe<Chat>;
  Files: Array<File>;
  OrderPrice?: Maybe<OrderPrice>;
  OrderSize?: Maybe<OrderSize>;
  Receiver: User;
  Sender: User;
  ValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  _count?: Maybe<ChatMessageCount>;
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentMessageType>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  isAdminMessage: Scalars['Boolean']['output'];
  isCraftmanMessage: Scalars['Boolean']['output'];
  isCustomerMessage: Scalars['Boolean']['output'];
  isDelete: Scalars['Boolean']['output'];
  orderCraftmanId: Scalars['Int']['output'];
  orderPriceId?: Maybe<Scalars['Int']['output']>;
  orderSizeId?: Maybe<Scalars['Int']['output']>;
  receiverId: Scalars['Int']['output'];
  senderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};


export type ChatMessageAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type ChatMessageChatArgs = {
  where?: InputMaybe<ChatWhereInput>;
};


export type ChatMessageFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type ChatMessageOrderPriceArgs = {
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type ChatMessageOrderSizeArgs = {
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type ChatMessageValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ChatMessageAvgAggregate = {
  __typename?: 'ChatMessageAvgAggregate';
  askDeliveryManId?: Maybe<Scalars['Float']['output']>;
  chatId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderPriceId?: Maybe<Scalars['Float']['output']>;
  orderSizeId?: Maybe<Scalars['Float']['output']>;
  receiverId?: Maybe<Scalars['Float']['output']>;
  senderId?: Maybe<Scalars['Float']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Float']['output']>;
};

export type ChatMessageAvgOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrder>;
  orderSizeId?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type ChatMessageCount = {
  __typename?: 'ChatMessageCount';
  Files: Scalars['Int']['output'];
};


export type ChatMessageCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type ChatMessageCountAggregate = {
  __typename?: 'ChatMessageCountAggregate';
  _all: Scalars['Int']['output'];
  askDeliveryManId: Scalars['Int']['output'];
  chatId: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  contentType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDelete: Scalars['Int']['output'];
  orderPriceId: Scalars['Int']['output'];
  orderSizeId: Scalars['Int']['output'];
  receiverId: Scalars['Int']['output'];
  senderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  validOrderEvidenceId: Scalars['Int']['output'];
};

export type ChatMessageCountOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDelete?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrder>;
  orderSizeId?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type ChatMessageCreateInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateManyAskDeliveryManInput = {
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyAskDeliveryManInputEnvelope = {
  data: Array<ChatMessageCreateManyAskDeliveryManInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManyChatInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyChatInputEnvelope = {
  data: Array<ChatMessageCreateManyChatInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManyInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyOrderPriceInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyOrderPriceInputEnvelope = {
  data: Array<ChatMessageCreateManyOrderPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManyOrderSizeInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyOrderSizeInputEnvelope = {
  data: Array<ChatMessageCreateManyOrderSizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManyReceiverInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManyReceiverInputEnvelope = {
  data: Array<ChatMessageCreateManyReceiverInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManySenderInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessageCreateManySenderInputEnvelope = {
  data: Array<ChatMessageCreateManySenderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateManyValidOrderEvidenceInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatId?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  orderPriceId?: InputMaybe<Scalars['Int']['input']>;
  orderSizeId?: InputMaybe<Scalars['Int']['input']>;
  receiverId: Scalars['Int']['input'];
  senderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateManyValidOrderEvidenceInputEnvelope = {
  data: Array<ChatMessageCreateManyValidOrderEvidenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMessageCreateNestedManyWithoutAskDeliveryManInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutAskDeliveryManInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutAskDeliveryManInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyAskDeliveryManInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutChatInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutChatInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyChatInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutOrderPriceInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutOrderPriceInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutOrderPriceInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyOrderPriceInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutOrderSizeInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutOrderSizeInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutOrderSizeInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyOrderSizeInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutReceiverInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutReceiverInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutReceiverInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyReceiverInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutSenderInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutSenderInput>>;
  createMany?: InputMaybe<ChatMessageCreateManySenderInputEnvelope>;
};

export type ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutValidOrderEvidenceInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutValidOrderEvidenceInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyValidOrderEvidenceInputEnvelope>;
};

export type ChatMessageCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<ChatMessageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatMessageCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<ChatMessageCreateWithoutFilesInput>;
};

export type ChatMessageCreateOrConnectWithoutAskDeliveryManInput = {
  create: ChatMessageCreateWithoutAskDeliveryManInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutChatInput = {
  create: ChatMessageCreateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutFilesInput = {
  create: ChatMessageCreateWithoutFilesInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutOrderPriceInput = {
  create: ChatMessageCreateWithoutOrderPriceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutOrderSizeInput = {
  create: ChatMessageCreateWithoutOrderSizeInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutReceiverInput = {
  create: ChatMessageCreateWithoutReceiverInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutSenderInput = {
  create: ChatMessageCreateWithoutSenderInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateOrConnectWithoutValidOrderEvidenceInput = {
  create: ChatMessageCreateWithoutValidOrderEvidenceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateWithoutAskDeliveryManInput = {
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutChatInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutFilesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutOrderPriceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutOrderSizeInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutReceiverInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutSenderInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageCreateWithoutValidOrderEvidenceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutChatMessageInput>;
  Chat?: InputMaybe<ChatCreateNestedOneWithoutChatMessagesInput>;
  Files?: InputMaybe<FileCreateNestedManyWithoutChatMessageInput>;
  OrderPrice?: InputMaybe<OrderPriceCreateNestedOneWithoutChatMessagesInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedOneWithoutChatMessageInput>;
  Receiver: UserCreateNestedOneWithoutReceiverChatMessagesInput;
  Sender: UserCreateNestedOneWithoutSenderChatMessagesInput;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentMessageType>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ChatMessageGroupBy = {
  __typename?: 'ChatMessageGroupBy';
  _avg?: Maybe<ChatMessageAvgAggregate>;
  _count?: Maybe<ChatMessageCountAggregate>;
  _max?: Maybe<ChatMessageMaxAggregate>;
  _min?: Maybe<ChatMessageMinAggregate>;
  _sum?: Maybe<ChatMessageSumAggregate>;
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentMessageType>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  isDelete: Scalars['Boolean']['output'];
  orderPriceId?: Maybe<Scalars['Int']['output']>;
  orderSizeId?: Maybe<Scalars['Int']['output']>;
  receiverId: Scalars['Int']['output'];
  senderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessageListRelationFilter = {
  every?: InputMaybe<ChatMessageWhereInput>;
  none?: InputMaybe<ChatMessageWhereInput>;
  some?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatMessageMaxAggregate = {
  __typename?: 'ChatMessageMaxAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentMessageType>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  orderPriceId?: Maybe<Scalars['Int']['output']>;
  orderSizeId?: Maybe<Scalars['Int']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessageMaxOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDelete?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrder>;
  orderSizeId?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type ChatMessageMinAggregate = {
  __typename?: 'ChatMessageMinAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentMessageType>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  orderPriceId?: Maybe<Scalars['Int']['output']>;
  orderSizeId?: Maybe<Scalars['Int']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessageMinOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDelete?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrder>;
  orderSizeId?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type ChatMessageNullableRelationFilter = {
  is?: InputMaybe<ChatMessageWhereInput>;
  isNot?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatMessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ChatMessageOrderByRelevanceFieldEnum {
  Content = 'content'
}

export type ChatMessageOrderByRelevanceInput = {
  fields: Array<ChatMessageOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ChatMessageOrderByWithAggregationInput = {
  _avg?: InputMaybe<ChatMessageAvgOrderByAggregateInput>;
  _count?: InputMaybe<ChatMessageCountOrderByAggregateInput>;
  _max?: InputMaybe<ChatMessageMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChatMessageMinOrderByAggregateInput>;
  _sum?: InputMaybe<ChatMessageSumOrderByAggregateInput>;
  askDeliveryManId?: InputMaybe<SortOrderInput>;
  chatId?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrderInput>;
  contentType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDelete?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrderInput>;
  orderSizeId?: InputMaybe<SortOrderInput>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrderInput>;
};

export type ChatMessageOrderByWithRelationAndSearchRelevanceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>;
  Chat?: InputMaybe<ChatOrderByWithRelationAndSearchRelevanceInput>;
  Files?: InputMaybe<FileOrderByRelationAggregateInput>;
  OrderPrice?: InputMaybe<OrderPriceOrderByWithRelationAndSearchRelevanceInput>;
  OrderSize?: InputMaybe<OrderSizeOrderByWithRelationAndSearchRelevanceInput>;
  Receiver?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Sender?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<ChatMessageOrderByRelevanceInput>;
  askDeliveryManId?: InputMaybe<SortOrderInput>;
  chatId?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<SortOrderInput>;
  contentType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDelete?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrderInput>;
  orderSizeId?: InputMaybe<SortOrderInput>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrderInput>;
};

export enum ChatMessageScalarFieldEnum {
  AskDeliveryManId = 'askDeliveryManId',
  ChatId = 'chatId',
  Content = 'content',
  ContentType = 'contentType',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDelete = 'isDelete',
  OrderPriceId = 'orderPriceId',
  OrderSizeId = 'orderSizeId',
  ReceiverId = 'receiverId',
  SenderId = 'senderId',
  UpdatedAt = 'updatedAt',
  ValidOrderEvidenceId = 'validOrderEvidenceId'
}

export type ChatMessageScalarWhereInput = {
  AND?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatId?: InputMaybe<IntNullableFilter>;
  content?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<EnumContentMessageTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isDelete?: InputMaybe<BoolFilter>;
  orderPriceId?: InputMaybe<IntNullableFilter>;
  orderSizeId?: InputMaybe<IntNullableFilter>;
  receiverId?: InputMaybe<IntFilter>;
  senderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type ChatMessageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ChatMessageScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ChatMessageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ChatMessageScalarWhereWithAggregatesInput>>;
  askDeliveryManId?: InputMaybe<IntNullableWithAggregatesFilter>;
  chatId?: InputMaybe<IntNullableWithAggregatesFilter>;
  content?: InputMaybe<StringNullableWithAggregatesFilter>;
  contentType?: InputMaybe<EnumContentMessageTypeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isDelete?: InputMaybe<BoolWithAggregatesFilter>;
  orderPriceId?: InputMaybe<IntNullableWithAggregatesFilter>;
  orderSizeId?: InputMaybe<IntNullableWithAggregatesFilter>;
  receiverId?: InputMaybe<IntWithAggregatesFilter>;
  senderId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type ChatMessageSumAggregate = {
  __typename?: 'ChatMessageSumAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderPriceId?: Maybe<Scalars['Int']['output']>;
  orderSizeId?: Maybe<Scalars['Int']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type ChatMessageSumOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderPriceId?: InputMaybe<SortOrder>;
  orderSizeId?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type ChatMessageUpdateInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateManyMutationInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateManyWithWhereWithoutAskDeliveryManInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutChatInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutOrderPriceInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutOrderSizeInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutReceiverInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutSenderInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithWhereWithoutValidOrderEvidenceInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithoutAskDeliveryManNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutAskDeliveryManInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutAskDeliveryManInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyAskDeliveryManInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutAskDeliveryManInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutAskDeliveryManInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutAskDeliveryManInput>>;
};

export type ChatMessageUpdateManyWithoutChatNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutChatInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyChatInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutChatInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutChatInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutChatInput>>;
};

export type ChatMessageUpdateManyWithoutOrderPriceNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutOrderPriceInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutOrderPriceInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyOrderPriceInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutOrderPriceInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutOrderPriceInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutOrderPriceInput>>;
};

export type ChatMessageUpdateManyWithoutOrderSizeNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutOrderSizeInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutOrderSizeInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyOrderSizeInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutOrderSizeInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutOrderSizeInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutOrderSizeInput>>;
};

export type ChatMessageUpdateManyWithoutReceiverNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutReceiverInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutReceiverInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyReceiverInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutReceiverInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutReceiverInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutReceiverInput>>;
};

export type ChatMessageUpdateManyWithoutSenderNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutSenderInput>>;
  createMany?: InputMaybe<ChatMessageCreateManySenderInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutSenderInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutSenderInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutSenderInput>>;
};

export type ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutValidOrderEvidenceInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutValidOrderEvidenceInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyValidOrderEvidenceInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutValidOrderEvidenceInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutValidOrderEvidenceInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutValidOrderEvidenceInput>>;
};

export type ChatMessageUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<ChatMessageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatMessageCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<ChatMessageCreateWithoutFilesInput>;
  delete?: InputMaybe<ChatMessageWhereInput>;
  disconnect?: InputMaybe<ChatMessageWhereInput>;
  update?: InputMaybe<ChatMessageUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<ChatMessageUpsertWithoutFilesInput>;
};

export type ChatMessageUpdateToOneWithWhereWithoutFilesInput = {
  data: ChatMessageUpdateWithoutFilesInput;
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatMessageUpdateWithWhereUniqueWithoutAskDeliveryManInput = {
  data: ChatMessageUpdateWithoutAskDeliveryManInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutChatInput = {
  data: ChatMessageUpdateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutOrderPriceInput = {
  data: ChatMessageUpdateWithoutOrderPriceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutOrderSizeInput = {
  data: ChatMessageUpdateWithoutOrderSizeInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutReceiverInput = {
  data: ChatMessageUpdateWithoutReceiverInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutSenderInput = {
  data: ChatMessageUpdateWithoutSenderInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithWhereUniqueWithoutValidOrderEvidenceInput = {
  data: ChatMessageUpdateWithoutValidOrderEvidenceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithoutAskDeliveryManInput = {
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutChatInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutFilesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutOrderPriceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutOrderSizeInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutReceiverInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutSenderInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateWithoutValidOrderEvidenceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutChatMessageNestedInput>;
  Chat?: InputMaybe<ChatUpdateOneWithoutChatMessagesNestedInput>;
  Files?: InputMaybe<FileUpdateManyWithoutChatMessageNestedInput>;
  OrderPrice?: InputMaybe<OrderPriceUpdateOneWithoutChatMessagesNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateOneWithoutChatMessageNestedInput>;
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput>;
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contentType?: InputMaybe<NullableEnumContentMessageTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDelete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatMessageUpsertWithWhereUniqueWithoutAskDeliveryManInput = {
  create: ChatMessageCreateWithoutAskDeliveryManInput;
  update: ChatMessageUpdateWithoutAskDeliveryManInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutChatInput = {
  create: ChatMessageCreateWithoutChatInput;
  update: ChatMessageUpdateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutOrderPriceInput = {
  create: ChatMessageCreateWithoutOrderPriceInput;
  update: ChatMessageUpdateWithoutOrderPriceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutOrderSizeInput = {
  create: ChatMessageCreateWithoutOrderSizeInput;
  update: ChatMessageUpdateWithoutOrderSizeInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutReceiverInput = {
  create: ChatMessageCreateWithoutReceiverInput;
  update: ChatMessageUpdateWithoutReceiverInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutSenderInput = {
  create: ChatMessageCreateWithoutSenderInput;
  update: ChatMessageUpdateWithoutSenderInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithWhereUniqueWithoutValidOrderEvidenceInput = {
  create: ChatMessageCreateWithoutValidOrderEvidenceInput;
  update: ChatMessageUpdateWithoutValidOrderEvidenceInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpsertWithoutFilesInput = {
  create: ChatMessageCreateWithoutFilesInput;
  update: ChatMessageUpdateWithoutFilesInput;
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type ChatMessageWhereInput = {
  AND?: InputMaybe<Array<ChatMessageWhereInput>>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManNullableRelationFilter>;
  Chat?: InputMaybe<ChatNullableRelationFilter>;
  Files?: InputMaybe<FileListRelationFilter>;
  NOT?: InputMaybe<Array<ChatMessageWhereInput>>;
  OR?: InputMaybe<Array<ChatMessageWhereInput>>;
  OrderPrice?: InputMaybe<OrderPriceNullableRelationFilter>;
  OrderSize?: InputMaybe<OrderSizeNullableRelationFilter>;
  Receiver?: InputMaybe<UserRelationFilter>;
  Sender?: InputMaybe<UserRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceNullableRelationFilter>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatId?: InputMaybe<IntNullableFilter>;
  content?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<EnumContentMessageTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isDelete?: InputMaybe<BoolFilter>;
  orderPriceId?: InputMaybe<IntNullableFilter>;
  orderSizeId?: InputMaybe<IntNullableFilter>;
  receiverId?: InputMaybe<IntFilter>;
  senderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type ChatMessageWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatMessageWhereInput>>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManNullableRelationFilter>;
  Chat?: InputMaybe<ChatNullableRelationFilter>;
  Files?: InputMaybe<FileListRelationFilter>;
  NOT?: InputMaybe<Array<ChatMessageWhereInput>>;
  OR?: InputMaybe<Array<ChatMessageWhereInput>>;
  OrderPrice?: InputMaybe<OrderPriceNullableRelationFilter>;
  OrderSize?: InputMaybe<OrderSizeNullableRelationFilter>;
  Receiver?: InputMaybe<UserRelationFilter>;
  Sender?: InputMaybe<UserRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceNullableRelationFilter>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatId?: InputMaybe<IntNullableFilter>;
  content?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<EnumContentMessageTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<BoolFilter>;
  orderPriceId?: InputMaybe<IntNullableFilter>;
  orderSizeId?: InputMaybe<IntNullableFilter>;
  receiverId?: InputMaybe<IntFilter>;
  senderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type ChatMinAggregate = {
  __typename?: 'ChatMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ChatMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ChatNullableRelationFilter = {
  is?: InputMaybe<ChatWhereInput>;
  isNot?: InputMaybe<ChatWhereInput>;
};

export type ChatOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChatOrderByWithAggregationInput = {
  _avg?: InputMaybe<ChatAvgOrderByAggregateInput>;
  _count?: InputMaybe<ChatCountOrderByAggregateInput>;
  _max?: InputMaybe<ChatMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChatMinOrderByAggregateInput>;
  _sum?: InputMaybe<ChatSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ChatOrderByWithRelationAndSearchRelevanceInput = {
  ChatMessages?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ChatScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrderId = 'orderId',
  UpdatedAt = 'updatedAt'
}

export type ChatScalarWhereInput = {
  AND?: InputMaybe<Array<ChatScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ChatScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ChatScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ChatScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ChatScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ChatSumAggregate = {
  __typename?: 'ChatSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type ChatSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ChatUpdateInput = {
  ChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutChatNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutChatsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatUpdateManyWithWhereWithoutOrderInput = {
  data: ChatUpdateManyMutationInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ChatUpdateOneWithoutChatMessagesNestedInput = {
  connect?: InputMaybe<ChatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatCreateOrConnectWithoutChatMessagesInput>;
  create?: InputMaybe<ChatCreateWithoutChatMessagesInput>;
  delete?: InputMaybe<ChatWhereInput>;
  disconnect?: InputMaybe<ChatWhereInput>;
  update?: InputMaybe<ChatUpdateToOneWithWhereWithoutChatMessagesInput>;
  upsert?: InputMaybe<ChatUpsertWithoutChatMessagesInput>;
};

export type ChatUpdateToOneWithWhereWithoutChatMessagesInput = {
  data: ChatUpdateWithoutChatMessagesInput;
  where?: InputMaybe<ChatWhereInput>;
};

export type ChatUpdateWithWhereUniqueWithoutOrderInput = {
  data: ChatUpdateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithoutChatMessagesInput = {
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutChatsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatUpdateWithoutOrderInput = {
  ChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutChatNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatUpsertWithWhereUniqueWithoutOrderInput = {
  create: ChatCreateWithoutOrderInput;
  update: ChatUpdateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpsertWithoutChatMessagesInput = {
  create: ChatCreateWithoutChatMessagesInput;
  update: ChatUpdateWithoutChatMessagesInput;
  where?: InputMaybe<ChatWhereInput>;
};

export type ChatWhereInput = {
  AND?: InputMaybe<Array<ChatWhereInput>>;
  ChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  NOT?: InputMaybe<Array<ChatWhereInput>>;
  OR?: InputMaybe<Array<ChatWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ChatWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatWhereInput>>;
  ChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  NOT?: InputMaybe<Array<ChatWhereInput>>;
  OR?: InputMaybe<Array<ChatWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  sessionId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ContentMessageType {
  Date = 'DATE',
  Infotext = 'INFOTEXT',
  Text = 'TEXT'
}

export type Country = {
  __typename?: 'Country';
  Categories: Array<Category>;
  ItemTypes: Array<ItemType>;
  MaterialTypes: Array<MaterialType>;
  Orders: Array<Order>;
  TransporterZones: Array<TransporterZone>;
  UserAddresses: Array<UserAddress>;
  Users: Array<User>;
  _count?: Maybe<CountryCount>;
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
};


export type CountryCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type CountryItemTypesArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type CountryMaterialTypesArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type CountryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type CountryTransporterZonesArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type CountryUserAddressesArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type CountryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type CountryAvgAggregate = {
  __typename?: 'CountryAvgAggregate';
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
};

export type CountryAvgOrderByAggregateInput = {
  ceedowCommission?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minPrice?: InputMaybe<SortOrder>;
};

export type CountryCount = {
  __typename?: 'CountryCount';
  Categories: Scalars['Int']['output'];
  ItemTypes: Scalars['Int']['output'];
  MaterialTypes: Scalars['Int']['output'];
  Orders: Scalars['Int']['output'];
  TransporterZones: Scalars['Int']['output'];
  UserAddresses: Scalars['Int']['output'];
  Users: Scalars['Int']['output'];
};


export type CountryCountCategoriesArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type CountryCountItemTypesArgs = {
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type CountryCountMaterialTypesArgs = {
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type CountryCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type CountryCountTransporterZonesArgs = {
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type CountryCountUserAddressesArgs = {
  where?: InputMaybe<UserAddressWhereInput>;
};


export type CountryCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type CountryCountAggregate = {
  __typename?: 'CountryCountAggregate';
  _all: Scalars['Int']['output'];
  alpha2: Scalars['Int']['output'];
  alpha3: Scalars['Int']['output'];
  ceedowCommission: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isOpen: Scalars['Int']['output'];
  minPrice: Scalars['Int']['output'];
  name_en: Scalars['Int']['output'];
  name_fr: Scalars['Int']['output'];
};

export type CountryCountOrderByAggregateInput = {
  alpha2?: InputMaybe<SortOrder>;
  alpha3?: InputMaybe<SortOrder>;
  ceedowCommission?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOpen?: InputMaybe<SortOrder>;
  minPrice?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
};

export type CountryCreateInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateManyInput = {
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateNestedManyWithoutCategoriesInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutCategoriesInput>>;
};

export type CountryCreateNestedManyWithoutItemTypesInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutItemTypesInput>>;
};

export type CountryCreateNestedManyWithoutMaterialTypesInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutMaterialTypesInput>>;
};

export type CountryCreateNestedManyWithoutTransporterZonesInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutTransporterZonesInput>>;
};

export type CountryCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CountryCreateWithoutOrdersInput>;
};

export type CountryCreateNestedOneWithoutUserAddressesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUserAddressesInput>;
  create?: InputMaybe<CountryCreateWithoutUserAddressesInput>;
};

export type CountryCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CountryCreateWithoutUsersInput>;
};

export type CountryCreateOrConnectWithoutCategoriesInput = {
  create: CountryCreateWithoutCategoriesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutItemTypesInput = {
  create: CountryCreateWithoutItemTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutMaterialTypesInput = {
  create: CountryCreateWithoutMaterialTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutOrdersInput = {
  create: CountryCreateWithoutOrdersInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutTransporterZonesInput = {
  create: CountryCreateWithoutTransporterZonesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutUserAddressesInput = {
  create: CountryCreateWithoutUserAddressesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutUsersInput = {
  create: CountryCreateWithoutUsersInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateWithoutCategoriesInput = {
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutItemTypesInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutMaterialTypesInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutOrdersInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutTransporterZonesInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutUserAddressesInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryCreateWithoutUsersInput = {
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutCountriesInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutCountriesInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutCountriesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutCountryInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutCountriesInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCountryInput>;
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  ceedowCommission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
};

export type CountryGroupBy = {
  __typename?: 'CountryGroupBy';
  _avg?: Maybe<CountryAvgAggregate>;
  _count?: Maybe<CountryCountAggregate>;
  _max?: Maybe<CountryMaxAggregate>;
  _min?: Maybe<CountryMinAggregate>;
  _sum?: Maybe<CountrySumAggregate>;
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
};

export type CountryListRelationFilter = {
  every?: InputMaybe<CountryWhereInput>;
  none?: InputMaybe<CountryWhereInput>;
  some?: InputMaybe<CountryWhereInput>;
};

export type CountryMaxAggregate = {
  __typename?: 'CountryMaxAggregate';
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
};

export type CountryMaxOrderByAggregateInput = {
  alpha2?: InputMaybe<SortOrder>;
  alpha3?: InputMaybe<SortOrder>;
  ceedowCommission?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOpen?: InputMaybe<SortOrder>;
  minPrice?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
};

export type CountryMinAggregate = {
  __typename?: 'CountryMinAggregate';
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
};

export type CountryMinOrderByAggregateInput = {
  alpha2?: InputMaybe<SortOrder>;
  alpha3?: InputMaybe<SortOrder>;
  ceedowCommission?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOpen?: InputMaybe<SortOrder>;
  minPrice?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
};

export type CountryNullableRelationFilter = {
  is?: InputMaybe<CountryWhereInput>;
  isNot?: InputMaybe<CountryWhereInput>;
};

export type CountryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum CountryOrderByRelevanceFieldEnum {
  Alpha2 = 'alpha2',
  Alpha3 = 'alpha3',
  Currency = 'currency',
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type CountryOrderByRelevanceInput = {
  fields: Array<CountryOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type CountryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CountryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CountryCountOrderByAggregateInput>;
  _max?: InputMaybe<CountryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CountryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CountrySumOrderByAggregateInput>;
  alpha2?: InputMaybe<SortOrderInput>;
  alpha3?: InputMaybe<SortOrderInput>;
  ceedowCommission?: InputMaybe<SortOrderInput>;
  currency?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isOpen?: InputMaybe<SortOrderInput>;
  minPrice?: InputMaybe<SortOrderInput>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
};

export type CountryOrderByWithRelationAndSearchRelevanceInput = {
  Categories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  ItemTypes?: InputMaybe<ItemTypeOrderByRelationAggregateInput>;
  MaterialTypes?: InputMaybe<MaterialTypeOrderByRelationAggregateInput>;
  Orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  TransporterZones?: InputMaybe<TransporterZoneOrderByRelationAggregateInput>;
  UserAddresses?: InputMaybe<UserAddressOrderByRelationAggregateInput>;
  Users?: InputMaybe<UserOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<CountryOrderByRelevanceInput>;
  alpha2?: InputMaybe<SortOrderInput>;
  alpha3?: InputMaybe<SortOrderInput>;
  ceedowCommission?: InputMaybe<SortOrderInput>;
  currency?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isOpen?: InputMaybe<SortOrderInput>;
  minPrice?: InputMaybe<SortOrderInput>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
};

export type CountryRelationFilter = {
  is?: InputMaybe<CountryWhereInput>;
  isNot?: InputMaybe<CountryWhereInput>;
};

export enum CountryScalarFieldEnum {
  Alpha2 = 'alpha2',
  Alpha3 = 'alpha3',
  CeedowCommission = 'ceedowCommission',
  Currency = 'currency',
  Id = 'id',
  IsOpen = 'isOpen',
  MinPrice = 'minPrice',
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type CountryScalarWhereInput = {
  AND?: InputMaybe<Array<CountryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CountryScalarWhereInput>>;
  OR?: InputMaybe<Array<CountryScalarWhereInput>>;
  alpha2?: InputMaybe<StringNullableFilter>;
  alpha3?: InputMaybe<StringNullableFilter>;
  ceedowCommission?: InputMaybe<FloatNullableFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isOpen?: InputMaybe<BoolNullableFilter>;
  minPrice?: InputMaybe<FloatNullableFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
};

export type CountryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CountryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CountryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CountryScalarWhereWithAggregatesInput>>;
  alpha2?: InputMaybe<StringNullableWithAggregatesFilter>;
  alpha3?: InputMaybe<StringNullableWithAggregatesFilter>;
  ceedowCommission?: InputMaybe<FloatNullableWithAggregatesFilter>;
  currency?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isOpen?: InputMaybe<BoolNullableWithAggregatesFilter>;
  minPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  name_en?: InputMaybe<StringWithAggregatesFilter>;
  name_fr?: InputMaybe<StringWithAggregatesFilter>;
};

export type CountrySumAggregate = {
  __typename?: 'CountrySumAggregate';
  ceedowCommission?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
};

export type CountrySumOrderByAggregateInput = {
  ceedowCommission?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minPrice?: InputMaybe<SortOrder>;
};

export type CountryUpdateInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateManyMutationInput = {
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateManyWithWhereWithoutCategoriesInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithWhereWithoutItemTypesInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithWhereWithoutMaterialTypesInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithWhereWithoutTransporterZonesInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithoutCategoriesNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutCategoriesInput>>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutCategoriesInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutCategoriesInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutCategoriesInput>>;
};

export type CountryUpdateManyWithoutItemTypesNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutItemTypesInput>>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutItemTypesInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutItemTypesInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutItemTypesInput>>;
};

export type CountryUpdateManyWithoutMaterialTypesNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutMaterialTypesInput>>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutMaterialTypesInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutMaterialTypesInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutMaterialTypesInput>>;
};

export type CountryUpdateManyWithoutTransporterZonesNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutTransporterZonesInput>>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutTransporterZonesInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutTransporterZonesInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutTransporterZonesInput>>;
};

export type CountryUpdateOneRequiredWithoutUserAddressesNestedInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUserAddressesInput>;
  create?: InputMaybe<CountryCreateWithoutUserAddressesInput>;
  update?: InputMaybe<CountryUpdateToOneWithWhereWithoutUserAddressesInput>;
  upsert?: InputMaybe<CountryUpsertWithoutUserAddressesInput>;
};

export type CountryUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CountryCreateWithoutOrdersInput>;
  delete?: InputMaybe<CountryWhereInput>;
  disconnect?: InputMaybe<CountryWhereInput>;
  update?: InputMaybe<CountryUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<CountryUpsertWithoutOrdersInput>;
};

export type CountryUpdateOneWithoutUsersNestedInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CountryCreateWithoutUsersInput>;
  delete?: InputMaybe<CountryWhereInput>;
  disconnect?: InputMaybe<CountryWhereInput>;
  update?: InputMaybe<CountryUpdateToOneWithWhereWithoutUsersInput>;
  upsert?: InputMaybe<CountryUpsertWithoutUsersInput>;
};

export type CountryUpdateToOneWithWhereWithoutOrdersInput = {
  data: CountryUpdateWithoutOrdersInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpdateToOneWithWhereWithoutUserAddressesInput = {
  data: CountryUpdateWithoutUserAddressesInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpdateToOneWithWhereWithoutUsersInput = {
  data: CountryUpdateWithoutUsersInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpdateWithWhereUniqueWithoutCategoriesInput = {
  data: CountryUpdateWithoutCategoriesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithWhereUniqueWithoutItemTypesInput = {
  data: CountryUpdateWithoutItemTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithWhereUniqueWithoutMaterialTypesInput = {
  data: CountryUpdateWithoutMaterialTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithWhereUniqueWithoutTransporterZonesInput = {
  data: CountryUpdateWithoutTransporterZonesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithoutCategoriesInput = {
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutItemTypesInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutMaterialTypesInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutOrdersInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutTransporterZonesInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutUserAddressesInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpdateWithoutUsersInput = {
  Categories?: InputMaybe<CategoryUpdateManyWithoutCountriesNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutCountriesNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutCountriesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutCountryNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutCountriesNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCountryNestedInput>;
  alpha2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  alpha3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ceedowCommission?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOpen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CountryUpsertWithWhereUniqueWithoutCategoriesInput = {
  create: CountryCreateWithoutCategoriesInput;
  update: CountryUpdateWithoutCategoriesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithWhereUniqueWithoutItemTypesInput = {
  create: CountryCreateWithoutItemTypesInput;
  update: CountryUpdateWithoutItemTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithWhereUniqueWithoutMaterialTypesInput = {
  create: CountryCreateWithoutMaterialTypesInput;
  update: CountryUpdateWithoutMaterialTypesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithWhereUniqueWithoutTransporterZonesInput = {
  create: CountryCreateWithoutTransporterZonesInput;
  update: CountryUpdateWithoutTransporterZonesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithoutOrdersInput = {
  create: CountryCreateWithoutOrdersInput;
  update: CountryUpdateWithoutOrdersInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpsertWithoutUserAddressesInput = {
  create: CountryCreateWithoutUserAddressesInput;
  update: CountryUpdateWithoutUserAddressesInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpsertWithoutUsersInput = {
  create: CountryCreateWithoutUsersInput;
  update: CountryUpdateWithoutUsersInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  UserAddresses?: InputMaybe<UserAddressListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  alpha2?: InputMaybe<StringNullableFilter>;
  alpha3?: InputMaybe<StringNullableFilter>;
  ceedowCommission?: InputMaybe<FloatNullableFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isOpen?: InputMaybe<BoolNullableFilter>;
  minPrice?: InputMaybe<FloatNullableFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
};

export type CountryWhereUniqueInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  UserAddresses?: InputMaybe<UserAddressListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  alpha2?: InputMaybe<StringNullableFilter>;
  alpha3?: InputMaybe<StringNullableFilter>;
  ceedowCommission?: InputMaybe<FloatNullableFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOpen?: InputMaybe<BoolNullableFilter>;
  minPrice?: InputMaybe<FloatNullableFilter>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_fr?: InputMaybe<Scalars['String']['input']>;
};

export type CraftmanStatisticBoard = {
  __typename?: 'CraftmanStatisticBoard';
  benefit: Scalars['Float']['output'];
  categories: Array<Category>;
  currency: Scalars['String']['output'];
  nbOrder: Scalars['Float']['output'];
  nbOrderValid: Scalars['Float']['output'];
  nbViewProfile: Scalars['Float']['output'];
};

export type CraftmanWallet = {
  __typename?: 'CraftmanWallet';
  Craftman: User;
  Order?: Maybe<Order>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  action: ActionTransaction;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  rib?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  username?: Maybe<Scalars['String']['output']>;
  walletType: WalletType;
};


export type CraftmanWalletOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type CraftmanWalletAvgAggregate = {
  __typename?: 'CraftmanWalletAvgAggregate';
  craftmanId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type CraftmanWalletAvgOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type CraftmanWalletCountAggregate = {
  __typename?: 'CraftmanWalletCountAggregate';
  _all: Scalars['Int']['output'];
  accountNumber: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  operator: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  rib: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  username: Scalars['Int']['output'];
  walletType: Scalars['Int']['output'];
};

export type CraftmanWalletCountOrderByAggregateInput = {
  accountNumber?: InputMaybe<SortOrder>;
  action?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operator?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  rib?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  walletType?: InputMaybe<SortOrder>;
};

export type CraftmanWalletCreateInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanWalletInput;
  Order?: InputMaybe<OrderCreateNestedOneWithoutCraftmanWalletInput>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletCreateManyCraftmanInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletCreateManyCraftmanInputEnvelope = {
  data: Array<CraftmanWalletCreateManyCraftmanInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CraftmanWalletCreateManyInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletCreateManyOrderInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletCreateManyOrderInputEnvelope = {
  data: Array<CraftmanWalletCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CraftmanWalletCreateNestedManyWithoutCraftmanInput = {
  connect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftmanWalletCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<CraftmanWalletCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<CraftmanWalletCreateManyCraftmanInputEnvelope>;
};

export type CraftmanWalletCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftmanWalletCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<CraftmanWalletCreateWithoutOrderInput>>;
  createMany?: InputMaybe<CraftmanWalletCreateManyOrderInputEnvelope>;
};

export type CraftmanWalletCreateOrConnectWithoutCraftmanInput = {
  create: CraftmanWalletCreateWithoutCraftmanInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletCreateOrConnectWithoutOrderInput = {
  create: CraftmanWalletCreateWithoutOrderInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletCreateWithoutCraftmanInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutCraftmanWalletInput>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletCreateWithoutOrderInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanWalletInput;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  action: ActionTransaction;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  rib?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType?: InputMaybe<WalletType>;
};

export type CraftmanWalletGroupBy = {
  __typename?: 'CraftmanWalletGroupBy';
  _avg?: Maybe<CraftmanWalletAvgAggregate>;
  _count?: Maybe<CraftmanWalletCountAggregate>;
  _max?: Maybe<CraftmanWalletMaxAggregate>;
  _min?: Maybe<CraftmanWalletMinAggregate>;
  _sum?: Maybe<CraftmanWalletSumAggregate>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  action: ActionTransaction;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  rib?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  username?: Maybe<Scalars['String']['output']>;
  walletType: WalletType;
};

export type CraftmanWalletListRelationFilter = {
  every?: InputMaybe<CraftmanWalletWhereInput>;
  none?: InputMaybe<CraftmanWalletWhereInput>;
  some?: InputMaybe<CraftmanWalletWhereInput>;
};

export type CraftmanWalletMaxAggregate = {
  __typename?: 'CraftmanWalletMaxAggregate';
  accountNumber?: Maybe<Scalars['String']['output']>;
  action?: Maybe<ActionTransaction>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  rib?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  walletType?: Maybe<WalletType>;
};

export type CraftmanWalletMaxOrderByAggregateInput = {
  accountNumber?: InputMaybe<SortOrder>;
  action?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operator?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  rib?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  walletType?: InputMaybe<SortOrder>;
};

export type CraftmanWalletMinAggregate = {
  __typename?: 'CraftmanWalletMinAggregate';
  accountNumber?: Maybe<Scalars['String']['output']>;
  action?: Maybe<ActionTransaction>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  rib?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  walletType?: Maybe<WalletType>;
};

export type CraftmanWalletMinOrderByAggregateInput = {
  accountNumber?: InputMaybe<SortOrder>;
  action?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operator?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  rib?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  walletType?: InputMaybe<SortOrder>;
};

export type CraftmanWalletOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum CraftmanWalletOrderByRelevanceFieldEnum {
  AccountNumber = 'accountNumber',
  Description = 'description',
  Operator = 'operator',
  PhoneNumber = 'phoneNumber',
  Rib = 'rib',
  Username = 'username'
}

export type CraftmanWalletOrderByRelevanceInput = {
  fields: Array<CraftmanWalletOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type CraftmanWalletOrderByWithAggregationInput = {
  _avg?: InputMaybe<CraftmanWalletAvgOrderByAggregateInput>;
  _count?: InputMaybe<CraftmanWalletCountOrderByAggregateInput>;
  _max?: InputMaybe<CraftmanWalletMaxOrderByAggregateInput>;
  _min?: InputMaybe<CraftmanWalletMinOrderByAggregateInput>;
  _sum?: InputMaybe<CraftmanWalletSumOrderByAggregateInput>;
  accountNumber?: InputMaybe<SortOrderInput>;
  action?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  operator?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrderInput>;
  rib?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrderInput>;
  walletType?: InputMaybe<SortOrder>;
};

export type CraftmanWalletOrderByWithRelationAndSearchRelevanceInput = {
  Craftman?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<CraftmanWalletOrderByRelevanceInput>;
  accountNumber?: InputMaybe<SortOrderInput>;
  action?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  operator?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrderInput>;
  rib?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrderInput>;
  walletType?: InputMaybe<SortOrder>;
};

export enum CraftmanWalletScalarFieldEnum {
  AccountNumber = 'accountNumber',
  Action = 'action',
  CraftmanId = 'craftmanId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Operator = 'operator',
  OrderId = 'orderId',
  PhoneNumber = 'phoneNumber',
  Price = 'price',
  Rib = 'rib',
  UpdatedAt = 'updatedAt',
  Username = 'username',
  WalletType = 'walletType'
}

export type CraftmanWalletScalarWhereInput = {
  AND?: InputMaybe<Array<CraftmanWalletScalarWhereInput>>;
  NOT?: InputMaybe<Array<CraftmanWalletScalarWhereInput>>;
  OR?: InputMaybe<Array<CraftmanWalletScalarWhereInput>>;
  accountNumber?: InputMaybe<StringNullableFilter>;
  action?: InputMaybe<EnumActionTransactionFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  operator?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  rib?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringNullableFilter>;
  walletType?: InputMaybe<EnumWalletTypeFilter>;
};

export type CraftmanWalletScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CraftmanWalletScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CraftmanWalletScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CraftmanWalletScalarWhereWithAggregatesInput>>;
  accountNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  action?: InputMaybe<EnumActionTransactionWithAggregatesFilter>;
  craftmanId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  operator?: InputMaybe<StringNullableWithAggregatesFilter>;
  orderId?: InputMaybe<IntNullableWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  price?: InputMaybe<FloatNullableWithAggregatesFilter>;
  rib?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  username?: InputMaybe<StringNullableWithAggregatesFilter>;
  walletType?: InputMaybe<EnumWalletTypeWithAggregatesFilter>;
};

export type CraftmanWalletSumAggregate = {
  __typename?: 'CraftmanWalletSumAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type CraftmanWalletSumOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type CraftmanWalletUpdateInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanWalletNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutCraftmanWalletNestedInput>;
  accountNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  action?: InputMaybe<EnumActionTransactionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  operator?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  rib?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  walletType?: InputMaybe<EnumWalletTypeFieldUpdateOperationsInput>;
};

export type CraftmanWalletUpdateManyMutationInput = {
  accountNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  action?: InputMaybe<EnumActionTransactionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  operator?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  rib?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  walletType?: InputMaybe<EnumWalletTypeFieldUpdateOperationsInput>;
};

export type CraftmanWalletUpdateManyWithWhereWithoutCraftmanInput = {
  data: CraftmanWalletUpdateManyMutationInput;
  where: CraftmanWalletScalarWhereInput;
};

export type CraftmanWalletUpdateManyWithWhereWithoutOrderInput = {
  data: CraftmanWalletUpdateManyMutationInput;
  where: CraftmanWalletScalarWhereInput;
};

export type CraftmanWalletUpdateManyWithoutCraftmanNestedInput = {
  connect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftmanWalletCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<CraftmanWalletCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<CraftmanWalletCreateManyCraftmanInputEnvelope>;
  delete?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftmanWalletScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftmanWalletUpdateWithWhereUniqueWithoutCraftmanInput>>;
  updateMany?: InputMaybe<Array<CraftmanWalletUpdateManyWithWhereWithoutCraftmanInput>>;
  upsert?: InputMaybe<Array<CraftmanWalletUpsertWithWhereUniqueWithoutCraftmanInput>>;
};

export type CraftmanWalletUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftmanWalletCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<CraftmanWalletCreateWithoutOrderInput>>;
  createMany?: InputMaybe<CraftmanWalletCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftmanWalletScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftmanWalletWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftmanWalletUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<CraftmanWalletUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<CraftmanWalletUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type CraftmanWalletUpdateWithWhereUniqueWithoutCraftmanInput = {
  data: CraftmanWalletUpdateWithoutCraftmanInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletUpdateWithWhereUniqueWithoutOrderInput = {
  data: CraftmanWalletUpdateWithoutOrderInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletUpdateWithoutCraftmanInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutCraftmanWalletNestedInput>;
  accountNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  action?: InputMaybe<EnumActionTransactionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  operator?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  rib?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  walletType?: InputMaybe<EnumWalletTypeFieldUpdateOperationsInput>;
};

export type CraftmanWalletUpdateWithoutOrderInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanWalletNestedInput>;
  accountNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  action?: InputMaybe<EnumActionTransactionFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  operator?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  rib?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  walletType?: InputMaybe<EnumWalletTypeFieldUpdateOperationsInput>;
};

export type CraftmanWalletUpsertWithWhereUniqueWithoutCraftmanInput = {
  create: CraftmanWalletCreateWithoutCraftmanInput;
  update: CraftmanWalletUpdateWithoutCraftmanInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletUpsertWithWhereUniqueWithoutOrderInput = {
  create: CraftmanWalletCreateWithoutOrderInput;
  update: CraftmanWalletUpdateWithoutOrderInput;
  where: CraftmanWalletWhereUniqueInput;
};

export type CraftmanWalletWhereInput = {
  AND?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  Craftman?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  OR?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  accountNumber?: InputMaybe<StringNullableFilter>;
  action?: InputMaybe<EnumActionTransactionFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  operator?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  rib?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringNullableFilter>;
  walletType?: InputMaybe<EnumWalletTypeFilter>;
};

export type CraftmanWalletWhereUniqueInput = {
  AND?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  Craftman?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  OR?: InputMaybe<Array<CraftmanWalletWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  accountNumber?: InputMaybe<StringNullableFilter>;
  action?: InputMaybe<EnumActionTransactionFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operator?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  rib?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringNullableFilter>;
  walletType?: InputMaybe<EnumWalletTypeFilter>;
};

export type CraftmenFeedResponse = {
  __typename?: 'CraftmenFeedResponse';
  /** Total count of matching users */
  totalCount: Scalars['Int']['output'];
  /** List of craftmen with their average notes */
  users: Array<UserWithNote>;
};

export type CraftmenFeedWhereInput = {
  /** Filter by active status */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by ban status */
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by deleted status */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter users with photos */
  hasPhotos?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum average note */
  maxNote?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum average note */
  minNote?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by user role */
  role?: InputMaybe<Role>;
};

export type CreateNewAdressInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryId: Scalars['Float']['input'];
  customerId: Scalars['Float']['input'];
  zipCode: Scalars['String']['input'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type Email = {
  __typename?: 'Email';
  Sender: User;
  content: Scalars['String']['output'];
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  recipients: Array<Scalars['String']['output']>;
  senderId: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type EmailAvgAggregate = {
  __typename?: 'EmailAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  senderId?: Maybe<Scalars['Float']['output']>;
};

export type EmailAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
};

export type EmailCountAggregate = {
  __typename?: 'EmailCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  contentHtml: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  recipients: Scalars['Int']['output'];
  senderId: Scalars['Int']['output'];
  subject: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  contentHtml?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailCreateInput = {
  Sender: UserCreateNestedOneWithoutEmailsInput;
  content: Scalars['String']['input'];
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  recipients?: InputMaybe<EmailCreaterecipientsInput>;
  subject: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EmailCreateManyInput = {
  content: Scalars['String']['input'];
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<EmailCreaterecipientsInput>;
  senderId: Scalars['Int']['input'];
  subject: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EmailCreateManySenderInput = {
  content: Scalars['String']['input'];
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<EmailCreaterecipientsInput>;
  subject: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EmailCreateManySenderInputEnvelope = {
  data: Array<EmailCreateManySenderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailCreateNestedManyWithoutSenderInput = {
  connect?: InputMaybe<Array<EmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<EmailCreateWithoutSenderInput>>;
  createMany?: InputMaybe<EmailCreateManySenderInputEnvelope>;
};

export type EmailCreateOrConnectWithoutSenderInput = {
  create: EmailCreateWithoutSenderInput;
  where: EmailWhereUniqueInput;
};

export type EmailCreateWithoutSenderInput = {
  content: Scalars['String']['input'];
  contentHtml?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  recipients?: InputMaybe<EmailCreaterecipientsInput>;
  subject: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EmailCreaterecipientsInput = {
  set: Array<Scalars['String']['input']>;
};

export type EmailGroupBy = {
  __typename?: 'EmailGroupBy';
  _avg?: Maybe<EmailAvgAggregate>;
  _count?: Maybe<EmailCountAggregate>;
  _max?: Maybe<EmailMaxAggregate>;
  _min?: Maybe<EmailMinAggregate>;
  _sum?: Maybe<EmailSumAggregate>;
  content: Scalars['String']['output'];
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  senderId: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type EmailListRelationFilter = {
  every?: InputMaybe<EmailWhereInput>;
  none?: InputMaybe<EmailWhereInput>;
  some?: InputMaybe<EmailWhereInput>;
};

export type EmailMaxAggregate = {
  __typename?: 'EmailMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EmailMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  contentHtml?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailMinAggregate = {
  __typename?: 'EmailMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  contentHtml?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EmailMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  contentHtml?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum EmailOrderByRelevanceFieldEnum {
  Content = 'content',
  ContentHtml = 'contentHtml',
  Recipients = 'recipients',
  Subject = 'subject'
}

export type EmailOrderByRelevanceInput = {
  fields: Array<EmailOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  contentHtml?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailOrderByWithRelationAndSearchRelevanceInput = {
  Sender?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<EmailOrderByRelevanceInput>;
  content?: InputMaybe<SortOrder>;
  contentHtml?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EmailScalarFieldEnum {
  Content = 'content',
  ContentHtml = 'contentHtml',
  CreatedAt = 'createdAt',
  Id = 'id',
  Recipients = 'recipients',
  SenderId = 'senderId',
  Subject = 'subject',
  UpdatedAt = 'updatedAt'
}

export type EmailScalarWhereInput = {
  AND?: InputMaybe<Array<EmailScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmailScalarWhereInput>>;
  OR?: InputMaybe<Array<EmailScalarWhereInput>>;
  content?: InputMaybe<StringFilter>;
  contentHtml?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  senderId?: InputMaybe<IntFilter>;
  subject?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  contentHtml?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  senderId?: InputMaybe<IntWithAggregatesFilter>;
  subject?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailSumAggregate = {
  __typename?: 'EmailSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  senderId?: Maybe<Scalars['Int']['output']>;
};

export type EmailSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  senderId?: InputMaybe<SortOrder>;
};

export type EmailUpdateInput = {
  Sender?: InputMaybe<UserUpdateOneRequiredWithoutEmailsNestedInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  contentHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipients?: InputMaybe<EmailUpdaterecipientsInput>;
  subject?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  contentHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipients?: InputMaybe<EmailUpdaterecipientsInput>;
  subject?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailUpdateManyWithWhereWithoutSenderInput = {
  data: EmailUpdateManyMutationInput;
  where: EmailScalarWhereInput;
};

export type EmailUpdateManyWithoutSenderNestedInput = {
  connect?: InputMaybe<Array<EmailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<EmailCreateWithoutSenderInput>>;
  createMany?: InputMaybe<EmailCreateManySenderInputEnvelope>;
  delete?: InputMaybe<Array<EmailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailUpdateWithWhereUniqueWithoutSenderInput>>;
  updateMany?: InputMaybe<Array<EmailUpdateManyWithWhereWithoutSenderInput>>;
  upsert?: InputMaybe<Array<EmailUpsertWithWhereUniqueWithoutSenderInput>>;
};

export type EmailUpdateWithWhereUniqueWithoutSenderInput = {
  data: EmailUpdateWithoutSenderInput;
  where: EmailWhereUniqueInput;
};

export type EmailUpdateWithoutSenderInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  contentHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recipients?: InputMaybe<EmailUpdaterecipientsInput>;
  subject?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailUpdaterecipientsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmailUpsertWithWhereUniqueWithoutSenderInput = {
  create: EmailCreateWithoutSenderInput;
  update: EmailUpdateWithoutSenderInput;
  where: EmailWhereUniqueInput;
};

export type EmailWhereInput = {
  AND?: InputMaybe<Array<EmailWhereInput>>;
  NOT?: InputMaybe<Array<EmailWhereInput>>;
  OR?: InputMaybe<Array<EmailWhereInput>>;
  Sender?: InputMaybe<UserRelationFilter>;
  content?: InputMaybe<StringFilter>;
  contentHtml?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  senderId?: InputMaybe<IntFilter>;
  subject?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailWhereInput>>;
  NOT?: InputMaybe<Array<EmailWhereInput>>;
  OR?: InputMaybe<Array<EmailWhereInput>>;
  Sender?: InputMaybe<UserRelationFilter>;
  content?: InputMaybe<StringFilter>;
  contentHtml?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<StringNullableListFilter>;
  senderId?: InputMaybe<IntFilter>;
  subject?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnumActionFieldUpdateOperationsInput = {
  set?: InputMaybe<Action>;
};

export type EnumActionFilter = {
  equals?: InputMaybe<Action>;
  in?: InputMaybe<Array<Action>>;
  not?: InputMaybe<NestedEnumActionFilter>;
  notIn?: InputMaybe<Array<Action>>;
};

export type EnumActionTransactionFieldUpdateOperationsInput = {
  set?: InputMaybe<ActionTransaction>;
};

export type EnumActionTransactionFilter = {
  equals?: InputMaybe<ActionTransaction>;
  in?: InputMaybe<Array<ActionTransaction>>;
  not?: InputMaybe<NestedEnumActionTransactionFilter>;
  notIn?: InputMaybe<Array<ActionTransaction>>;
};

export type EnumActionTransactionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionTransactionFilter>;
  _min?: InputMaybe<NestedEnumActionTransactionFilter>;
  equals?: InputMaybe<ActionTransaction>;
  in?: InputMaybe<Array<ActionTransaction>>;
  not?: InputMaybe<NestedEnumActionTransactionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ActionTransaction>>;
};

export type EnumActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionFilter>;
  _min?: InputMaybe<NestedEnumActionFilter>;
  equals?: InputMaybe<Action>;
  in?: InputMaybe<Array<Action>>;
  not?: InputMaybe<NestedEnumActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Action>>;
};

export type EnumContentMessageTypeNullableFilter = {
  equals?: InputMaybe<ContentMessageType>;
  in?: InputMaybe<Array<ContentMessageType>>;
  not?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  notIn?: InputMaybe<Array<ContentMessageType>>;
};

export type EnumContentMessageTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  equals?: InputMaybe<ContentMessageType>;
  in?: InputMaybe<Array<ContentMessageType>>;
  not?: InputMaybe<NestedEnumContentMessageTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ContentMessageType>>;
};

export type EnumNotificationDataTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationDataType>;
};

export type EnumNotificationDataTypeFilter = {
  equals?: InputMaybe<NotificationDataType>;
  in?: InputMaybe<Array<NotificationDataType>>;
  not?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  notIn?: InputMaybe<Array<NotificationDataType>>;
};

export type EnumNotificationDataTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  _min?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  equals?: InputMaybe<NotificationDataType>;
  in?: InputMaybe<Array<NotificationDataType>>;
  not?: InputMaybe<NestedEnumNotificationDataTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<NotificationDataType>>;
};

export type EnumPaimentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaimentStatus>;
};

export type EnumPaimentStatusFilter = {
  equals?: InputMaybe<PaimentStatus>;
  in?: InputMaybe<Array<PaimentStatus>>;
  not?: InputMaybe<NestedEnumPaimentStatusFilter>;
  notIn?: InputMaybe<Array<PaimentStatus>>;
};

export type EnumPaimentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaimentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaimentStatusFilter>;
  equals?: InputMaybe<PaimentStatus>;
  in?: InputMaybe<Array<PaimentStatus>>;
  not?: InputMaybe<NestedEnumPaimentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaimentStatus>>;
};

export type EnumPlatformFieldUpdateOperationsInput = {
  set?: InputMaybe<Platform>;
};

export type EnumPlatformFilter = {
  equals?: InputMaybe<Platform>;
  in?: InputMaybe<Array<Platform>>;
  not?: InputMaybe<NestedEnumPlatformFilter>;
  notIn?: InputMaybe<Array<Platform>>;
};

export type EnumPlatformWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPlatformFilter>;
  _min?: InputMaybe<NestedEnumPlatformFilter>;
  equals?: InputMaybe<Platform>;
  in?: InputMaybe<Array<Platform>>;
  not?: InputMaybe<NestedEnumPlatformWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Platform>>;
};

export type EnumPromptTargetFieldUpdateOperationsInput = {
  set?: InputMaybe<PromptTarget>;
};

export type EnumPromptTargetFilter = {
  equals?: InputMaybe<PromptTarget>;
  in?: InputMaybe<Array<PromptTarget>>;
  not?: InputMaybe<NestedEnumPromptTargetFilter>;
  notIn?: InputMaybe<Array<PromptTarget>>;
};

export type EnumPromptTargetWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPromptTargetFilter>;
  _min?: InputMaybe<NestedEnumPromptTargetFilter>;
  equals?: InputMaybe<PromptTarget>;
  in?: InputMaybe<Array<PromptTarget>>;
  not?: InputMaybe<NestedEnumPromptTargetWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PromptTarget>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<Status>;
};

export type EnumStatusFilter = {
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type EnumStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStatusFilter>;
  _min?: InputMaybe<NestedEnumStatusFilter>;
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type EnumWalletTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WalletType>;
};

export type EnumWalletTypeFilter = {
  equals?: InputMaybe<WalletType>;
  in?: InputMaybe<Array<WalletType>>;
  not?: InputMaybe<NestedEnumWalletTypeFilter>;
  notIn?: InputMaybe<Array<WalletType>>;
};

export type EnumWalletTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumWalletTypeFilter>;
  _min?: InputMaybe<NestedEnumWalletTypeFilter>;
  equals?: InputMaybe<WalletType>;
  in?: InputMaybe<Array<WalletType>>;
  not?: InputMaybe<NestedEnumWalletTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WalletType>>;
};

export type ExchangeCurrency = {
  __typename?: 'ExchangeCurrency';
  createdAt: Scalars['DateTimeISO']['output'];
  from: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rates: Scalars['Float']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExchangeCurrencyAvgAggregate = {
  __typename?: 'ExchangeCurrencyAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  rates?: Maybe<Scalars['Float']['output']>;
};

export type ExchangeCurrencyAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
};

export type ExchangeCurrencyCountAggregate = {
  __typename?: 'ExchangeCurrencyCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  rates: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ExchangeCurrencyCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
  to?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExchangeCurrencyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  from: Scalars['String']['input'];
  rates: Scalars['Float']['input'];
  to: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExchangeCurrencyCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  rates: Scalars['Float']['input'];
  to: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ExchangeCurrencyGroupBy = {
  __typename?: 'ExchangeCurrencyGroupBy';
  _avg?: Maybe<ExchangeCurrencyAvgAggregate>;
  _count?: Maybe<ExchangeCurrencyCountAggregate>;
  _max?: Maybe<ExchangeCurrencyMaxAggregate>;
  _min?: Maybe<ExchangeCurrencyMinAggregate>;
  _sum?: Maybe<ExchangeCurrencySumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  from: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rates: Scalars['Float']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ExchangeCurrencyMaxAggregate = {
  __typename?: 'ExchangeCurrencyMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExchangeCurrencyMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
  to?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExchangeCurrencyMinAggregate = {
  __typename?: 'ExchangeCurrencyMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExchangeCurrencyMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
  to?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ExchangeCurrencyOrderByRelevanceFieldEnum {
  From = 'from',
  To = 'to'
}

export type ExchangeCurrencyOrderByRelevanceInput = {
  fields: Array<ExchangeCurrencyOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ExchangeCurrencyOrderByWithAggregationInput = {
  _avg?: InputMaybe<ExchangeCurrencyAvgOrderByAggregateInput>;
  _count?: InputMaybe<ExchangeCurrencyCountOrderByAggregateInput>;
  _max?: InputMaybe<ExchangeCurrencyMaxOrderByAggregateInput>;
  _min?: InputMaybe<ExchangeCurrencyMinOrderByAggregateInput>;
  _sum?: InputMaybe<ExchangeCurrencySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
  to?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExchangeCurrencyOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ExchangeCurrencyOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
  to?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ExchangeCurrencyScalarFieldEnum {
  CreatedAt = 'createdAt',
  From = 'from',
  Id = 'id',
  Rates = 'rates',
  To = 'to',
  UpdatedAt = 'updatedAt'
}

export type ExchangeCurrencyScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ExchangeCurrencyScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ExchangeCurrencyScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ExchangeCurrencyScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  from?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  rates?: InputMaybe<FloatWithAggregatesFilter>;
  to?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ExchangeCurrencySumAggregate = {
  __typename?: 'ExchangeCurrencySumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  rates?: Maybe<Scalars['Float']['output']>;
};

export type ExchangeCurrencySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  rates?: InputMaybe<SortOrder>;
};

export type ExchangeCurrencyUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<FloatFieldUpdateOperationsInput>;
  to?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExchangeCurrencyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  rates?: InputMaybe<FloatFieldUpdateOperationsInput>;
  to?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ExchangeCurrencyWhereInput = {
  AND?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  NOT?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  OR?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  from?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  rates?: InputMaybe<FloatFilter>;
  to?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ExchangeCurrencyWhereUniqueInput = {
  AND?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  NOT?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  OR?: InputMaybe<Array<ExchangeCurrencyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  from?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rates?: InputMaybe<FloatFilter>;
  to?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Faq = {
  __typename?: 'Faq';
  createdAt: Scalars['DateTimeISO']['output'];
  description_en: Scalars['String']['output'];
  description_fr: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isShowOnCraftman: Scalars['Boolean']['output'];
  isShowOnCustomer: Scalars['Boolean']['output'];
  priority: Scalars['Float']['output'];
  title_en: Scalars['String']['output'];
  title_fr: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type FaqAvgAggregate = {
  __typename?: 'FaqAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type FaqAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
};

export type FaqCountAggregate = {
  __typename?: 'FaqCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description_en: Scalars['Int']['output'];
  description_fr: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isShowOnCraftman: Scalars['Int']['output'];
  isShowOnCustomer: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  title_en: Scalars['Int']['output'];
  title_fr: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FaqCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description_en?: InputMaybe<SortOrder>;
  description_fr?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isShowOnCraftman?: InputMaybe<SortOrder>;
  isShowOnCustomer?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FaqCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description_en: Scalars['String']['input'];
  description_fr: Scalars['String']['input'];
  isShowOnCraftman?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  title_en: Scalars['String']['input'];
  title_fr: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FaqCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description_en: Scalars['String']['input'];
  description_fr: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isShowOnCraftman?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  title_en: Scalars['String']['input'];
  title_fr: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FaqGroupBy = {
  __typename?: 'FaqGroupBy';
  _avg?: Maybe<FaqAvgAggregate>;
  _count?: Maybe<FaqCountAggregate>;
  _max?: Maybe<FaqMaxAggregate>;
  _min?: Maybe<FaqMinAggregate>;
  _sum?: Maybe<FaqSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  description_en: Scalars['String']['output'];
  description_fr: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isShowOnCraftman: Scalars['Boolean']['output'];
  isShowOnCustomer: Scalars['Boolean']['output'];
  priority: Scalars['Float']['output'];
  title_en: Scalars['String']['output'];
  title_fr: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type FaqMaxAggregate = {
  __typename?: 'FaqMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isShowOnCraftman?: Maybe<Scalars['Boolean']['output']>;
  isShowOnCustomer?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  title_fr?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FaqMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description_en?: InputMaybe<SortOrder>;
  description_fr?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isShowOnCraftman?: InputMaybe<SortOrder>;
  isShowOnCustomer?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FaqMinAggregate = {
  __typename?: 'FaqMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isShowOnCraftman?: Maybe<Scalars['Boolean']['output']>;
  isShowOnCustomer?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  title_fr?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FaqMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description_en?: InputMaybe<SortOrder>;
  description_fr?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isShowOnCraftman?: InputMaybe<SortOrder>;
  isShowOnCustomer?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FaqOrderByRelevanceFieldEnum {
  DescriptionEn = 'description_en',
  DescriptionFr = 'description_fr',
  TitleEn = 'title_en',
  TitleFr = 'title_fr'
}

export type FaqOrderByRelevanceInput = {
  fields: Array<FaqOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type FaqOrderByWithAggregationInput = {
  _avg?: InputMaybe<FaqAvgOrderByAggregateInput>;
  _count?: InputMaybe<FaqCountOrderByAggregateInput>;
  _max?: InputMaybe<FaqMaxOrderByAggregateInput>;
  _min?: InputMaybe<FaqMinOrderByAggregateInput>;
  _sum?: InputMaybe<FaqSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  description_en?: InputMaybe<SortOrder>;
  description_fr?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isShowOnCraftman?: InputMaybe<SortOrder>;
  isShowOnCustomer?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FaqOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<FaqOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  description_en?: InputMaybe<SortOrder>;
  description_fr?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isShowOnCraftman?: InputMaybe<SortOrder>;
  isShowOnCustomer?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FaqScalarFieldEnum {
  CreatedAt = 'createdAt',
  DescriptionEn = 'description_en',
  DescriptionFr = 'description_fr',
  Id = 'id',
  IsShowOnCraftman = 'isShowOnCraftman',
  IsShowOnCustomer = 'isShowOnCustomer',
  Priority = 'priority',
  TitleEn = 'title_en',
  TitleFr = 'title_fr',
  UpdatedAt = 'updatedAt'
}

export type FaqScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FaqScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FaqScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FaqScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description_en?: InputMaybe<StringWithAggregatesFilter>;
  description_fr?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isShowOnCraftman?: InputMaybe<BoolWithAggregatesFilter>;
  isShowOnCustomer?: InputMaybe<BoolWithAggregatesFilter>;
  priority?: InputMaybe<FloatWithAggregatesFilter>;
  title_en?: InputMaybe<StringWithAggregatesFilter>;
  title_fr?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type FaqSumAggregate = {
  __typename?: 'FaqSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
};

export type FaqSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
};

export type FaqUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  description_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  isShowOnCraftman?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShowOnCustomer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
  title_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  title_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FaqUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  description_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  isShowOnCraftman?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShowOnCustomer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<FloatFieldUpdateOperationsInput>;
  title_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  title_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FaqWhereInput = {
  AND?: InputMaybe<Array<FaqWhereInput>>;
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  OR?: InputMaybe<Array<FaqWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description_en?: InputMaybe<StringFilter>;
  description_fr?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isShowOnCraftman?: InputMaybe<BoolFilter>;
  isShowOnCustomer?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<FloatFilter>;
  title_en?: InputMaybe<StringFilter>;
  title_fr?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FaqWhereUniqueInput = {
  AND?: InputMaybe<Array<FaqWhereInput>>;
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  OR?: InputMaybe<Array<FaqWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description_en?: InputMaybe<StringFilter>;
  description_fr?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isShowOnCraftman?: InputMaybe<BoolFilter>;
  isShowOnCustomer?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<FloatFilter>;
  title_en?: InputMaybe<StringFilter>;
  title_fr?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Favorites = {
  __typename?: 'Favorites';
  Craftman: User;
  Customer?: Maybe<User>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ownerType: Role;
};


export type FavoritesCustomerArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type FavoritesAvgAggregate = {
  __typename?: 'FavoritesAvgAggregate';
  craftmanId?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type FavoritesAvgOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type FavoritesCountAggregate = {
  __typename?: 'FavoritesCountAggregate';
  _all: Scalars['Int']['output'];
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  deviceId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ownerType: Scalars['Int']['output'];
};

export type FavoritesCountOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
};

export type FavoritesCreateInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanFavoritesInput;
  Customer?: InputMaybe<UserCreateNestedOneWithoutCustomerFavoritesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesCreateManyCraftmanInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesCreateManyCraftmanInputEnvelope = {
  data: Array<FavoritesCreateManyCraftmanInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FavoritesCreateManyCustomerInput = {
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesCreateManyCustomerInputEnvelope = {
  data: Array<FavoritesCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FavoritesCreateManyInput = {
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesCreateNestedManyWithoutCraftmanInput = {
  connect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoritesCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<FavoritesCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<FavoritesCreateManyCraftmanInputEnvelope>;
};

export type FavoritesCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoritesCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<FavoritesCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<FavoritesCreateManyCustomerInputEnvelope>;
};

export type FavoritesCreateOrConnectWithoutCraftmanInput = {
  create: FavoritesCreateWithoutCraftmanInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesCreateOrConnectWithoutCustomerInput = {
  create: FavoritesCreateWithoutCustomerInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesCreateWithoutCraftmanInput = {
  Customer?: InputMaybe<UserCreateNestedOneWithoutCustomerFavoritesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesCreateWithoutCustomerInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanFavoritesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<Role>;
};

export type FavoritesGroupBy = {
  __typename?: 'FavoritesGroupBy';
  _avg?: Maybe<FavoritesAvgAggregate>;
  _count?: Maybe<FavoritesCountAggregate>;
  _max?: Maybe<FavoritesMaxAggregate>;
  _min?: Maybe<FavoritesMinAggregate>;
  _sum?: Maybe<FavoritesSumAggregate>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ownerType: Role;
};

export type FavoritesListRelationFilter = {
  every?: InputMaybe<FavoritesWhereInput>;
  none?: InputMaybe<FavoritesWhereInput>;
  some?: InputMaybe<FavoritesWhereInput>;
};

export type FavoritesMaxAggregate = {
  __typename?: 'FavoritesMaxAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ownerType?: Maybe<Role>;
};

export type FavoritesMaxOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
};

export type FavoritesMinAggregate = {
  __typename?: 'FavoritesMinAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ownerType?: Maybe<Role>;
};

export type FavoritesMinOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
};

export type FavoritesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FavoritesOrderByRelevanceFieldEnum {
  DeviceId = 'deviceId'
}

export type FavoritesOrderByRelevanceInput = {
  fields: Array<FavoritesOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type FavoritesOrderByWithAggregationInput = {
  _avg?: InputMaybe<FavoritesAvgOrderByAggregateInput>;
  _count?: InputMaybe<FavoritesCountOrderByAggregateInput>;
  _max?: InputMaybe<FavoritesMaxOrderByAggregateInput>;
  _min?: InputMaybe<FavoritesMinOrderByAggregateInput>;
  _sum?: InputMaybe<FavoritesSumOrderByAggregateInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrderInput>;
  deviceId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
};

export type FavoritesOrderByWithRelationAndSearchRelevanceInput = {
  Craftman?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<FavoritesOrderByRelevanceInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrderInput>;
  deviceId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  ownerType?: InputMaybe<SortOrder>;
};

export enum FavoritesScalarFieldEnum {
  CraftmanId = 'craftmanId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  DeviceId = 'deviceId',
  Id = 'id',
  OwnerType = 'ownerType'
}

export type FavoritesScalarWhereInput = {
  AND?: InputMaybe<Array<FavoritesScalarWhereInput>>;
  NOT?: InputMaybe<Array<FavoritesScalarWhereInput>>;
  OR?: InputMaybe<Array<FavoritesScalarWhereInput>>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  deviceId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ownerType?: InputMaybe<EnumRoleFilter>;
};

export type FavoritesScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FavoritesScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FavoritesScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FavoritesScalarWhereWithAggregatesInput>>;
  craftmanId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  deviceId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  ownerType?: InputMaybe<EnumRoleWithAggregatesFilter>;
};

export type FavoritesSumAggregate = {
  __typename?: 'FavoritesSumAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type FavoritesSumOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type FavoritesUpdateInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanFavoritesNestedInput>;
  Customer?: InputMaybe<UserUpdateOneWithoutCustomerFavoritesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ownerType?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type FavoritesUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ownerType?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type FavoritesUpdateManyWithWhereWithoutCraftmanInput = {
  data: FavoritesUpdateManyMutationInput;
  where: FavoritesScalarWhereInput;
};

export type FavoritesUpdateManyWithWhereWithoutCustomerInput = {
  data: FavoritesUpdateManyMutationInput;
  where: FavoritesScalarWhereInput;
};

export type FavoritesUpdateManyWithoutCraftmanNestedInput = {
  connect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoritesCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<FavoritesCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<FavoritesCreateManyCraftmanInputEnvelope>;
  delete?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavoritesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  update?: InputMaybe<Array<FavoritesUpdateWithWhereUniqueWithoutCraftmanInput>>;
  updateMany?: InputMaybe<Array<FavoritesUpdateManyWithWhereWithoutCraftmanInput>>;
  upsert?: InputMaybe<Array<FavoritesUpsertWithWhereUniqueWithoutCraftmanInput>>;
};

export type FavoritesUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoritesCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<FavoritesCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<FavoritesCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavoritesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoritesWhereUniqueInput>>;
  update?: InputMaybe<Array<FavoritesUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<FavoritesUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<FavoritesUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type FavoritesUpdateWithWhereUniqueWithoutCraftmanInput = {
  data: FavoritesUpdateWithoutCraftmanInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesUpdateWithWhereUniqueWithoutCustomerInput = {
  data: FavoritesUpdateWithoutCustomerInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesUpdateWithoutCraftmanInput = {
  Customer?: InputMaybe<UserUpdateOneWithoutCustomerFavoritesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ownerType?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type FavoritesUpdateWithoutCustomerInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanFavoritesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ownerType?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type FavoritesUpsertWithWhereUniqueWithoutCraftmanInput = {
  create: FavoritesCreateWithoutCraftmanInput;
  update: FavoritesUpdateWithoutCraftmanInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesUpsertWithWhereUniqueWithoutCustomerInput = {
  create: FavoritesCreateWithoutCustomerInput;
  update: FavoritesUpdateWithoutCustomerInput;
  where: FavoritesWhereUniqueInput;
};

export type FavoritesWhereInput = {
  AND?: InputMaybe<Array<FavoritesWhereInput>>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserNullableRelationFilter>;
  NOT?: InputMaybe<Array<FavoritesWhereInput>>;
  OR?: InputMaybe<Array<FavoritesWhereInput>>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  deviceId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ownerType?: InputMaybe<EnumRoleFilter>;
};

export type FavoritesWhereUniqueInput = {
  AND?: InputMaybe<Array<FavoritesWhereInput>>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserNullableRelationFilter>;
  NOT?: InputMaybe<Array<FavoritesWhereInput>>;
  OR?: InputMaybe<Array<FavoritesWhereInput>>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  deviceId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<EnumRoleFilter>;
};

export type File = {
  __typename?: 'File';
  AskDeliveryMan?: Maybe<AskDeliveryMan>;
  ChatMessage?: Maybe<ChatMessage>;
  Order?: Maybe<Order>;
  UserBanners: Array<User>;
  UserPrompts: Array<UserPrompt>;
  UserRealtionProfiles: Array<User>;
  UserRealtionRealisation?: Maybe<User>;
  UserStories: Array<UserStory>;
  ValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  _count?: Maybe<FileCount>;
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatMessageId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userRealtionRealisationId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};


export type FileAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type FileChatMessageArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type FileOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type FileUserBannersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type FileUserPromptsArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPromptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type FileUserRealtionProfilesArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type FileUserRealtionRealisationArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileUserStoriesArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserStoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type FileValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type FileAvgAggregate = {
  __typename?: 'FileAvgAggregate';
  askDeliveryManId?: Maybe<Scalars['Float']['output']>;
  chatMessageId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userRealtionRealisationId?: Maybe<Scalars['Float']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Float']['output']>;
};

export type FileAvgOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatMessageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type FileCount = {
  __typename?: 'FileCount';
  UserBanners: Scalars['Int']['output'];
  UserPrompts: Scalars['Int']['output'];
  UserRealtionProfiles: Scalars['Int']['output'];
  UserStories: Scalars['Int']['output'];
};


export type FileCountUserBannersArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileCountUserPromptsArgs = {
  where?: InputMaybe<UserPromptWhereInput>;
};


export type FileCountUserRealtionProfilesArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileCountUserStoriesArgs = {
  where?: InputMaybe<UserStoryWhereInput>;
};

export type FileCountAggregate = {
  __typename?: 'FileCountAggregate';
  _all: Scalars['Int']['output'];
  askDeliveryManId: Scalars['Int']['output'];
  chatMessageId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
  userRealtionRealisationId: Scalars['Int']['output'];
  validOrderEvidenceId: Scalars['Int']['output'];
};

export type FileCountOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatMessageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type FileCreateInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateManyAskDeliveryManInput = {
  chatMessageId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userRealtionRealisationId?: InputMaybe<Scalars['Int']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyAskDeliveryManInputEnvelope = {
  data: Array<FileCreateManyAskDeliveryManInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyChatMessageInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userRealtionRealisationId?: InputMaybe<Scalars['Int']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyChatMessageInputEnvelope = {
  data: Array<FileCreateManyChatMessageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatMessageId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userRealtionRealisationId?: InputMaybe<Scalars['Int']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyOrderInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatMessageId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userRealtionRealisationId?: InputMaybe<Scalars['Int']['input']>;
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyOrderInputEnvelope = {
  data: Array<FileCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyUserRealtionRealisationInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatMessageId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  validOrderEvidenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyUserRealtionRealisationInputEnvelope = {
  data: Array<FileCreateManyUserRealtionRealisationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyValidOrderEvidenceInput = {
  askDeliveryManId?: InputMaybe<Scalars['Int']['input']>;
  chatMessageId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userRealtionRealisationId?: InputMaybe<Scalars['Int']['input']>;
};

export type FileCreateManyValidOrderEvidenceInputEnvelope = {
  data: Array<FileCreateManyValidOrderEvidenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateNestedManyWithoutAskDeliveryManInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutAskDeliveryManInput>>;
  create?: InputMaybe<Array<FileCreateWithoutAskDeliveryManInput>>;
  createMany?: InputMaybe<FileCreateManyAskDeliveryManInputEnvelope>;
};

export type FileCreateNestedManyWithoutChatMessageInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutChatMessageInput>>;
  create?: InputMaybe<Array<FileCreateWithoutChatMessageInput>>;
  createMany?: InputMaybe<FileCreateManyChatMessageInputEnvelope>;
};

export type FileCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
};

export type FileCreateNestedManyWithoutUserPromptsInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserPromptsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserPromptsInput>>;
};

export type FileCreateNestedManyWithoutUserRealtionRealisationInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserRealtionRealisationInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserRealtionRealisationInput>>;
  createMany?: InputMaybe<FileCreateManyUserRealtionRealisationInputEnvelope>;
};

export type FileCreateNestedManyWithoutValidOrderEvidenceInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutValidOrderEvidenceInput>>;
  create?: InputMaybe<Array<FileCreateWithoutValidOrderEvidenceInput>>;
  createMany?: InputMaybe<FileCreateManyValidOrderEvidenceInputEnvelope>;
};

export type FileCreateNestedOneWithoutUserBannersInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserBannersInput>;
  create?: InputMaybe<FileCreateWithoutUserBannersInput>;
};

export type FileCreateNestedOneWithoutUserRealtionProfilesInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserRealtionProfilesInput>;
  create?: InputMaybe<FileCreateWithoutUserRealtionProfilesInput>;
};

export type FileCreateNestedOneWithoutUserStoriesInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserStoriesInput>;
  create?: InputMaybe<FileCreateWithoutUserStoriesInput>;
};

export type FileCreateOrConnectWithoutAskDeliveryManInput = {
  create: FileCreateWithoutAskDeliveryManInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutChatMessageInput = {
  create: FileCreateWithoutChatMessageInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserBannersInput = {
  create: FileCreateWithoutUserBannersInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserPromptsInput = {
  create: FileCreateWithoutUserPromptsInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserRealtionProfilesInput = {
  create: FileCreateWithoutUserRealtionProfilesInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserRealtionRealisationInput = {
  create: FileCreateWithoutUserRealtionRealisationInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserStoriesInput = {
  create: FileCreateWithoutUserStoriesInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutValidOrderEvidenceInput = {
  create: FileCreateWithoutValidOrderEvidenceInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutAskDeliveryManInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutChatMessageInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutOrderInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutUserBannersInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutUserPromptsInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutUserRealtionProfilesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutUserRealtionRealisationInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutUserStoriesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedOneWithoutPhotosInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileCreateWithoutValidOrderEvidenceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedOneWithoutPhotosInput>;
  ChatMessage?: InputMaybe<ChatMessageCreateNestedOneWithoutFilesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPhotosInput>;
  UserBanners?: InputMaybe<UserCreateNestedManyWithoutBannerPhotoInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutResultFileInput>;
  UserRealtionProfiles?: InputMaybe<UserCreateNestedManyWithoutProfilePhotoInput>;
  UserRealtionRealisation?: InputMaybe<UserCreateNestedOneWithoutPhotoAchievementsInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutFileInput>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileGroupBy = {
  __typename?: 'FileGroupBy';
  _avg?: Maybe<FileAvgAggregate>;
  _count?: Maybe<FileCountAggregate>;
  _max?: Maybe<FileMaxAggregate>;
  _min?: Maybe<FileMinAggregate>;
  _sum?: Maybe<FileSumAggregate>;
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatMessageId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userRealtionRealisationId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type FileListRelationFilter = {
  every?: InputMaybe<FileWhereInput>;
  none?: InputMaybe<FileWhereInput>;
  some?: InputMaybe<FileWhereInput>;
};

export type FileMaxAggregate = {
  __typename?: 'FileMaxAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatMessageId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userRealtionRealisationId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type FileMaxOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatMessageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type FileMinAggregate = {
  __typename?: 'FileMinAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatMessageId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userRealtionRealisationId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type FileMinOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatMessageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type FileNullableRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export type FileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FileOrderByRelevanceFieldEnum {
  Name = 'name',
  Type = 'type',
  Url = 'url'
}

export type FileOrderByRelevanceInput = {
  fields: Array<FileOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type FileOrderByWithAggregationInput = {
  _avg?: InputMaybe<FileAvgOrderByAggregateInput>;
  _count?: InputMaybe<FileCountOrderByAggregateInput>;
  _max?: InputMaybe<FileMaxOrderByAggregateInput>;
  _min?: InputMaybe<FileMinOrderByAggregateInput>;
  _sum?: InputMaybe<FileSumOrderByAggregateInput>;
  askDeliveryManId?: InputMaybe<SortOrderInput>;
  chatMessageId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  size?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrderInput>;
  validOrderEvidenceId?: InputMaybe<SortOrderInput>;
};

export type FileOrderByWithRelationAndSearchRelevanceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>;
  ChatMessage?: InputMaybe<ChatMessageOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  UserBanners?: InputMaybe<UserOrderByRelationAggregateInput>;
  UserPrompts?: InputMaybe<UserPromptOrderByRelationAggregateInput>;
  UserRealtionProfiles?: InputMaybe<UserOrderByRelationAggregateInput>;
  UserRealtionRealisation?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  UserStories?: InputMaybe<UserStoryOrderByRelationAggregateInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<FileOrderByRelevanceInput>;
  askDeliveryManId?: InputMaybe<SortOrderInput>;
  chatMessageId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  size?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrderInput>;
  validOrderEvidenceId?: InputMaybe<SortOrderInput>;
};

export type FileRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export enum FileScalarFieldEnum {
  AskDeliveryManId = 'askDeliveryManId',
  ChatMessageId = 'chatMessageId',
  Id = 'id',
  Name = 'name',
  OrderId = 'orderId',
  Size = 'size',
  Type = 'type',
  Url = 'url',
  UserRealtionRealisationId = 'userRealtionRealisationId',
  ValidOrderEvidenceId = 'validOrderEvidenceId'
}

export type FileScalarWhereInput = {
  AND?: InputMaybe<Array<FileScalarWhereInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereInput>>;
  OR?: InputMaybe<Array<FileScalarWhereInput>>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatMessageId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  size?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  userRealtionRealisationId?: InputMaybe<IntNullableFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type FileScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FileScalarWhereWithAggregatesInput>>;
  askDeliveryManId?: InputMaybe<IntNullableWithAggregatesFilter>;
  chatMessageId?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  orderId?: InputMaybe<IntNullableWithAggregatesFilter>;
  size?: InputMaybe<FloatNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  url?: InputMaybe<StringWithAggregatesFilter>;
  userRealtionRealisationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type FileSumAggregate = {
  __typename?: 'FileSumAggregate';
  askDeliveryManId?: Maybe<Scalars['Int']['output']>;
  chatMessageId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userRealtionRealisationId?: Maybe<Scalars['Int']['output']>;
  validOrderEvidenceId?: Maybe<Scalars['Int']['output']>;
};

export type FileSumOrderByAggregateInput = {
  askDeliveryManId?: InputMaybe<SortOrder>;
  chatMessageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  userRealtionRealisationId?: InputMaybe<SortOrder>;
  validOrderEvidenceId?: InputMaybe<SortOrder>;
};

export type FileUpdateInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateManyWithWhereWithoutAskDeliveryManInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutChatMessageInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutOrderInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutUserPromptsInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutUserRealtionRealisationInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutValidOrderEvidenceInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithoutAskDeliveryManNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutAskDeliveryManInput>>;
  create?: InputMaybe<Array<FileCreateWithoutAskDeliveryManInput>>;
  createMany?: InputMaybe<FileCreateManyAskDeliveryManInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutAskDeliveryManInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutAskDeliveryManInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutAskDeliveryManInput>>;
};

export type FileUpdateManyWithoutChatMessageNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutChatMessageInput>>;
  create?: InputMaybe<Array<FileCreateWithoutChatMessageInput>>;
  createMany?: InputMaybe<FileCreateManyChatMessageInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutChatMessageInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutChatMessageInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutChatMessageInput>>;
};

export type FileUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type FileUpdateManyWithoutUserPromptsNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserPromptsInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserPromptsInput>>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutUserPromptsInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutUserPromptsInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutUserPromptsInput>>;
};

export type FileUpdateManyWithoutUserRealtionRealisationNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserRealtionRealisationInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserRealtionRealisationInput>>;
  createMany?: InputMaybe<FileCreateManyUserRealtionRealisationInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutUserRealtionRealisationInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutUserRealtionRealisationInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutUserRealtionRealisationInput>>;
};

export type FileUpdateManyWithoutValidOrderEvidenceNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutValidOrderEvidenceInput>>;
  create?: InputMaybe<Array<FileCreateWithoutValidOrderEvidenceInput>>;
  createMany?: InputMaybe<FileCreateManyValidOrderEvidenceInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutValidOrderEvidenceInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutValidOrderEvidenceInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutValidOrderEvidenceInput>>;
};

export type FileUpdateOneRequiredWithoutUserStoriesNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserStoriesInput>;
  create?: InputMaybe<FileCreateWithoutUserStoriesInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutUserStoriesInput>;
  upsert?: InputMaybe<FileUpsertWithoutUserStoriesInput>;
};

export type FileUpdateOneWithoutUserBannersNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserBannersInput>;
  create?: InputMaybe<FileCreateWithoutUserBannersInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutUserBannersInput>;
  upsert?: InputMaybe<FileUpsertWithoutUserBannersInput>;
};

export type FileUpdateOneWithoutUserRealtionProfilesNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutUserRealtionProfilesInput>;
  create?: InputMaybe<FileCreateWithoutUserRealtionProfilesInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutUserRealtionProfilesInput>;
  upsert?: InputMaybe<FileUpsertWithoutUserRealtionProfilesInput>;
};

export type FileUpdateToOneWithWhereWithoutUserBannersInput = {
  data: FileUpdateWithoutUserBannersInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutUserRealtionProfilesInput = {
  data: FileUpdateWithoutUserRealtionProfilesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutUserStoriesInput = {
  data: FileUpdateWithoutUserStoriesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateWithWhereUniqueWithoutAskDeliveryManInput = {
  data: FileUpdateWithoutAskDeliveryManInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutChatMessageInput = {
  data: FileUpdateWithoutChatMessageInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutOrderInput = {
  data: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutUserPromptsInput = {
  data: FileUpdateWithoutUserPromptsInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutUserRealtionRealisationInput = {
  data: FileUpdateWithoutUserRealtionRealisationInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutValidOrderEvidenceInput = {
  data: FileUpdateWithoutValidOrderEvidenceInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithoutAskDeliveryManInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutChatMessageInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutOrderInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutUserBannersInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutUserPromptsInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutUserRealtionProfilesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutUserRealtionRealisationInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutUserStoriesInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpdateWithoutValidOrderEvidenceInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateOneWithoutPhotosNestedInput>;
  ChatMessage?: InputMaybe<ChatMessageUpdateOneWithoutFilesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPhotosNestedInput>;
  UserBanners?: InputMaybe<UserUpdateManyWithoutBannerPhotoNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutResultFileNestedInput>;
  UserRealtionProfiles?: InputMaybe<UserUpdateManyWithoutProfilePhotoNestedInput>;
  UserRealtionRealisation?: InputMaybe<UserUpdateOneWithoutPhotoAchievementsNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutFileNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpsertWithWhereUniqueWithoutAskDeliveryManInput = {
  create: FileCreateWithoutAskDeliveryManInput;
  update: FileUpdateWithoutAskDeliveryManInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutChatMessageInput = {
  create: FileCreateWithoutChatMessageInput;
  update: FileUpdateWithoutChatMessageInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  update: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutUserPromptsInput = {
  create: FileCreateWithoutUserPromptsInput;
  update: FileUpdateWithoutUserPromptsInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutUserRealtionRealisationInput = {
  create: FileCreateWithoutUserRealtionRealisationInput;
  update: FileUpdateWithoutUserRealtionRealisationInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutValidOrderEvidenceInput = {
  create: FileCreateWithoutValidOrderEvidenceInput;
  update: FileUpdateWithoutValidOrderEvidenceInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithoutUserBannersInput = {
  create: FileCreateWithoutUserBannersInput;
  update: FileUpdateWithoutUserBannersInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutUserRealtionProfilesInput = {
  create: FileCreateWithoutUserRealtionProfilesInput;
  update: FileUpdateWithoutUserRealtionProfilesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutUserStoriesInput = {
  create: FileCreateWithoutUserStoriesInput;
  update: FileUpdateWithoutUserStoriesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManNullableRelationFilter>;
  ChatMessage?: InputMaybe<ChatMessageNullableRelationFilter>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  UserBanners?: InputMaybe<UserListRelationFilter>;
  UserPrompts?: InputMaybe<UserPromptListRelationFilter>;
  UserRealtionProfiles?: InputMaybe<UserListRelationFilter>;
  UserRealtionRealisation?: InputMaybe<UserNullableRelationFilter>;
  UserStories?: InputMaybe<UserStoryListRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceNullableRelationFilter>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatMessageId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  size?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  userRealtionRealisationId?: InputMaybe<IntNullableFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type FileWhereUniqueInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManNullableRelationFilter>;
  ChatMessage?: InputMaybe<ChatMessageNullableRelationFilter>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  UserBanners?: InputMaybe<UserListRelationFilter>;
  UserPrompts?: InputMaybe<UserPromptListRelationFilter>;
  UserRealtionProfiles?: InputMaybe<UserListRelationFilter>;
  UserRealtionRealisation?: InputMaybe<UserNullableRelationFilter>;
  UserStories?: InputMaybe<UserStoryListRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceNullableRelationFilter>;
  askDeliveryManId?: InputMaybe<IntNullableFilter>;
  chatMessageId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  size?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  userRealtionRealisationId?: InputMaybe<IntNullableFilter>;
  validOrderEvidenceId?: InputMaybe<IntNullableFilter>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ItemType = {
  __typename?: 'ItemType';
  Category: Category;
  Countries: Array<Country>;
  Orders: Array<Order>;
  Users: Array<User>;
  _count?: Maybe<ItemTypeCount>;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type ItemTypeCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type ItemTypeOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type ItemTypeUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type ItemTypeAvgAggregate = {
  __typename?: 'ItemTypeAvgAggregate';
  categoryId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemTypeAvgOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ItemTypeCount = {
  __typename?: 'ItemTypeCount';
  Countries: Scalars['Int']['output'];
  Orders: Scalars['Int']['output'];
  Users: Scalars['Int']['output'];
};


export type ItemTypeCountCountriesArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type ItemTypeCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type ItemTypeCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type ItemTypeCountAggregate = {
  __typename?: 'ItemTypeCountAggregate';
  _all: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['Int']['output'];
  name_fr: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type ItemTypeCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ItemTypeCreateInput = {
  Category: CategoryCreateNestedOneWithoutItemTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutItemTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutItemTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutItemTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateManyCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateManyCategoryInputEnvelope = {
  data: Array<ItemTypeCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemTypeCreateManyInput = {
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ItemTypeCreateManyCategoryInputEnvelope>;
};

export type ItemTypeCreateNestedManyWithoutCountriesInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutCountriesInput>>;
};

export type ItemTypeCreateNestedManyWithoutOrdersInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutOrdersInput>>;
};

export type ItemTypeCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutUsersInput>>;
};

export type ItemTypeCreateOrConnectWithoutCategoryInput = {
  create: ItemTypeCreateWithoutCategoryInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeCreateOrConnectWithoutCountriesInput = {
  create: ItemTypeCreateWithoutCountriesInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeCreateOrConnectWithoutOrdersInput = {
  create: ItemTypeCreateWithoutOrdersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeCreateOrConnectWithoutUsersInput = {
  create: ItemTypeCreateWithoutUsersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeCreateWithoutCategoryInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutItemTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutItemTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutItemTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateWithoutCountriesInput = {
  Category: CategoryCreateNestedOneWithoutItemTypesInput;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutItemTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutItemTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateWithoutOrdersInput = {
  Category: CategoryCreateNestedOneWithoutItemTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutItemTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutItemTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeCreateWithoutUsersInput = {
  Category: CategoryCreateNestedOneWithoutItemTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutItemTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutItemTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ItemTypeGroupBy = {
  __typename?: 'ItemTypeGroupBy';
  _avg?: Maybe<ItemTypeAvgAggregate>;
  _count?: Maybe<ItemTypeCountAggregate>;
  _max?: Maybe<ItemTypeMaxAggregate>;
  _min?: Maybe<ItemTypeMinAggregate>;
  _sum?: Maybe<ItemTypeSumAggregate>;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemTypeListRelationFilter = {
  every?: InputMaybe<ItemTypeWhereInput>;
  none?: InputMaybe<ItemTypeWhereInput>;
  some?: InputMaybe<ItemTypeWhereInput>;
};

export type ItemTypeMaxAggregate = {
  __typename?: 'ItemTypeMaxAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemTypeMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ItemTypeMinAggregate = {
  __typename?: 'ItemTypeMinAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemTypeMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ItemTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ItemTypeOrderByRelevanceFieldEnum {
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type ItemTypeOrderByRelevanceInput = {
  fields: Array<ItemTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ItemTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<ItemTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<ItemTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<ItemTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ItemTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<ItemTypeSumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  weight?: InputMaybe<SortOrderInput>;
};

export type ItemTypeOrderByWithRelationAndSearchRelevanceInput = {
  Category?: InputMaybe<CategoryOrderByWithRelationAndSearchRelevanceInput>;
  Countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  Orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  Users?: InputMaybe<UserOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<ItemTypeOrderByRelevanceInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  weight?: InputMaybe<SortOrderInput>;
};

export enum ItemTypeScalarFieldEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  NameEn = 'name_en',
  NameFr = 'name_fr',
  OldId = 'oldID',
  Weight = 'weight'
}

export type ItemTypeScalarWhereInput = {
  AND?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type ItemTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ItemTypeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ItemTypeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ItemTypeScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name_en?: InputMaybe<StringWithAggregatesFilter>;
  name_fr?: InputMaybe<StringWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
  weight?: InputMaybe<FloatNullableWithAggregatesFilter>;
};

export type ItemTypeSumAggregate = {
  __typename?: 'ItemTypeSumAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ItemTypeSumOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type ItemTypeUpdateInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutItemTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutItemTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutItemTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutItemTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpdateManyWithWhereWithoutCategoryInput = {
  data: ItemTypeUpdateManyMutationInput;
  where: ItemTypeScalarWhereInput;
};

export type ItemTypeUpdateManyWithWhereWithoutCountriesInput = {
  data: ItemTypeUpdateManyMutationInput;
  where: ItemTypeScalarWhereInput;
};

export type ItemTypeUpdateManyWithWhereWithoutOrdersInput = {
  data: ItemTypeUpdateManyMutationInput;
  where: ItemTypeScalarWhereInput;
};

export type ItemTypeUpdateManyWithWhereWithoutUsersInput = {
  data: ItemTypeUpdateManyMutationInput;
  where: ItemTypeScalarWhereInput;
};

export type ItemTypeUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ItemTypeCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemTypeUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<ItemTypeUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<ItemTypeUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type ItemTypeUpdateManyWithoutCountriesNestedInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutCountriesInput>>;
  delete?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemTypeUpdateWithWhereUniqueWithoutCountriesInput>>;
  updateMany?: InputMaybe<Array<ItemTypeUpdateManyWithWhereWithoutCountriesInput>>;
  upsert?: InputMaybe<Array<ItemTypeUpsertWithWhereUniqueWithoutCountriesInput>>;
};

export type ItemTypeUpdateManyWithoutOrdersNestedInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutOrdersInput>>;
  delete?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemTypeUpdateWithWhereUniqueWithoutOrdersInput>>;
  updateMany?: InputMaybe<Array<ItemTypeUpdateManyWithWhereWithoutOrdersInput>>;
  upsert?: InputMaybe<Array<ItemTypeUpsertWithWhereUniqueWithoutOrdersInput>>;
};

export type ItemTypeUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemTypeCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<ItemTypeCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemTypeUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<ItemTypeUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<ItemTypeUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type ItemTypeUpdateWithWhereUniqueWithoutCategoryInput = {
  data: ItemTypeUpdateWithoutCategoryInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpdateWithWhereUniqueWithoutCountriesInput = {
  data: ItemTypeUpdateWithoutCountriesInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpdateWithWhereUniqueWithoutOrdersInput = {
  data: ItemTypeUpdateWithoutOrdersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpdateWithWhereUniqueWithoutUsersInput = {
  data: ItemTypeUpdateWithoutUsersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpdateWithoutCategoryInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutItemTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutItemTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutItemTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpdateWithoutCountriesInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutItemTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutItemTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutItemTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpdateWithoutOrdersInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutItemTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutItemTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutItemTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpdateWithoutUsersInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutItemTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutItemTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutItemTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ItemTypeUpsertWithWhereUniqueWithoutCategoryInput = {
  create: ItemTypeCreateWithoutCategoryInput;
  update: ItemTypeUpdateWithoutCategoryInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpsertWithWhereUniqueWithoutCountriesInput = {
  create: ItemTypeCreateWithoutCountriesInput;
  update: ItemTypeUpdateWithoutCountriesInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpsertWithWhereUniqueWithoutOrdersInput = {
  create: ItemTypeCreateWithoutOrdersInput;
  update: ItemTypeUpdateWithoutOrdersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeUpsertWithWhereUniqueWithoutUsersInput = {
  create: ItemTypeCreateWithoutUsersInput;
  update: ItemTypeUpdateWithoutUsersInput;
  where: ItemTypeWhereUniqueInput;
};

export type ItemTypeWhereInput = {
  AND?: InputMaybe<Array<ItemTypeWhereInput>>;
  Category?: InputMaybe<CategoryRelationFilter>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<ItemTypeWhereInput>>;
  OR?: InputMaybe<Array<ItemTypeWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type ItemTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemTypeWhereInput>>;
  Category?: InputMaybe<CategoryRelationFilter>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<ItemTypeWhereInput>>;
  OR?: InputMaybe<Array<ItemTypeWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialType = {
  __typename?: 'MaterialType';
  Category: Category;
  Countries: Array<Country>;
  Orders: Array<Order>;
  Users: Array<User>;
  _count?: Maybe<MaterialTypeCount>;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
};


export type MaterialTypeCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type MaterialTypeOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type MaterialTypeUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type MaterialTypeAvgAggregate = {
  __typename?: 'MaterialTypeAvgAggregate';
  categoryId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
};

export type MaterialTypeAvgOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type MaterialTypeCount = {
  __typename?: 'MaterialTypeCount';
  Countries: Scalars['Int']['output'];
  Orders: Scalars['Int']['output'];
  Users: Scalars['Int']['output'];
};


export type MaterialTypeCountCountriesArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type MaterialTypeCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type MaterialTypeCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type MaterialTypeCountAggregate = {
  __typename?: 'MaterialTypeCountAggregate';
  _all: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['Int']['output'];
  name_fr: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
};

export type MaterialTypeCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type MaterialTypeCreateInput = {
  Category: CategoryCreateNestedOneWithoutMaterialTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutMaterialTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutMaterialTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutMaterialTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateManyCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateManyCategoryInputEnvelope = {
  data: Array<MaterialTypeCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterialTypeCreateManyInput = {
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MaterialTypeCreateManyCategoryInputEnvelope>;
};

export type MaterialTypeCreateNestedManyWithoutCountriesInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutCountriesInput>>;
};

export type MaterialTypeCreateNestedManyWithoutOrdersInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutOrdersInput>>;
};

export type MaterialTypeCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutUsersInput>>;
};

export type MaterialTypeCreateOrConnectWithoutCategoryInput = {
  create: MaterialTypeCreateWithoutCategoryInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeCreateOrConnectWithoutCountriesInput = {
  create: MaterialTypeCreateWithoutCountriesInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeCreateOrConnectWithoutOrdersInput = {
  create: MaterialTypeCreateWithoutOrdersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeCreateOrConnectWithoutUsersInput = {
  create: MaterialTypeCreateWithoutUsersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeCreateWithoutCategoryInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutMaterialTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutMaterialTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutMaterialTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateWithoutCountriesInput = {
  Category: CategoryCreateNestedOneWithoutMaterialTypesInput;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutMaterialTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutMaterialTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateWithoutOrdersInput = {
  Category: CategoryCreateNestedOneWithoutMaterialTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutMaterialTypesInput>;
  Users?: InputMaybe<UserCreateNestedManyWithoutMaterialTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeCreateWithoutUsersInput = {
  Category: CategoryCreateNestedOneWithoutMaterialTypesInput;
  Countries?: InputMaybe<CountryCreateNestedManyWithoutMaterialTypesInput>;
  Orders?: InputMaybe<OrderCreateNestedManyWithoutMaterialTypesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialTypeGroupBy = {
  __typename?: 'MaterialTypeGroupBy';
  _avg?: Maybe<MaterialTypeAvgAggregate>;
  _count?: Maybe<MaterialTypeCountAggregate>;
  _max?: Maybe<MaterialTypeMaxAggregate>;
  _min?: Maybe<MaterialTypeMinAggregate>;
  _sum?: Maybe<MaterialTypeSumAggregate>;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
};

export type MaterialTypeListRelationFilter = {
  every?: InputMaybe<MaterialTypeWhereInput>;
  none?: InputMaybe<MaterialTypeWhereInput>;
  some?: InputMaybe<MaterialTypeWhereInput>;
};

export type MaterialTypeMaxAggregate = {
  __typename?: 'MaterialTypeMaxAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
};

export type MaterialTypeMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type MaterialTypeMinAggregate = {
  __typename?: 'MaterialTypeMinAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
};

export type MaterialTypeMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type MaterialTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum MaterialTypeOrderByRelevanceFieldEnum {
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type MaterialTypeOrderByRelevanceInput = {
  fields: Array<MaterialTypeOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type MaterialTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<MaterialTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<MaterialTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<MaterialTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<MaterialTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<MaterialTypeSumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
};

export type MaterialTypeOrderByWithRelationAndSearchRelevanceInput = {
  Category?: InputMaybe<CategoryOrderByWithRelationAndSearchRelevanceInput>;
  Countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  Orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  Users?: InputMaybe<UserOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<MaterialTypeOrderByRelevanceInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
};

export enum MaterialTypeScalarFieldEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  NameEn = 'name_en',
  NameFr = 'name_fr',
  OldId = 'oldID'
}

export type MaterialTypeScalarWhereInput = {
  AND?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
};

export type MaterialTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MaterialTypeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MaterialTypeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MaterialTypeScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name_en?: InputMaybe<StringWithAggregatesFilter>;
  name_fr?: InputMaybe<StringWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type MaterialTypeSumAggregate = {
  __typename?: 'MaterialTypeSumAggregate';
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
};

export type MaterialTypeSumOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type MaterialTypeUpdateInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutMaterialTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutMaterialTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutMaterialTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutMaterialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpdateManyWithWhereWithoutCategoryInput = {
  data: MaterialTypeUpdateManyMutationInput;
  where: MaterialTypeScalarWhereInput;
};

export type MaterialTypeUpdateManyWithWhereWithoutCountriesInput = {
  data: MaterialTypeUpdateManyMutationInput;
  where: MaterialTypeScalarWhereInput;
};

export type MaterialTypeUpdateManyWithWhereWithoutOrdersInput = {
  data: MaterialTypeUpdateManyMutationInput;
  where: MaterialTypeScalarWhereInput;
};

export type MaterialTypeUpdateManyWithWhereWithoutUsersInput = {
  data: MaterialTypeUpdateManyMutationInput;
  where: MaterialTypeScalarWhereInput;
};

export type MaterialTypeUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MaterialTypeCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialTypeUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<MaterialTypeUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<MaterialTypeUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type MaterialTypeUpdateManyWithoutCountriesNestedInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutCountriesInput>>;
  delete?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialTypeUpdateWithWhereUniqueWithoutCountriesInput>>;
  updateMany?: InputMaybe<Array<MaterialTypeUpdateManyWithWhereWithoutCountriesInput>>;
  upsert?: InputMaybe<Array<MaterialTypeUpsertWithWhereUniqueWithoutCountriesInput>>;
};

export type MaterialTypeUpdateManyWithoutOrdersNestedInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutOrdersInput>>;
  delete?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialTypeUpdateWithWhereUniqueWithoutOrdersInput>>;
  updateMany?: InputMaybe<Array<MaterialTypeUpdateManyWithWhereWithoutOrdersInput>>;
  upsert?: InputMaybe<Array<MaterialTypeUpsertWithWhereUniqueWithoutOrdersInput>>;
};

export type MaterialTypeUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTypeCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<MaterialTypeCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialTypeUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<MaterialTypeUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<MaterialTypeUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type MaterialTypeUpdateWithWhereUniqueWithoutCategoryInput = {
  data: MaterialTypeUpdateWithoutCategoryInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpdateWithWhereUniqueWithoutCountriesInput = {
  data: MaterialTypeUpdateWithoutCountriesInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpdateWithWhereUniqueWithoutOrdersInput = {
  data: MaterialTypeUpdateWithoutOrdersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpdateWithWhereUniqueWithoutUsersInput = {
  data: MaterialTypeUpdateWithoutUsersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpdateWithoutCategoryInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutMaterialTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutMaterialTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutMaterialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpdateWithoutCountriesInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutMaterialTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutMaterialTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutMaterialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpdateWithoutOrdersInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutMaterialTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutMaterialTypesNestedInput>;
  Users?: InputMaybe<UserUpdateManyWithoutMaterialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpdateWithoutUsersInput = {
  Category?: InputMaybe<CategoryUpdateOneRequiredWithoutMaterialTypesNestedInput>;
  Countries?: InputMaybe<CountryUpdateManyWithoutMaterialTypesNestedInput>;
  Orders?: InputMaybe<OrderUpdateManyWithoutMaterialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MaterialTypeUpsertWithWhereUniqueWithoutCategoryInput = {
  create: MaterialTypeCreateWithoutCategoryInput;
  update: MaterialTypeUpdateWithoutCategoryInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpsertWithWhereUniqueWithoutCountriesInput = {
  create: MaterialTypeCreateWithoutCountriesInput;
  update: MaterialTypeUpdateWithoutCountriesInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpsertWithWhereUniqueWithoutOrdersInput = {
  create: MaterialTypeCreateWithoutOrdersInput;
  update: MaterialTypeUpdateWithoutOrdersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeUpsertWithWhereUniqueWithoutUsersInput = {
  create: MaterialTypeCreateWithoutUsersInput;
  update: MaterialTypeUpdateWithoutUsersInput;
  where: MaterialTypeWhereUniqueInput;
};

export type MaterialTypeWhereInput = {
  AND?: InputMaybe<Array<MaterialTypeWhereInput>>;
  Category?: InputMaybe<CategoryRelationFilter>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<MaterialTypeWhereInput>>;
  OR?: InputMaybe<Array<MaterialTypeWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
};

export type MaterialTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<MaterialTypeWhereInput>>;
  Category?: InputMaybe<CategoryRelationFilter>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<MaterialTypeWhereInput>>;
  OR?: InputMaybe<Array<MaterialTypeWhereInput>>;
  Orders?: InputMaybe<OrderListRelationFilter>;
  Users?: InputMaybe<UserListRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrderDealine: ChatMessage;
  adviceNewOrderPrice: ChatMessage;
  askDeliveryMan: ChatMessage;
  askPayment: CraftmanWallet;
  askResetPassword: Scalars['String']['output'];
  changeActiveAdress: UserAddress;
  createCraftmanWallet: CraftmanWallet;
  createManyActionOrder: AffectedRowsOutput;
  createManyAskDeliveryMan: AffectedRowsOutput;
  createManyCategory: AffectedRowsOutput;
  createManyChat: AffectedRowsOutput;
  createManyChatMessage: AffectedRowsOutput;
  createManyCountry: AffectedRowsOutput;
  createManyCraftmanWallet: AffectedRowsOutput;
  createManyEmail: AffectedRowsOutput;
  createManyExchangeCurrency: AffectedRowsOutput;
  createManyFaq: AffectedRowsOutput;
  createManyFavorites: AffectedRowsOutput;
  createManyFile: AffectedRowsOutput;
  createManyItemType: AffectedRowsOutput;
  createManyMaterialType: AffectedRowsOutput;
  createManyNoticeOrder: AffectedRowsOutput;
  createManyNotification: AffectedRowsOutput;
  createManyOrder: AffectedRowsOutput;
  createManyOrderPrice: AffectedRowsOutput;
  createManyOrderSize: AffectedRowsOutput;
  createManyPaimentHistory: AffectedRowsOutput;
  createManyPromptEngineer: AffectedRowsOutput;
  createManyPushTokens: AffectedRowsOutput;
  createManySegmentation: AffectedRowsOutput;
  createManyTransporter: AffectedRowsOutput;
  createManyTransporterPrice: AffectedRowsOutput;
  createManyTransporterZone: AffectedRowsOutput;
  createManyUser: AffectedRowsOutput;
  createManyUserAddress: AffectedRowsOutput;
  createManyUserPrompt: AffectedRowsOutput;
  createManyUserRestPassword: AffectedRowsOutput;
  createManyUserStory: AffectedRowsOutput;
  createManyValidOrderEvidence: AffectedRowsOutput;
  createNewAdress: UserAddress;
  createNewOrder: Order;
  createNewOrderSize: ChatMessage;
  createOneActionOrder: ActionOrder;
  createOneAskDeliveryMan: AskDeliveryMan;
  createOneCategory: Category;
  createOneChat: Chat;
  createOneChatMessage: ChatMessage;
  createOneCountry: Country;
  createOneCraftmanWallet: CraftmanWallet;
  createOneEmail: Email;
  createOneExchangeCurrency: ExchangeCurrency;
  createOneFaq: Faq;
  createOneFavorites: Favorites;
  createOneFile: File;
  createOneItemType: ItemType;
  createOneMaterialType: MaterialType;
  createOneNoticeOrder: NoticeOrder;
  createOneNotification: Notification;
  createOneOrder: Order;
  createOneOrderPrice: OrderPrice;
  createOneOrderSize: OrderSize;
  createOnePaimentHistory: PaimentHistory;
  createOnePromptEngineer: PromptEngineer;
  createOnePushTokens: PushTokens;
  createOneSegmentation: Segmentation;
  createOneTransporter: Transporter;
  createOneTransporterPrice: TransporterPrice;
  createOneTransporterZone: TransporterZone;
  createOneUser: User;
  createOneUserAddress: UserAddress;
  createOneUserPrompt: UserPrompt;
  createOneUserRestPassword: UserRestPassword;
  createOneUserStory: UserStory;
  createOneValidOrderEvidence: ValidOrderEvidence;
  createStripeCheckoutSession: CheckoutSessionResponse;
  createStripePaymentIntent: PaymentIntentResponse;
  createUserStory: UserStory;
  deleteManyActionOrder: AffectedRowsOutput;
  deleteManyAskDeliveryMan: AffectedRowsOutput;
  deleteManyCategory: AffectedRowsOutput;
  deleteManyChat: AffectedRowsOutput;
  deleteManyChatMessage: AffectedRowsOutput;
  deleteManyCountry: AffectedRowsOutput;
  deleteManyCraftmanWallet: AffectedRowsOutput;
  deleteManyEmail: AffectedRowsOutput;
  deleteManyExchangeCurrency: AffectedRowsOutput;
  deleteManyFaq: AffectedRowsOutput;
  deleteManyFavorites: AffectedRowsOutput;
  deleteManyFile: AffectedRowsOutput;
  deleteManyItemType: AffectedRowsOutput;
  deleteManyMaterialType: AffectedRowsOutput;
  deleteManyNoticeOrder: AffectedRowsOutput;
  deleteManyNotification: AffectedRowsOutput;
  deleteManyOrder: AffectedRowsOutput;
  deleteManyOrderPrice: AffectedRowsOutput;
  deleteManyOrderSize: AffectedRowsOutput;
  deleteManyPaimentHistory: AffectedRowsOutput;
  deleteManyPromptEngineer: AffectedRowsOutput;
  deleteManyPushTokens: AffectedRowsOutput;
  deleteManySegmentation: AffectedRowsOutput;
  deleteManyTransporter: AffectedRowsOutput;
  deleteManyTransporterPrice: AffectedRowsOutput;
  deleteManyTransporterZone: AffectedRowsOutput;
  deleteManyUser: AffectedRowsOutput;
  deleteManyUserAddress: AffectedRowsOutput;
  deleteManyUserPrompt: AffectedRowsOutput;
  deleteManyUserRestPassword: AffectedRowsOutput;
  deleteManyUserStory: AffectedRowsOutput;
  deleteManyValidOrderEvidence: AffectedRowsOutput;
  deleteOneActionOrder?: Maybe<ActionOrder>;
  deleteOneAskDeliveryMan?: Maybe<AskDeliveryMan>;
  deleteOneCategory?: Maybe<Category>;
  deleteOneChat?: Maybe<Chat>;
  deleteOneChatMessage?: Maybe<ChatMessage>;
  deleteOneCountry?: Maybe<Country>;
  deleteOneCraftmanWallet?: Maybe<CraftmanWallet>;
  deleteOneEmail?: Maybe<Email>;
  deleteOneExchangeCurrency?: Maybe<ExchangeCurrency>;
  deleteOneFaq?: Maybe<Faq>;
  deleteOneFavorites?: Maybe<Favorites>;
  deleteOneFile?: Maybe<File>;
  deleteOneItemType?: Maybe<ItemType>;
  deleteOneMaterialType?: Maybe<MaterialType>;
  deleteOneNoticeOrder?: Maybe<NoticeOrder>;
  deleteOneNotification?: Maybe<Notification>;
  deleteOneOrder?: Maybe<Order>;
  deleteOneOrderPrice?: Maybe<OrderPrice>;
  deleteOneOrderSize?: Maybe<OrderSize>;
  deleteOnePaimentHistory?: Maybe<PaimentHistory>;
  deleteOnePromptEngineer?: Maybe<PromptEngineer>;
  deleteOnePushTokens?: Maybe<PushTokens>;
  deleteOneSegmentation?: Maybe<Segmentation>;
  deleteOneTransporter?: Maybe<Transporter>;
  deleteOneTransporterPrice?: Maybe<TransporterPrice>;
  deleteOneTransporterZone?: Maybe<TransporterZone>;
  deleteOneUser?: Maybe<User>;
  deleteOneUserAddress?: Maybe<UserAddress>;
  deleteOneUserPrompt?: Maybe<UserPrompt>;
  deleteOneUserRestPassword?: Maybe<UserRestPassword>;
  deleteOneUserStory?: Maybe<UserStory>;
  deleteOneValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  editContentMessage: ChatMessage;
  generateImages: UserPrompt;
  incrementCraftmanView: User;
  login: AuthPayload;
  noticeOrder: Order;
  notifyAdminForSubcription: Scalars['Boolean']['output'];
  relaunchOrder: Scalars['Float']['output'];
  sendAnonymousEmail: Scalars['Int']['output'];
  sendEmail: Scalars['Int']['output'];
  sendEmailMessagePending: Scalars['Boolean']['output'];
  sendEmailValidOrderDelivery: Scalars['Boolean']['output'];
  sendNewMessage: ChatMessage;
  signupUser: AuthPayload;
  socialCraftman: AuthPayload;
  socialCustomer: AuthPayload;
  toggleFavoris?: Maybe<Favorites>;
  toogleArchiveOrder: Order;
  toogleFavoris?: Maybe<Favorites>;
  updateCustomerOrder: Order;
  updateManyActionOrder: AffectedRowsOutput;
  updateManyAskDeliveryMan: AffectedRowsOutput;
  updateManyCategory: AffectedRowsOutput;
  updateManyChat: AffectedRowsOutput;
  updateManyChatMessage: AffectedRowsOutput;
  updateManyCountry: AffectedRowsOutput;
  updateManyCraftmanWallet: AffectedRowsOutput;
  updateManyEmail: AffectedRowsOutput;
  updateManyExchangeCurrency: AffectedRowsOutput;
  updateManyFaq: AffectedRowsOutput;
  updateManyFavorites: AffectedRowsOutput;
  updateManyFile: AffectedRowsOutput;
  updateManyItemType: AffectedRowsOutput;
  updateManyMaterialType: AffectedRowsOutput;
  updateManyNoticeOrder: AffectedRowsOutput;
  updateManyNotification: AffectedRowsOutput;
  updateManyOrder: AffectedRowsOutput;
  updateManyOrderPrice: AffectedRowsOutput;
  updateManyOrderSize: AffectedRowsOutput;
  updateManyPaimentHistory: AffectedRowsOutput;
  updateManyPromptEngineer: AffectedRowsOutput;
  updateManyPushTokens: AffectedRowsOutput;
  updateManySegmentation: AffectedRowsOutput;
  updateManyTransporter: AffectedRowsOutput;
  updateManyTransporterPrice: AffectedRowsOutput;
  updateManyTransporterZone: AffectedRowsOutput;
  updateManyUser: AffectedRowsOutput;
  updateManyUserAddress: AffectedRowsOutput;
  updateManyUserPrompt: AffectedRowsOutput;
  updateManyUserRestPassword: AffectedRowsOutput;
  updateManyUserStory: AffectedRowsOutput;
  updateManyValidOrderEvidence: AffectedRowsOutput;
  updateOneActionOrder?: Maybe<ActionOrder>;
  updateOneAskDeliveryMan?: Maybe<AskDeliveryMan>;
  updateOneCategory?: Maybe<Category>;
  updateOneChat?: Maybe<Chat>;
  updateOneChatMessage?: Maybe<ChatMessage>;
  updateOneCountry?: Maybe<Country>;
  updateOneCraftmanWallet?: Maybe<CraftmanWallet>;
  updateOneEmail?: Maybe<Email>;
  updateOneExchangeCurrency?: Maybe<ExchangeCurrency>;
  updateOneFaq?: Maybe<Faq>;
  updateOneFavorites?: Maybe<Favorites>;
  updateOneFile?: Maybe<File>;
  updateOneItemType?: Maybe<ItemType>;
  updateOneMaterialType?: Maybe<MaterialType>;
  updateOneNoticeOrder?: Maybe<NoticeOrder>;
  updateOneNotification?: Maybe<Notification>;
  updateOneOrder?: Maybe<Order>;
  updateOneOrderPrice?: Maybe<OrderPrice>;
  updateOneOrderSize?: Maybe<OrderSize>;
  updateOnePaimentHistory?: Maybe<PaimentHistory>;
  updateOnePromptEngineer?: Maybe<PromptEngineer>;
  updateOnePushTokens?: Maybe<PushTokens>;
  updateOneSegmentation?: Maybe<Segmentation>;
  updateOneTransporter?: Maybe<Transporter>;
  updateOneTransporterPrice?: Maybe<TransporterPrice>;
  updateOneTransporterZone?: Maybe<TransporterZone>;
  updateOneUser?: Maybe<User>;
  updateOneUserAddress?: Maybe<UserAddress>;
  updateOneUserPrompt?: Maybe<UserPrompt>;
  updateOneUserRestPassword?: Maybe<UserRestPassword>;
  updateOneUserStory?: Maybe<UserStory>;
  updateOneValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  updateUserAccount: AuthPayload;
  upsertOneActionOrder: ActionOrder;
  upsertOneAskDeliveryMan: AskDeliveryMan;
  upsertOneCategory: Category;
  upsertOneChat: Chat;
  upsertOneChatMessage: ChatMessage;
  upsertOneCountry: Country;
  upsertOneCraftmanWallet: CraftmanWallet;
  upsertOneEmail: Email;
  upsertOneExchangeCurrency: ExchangeCurrency;
  upsertOneFaq: Faq;
  upsertOneFavorites: Favorites;
  upsertOneFile: File;
  upsertOneItemType: ItemType;
  upsertOneMaterialType: MaterialType;
  upsertOneNoticeOrder: NoticeOrder;
  upsertOneNotification: Notification;
  upsertOneOrder: Order;
  upsertOneOrderPrice: OrderPrice;
  upsertOneOrderSize: OrderSize;
  upsertOnePaimentHistory: PaimentHistory;
  upsertOnePromptEngineer: PromptEngineer;
  upsertOnePushTokens: PushTokens;
  upsertOneSegmentation: Segmentation;
  upsertOneTransporter: Transporter;
  upsertOneTransporterPrice: TransporterPrice;
  upsertOneTransporterZone: TransporterZone;
  upsertOneUser: User;
  upsertOneUserAddress: UserAddress;
  upsertOneUserPrompt: UserPrompt;
  upsertOneUserRestPassword: UserRestPassword;
  upsertOneUserStory: UserStory;
  upsertOneValidOrderEvidence: ValidOrderEvidence;
  validAdviceOrderPrice: ChatMessage;
  validCraftmanPaiment: CraftmanWallet;
  validOrderDelivry: Order;
  validOrderDelivryByCustomer: ChatMessage;
  validOrderPaiment: Order;
  verifyCodeAndChangePassword: AuthPayload;
};


export type MutationAddOrderDealineArgs = {
  chatId: Scalars['Float']['input'];
  deadline: Scalars['DateTimeISO']['input'];
  orderId: Scalars['Float']['input'];
  receiverId: Scalars['Float']['input'];
};


export type MutationAdviceNewOrderPriceArgs = {
  chatId: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  receiverId: Scalars['Float']['input'];
};


export type MutationAskDeliveryManArgs = {
  address: Scalars['String']['input'];
  chatId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  customerId: Scalars['Float']['input'];
  delivryDate: Scalars['DateTimeISO']['input'];
  orderId: Scalars['Float']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photos: Array<NewFileInput>;
};


export type MutationAskPaymentArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  rib?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletType: WalletType;
};


export type MutationAskResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationChangeActiveAdressArgs = {
  userAdressId: Scalars['Float']['input'];
};


export type MutationCreateCraftmanWalletArgs = {
  action: ActionTransaction;
  craftmanId: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};


export type MutationCreateManyActionOrderArgs = {
  data: Array<ActionOrderCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyAskDeliveryManArgs = {
  data: Array<AskDeliveryManCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyCategoryArgs = {
  data: Array<CategoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyChatArgs = {
  data: Array<ChatCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyChatMessageArgs = {
  data: Array<ChatMessageCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyCountryArgs = {
  data: Array<CountryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyCraftmanWalletArgs = {
  data: Array<CraftmanWalletCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyEmailArgs = {
  data: Array<EmailCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyExchangeCurrencyArgs = {
  data: Array<ExchangeCurrencyCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyFaqArgs = {
  data: Array<FaqCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyFavoritesArgs = {
  data: Array<FavoritesCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyFileArgs = {
  data: Array<FileCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyItemTypeArgs = {
  data: Array<ItemTypeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyMaterialTypeArgs = {
  data: Array<MaterialTypeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyNoticeOrderArgs = {
  data: Array<NoticeOrderCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyNotificationArgs = {
  data: Array<NotificationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyOrderArgs = {
  data: Array<OrderCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyOrderPriceArgs = {
  data: Array<OrderPriceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyOrderSizeArgs = {
  data: Array<OrderSizeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyPaimentHistoryArgs = {
  data: Array<PaimentHistoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyPromptEngineerArgs = {
  data: Array<PromptEngineerCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyPushTokensArgs = {
  data: Array<PushTokensCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManySegmentationArgs = {
  data: Array<SegmentationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyTransporterArgs = {
  data: Array<TransporterCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyTransporterPriceArgs = {
  data: Array<TransporterPriceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyTransporterZoneArgs = {
  data: Array<TransporterZoneCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserArgs = {
  data: Array<UserCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserAddressArgs = {
  data: Array<UserAddressCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserPromptArgs = {
  data: Array<UserPromptCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserRestPasswordArgs = {
  data: Array<UserRestPasswordCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserStoryArgs = {
  data: Array<UserStoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyValidOrderEvidenceArgs = {
  data: Array<ValidOrderEvidenceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateNewAdressArgs = {
  data: CreateNewAdressInput;
};


export type MutationCreateNewOrderArgs = {
  categoryId: Scalars['Float']['input'];
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['Float']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  imageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemId: Scalars['Float']['input'];
  materialId: Scalars['Float']['input'];
  message: Scalars['String']['input'];
  photos: Array<NewFileInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateNewOrderSizeArgs = {
  chatId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  other?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOneActionOrderArgs = {
  data: ActionOrderCreateInput;
};


export type MutationCreateOneAskDeliveryManArgs = {
  data: AskDeliveryManCreateInput;
};


export type MutationCreateOneCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateOneChatArgs = {
  data: ChatCreateInput;
};


export type MutationCreateOneChatMessageArgs = {
  data: ChatMessageCreateInput;
};


export type MutationCreateOneCountryArgs = {
  data: CountryCreateInput;
};


export type MutationCreateOneCraftmanWalletArgs = {
  data: CraftmanWalletCreateInput;
};


export type MutationCreateOneEmailArgs = {
  data: EmailCreateInput;
};


export type MutationCreateOneExchangeCurrencyArgs = {
  data: ExchangeCurrencyCreateInput;
};


export type MutationCreateOneFaqArgs = {
  data: FaqCreateInput;
};


export type MutationCreateOneFavoritesArgs = {
  data: FavoritesCreateInput;
};


export type MutationCreateOneFileArgs = {
  data: FileCreateInput;
};


export type MutationCreateOneItemTypeArgs = {
  data: ItemTypeCreateInput;
};


export type MutationCreateOneMaterialTypeArgs = {
  data: MaterialTypeCreateInput;
};


export type MutationCreateOneNoticeOrderArgs = {
  data: NoticeOrderCreateInput;
};


export type MutationCreateOneNotificationArgs = {
  data: NotificationCreateInput;
};


export type MutationCreateOneOrderArgs = {
  data: OrderCreateInput;
};


export type MutationCreateOneOrderPriceArgs = {
  data: OrderPriceCreateInput;
};


export type MutationCreateOneOrderSizeArgs = {
  data: OrderSizeCreateInput;
};


export type MutationCreateOnePaimentHistoryArgs = {
  data: PaimentHistoryCreateInput;
};


export type MutationCreateOnePromptEngineerArgs = {
  data: PromptEngineerCreateInput;
};


export type MutationCreateOnePushTokensArgs = {
  data: PushTokensCreateInput;
};


export type MutationCreateOneSegmentationArgs = {
  data: SegmentationCreateInput;
};


export type MutationCreateOneTransporterArgs = {
  data: TransporterCreateInput;
};


export type MutationCreateOneTransporterPriceArgs = {
  data: TransporterPriceCreateInput;
};


export type MutationCreateOneTransporterZoneArgs = {
  data: TransporterZoneCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneUserAddressArgs = {
  data: UserAddressCreateInput;
};


export type MutationCreateOneUserPromptArgs = {
  data: UserPromptCreateInput;
};


export type MutationCreateOneUserRestPasswordArgs = {
  data: UserRestPasswordCreateInput;
};


export type MutationCreateOneUserStoryArgs = {
  data: UserStoryCreateInput;
};


export type MutationCreateOneValidOrderEvidenceArgs = {
  data: ValidOrderEvidenceCreateInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  amount: Scalars['String']['input'];
  cancelUrl: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  isFromBO: Scalars['Boolean']['input'];
  isWeb: Scalars['Boolean']['input'];
  orderId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  tokenCeedow: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateStripePaymentIntentArgs = {
  amount: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  isFromBO: Scalars['Boolean']['input'];
  isWeb: Scalars['Boolean']['input'];
  orderId: Scalars['String']['input'];
  tokenCeedow: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateUserStoryArgs = {
  duration: Scalars['Int']['input'];
  file: NewFileInput;
};


export type MutationDeleteManyActionOrderArgs = {
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type MutationDeleteManyAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type MutationDeleteManyCategoryArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type MutationDeleteManyChatArgs = {
  where?: InputMaybe<ChatWhereInput>;
};


export type MutationDeleteManyChatMessageArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type MutationDeleteManyCountryArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type MutationDeleteManyCraftmanWalletArgs = {
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type MutationDeleteManyEmailArgs = {
  where?: InputMaybe<EmailWhereInput>;
};


export type MutationDeleteManyExchangeCurrencyArgs = {
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type MutationDeleteManyFaqArgs = {
  where?: InputMaybe<FaqWhereInput>;
};


export type MutationDeleteManyFavoritesArgs = {
  where?: InputMaybe<FavoritesWhereInput>;
};


export type MutationDeleteManyFileArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type MutationDeleteManyItemTypeArgs = {
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type MutationDeleteManyMaterialTypeArgs = {
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type MutationDeleteManyNoticeOrderArgs = {
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type MutationDeleteManyNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type MutationDeleteManyOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationDeleteManyOrderPriceArgs = {
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type MutationDeleteManyOrderSizeArgs = {
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type MutationDeleteManyPaimentHistoryArgs = {
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type MutationDeleteManyPromptEngineerArgs = {
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type MutationDeleteManyPushTokensArgs = {
  where?: InputMaybe<PushTokensWhereInput>;
};


export type MutationDeleteManySegmentationArgs = {
  where?: InputMaybe<SegmentationWhereInput>;
};


export type MutationDeleteManyTransporterArgs = {
  where?: InputMaybe<TransporterWhereInput>;
};


export type MutationDeleteManyTransporterPriceArgs = {
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type MutationDeleteManyTransporterZoneArgs = {
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MutationDeleteManyUserAddressArgs = {
  where?: InputMaybe<UserAddressWhereInput>;
};


export type MutationDeleteManyUserPromptArgs = {
  where?: InputMaybe<UserPromptWhereInput>;
};


export type MutationDeleteManyUserRestPasswordArgs = {
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type MutationDeleteManyUserStoryArgs = {
  where?: InputMaybe<UserStoryWhereInput>;
};


export type MutationDeleteManyValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type MutationDeleteOneActionOrderArgs = {
  where: ActionOrderWhereUniqueInput;
};


export type MutationDeleteOneAskDeliveryManArgs = {
  where: AskDeliveryManWhereUniqueInput;
};


export type MutationDeleteOneCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteOneChatArgs = {
  where: ChatWhereUniqueInput;
};


export type MutationDeleteOneChatMessageArgs = {
  where: ChatMessageWhereUniqueInput;
};


export type MutationDeleteOneCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type MutationDeleteOneCraftmanWalletArgs = {
  where: CraftmanWalletWhereUniqueInput;
};


export type MutationDeleteOneEmailArgs = {
  where: EmailWhereUniqueInput;
};


export type MutationDeleteOneExchangeCurrencyArgs = {
  where: ExchangeCurrencyWhereUniqueInput;
};


export type MutationDeleteOneFaqArgs = {
  where: FaqWhereUniqueInput;
};


export type MutationDeleteOneFavoritesArgs = {
  where: FavoritesWhereUniqueInput;
};


export type MutationDeleteOneFileArgs = {
  where: FileWhereUniqueInput;
};


export type MutationDeleteOneItemTypeArgs = {
  where: ItemTypeWhereUniqueInput;
};


export type MutationDeleteOneMaterialTypeArgs = {
  where: MaterialTypeWhereUniqueInput;
};


export type MutationDeleteOneNoticeOrderArgs = {
  where: NoticeOrderWhereUniqueInput;
};


export type MutationDeleteOneNotificationArgs = {
  where: NotificationWhereUniqueInput;
};


export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteOneOrderPriceArgs = {
  where: OrderPriceWhereUniqueInput;
};


export type MutationDeleteOneOrderSizeArgs = {
  where: OrderSizeWhereUniqueInput;
};


export type MutationDeleteOnePaimentHistoryArgs = {
  where: PaimentHistoryWhereUniqueInput;
};


export type MutationDeleteOnePromptEngineerArgs = {
  where: PromptEngineerWhereUniqueInput;
};


export type MutationDeleteOnePushTokensArgs = {
  where: PushTokensWhereUniqueInput;
};


export type MutationDeleteOneSegmentationArgs = {
  where: SegmentationWhereUniqueInput;
};


export type MutationDeleteOneTransporterArgs = {
  where: TransporterWhereUniqueInput;
};


export type MutationDeleteOneTransporterPriceArgs = {
  where: TransporterPriceWhereUniqueInput;
};


export type MutationDeleteOneTransporterZoneArgs = {
  where: TransporterZoneWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneUserAddressArgs = {
  where: UserAddressWhereUniqueInput;
};


export type MutationDeleteOneUserPromptArgs = {
  where: UserPromptWhereUniqueInput;
};


export type MutationDeleteOneUserRestPasswordArgs = {
  where: UserRestPasswordWhereUniqueInput;
};


export type MutationDeleteOneUserStoryArgs = {
  where: UserStoryWhereUniqueInput;
};


export type MutationDeleteOneValidOrderEvidenceArgs = {
  where: ValidOrderEvidenceWhereUniqueInput;
};


export type MutationEditContentMessageArgs = {
  chatMessageId: Scalars['Float']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGenerateImagesArgs = {
  prompt: Scalars['String']['input'];
  resultLimit: Scalars['Float']['input'];
};


export type MutationIncrementCraftmanViewArgs = {
  craftmanId: Scalars['Float']['input'];
};


export type MutationLoginArgs = {
  userLoginInput: UserLoginInput;
};


export type MutationNoticeOrderArgs = {
  chatId: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  note: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationNotifyAdminForSubcriptionArgs = {
  isWantSubscribe: Scalars['Boolean']['input'];
};


export type MutationRelaunchOrderArgs = {
  chatId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationSendAnonymousEmailArgs = {
  content: Scalars['String']['input'];
  contentHtml: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationSendEmailArgs = {
  content: Scalars['String']['input'];
  contentHtml: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationSendEmailMessagePendingArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSendEmailValidOrderDeliveryArgs = {
  craftmanId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
};


export type MutationSendNewMessageArgs = {
  chatId: Scalars['Float']['input'];
  content: Scalars['String']['input'];
  imageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  photos: Array<NewFileInput>;
  receiverId: Scalars['Float']['input'];
};


export type MutationSignupUserArgs = {
  signupInput: SignupInput;
};


export type MutationSocialCraftmanArgs = {
  socialCraftmaInput: SocialCraftmaInput;
};


export type MutationSocialCustomerArgs = {
  socialCustomerInput: SocialCustomerInput;
};


export type MutationToggleFavorisArgs = {
  craftmanId: Scalars['Float']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToogleArchiveOrderArgs = {
  id: Scalars['Float']['input'];
  isToogle?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationToogleFavorisArgs = {
  craftmanId: Scalars['Float']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerOrderArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Float']['input']>;
  customerId?: InputMaybe<Scalars['Float']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id: Scalars['Float']['input'];
  itemId?: InputMaybe<Scalars['Float']['input']>;
  materialId?: InputMaybe<Scalars['Float']['input']>;
  photosDeleteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  photosOrders?: InputMaybe<Array<NewFileInput>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateManyActionOrderArgs = {
  data: ActionOrderUpdateManyMutationInput;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type MutationUpdateManyAskDeliveryManArgs = {
  data: AskDeliveryManUpdateManyMutationInput;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type MutationUpdateManyCategoryArgs = {
  data: CategoryUpdateManyMutationInput;
  where?: InputMaybe<CategoryWhereInput>;
};


export type MutationUpdateManyChatArgs = {
  data: ChatUpdateManyMutationInput;
  where?: InputMaybe<ChatWhereInput>;
};


export type MutationUpdateManyChatMessageArgs = {
  data: ChatMessageUpdateManyMutationInput;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type MutationUpdateManyCountryArgs = {
  data: CountryUpdateManyMutationInput;
  where?: InputMaybe<CountryWhereInput>;
};


export type MutationUpdateManyCraftmanWalletArgs = {
  data: CraftmanWalletUpdateManyMutationInput;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type MutationUpdateManyEmailArgs = {
  data: EmailUpdateManyMutationInput;
  where?: InputMaybe<EmailWhereInput>;
};


export type MutationUpdateManyExchangeCurrencyArgs = {
  data: ExchangeCurrencyUpdateManyMutationInput;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type MutationUpdateManyFaqArgs = {
  data: FaqUpdateManyMutationInput;
  where?: InputMaybe<FaqWhereInput>;
};


export type MutationUpdateManyFavoritesArgs = {
  data: FavoritesUpdateManyMutationInput;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type MutationUpdateManyFileArgs = {
  data: FileUpdateManyMutationInput;
  where?: InputMaybe<FileWhereInput>;
};


export type MutationUpdateManyItemTypeArgs = {
  data: ItemTypeUpdateManyMutationInput;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type MutationUpdateManyMaterialTypeArgs = {
  data: MaterialTypeUpdateManyMutationInput;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type MutationUpdateManyNoticeOrderArgs = {
  data: NoticeOrderUpdateManyMutationInput;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type MutationUpdateManyNotificationArgs = {
  data: NotificationUpdateManyMutationInput;
  where?: InputMaybe<NotificationWhereInput>;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateManyOrderPriceArgs = {
  data: OrderPriceUpdateManyMutationInput;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type MutationUpdateManyOrderSizeArgs = {
  data: OrderSizeUpdateManyMutationInput;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type MutationUpdateManyPaimentHistoryArgs = {
  data: PaimentHistoryUpdateManyMutationInput;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type MutationUpdateManyPromptEngineerArgs = {
  data: PromptEngineerUpdateManyMutationInput;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type MutationUpdateManyPushTokensArgs = {
  data: PushTokensUpdateManyMutationInput;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type MutationUpdateManySegmentationArgs = {
  data: SegmentationUpdateManyMutationInput;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type MutationUpdateManyTransporterArgs = {
  data: TransporterUpdateManyMutationInput;
  where?: InputMaybe<TransporterWhereInput>;
};


export type MutationUpdateManyTransporterPriceArgs = {
  data: TransporterPriceUpdateManyMutationInput;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type MutationUpdateManyTransporterZoneArgs = {
  data: TransporterZoneUpdateManyMutationInput;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationUpdateManyUserAddressArgs = {
  data: UserAddressUpdateManyMutationInput;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type MutationUpdateManyUserPromptArgs = {
  data: UserPromptUpdateManyMutationInput;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type MutationUpdateManyUserRestPasswordArgs = {
  data: UserRestPasswordUpdateManyMutationInput;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type MutationUpdateManyUserStoryArgs = {
  data: UserStoryUpdateManyMutationInput;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type MutationUpdateManyValidOrderEvidenceArgs = {
  data: ValidOrderEvidenceUpdateManyMutationInput;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type MutationUpdateOneActionOrderArgs = {
  data: ActionOrderUpdateInput;
  where: ActionOrderWhereUniqueInput;
};


export type MutationUpdateOneAskDeliveryManArgs = {
  data: AskDeliveryManUpdateInput;
  where: AskDeliveryManWhereUniqueInput;
};


export type MutationUpdateOneCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateOneChatArgs = {
  data: ChatUpdateInput;
  where: ChatWhereUniqueInput;
};


export type MutationUpdateOneChatMessageArgs = {
  data: ChatMessageUpdateInput;
  where: ChatMessageWhereUniqueInput;
};


export type MutationUpdateOneCountryArgs = {
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};


export type MutationUpdateOneCraftmanWalletArgs = {
  data: CraftmanWalletUpdateInput;
  where: CraftmanWalletWhereUniqueInput;
};


export type MutationUpdateOneEmailArgs = {
  data: EmailUpdateInput;
  where: EmailWhereUniqueInput;
};


export type MutationUpdateOneExchangeCurrencyArgs = {
  data: ExchangeCurrencyUpdateInput;
  where: ExchangeCurrencyWhereUniqueInput;
};


export type MutationUpdateOneFaqArgs = {
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};


export type MutationUpdateOneFavoritesArgs = {
  data: FavoritesUpdateInput;
  where: FavoritesWhereUniqueInput;
};


export type MutationUpdateOneFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateOneItemTypeArgs = {
  data: ItemTypeUpdateInput;
  where: ItemTypeWhereUniqueInput;
};


export type MutationUpdateOneMaterialTypeArgs = {
  data: MaterialTypeUpdateInput;
  where: MaterialTypeWhereUniqueInput;
};


export type MutationUpdateOneNoticeOrderArgs = {
  data: NoticeOrderUpdateInput;
  where: NoticeOrderWhereUniqueInput;
};


export type MutationUpdateOneNotificationArgs = {
  data: NotificationUpdateInput;
  where: NotificationWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOneOrderPriceArgs = {
  data: OrderPriceUpdateInput;
  where: OrderPriceWhereUniqueInput;
};


export type MutationUpdateOneOrderSizeArgs = {
  data: OrderSizeUpdateInput;
  where: OrderSizeWhereUniqueInput;
};


export type MutationUpdateOnePaimentHistoryArgs = {
  data: PaimentHistoryUpdateInput;
  where: PaimentHistoryWhereUniqueInput;
};


export type MutationUpdateOnePromptEngineerArgs = {
  data: PromptEngineerUpdateInput;
  where: PromptEngineerWhereUniqueInput;
};


export type MutationUpdateOnePushTokensArgs = {
  data: PushTokensUpdateInput;
  where: PushTokensWhereUniqueInput;
};


export type MutationUpdateOneSegmentationArgs = {
  data: SegmentationUpdateInput;
  where: SegmentationWhereUniqueInput;
};


export type MutationUpdateOneTransporterArgs = {
  data: TransporterUpdateInput;
  where: TransporterWhereUniqueInput;
};


export type MutationUpdateOneTransporterPriceArgs = {
  data: TransporterPriceUpdateInput;
  where: TransporterPriceWhereUniqueInput;
};


export type MutationUpdateOneTransporterZoneArgs = {
  data: TransporterZoneUpdateInput;
  where: TransporterZoneWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneUserAddressArgs = {
  data: UserAddressUpdateInput;
  where: UserAddressWhereUniqueInput;
};


export type MutationUpdateOneUserPromptArgs = {
  data: UserPromptUpdateInput;
  where: UserPromptWhereUniqueInput;
};


export type MutationUpdateOneUserRestPasswordArgs = {
  data: UserRestPasswordUpdateInput;
  where: UserRestPasswordWhereUniqueInput;
};


export type MutationUpdateOneUserStoryArgs = {
  data: UserStoryUpdateInput;
  where: UserStoryWhereUniqueInput;
};


export type MutationUpdateOneValidOrderEvidenceArgs = {
  data: ValidOrderEvidenceUpdateInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};


export type MutationUpdateUserAccountArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpsertOneActionOrderArgs = {
  create: ActionOrderCreateInput;
  update: ActionOrderUpdateInput;
  where: ActionOrderWhereUniqueInput;
};


export type MutationUpsertOneAskDeliveryManArgs = {
  create: AskDeliveryManCreateInput;
  update: AskDeliveryManUpdateInput;
  where: AskDeliveryManWhereUniqueInput;
};


export type MutationUpsertOneCategoryArgs = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertOneChatArgs = {
  create: ChatCreateInput;
  update: ChatUpdateInput;
  where: ChatWhereUniqueInput;
};


export type MutationUpsertOneChatMessageArgs = {
  create: ChatMessageCreateInput;
  update: ChatMessageUpdateInput;
  where: ChatMessageWhereUniqueInput;
};


export type MutationUpsertOneCountryArgs = {
  create: CountryCreateInput;
  update: CountryUpdateInput;
  where: CountryWhereUniqueInput;
};


export type MutationUpsertOneCraftmanWalletArgs = {
  create: CraftmanWalletCreateInput;
  update: CraftmanWalletUpdateInput;
  where: CraftmanWalletWhereUniqueInput;
};


export type MutationUpsertOneEmailArgs = {
  create: EmailCreateInput;
  update: EmailUpdateInput;
  where: EmailWhereUniqueInput;
};


export type MutationUpsertOneExchangeCurrencyArgs = {
  create: ExchangeCurrencyCreateInput;
  update: ExchangeCurrencyUpdateInput;
  where: ExchangeCurrencyWhereUniqueInput;
};


export type MutationUpsertOneFaqArgs = {
  create: FaqCreateInput;
  update: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};


export type MutationUpsertOneFavoritesArgs = {
  create: FavoritesCreateInput;
  update: FavoritesUpdateInput;
  where: FavoritesWhereUniqueInput;
};


export type MutationUpsertOneFileArgs = {
  create: FileCreateInput;
  update: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpsertOneItemTypeArgs = {
  create: ItemTypeCreateInput;
  update: ItemTypeUpdateInput;
  where: ItemTypeWhereUniqueInput;
};


export type MutationUpsertOneMaterialTypeArgs = {
  create: MaterialTypeCreateInput;
  update: MaterialTypeUpdateInput;
  where: MaterialTypeWhereUniqueInput;
};


export type MutationUpsertOneNoticeOrderArgs = {
  create: NoticeOrderCreateInput;
  update: NoticeOrderUpdateInput;
  where: NoticeOrderWhereUniqueInput;
};


export type MutationUpsertOneNotificationArgs = {
  create: NotificationCreateInput;
  update: NotificationUpdateInput;
  where: NotificationWhereUniqueInput;
};


export type MutationUpsertOneOrderArgs = {
  create: OrderCreateInput;
  update: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpsertOneOrderPriceArgs = {
  create: OrderPriceCreateInput;
  update: OrderPriceUpdateInput;
  where: OrderPriceWhereUniqueInput;
};


export type MutationUpsertOneOrderSizeArgs = {
  create: OrderSizeCreateInput;
  update: OrderSizeUpdateInput;
  where: OrderSizeWhereUniqueInput;
};


export type MutationUpsertOnePaimentHistoryArgs = {
  create: PaimentHistoryCreateInput;
  update: PaimentHistoryUpdateInput;
  where: PaimentHistoryWhereUniqueInput;
};


export type MutationUpsertOnePromptEngineerArgs = {
  create: PromptEngineerCreateInput;
  update: PromptEngineerUpdateInput;
  where: PromptEngineerWhereUniqueInput;
};


export type MutationUpsertOnePushTokensArgs = {
  create: PushTokensCreateInput;
  update: PushTokensUpdateInput;
  where: PushTokensWhereUniqueInput;
};


export type MutationUpsertOneSegmentationArgs = {
  create: SegmentationCreateInput;
  update: SegmentationUpdateInput;
  where: SegmentationWhereUniqueInput;
};


export type MutationUpsertOneTransporterArgs = {
  create: TransporterCreateInput;
  update: TransporterUpdateInput;
  where: TransporterWhereUniqueInput;
};


export type MutationUpsertOneTransporterPriceArgs = {
  create: TransporterPriceCreateInput;
  update: TransporterPriceUpdateInput;
  where: TransporterPriceWhereUniqueInput;
};


export type MutationUpsertOneTransporterZoneArgs = {
  create: TransporterZoneCreateInput;
  update: TransporterZoneUpdateInput;
  where: TransporterZoneWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneUserAddressArgs = {
  create: UserAddressCreateInput;
  update: UserAddressUpdateInput;
  where: UserAddressWhereUniqueInput;
};


export type MutationUpsertOneUserPromptArgs = {
  create: UserPromptCreateInput;
  update: UserPromptUpdateInput;
  where: UserPromptWhereUniqueInput;
};


export type MutationUpsertOneUserRestPasswordArgs = {
  create: UserRestPasswordCreateInput;
  update: UserRestPasswordUpdateInput;
  where: UserRestPasswordWhereUniqueInput;
};


export type MutationUpsertOneUserStoryArgs = {
  create: UserStoryCreateInput;
  update: UserStoryUpdateInput;
  where: UserStoryWhereUniqueInput;
};


export type MutationUpsertOneValidOrderEvidenceArgs = {
  create: ValidOrderEvidenceCreateInput;
  update: ValidOrderEvidenceUpdateInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};


export type MutationValidAdviceOrderPriceArgs = {
  chatId: Scalars['Float']['input'];
  orderPriceId: Scalars['Float']['input'];
  receiverId: Scalars['Float']['input'];
};


export type MutationValidCraftmanPaimentArgs = {
  craftmanId: Scalars['Float']['input'];
  paimentId: Scalars['Float']['input'];
};


export type MutationValidOrderDelivryArgs = {
  orderId: Scalars['Float']['input'];
};


export type MutationValidOrderDelivryByCustomerArgs = {
  chatId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  customerId: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
  photos: Array<NewFileInput>;
};


export type MutationValidOrderPaimentArgs = {
  chatId: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
};


export type MutationVerifyCodeAndChangePasswordArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedEnumActionFilter = {
  equals?: InputMaybe<Action>;
  in?: InputMaybe<Array<Action>>;
  not?: InputMaybe<NestedEnumActionFilter>;
  notIn?: InputMaybe<Array<Action>>;
};

export type NestedEnumActionTransactionFilter = {
  equals?: InputMaybe<ActionTransaction>;
  in?: InputMaybe<Array<ActionTransaction>>;
  not?: InputMaybe<NestedEnumActionTransactionFilter>;
  notIn?: InputMaybe<Array<ActionTransaction>>;
};

export type NestedEnumActionTransactionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionTransactionFilter>;
  _min?: InputMaybe<NestedEnumActionTransactionFilter>;
  equals?: InputMaybe<ActionTransaction>;
  in?: InputMaybe<Array<ActionTransaction>>;
  not?: InputMaybe<NestedEnumActionTransactionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ActionTransaction>>;
};

export type NestedEnumActionWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumActionFilter>;
  _min?: InputMaybe<NestedEnumActionFilter>;
  equals?: InputMaybe<Action>;
  in?: InputMaybe<Array<Action>>;
  not?: InputMaybe<NestedEnumActionWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Action>>;
};

export type NestedEnumContentMessageTypeNullableFilter = {
  equals?: InputMaybe<ContentMessageType>;
  in?: InputMaybe<Array<ContentMessageType>>;
  not?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  notIn?: InputMaybe<Array<ContentMessageType>>;
};

export type NestedEnumContentMessageTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumContentMessageTypeNullableFilter>;
  equals?: InputMaybe<ContentMessageType>;
  in?: InputMaybe<Array<ContentMessageType>>;
  not?: InputMaybe<NestedEnumContentMessageTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ContentMessageType>>;
};

export type NestedEnumNotificationDataTypeFilter = {
  equals?: InputMaybe<NotificationDataType>;
  in?: InputMaybe<Array<NotificationDataType>>;
  not?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  notIn?: InputMaybe<Array<NotificationDataType>>;
};

export type NestedEnumNotificationDataTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  _min?: InputMaybe<NestedEnumNotificationDataTypeFilter>;
  equals?: InputMaybe<NotificationDataType>;
  in?: InputMaybe<Array<NotificationDataType>>;
  not?: InputMaybe<NestedEnumNotificationDataTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<NotificationDataType>>;
};

export type NestedEnumPaimentStatusFilter = {
  equals?: InputMaybe<PaimentStatus>;
  in?: InputMaybe<Array<PaimentStatus>>;
  not?: InputMaybe<NestedEnumPaimentStatusFilter>;
  notIn?: InputMaybe<Array<PaimentStatus>>;
};

export type NestedEnumPaimentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaimentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaimentStatusFilter>;
  equals?: InputMaybe<PaimentStatus>;
  in?: InputMaybe<Array<PaimentStatus>>;
  not?: InputMaybe<NestedEnumPaimentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaimentStatus>>;
};

export type NestedEnumPlatformFilter = {
  equals?: InputMaybe<Platform>;
  in?: InputMaybe<Array<Platform>>;
  not?: InputMaybe<NestedEnumPlatformFilter>;
  notIn?: InputMaybe<Array<Platform>>;
};

export type NestedEnumPlatformWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPlatformFilter>;
  _min?: InputMaybe<NestedEnumPlatformFilter>;
  equals?: InputMaybe<Platform>;
  in?: InputMaybe<Array<Platform>>;
  not?: InputMaybe<NestedEnumPlatformWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Platform>>;
};

export type NestedEnumPromptTargetFilter = {
  equals?: InputMaybe<PromptTarget>;
  in?: InputMaybe<Array<PromptTarget>>;
  not?: InputMaybe<NestedEnumPromptTargetFilter>;
  notIn?: InputMaybe<Array<PromptTarget>>;
};

export type NestedEnumPromptTargetWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPromptTargetFilter>;
  _min?: InputMaybe<NestedEnumPromptTargetFilter>;
  equals?: InputMaybe<PromptTarget>;
  in?: InputMaybe<Array<PromptTarget>>;
  not?: InputMaybe<NestedEnumPromptTargetWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PromptTarget>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumStatusFilter = {
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type NestedEnumStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStatusFilter>;
  _min?: InputMaybe<NestedEnumStatusFilter>;
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type NestedEnumWalletTypeFilter = {
  equals?: InputMaybe<WalletType>;
  in?: InputMaybe<Array<WalletType>>;
  not?: InputMaybe<NestedEnumWalletTypeFilter>;
  notIn?: InputMaybe<Array<WalletType>>;
};

export type NestedEnumWalletTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumWalletTypeFilter>;
  _min?: InputMaybe<NestedEnumWalletTypeFilter>;
  equals?: InputMaybe<WalletType>;
  in?: InputMaybe<Array<WalletType>>;
  not?: InputMaybe<NestedEnumWalletTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WalletType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NewFileInput = {
  chatMessageId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NoticeOrder = {
  __typename?: 'NoticeOrder';
  Customer: User;
  Order: Order;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type NoticeOrderAvgAggregate = {
  __typename?: 'NoticeOrderAvgAggregate';
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type NoticeOrderAvgOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type NoticeOrderCountAggregate = {
  __typename?: 'NoticeOrderCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type NoticeOrderCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NoticeOrderCreateInput = {
  Customer: UserCreateNestedOneWithoutNoticeOrdersInput;
  Order: OrderCreateNestedOneWithoutNoticeOrdersInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderCreateManyCustomerInputEnvelope = {
  data: Array<NoticeOrderCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoticeOrderCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderCreateManyOrderInputEnvelope = {
  data: Array<NoticeOrderCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoticeOrderCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoticeOrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<NoticeOrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<NoticeOrderCreateManyCustomerInputEnvelope>;
};

export type NoticeOrderCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoticeOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<NoticeOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<NoticeOrderCreateManyOrderInputEnvelope>;
};

export type NoticeOrderCreateOrConnectWithoutCustomerInput = {
  create: NoticeOrderCreateWithoutCustomerInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderCreateOrConnectWithoutOrderInput = {
  create: NoticeOrderCreateWithoutOrderInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderCreateWithoutCustomerInput = {
  Order: OrderCreateNestedOneWithoutNoticeOrdersInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderCreateWithoutOrderInput = {
  Customer: UserCreateNestedOneWithoutNoticeOrdersInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NoticeOrderGroupBy = {
  __typename?: 'NoticeOrderGroupBy';
  _avg?: Maybe<NoticeOrderAvgAggregate>;
  _count?: Maybe<NoticeOrderCountAggregate>;
  _max?: Maybe<NoticeOrderMaxAggregate>;
  _min?: Maybe<NoticeOrderMinAggregate>;
  _sum?: Maybe<NoticeOrderSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type NoticeOrderListRelationFilter = {
  every?: InputMaybe<NoticeOrderWhereInput>;
  none?: InputMaybe<NoticeOrderWhereInput>;
  some?: InputMaybe<NoticeOrderWhereInput>;
};

export type NoticeOrderMaxAggregate = {
  __typename?: 'NoticeOrderMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type NoticeOrderMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NoticeOrderMinAggregate = {
  __typename?: 'NoticeOrderMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type NoticeOrderMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NoticeOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum NoticeOrderOrderByRelevanceFieldEnum {
  Description = 'description'
}

export type NoticeOrderOrderByRelevanceInput = {
  fields: Array<NoticeOrderOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type NoticeOrderOrderByWithAggregationInput = {
  _avg?: InputMaybe<NoticeOrderAvgOrderByAggregateInput>;
  _count?: InputMaybe<NoticeOrderCountOrderByAggregateInput>;
  _max?: InputMaybe<NoticeOrderMaxOrderByAggregateInput>;
  _min?: InputMaybe<NoticeOrderMinOrderByAggregateInput>;
  _sum?: InputMaybe<NoticeOrderSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NoticeOrderOrderByWithRelationAndSearchRelevanceInput = {
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<NoticeOrderOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum NoticeOrderScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Description = 'description',
  Id = 'id',
  Note = 'note',
  OrderId = 'orderId',
  UpdatedAt = 'updatedAt'
}

export type NoticeOrderScalarWhereInput = {
  AND?: InputMaybe<Array<NoticeOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<NoticeOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<NoticeOrderScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  note?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NoticeOrderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<NoticeOrderScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<NoticeOrderScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<NoticeOrderScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  note?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type NoticeOrderSumAggregate = {
  __typename?: 'NoticeOrderSumAggregate';
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type NoticeOrderSumOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  note?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type NoticeOrderUpdateInput = {
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutNoticeOrdersNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutNoticeOrdersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NoticeOrderUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NoticeOrderUpdateManyWithWhereWithoutCustomerInput = {
  data: NoticeOrderUpdateManyMutationInput;
  where: NoticeOrderScalarWhereInput;
};

export type NoticeOrderUpdateManyWithWhereWithoutOrderInput = {
  data: NoticeOrderUpdateManyMutationInput;
  where: NoticeOrderScalarWhereInput;
};

export type NoticeOrderUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoticeOrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<NoticeOrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<NoticeOrderCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NoticeOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<NoticeOrderUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<NoticeOrderUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<NoticeOrderUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type NoticeOrderUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoticeOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<NoticeOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<NoticeOrderCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NoticeOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<NoticeOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<NoticeOrderUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<NoticeOrderUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<NoticeOrderUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type NoticeOrderUpdateWithWhereUniqueWithoutCustomerInput = {
  data: NoticeOrderUpdateWithoutCustomerInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderUpdateWithWhereUniqueWithoutOrderInput = {
  data: NoticeOrderUpdateWithoutOrderInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderUpdateWithoutCustomerInput = {
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutNoticeOrdersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NoticeOrderUpdateWithoutOrderInput = {
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutNoticeOrdersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  note?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NoticeOrderUpsertWithWhereUniqueWithoutCustomerInput = {
  create: NoticeOrderCreateWithoutCustomerInput;
  update: NoticeOrderUpdateWithoutCustomerInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderUpsertWithWhereUniqueWithoutOrderInput = {
  create: NoticeOrderCreateWithoutOrderInput;
  update: NoticeOrderUpdateWithoutOrderInput;
  where: NoticeOrderWhereUniqueInput;
};

export type NoticeOrderWhereInput = {
  AND?: InputMaybe<Array<NoticeOrderWhereInput>>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<NoticeOrderWhereInput>>;
  OR?: InputMaybe<Array<NoticeOrderWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  note?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NoticeOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<NoticeOrderWhereInput>>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<NoticeOrderWhereInput>>;
  OR?: InputMaybe<Array<NoticeOrderWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Notification = {
  __typename?: 'Notification';
  Receiver: User;
  body_en: Scalars['String']['output'];
  body_fr: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  read: Scalars['Boolean']['output'];
  receiverId: Scalars['Int']['output'];
  title_en: Scalars['String']['output'];
  title_fr: Scalars['String']['output'];
  type: NotificationDataType;
};

export type NotificationAvgAggregate = {
  __typename?: 'NotificationAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  receiverId?: Maybe<Scalars['Float']['output']>;
};

export type NotificationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
};

export type NotificationCountAggregate = {
  __typename?: 'NotificationCountAggregate';
  _all: Scalars['Int']['output'];
  body_en: Scalars['Int']['output'];
  body_fr: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  read: Scalars['Int']['output'];
  receiverId: Scalars['Int']['output'];
  title_en: Scalars['Int']['output'];
  title_fr: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type NotificationCountOrderByAggregateInput = {
  body_en?: InputMaybe<SortOrder>;
  body_fr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationCreateInput = {
  Receiver: UserCreateNestedOneWithoutNotificationsInput;
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_fr?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  title_fr?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDataType;
};

export type NotificationCreateManyInput = {
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_fr?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  receiverId: Scalars['Int']['input'];
  title_en?: InputMaybe<Scalars['String']['input']>;
  title_fr?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDataType;
};

export type NotificationCreateManyReceiverInput = {
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_fr?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  title_fr?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDataType;
};

export type NotificationCreateManyReceiverInputEnvelope = {
  data: Array<NotificationCreateManyReceiverInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateNestedManyWithoutReceiverInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutReceiverInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutReceiverInput>>;
  createMany?: InputMaybe<NotificationCreateManyReceiverInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutReceiverInput = {
  create: NotificationCreateWithoutReceiverInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutReceiverInput = {
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_fr?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  title_fr?: InputMaybe<Scalars['String']['input']>;
  type: NotificationDataType;
};

export enum NotificationDataType {
  Askcraftmanpayment = 'ASKCRAFTMANPAYMENT',
  Askdelivryman = 'ASKDELIVRYMAN',
  Chatmessage = 'CHATMESSAGE',
  Newcraftman = 'NEWCRAFTMAN',
  Newcustomer = 'NEWCUSTOMER',
  Newfavorite = 'NEWFAVORITE',
  Offer = 'OFFER',
  Order = 'ORDER',
  Ordernotice = 'ORDERNOTICE',
  User = 'USER'
}

export type NotificationGroupBy = {
  __typename?: 'NotificationGroupBy';
  _avg?: Maybe<NotificationAvgAggregate>;
  _count?: Maybe<NotificationCountAggregate>;
  _max?: Maybe<NotificationMaxAggregate>;
  _min?: Maybe<NotificationMinAggregate>;
  _sum?: Maybe<NotificationSumAggregate>;
  body_en: Scalars['String']['output'];
  body_fr: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  read: Scalars['Boolean']['output'];
  receiverId: Scalars['Int']['output'];
  title_en: Scalars['String']['output'];
  title_fr: Scalars['String']['output'];
  type: NotificationDataType;
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationMaxAggregate = {
  __typename?: 'NotificationMaxAggregate';
  body_en?: Maybe<Scalars['String']['output']>;
  body_fr?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  title_fr?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationDataType>;
};

export type NotificationMaxOrderByAggregateInput = {
  body_en?: InputMaybe<SortOrder>;
  body_fr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationMinAggregate = {
  __typename?: 'NotificationMinAggregate';
  body_en?: Maybe<Scalars['String']['output']>;
  body_fr?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  title_fr?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NotificationDataType>;
};

export type NotificationMinOrderByAggregateInput = {
  body_en?: InputMaybe<SortOrder>;
  body_fr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum NotificationOrderByRelevanceFieldEnum {
  BodyEn = 'body_en',
  BodyFr = 'body_fr',
  TitleEn = 'title_en',
  TitleFr = 'title_fr'
}

export type NotificationOrderByRelevanceInput = {
  fields: Array<NotificationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type NotificationOrderByWithAggregationInput = {
  _avg?: InputMaybe<NotificationAvgOrderByAggregateInput>;
  _count?: InputMaybe<NotificationCountOrderByAggregateInput>;
  _max?: InputMaybe<NotificationMaxOrderByAggregateInput>;
  _min?: InputMaybe<NotificationMinOrderByAggregateInput>;
  _sum?: InputMaybe<NotificationSumOrderByAggregateInput>;
  body_en?: InputMaybe<SortOrder>;
  body_fr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithRelationAndSearchRelevanceInput = {
  Receiver?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<NotificationOrderByRelevanceInput>;
  body_en?: InputMaybe<SortOrder>;
  body_fr?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
  title_en?: InputMaybe<SortOrder>;
  title_fr?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum NotificationScalarFieldEnum {
  BodyEn = 'body_en',
  BodyFr = 'body_fr',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  Read = 'read',
  ReceiverId = 'receiverId',
  TitleEn = 'title_en',
  TitleFr = 'title_fr',
  Type = 'type'
}

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  body_en?: InputMaybe<StringFilter>;
  body_fr?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  read?: InputMaybe<BoolFilter>;
  receiverId?: InputMaybe<IntFilter>;
  title_en?: InputMaybe<StringFilter>;
  title_fr?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationDataTypeFilter>;
};

export type NotificationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  body_en?: InputMaybe<StringWithAggregatesFilter>;
  body_fr?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  read?: InputMaybe<BoolWithAggregatesFilter>;
  receiverId?: InputMaybe<IntWithAggregatesFilter>;
  title_en?: InputMaybe<StringWithAggregatesFilter>;
  title_fr?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumNotificationDataTypeWithAggregatesFilter>;
};

export type NotificationSumAggregate = {
  __typename?: 'NotificationSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
};

export type NotificationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  receiverId?: InputMaybe<SortOrder>;
};

export type NotificationUpdateInput = {
  Receiver?: InputMaybe<UserUpdateOneRequiredWithoutNotificationsNestedInput>;
  body_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  body_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  title_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationDataTypeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyMutationInput = {
  body_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  body_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  title_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationDataTypeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithWhereWithoutReceiverInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutReceiverNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutReceiverInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutReceiverInput>>;
  createMany?: InputMaybe<NotificationCreateManyReceiverInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutReceiverInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutReceiverInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutReceiverInput>>;
};

export type NotificationUpdateWithWhereUniqueWithoutReceiverInput = {
  data: NotificationUpdateWithoutReceiverInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutReceiverInput = {
  body_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  body_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  title_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationDataTypeFieldUpdateOperationsInput>;
};

export type NotificationUpsertWithWhereUniqueWithoutReceiverInput = {
  create: NotificationCreateWithoutReceiverInput;
  update: NotificationUpdateWithoutReceiverInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  Receiver?: InputMaybe<UserRelationFilter>;
  body_en?: InputMaybe<StringFilter>;
  body_fr?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  read?: InputMaybe<BoolFilter>;
  receiverId?: InputMaybe<IntFilter>;
  title_en?: InputMaybe<StringFilter>;
  title_fr?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationDataTypeFilter>;
};

export type NotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  Receiver?: InputMaybe<UserRelationFilter>;
  body_en?: InputMaybe<StringFilter>;
  body_fr?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<BoolFilter>;
  receiverId?: InputMaybe<IntFilter>;
  title_en?: InputMaybe<StringFilter>;
  title_fr?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationDataTypeFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NullableEnumContentMessageTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ContentMessageType>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Order = {
  __typename?: 'Order';
  ActionOrders: Array<ActionOrder>;
  AskDeliveryMan: Array<AskDeliveryMan>;
  Categories: Array<Category>;
  Chats: Array<Chat>;
  Country?: Maybe<Country>;
  Craftman?: Maybe<User>;
  CraftmanWallet: Array<CraftmanWallet>;
  Customer: User;
  DeliveryAdress?: Maybe<UserAddress>;
  ItemTypes: Array<ItemType>;
  MaterialTypes: Array<MaterialType>;
  NoticeOrders: Array<NoticeOrder>;
  OrderSize: Array<OrderSize>;
  PaimentHistories: Array<PaimentHistory>;
  Photos: Array<File>;
  Prices: Array<OrderPrice>;
  ValidOrderEvidence: Array<ValidOrderEvidence>;
  _count?: Maybe<OrderCount>;
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  craftmanAmount: Scalars['Float']['output'];
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  deadline?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryAdressId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  haveSize: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  orderInvoice: ShopCart;
  orderStatus: OrderAllStatus;
  quantity?: Maybe<Scalars['Float']['output']>;
  status: Status;
  tenderInitPrice: Scalars['String']['output'];
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type OrderActionOrdersArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActionOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type OrderAskDeliveryManArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type OrderCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type OrderChatsArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type OrderCountryArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type OrderCraftmanArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type OrderCraftmanWalletArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  distinct?: InputMaybe<Array<CraftmanWalletScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type OrderDeliveryAdressArgs = {
  where?: InputMaybe<UserAddressWhereInput>;
};


export type OrderItemTypesArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type OrderMaterialTypesArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type OrderNoticeOrdersArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticeOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type OrderOrderSizeArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type OrderPaimentHistoriesArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaimentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type OrderPhotosArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type OrderPricesArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type OrderValidOrderEvidenceArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type OrderAllStatus = {
  __typename?: 'OrderAllStatus';
  haveAmountNotPaid: Scalars['Boolean']['output'];
  haveAmountPaid: Scalars['Boolean']['output'];
  isCanRate: Scalars['Boolean']['output'];
  notPaid: Scalars['Boolean']['output'];
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Float']['output']>;
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  deliveryAdressId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
};

export type OrderAvgOrderByAggregateInput = {
  ceedowCommissionCustomPrice?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  craftmanCustomPrice?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deliveryAdressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrder>;
};

export type OrderByNoteInput = {
  /** Sort direction for average note */
  direction?: SortDirection;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  ActionOrders: Scalars['Int']['output'];
  AskDeliveryMan: Scalars['Int']['output'];
  Categories: Scalars['Int']['output'];
  Chats: Scalars['Int']['output'];
  CraftmanWallet: Scalars['Int']['output'];
  ItemTypes: Scalars['Int']['output'];
  MaterialTypes: Scalars['Int']['output'];
  NoticeOrders: Scalars['Int']['output'];
  OrderSize: Scalars['Int']['output'];
  PaimentHistories: Scalars['Int']['output'];
  Photos: Scalars['Int']['output'];
  Prices: Scalars['Int']['output'];
  ValidOrderEvidence: Scalars['Int']['output'];
};


export type OrderCountActionOrdersArgs = {
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type OrderCountAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type OrderCountCategoriesArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type OrderCountChatsArgs = {
  where?: InputMaybe<ChatWhereInput>;
};


export type OrderCountCraftmanWalletArgs = {
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type OrderCountItemTypesArgs = {
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type OrderCountMaterialTypesArgs = {
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type OrderCountNoticeOrdersArgs = {
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type OrderCountOrderSizeArgs = {
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type OrderCountPaimentHistoriesArgs = {
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type OrderCountPhotosArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type OrderCountPricesArgs = {
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type OrderCountValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int']['output'];
  ceedowCommissionCustomPrice: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
  craftmanCustomPrice: Scalars['Int']['output'];
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  deadline: Scalars['Int']['output'];
  deliveryAdressId: Scalars['Int']['output'];
  delivryDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  transporterCustomPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderCountOrderByAggregateInput = {
  ceedowCommissionCustomPrice?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  craftmanCustomPrice?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrder>;
  deliveryAdressId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderCreateInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateManyCountryInput = {
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deliveryAdressId?: InputMaybe<Scalars['Int']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateManyCountryInputEnvelope = {
  data: Array<OrderCreateManyCountryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyCraftmanInput = {
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deliveryAdressId?: InputMaybe<Scalars['Int']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateManyCraftmanInputEnvelope = {
  data: Array<OrderCreateManyCraftmanInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyCustomerInput = {
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deliveryAdressId?: InputMaybe<Scalars['Int']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateManyCustomerInputEnvelope = {
  data: Array<OrderCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyDeliveryAdressInput = {
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateManyDeliveryAdressInputEnvelope = {
  data: Array<OrderCreateManyDeliveryAdressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyInput = {
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deliveryAdressId?: InputMaybe<Scalars['Int']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateNestedManyWithoutCategoriesInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCategoriesInput>>;
};

export type OrderCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCountryInput>>;
  createMany?: InputMaybe<OrderCreateManyCountryInputEnvelope>;
};

export type OrderCreateNestedManyWithoutCraftmanInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<OrderCreateManyCraftmanInputEnvelope>;
};

export type OrderCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
};

export type OrderCreateNestedManyWithoutDeliveryAdressInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutDeliveryAdressInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutDeliveryAdressInput>>;
  createMany?: InputMaybe<OrderCreateManyDeliveryAdressInputEnvelope>;
};

export type OrderCreateNestedManyWithoutItemTypesInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutItemTypesInput>>;
};

export type OrderCreateNestedManyWithoutMaterialTypesInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutMaterialTypesInput>>;
};

export type OrderCreateNestedOneWithoutActionOrdersInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutActionOrdersInput>;
  create?: InputMaybe<OrderCreateWithoutActionOrdersInput>;
};

export type OrderCreateNestedOneWithoutAskDeliveryManInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAskDeliveryManInput>;
  create?: InputMaybe<OrderCreateWithoutAskDeliveryManInput>;
};

export type OrderCreateNestedOneWithoutChatsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<OrderCreateWithoutChatsInput>;
};

export type OrderCreateNestedOneWithoutCraftmanWalletInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutCraftmanWalletInput>;
  create?: InputMaybe<OrderCreateWithoutCraftmanWalletInput>;
};

export type OrderCreateNestedOneWithoutNoticeOrdersInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutNoticeOrdersInput>;
  create?: InputMaybe<OrderCreateWithoutNoticeOrdersInput>;
};

export type OrderCreateNestedOneWithoutOrderSizeInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderSizeInput>;
  create?: InputMaybe<OrderCreateWithoutOrderSizeInput>;
};

export type OrderCreateNestedOneWithoutPaimentHistoriesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaimentHistoriesInput>;
  create?: InputMaybe<OrderCreateWithoutPaimentHistoriesInput>;
};

export type OrderCreateNestedOneWithoutPhotosInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<OrderCreateWithoutPhotosInput>;
};

export type OrderCreateNestedOneWithoutPricesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<OrderCreateWithoutPricesInput>;
};

export type OrderCreateNestedOneWithoutValidOrderEvidenceInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutValidOrderEvidenceInput>;
  create?: InputMaybe<OrderCreateWithoutValidOrderEvidenceInput>;
};

export type OrderCreateOrConnectWithoutActionOrdersInput = {
  create: OrderCreateWithoutActionOrdersInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutAskDeliveryManInput = {
  create: OrderCreateWithoutAskDeliveryManInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCategoriesInput = {
  create: OrderCreateWithoutCategoriesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutChatsInput = {
  create: OrderCreateWithoutChatsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCountryInput = {
  create: OrderCreateWithoutCountryInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCraftmanInput = {
  create: OrderCreateWithoutCraftmanInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCraftmanWalletInput = {
  create: OrderCreateWithoutCraftmanWalletInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDeliveryAdressInput = {
  create: OrderCreateWithoutDeliveryAdressInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutItemTypesInput = {
  create: OrderCreateWithoutItemTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutMaterialTypesInput = {
  create: OrderCreateWithoutMaterialTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutNoticeOrdersInput = {
  create: OrderCreateWithoutNoticeOrdersInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutOrderSizeInput = {
  create: OrderCreateWithoutOrderSizeInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPaimentHistoriesInput = {
  create: OrderCreateWithoutPaimentHistoriesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPhotosInput = {
  create: OrderCreateWithoutPhotosInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPricesInput = {
  create: OrderCreateWithoutPricesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutValidOrderEvidenceInput = {
  create: OrderCreateWithoutValidOrderEvidenceInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutActionOrdersInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutCategoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutChatsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutCountryInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutCraftmanInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutCraftmanWalletInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutCustomerInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutDeliveryAdressInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutItemTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutMaterialTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutNoticeOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutOrderSizeInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutPaimentHistoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutPhotosInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutPricesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderCreateWithoutValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutOrderInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutOrderInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutOrdersInput>;
  Chats?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  Country?: InputMaybe<CountryCreateNestedOneWithoutOrdersInput>;
  Craftman?: InputMaybe<UserCreateNestedOneWithoutCraftmanOrdersInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutOrderInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrdersInput;
  DeliveryAdress?: InputMaybe<UserAddressCreateNestedOneWithoutOrderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutOrdersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutOrdersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutOrderInput>;
  OrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutOrderInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutOrderInput>;
  Photos?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  Prices?: InputMaybe<OrderPriceCreateNestedManyWithoutOrderInput>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delivryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Status>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderGroupBy = {
  __typename?: 'OrderGroupBy';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  deadline?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryAdressId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  status: Status;
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryAdressId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Status>;
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrderMaxOrderByAggregateInput = {
  ceedowCommissionCustomPrice?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  craftmanCustomPrice?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrder>;
  deliveryAdressId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryAdressId?: Maybe<Scalars['Int']['output']>;
  delivryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Status>;
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrderMinOrderByAggregateInput = {
  ceedowCommissionCustomPrice?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  craftmanCustomPrice?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrder>;
  deliveryAdressId?: InputMaybe<SortOrder>;
  delivryDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderNullableRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum OrderOrderByRelevanceFieldEnum {
  Message = 'message'
}

export type OrderOrderByRelevanceInput = {
  fields: Array<OrderOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type OrderOrderByWithAggregationInput = {
  _avg?: InputMaybe<OrderAvgOrderByAggregateInput>;
  _count?: InputMaybe<OrderCountOrderByAggregateInput>;
  _max?: InputMaybe<OrderMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrderMinOrderByAggregateInput>;
  _sum?: InputMaybe<OrderSumOrderByAggregateInput>;
  ceedowCommissionCustomPrice?: InputMaybe<SortOrderInput>;
  countryId?: InputMaybe<SortOrderInput>;
  craftmanCustomPrice?: InputMaybe<SortOrderInput>;
  craftmanId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrderInput>;
  deliveryAdressId?: InputMaybe<SortOrderInput>;
  delivryDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationAndSearchRelevanceInput = {
  ActionOrders?: InputMaybe<ActionOrderOrderByRelationAggregateInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManOrderByRelationAggregateInput>;
  Categories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  Chats?: InputMaybe<ChatOrderByRelationAggregateInput>;
  Country?: InputMaybe<CountryOrderByWithRelationAndSearchRelevanceInput>;
  Craftman?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletOrderByRelationAggregateInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  DeliveryAdress?: InputMaybe<UserAddressOrderByWithRelationAndSearchRelevanceInput>;
  ItemTypes?: InputMaybe<ItemTypeOrderByRelationAggregateInput>;
  MaterialTypes?: InputMaybe<MaterialTypeOrderByRelationAggregateInput>;
  NoticeOrders?: InputMaybe<NoticeOrderOrderByRelationAggregateInput>;
  OrderSize?: InputMaybe<OrderSizeOrderByRelationAggregateInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryOrderByRelationAggregateInput>;
  Photos?: InputMaybe<FileOrderByRelationAggregateInput>;
  Prices?: InputMaybe<OrderPriceOrderByRelationAggregateInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<OrderOrderByRelevanceInput>;
  ceedowCommissionCustomPrice?: InputMaybe<SortOrderInput>;
  countryId?: InputMaybe<SortOrderInput>;
  craftmanCustomPrice?: InputMaybe<SortOrderInput>;
  craftmanId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deadline?: InputMaybe<SortOrderInput>;
  deliveryAdressId?: InputMaybe<SortOrderInput>;
  delivryDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  ChatMessages: Array<ChatMessage>;
  Order?: Maybe<Order>;
  User: User;
  _count?: Maybe<OrderPriceCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  currenctUserPrice: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  status: Status;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};


export type OrderPriceChatMessagesArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type OrderPriceOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderPriceAvgAggregate = {
  __typename?: 'OrderPriceAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type OrderPriceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceCount = {
  __typename?: 'OrderPriceCount';
  ChatMessages: Scalars['Int']['output'];
};


export type OrderPriceCountChatMessagesArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type OrderPriceCountAggregate = {
  __typename?: 'OrderPriceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type OrderPriceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceCreateInput = {
  ChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderPriceInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPricesInput>;
  User: UserCreateNestedOneWithoutOrderPricesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderPriceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type OrderPriceCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type OrderPriceCreateManyOrderInputEnvelope = {
  data: Array<OrderPriceCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderPriceCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderPriceCreateManyUserInputEnvelope = {
  data: Array<OrderPriceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderPriceCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderPriceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderPriceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderPriceCreateManyOrderInputEnvelope>;
};

export type OrderPriceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderPriceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderPriceCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderPriceCreateManyUserInputEnvelope>;
};

export type OrderPriceCreateNestedOneWithoutChatMessagesInput = {
  connect?: InputMaybe<OrderPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderPriceCreateOrConnectWithoutChatMessagesInput>;
  create?: InputMaybe<OrderPriceCreateWithoutChatMessagesInput>;
};

export type OrderPriceCreateOrConnectWithoutChatMessagesInput = {
  create: OrderPriceCreateWithoutChatMessagesInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceCreateOrConnectWithoutOrderInput = {
  create: OrderPriceCreateWithoutOrderInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceCreateOrConnectWithoutUserInput = {
  create: OrderPriceCreateWithoutUserInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceCreateWithoutChatMessagesInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutPricesInput>;
  User: UserCreateNestedOneWithoutOrderPricesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderPriceCreateWithoutOrderInput = {
  ChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderPriceInput>;
  User: UserCreateNestedOneWithoutOrderPricesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderPriceCreateWithoutUserInput = {
  ChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderPriceInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPricesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<Status>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderPriceGroupBy = {
  __typename?: 'OrderPriceGroupBy';
  _avg?: Maybe<OrderPriceAvgAggregate>;
  _count?: Maybe<OrderPriceCountAggregate>;
  _max?: Maybe<OrderPriceMaxAggregate>;
  _min?: Maybe<OrderPriceMinAggregate>;
  _sum?: Maybe<OrderPriceSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  status: Status;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};

export type OrderPriceListRelationFilter = {
  every?: InputMaybe<OrderPriceWhereInput>;
  none?: InputMaybe<OrderPriceWhereInput>;
  some?: InputMaybe<OrderPriceWhereInput>;
};

export type OrderPriceMaxAggregate = {
  __typename?: 'OrderPriceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OrderPriceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceMinAggregate = {
  __typename?: 'OrderPriceMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OrderPriceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceNullableRelationFilter = {
  is?: InputMaybe<OrderPriceWhereInput>;
  isNot?: InputMaybe<OrderPriceWhereInput>;
};

export type OrderPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderPriceOrderByWithAggregationInput = {
  _avg?: InputMaybe<OrderPriceAvgOrderByAggregateInput>;
  _count?: InputMaybe<OrderPriceCountOrderByAggregateInput>;
  _max?: InputMaybe<OrderPriceMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrderPriceMinOrderByAggregateInput>;
  _sum?: InputMaybe<OrderPriceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceOrderByWithRelationAndSearchRelevanceInput = {
  ChatMessages?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  User?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum OrderPriceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrderId = 'orderId',
  Price = 'price',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type OrderPriceScalarWhereInput = {
  AND?: InputMaybe<Array<OrderPriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderPriceScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderPriceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type OrderPriceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<OrderPriceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<OrderPriceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<OrderPriceScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntNullableWithAggregatesFilter>;
  price?: InputMaybe<FloatWithAggregatesFilter>;
  status?: InputMaybe<EnumStatusWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type OrderPriceSumAggregate = {
  __typename?: 'OrderPriceSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OrderPriceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderPriceUpdateInput = {
  ChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutOrderPriceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPricesNestedInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutOrderPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderPriceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderPriceUpdateManyWithWhereWithoutOrderInput = {
  data: OrderPriceUpdateManyMutationInput;
  where: OrderPriceScalarWhereInput;
};

export type OrderPriceUpdateManyWithWhereWithoutUserInput = {
  data: OrderPriceUpdateManyMutationInput;
  where: OrderPriceScalarWhereInput;
};

export type OrderPriceUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderPriceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderPriceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderPriceCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderPriceUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderPriceUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderPriceUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderPriceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderPriceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderPriceCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderPriceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderPriceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<OrderPriceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<OrderPriceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type OrderPriceUpdateOneWithoutChatMessagesNestedInput = {
  connect?: InputMaybe<OrderPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderPriceCreateOrConnectWithoutChatMessagesInput>;
  create?: InputMaybe<OrderPriceCreateWithoutChatMessagesInput>;
  delete?: InputMaybe<OrderPriceWhereInput>;
  disconnect?: InputMaybe<OrderPriceWhereInput>;
  update?: InputMaybe<OrderPriceUpdateToOneWithWhereWithoutChatMessagesInput>;
  upsert?: InputMaybe<OrderPriceUpsertWithoutChatMessagesInput>;
};

export type OrderPriceUpdateToOneWithWhereWithoutChatMessagesInput = {
  data: OrderPriceUpdateWithoutChatMessagesInput;
  where?: InputMaybe<OrderPriceWhereInput>;
};

export type OrderPriceUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderPriceUpdateWithoutOrderInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceUpdateWithWhereUniqueWithoutUserInput = {
  data: OrderPriceUpdateWithoutUserInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceUpdateWithoutChatMessagesInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutPricesNestedInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutOrderPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderPriceUpdateWithoutOrderInput = {
  ChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutOrderPriceNestedInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutOrderPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderPriceUpdateWithoutUserInput = {
  ChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutOrderPriceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderPriceUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderPriceCreateWithoutOrderInput;
  update: OrderPriceUpdateWithoutOrderInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceUpsertWithWhereUniqueWithoutUserInput = {
  create: OrderPriceCreateWithoutUserInput;
  update: OrderPriceUpdateWithoutUserInput;
  where: OrderPriceWhereUniqueInput;
};

export type OrderPriceUpsertWithoutChatMessagesInput = {
  create: OrderPriceCreateWithoutChatMessagesInput;
  update: OrderPriceUpdateWithoutChatMessagesInput;
  where?: InputMaybe<OrderPriceWhereInput>;
};

export type OrderPriceWhereInput = {
  AND?: InputMaybe<Array<OrderPriceWhereInput>>;
  ChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  NOT?: InputMaybe<Array<OrderPriceWhereInput>>;
  OR?: InputMaybe<Array<OrderPriceWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type OrderPriceWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderPriceWhereInput>>;
  ChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  NOT?: InputMaybe<Array<OrderPriceWhereInput>>;
  OR?: InputMaybe<Array<OrderPriceWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type OrderRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export enum OrderScalarFieldEnum {
  CeedowCommissionCustomPrice = 'ceedowCommissionCustomPrice',
  CountryId = 'countryId',
  CraftmanCustomPrice = 'craftmanCustomPrice',
  CraftmanId = 'craftmanId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Deadline = 'deadline',
  DeliveryAdressId = 'deliveryAdressId',
  DelivryDate = 'delivryDate',
  Id = 'id',
  Message = 'message',
  OldId = 'oldID',
  Quantity = 'quantity',
  Status = 'status',
  TransporterCustomPrice = 'transporterCustomPrice',
  UpdatedAt = 'updatedAt'
}

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  ceedowCommissionCustomPrice?: InputMaybe<FloatNullableFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  craftmanCustomPrice?: InputMaybe<FloatNullableFilter>;
  craftmanId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  deadline?: InputMaybe<DateTimeNullableFilter>;
  deliveryAdressId?: InputMaybe<IntNullableFilter>;
  delivryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  quantity?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  transporterCustomPrice?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  ceedowCommissionCustomPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  countryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  craftmanCustomPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  craftmanId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  deadline?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deliveryAdressId?: InputMaybe<IntNullableWithAggregatesFilter>;
  delivryDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  message?: InputMaybe<StringWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
  quantity?: InputMaybe<FloatNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumStatusWithAggregatesFilter>;
  transporterCustomPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type OrderSize = {
  __typename?: 'OrderSize';
  ChatMessage: Array<ChatMessage>;
  Customer: User;
  Order: Order;
  _count?: Maybe<OrderSizeCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  depth?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  length?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  other?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};


export type OrderSizeChatMessageArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type OrderSizeAvgAggregate = {
  __typename?: 'OrderSizeAvgAggregate';
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type OrderSizeAvgOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type OrderSizeCount = {
  __typename?: 'OrderSizeCount';
  ChatMessage: Scalars['Int']['output'];
};


export type OrderSizeCountChatMessageArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};

export type OrderSizeCountAggregate = {
  __typename?: 'OrderSizeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  depth: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type OrderSizeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  depth?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  other?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type OrderSizeCreateInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderSizeInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrderSizeInput;
  Order: OrderCreateNestedOneWithoutOrderSizeInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateManyCustomerInputEnvelope = {
  data: Array<OrderSizeCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderSizeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateManyOrderInputEnvelope = {
  data: Array<OrderSizeCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderSizeCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderSizeCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderSizeCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderSizeCreateManyCustomerInputEnvelope>;
};

export type OrderSizeCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderSizeCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderSizeCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderSizeCreateManyOrderInputEnvelope>;
};

export type OrderSizeCreateNestedOneWithoutChatMessageInput = {
  connect?: InputMaybe<OrderSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderSizeCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<OrderSizeCreateWithoutChatMessageInput>;
};

export type OrderSizeCreateOrConnectWithoutChatMessageInput = {
  create: OrderSizeCreateWithoutChatMessageInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeCreateOrConnectWithoutCustomerInput = {
  create: OrderSizeCreateWithoutCustomerInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeCreateOrConnectWithoutOrderInput = {
  create: OrderSizeCreateWithoutOrderInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeCreateWithoutChatMessageInput = {
  Customer: UserCreateNestedOneWithoutCustomerOrderSizeInput;
  Order: OrderCreateNestedOneWithoutOrderSizeInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderSizeInput>;
  Order: OrderCreateNestedOneWithoutOrderSizeInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeCreateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutOrderSizeInput>;
  Customer: UserCreateNestedOneWithoutCustomerOrderSizeInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  depth?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSizeGroupBy = {
  __typename?: 'OrderSizeGroupBy';
  _avg?: Maybe<OrderSizeAvgAggregate>;
  _count?: Maybe<OrderSizeCountAggregate>;
  _max?: Maybe<OrderSizeMaxAggregate>;
  _min?: Maybe<OrderSizeMinAggregate>;
  _sum?: Maybe<OrderSizeSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  depth?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  length?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  other?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OrderSizeListRelationFilter = {
  every?: InputMaybe<OrderSizeWhereInput>;
  none?: InputMaybe<OrderSizeWhereInput>;
  some?: InputMaybe<OrderSizeWhereInput>;
};

export type OrderSizeMaxAggregate = {
  __typename?: 'OrderSizeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  depth?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OrderSizeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  depth?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  other?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type OrderSizeMinAggregate = {
  __typename?: 'OrderSizeMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  depth?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type OrderSizeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  depth?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  other?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type OrderSizeNullableRelationFilter = {
  is?: InputMaybe<OrderSizeWhereInput>;
  isNot?: InputMaybe<OrderSizeWhereInput>;
};

export type OrderSizeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum OrderSizeOrderByRelevanceFieldEnum {
  Depth = 'depth',
  Height = 'height',
  Length = 'length',
  Other = 'other',
  Weight = 'weight',
  Width = 'width'
}

export type OrderSizeOrderByRelevanceInput = {
  fields: Array<OrderSizeOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type OrderSizeOrderByWithAggregationInput = {
  _avg?: InputMaybe<OrderSizeAvgOrderByAggregateInput>;
  _count?: InputMaybe<OrderSizeCountOrderByAggregateInput>;
  _max?: InputMaybe<OrderSizeMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrderSizeMinOrderByAggregateInput>;
  _sum?: InputMaybe<OrderSizeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  depth?: InputMaybe<SortOrderInput>;
  height?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrder>;
  other?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrderInput>;
  width?: InputMaybe<SortOrderInput>;
};

export type OrderSizeOrderByWithRelationAndSearchRelevanceInput = {
  ChatMessage?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<OrderSizeOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  depth?: InputMaybe<SortOrderInput>;
  height?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrder>;
  other?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrderInput>;
  width?: InputMaybe<SortOrderInput>;
};

export enum OrderSizeScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Depth = 'depth',
  Height = 'height',
  Id = 'id',
  Length = 'length',
  OrderId = 'orderId',
  Other = 'other',
  UpdatedAt = 'updatedAt',
  Weight = 'weight',
  Width = 'width'
}

export type OrderSizeScalarWhereInput = {
  AND?: InputMaybe<Array<OrderSizeScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderSizeScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderSizeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  depth?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  length?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  other?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<StringNullableFilter>;
};

export type OrderSizeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<OrderSizeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<OrderSizeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<OrderSizeScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  depth?: InputMaybe<StringNullableWithAggregatesFilter>;
  height?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  length?: InputMaybe<StringNullableWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  other?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  weight?: InputMaybe<StringNullableWithAggregatesFilter>;
  width?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type OrderSizeSumAggregate = {
  __typename?: 'OrderSizeSumAggregate';
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type OrderSizeSumOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type OrderSizeUpdateInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutOrderSizeNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrderSizeNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderSizeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderSizeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderSizeUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderSizeUpdateManyMutationInput;
  where: OrderSizeScalarWhereInput;
};

export type OrderSizeUpdateManyWithWhereWithoutOrderInput = {
  data: OrderSizeUpdateManyMutationInput;
  where: OrderSizeScalarWhereInput;
};

export type OrderSizeUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderSizeCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderSizeCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderSizeCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderSizeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderSizeUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderSizeUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderSizeUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderSizeUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderSizeCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderSizeCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderSizeCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderSizeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderSizeWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderSizeUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderSizeUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderSizeUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderSizeUpdateOneWithoutChatMessageNestedInput = {
  connect?: InputMaybe<OrderSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderSizeCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<OrderSizeCreateWithoutChatMessageInput>;
  delete?: InputMaybe<OrderSizeWhereInput>;
  disconnect?: InputMaybe<OrderSizeWhereInput>;
  update?: InputMaybe<OrderSizeUpdateToOneWithWhereWithoutChatMessageInput>;
  upsert?: InputMaybe<OrderSizeUpsertWithoutChatMessageInput>;
};

export type OrderSizeUpdateToOneWithWhereWithoutChatMessageInput = {
  data: OrderSizeUpdateWithoutChatMessageInput;
  where?: InputMaybe<OrderSizeWhereInput>;
};

export type OrderSizeUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderSizeUpdateWithoutCustomerInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderSizeUpdateWithoutOrderInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeUpdateWithoutChatMessageInput = {
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrderSizeNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderSizeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderSizeUpdateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutOrderSizeNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderSizeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderSizeUpdateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutOrderSizeNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrderSizeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderSizeUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderSizeCreateWithoutCustomerInput;
  update: OrderSizeUpdateWithoutCustomerInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderSizeCreateWithoutOrderInput;
  update: OrderSizeUpdateWithoutOrderInput;
  where: OrderSizeWhereUniqueInput;
};

export type OrderSizeUpsertWithoutChatMessageInput = {
  create: OrderSizeCreateWithoutChatMessageInput;
  update: OrderSizeUpdateWithoutChatMessageInput;
  where?: InputMaybe<OrderSizeWhereInput>;
};

export type OrderSizeWhereInput = {
  AND?: InputMaybe<Array<OrderSizeWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<OrderSizeWhereInput>>;
  OR?: InputMaybe<Array<OrderSizeWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  depth?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  length?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  other?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<StringNullableFilter>;
};

export type OrderSizeWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderSizeWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<OrderSizeWhereInput>>;
  OR?: InputMaybe<Array<OrderSizeWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  depth?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  other?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<StringNullableFilter>;
};

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  ceedowCommissionCustomPrice?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  craftmanCustomPrice?: Maybe<Scalars['Float']['output']>;
  craftmanId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  deliveryAdressId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  transporterCustomPrice?: Maybe<Scalars['Float']['output']>;
};

export type OrderSumOrderByAggregateInput = {
  ceedowCommissionCustomPrice?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  craftmanCustomPrice?: InputMaybe<SortOrder>;
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  deliveryAdressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  transporterCustomPrice?: InputMaybe<SortOrder>;
};

export type OrderUpdateInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyMutationInput = {
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCategoriesInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutCountryInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutCraftmanInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutDeliveryAdressInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutItemTypesInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutMaterialTypesInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutCategoriesNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCategoriesInput>>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCategoriesInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCategoriesInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCategoriesInput>>;
};

export type OrderUpdateManyWithoutCountryNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCountryInput>>;
  createMany?: InputMaybe<OrderCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCountryInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCountryInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCountryInput>>;
};

export type OrderUpdateManyWithoutCraftmanNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<OrderCreateManyCraftmanInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCraftmanInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCraftmanInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCraftmanInput>>;
};

export type OrderUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderUpdateManyWithoutDeliveryAdressNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutDeliveryAdressInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutDeliveryAdressInput>>;
  createMany?: InputMaybe<OrderCreateManyDeliveryAdressInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutDeliveryAdressInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutDeliveryAdressInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutDeliveryAdressInput>>;
};

export type OrderUpdateManyWithoutItemTypesNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutItemTypesInput>>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutItemTypesInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutItemTypesInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutItemTypesInput>>;
};

export type OrderUpdateManyWithoutMaterialTypesNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutMaterialTypesInput>>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutMaterialTypesInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutMaterialTypesInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutMaterialTypesInput>>;
};

export type OrderUpdateOneRequiredWithoutActionOrdersNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutActionOrdersInput>;
  create?: InputMaybe<OrderCreateWithoutActionOrdersInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutActionOrdersInput>;
  upsert?: InputMaybe<OrderUpsertWithoutActionOrdersInput>;
};

export type OrderUpdateOneRequiredWithoutAskDeliveryManNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAskDeliveryManInput>;
  create?: InputMaybe<OrderCreateWithoutAskDeliveryManInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutAskDeliveryManInput>;
  upsert?: InputMaybe<OrderUpsertWithoutAskDeliveryManInput>;
};

export type OrderUpdateOneRequiredWithoutChatsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<OrderCreateWithoutChatsInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutChatsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutChatsInput>;
};

export type OrderUpdateOneRequiredWithoutNoticeOrdersNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutNoticeOrdersInput>;
  create?: InputMaybe<OrderCreateWithoutNoticeOrdersInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutNoticeOrdersInput>;
  upsert?: InputMaybe<OrderUpsertWithoutNoticeOrdersInput>;
};

export type OrderUpdateOneRequiredWithoutOrderSizeNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderSizeInput>;
  create?: InputMaybe<OrderCreateWithoutOrderSizeInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutOrderSizeInput>;
  upsert?: InputMaybe<OrderUpsertWithoutOrderSizeInput>;
};

export type OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutValidOrderEvidenceInput>;
  create?: InputMaybe<OrderCreateWithoutValidOrderEvidenceInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutValidOrderEvidenceInput>;
  upsert?: InputMaybe<OrderUpsertWithoutValidOrderEvidenceInput>;
};

export type OrderUpdateOneWithoutCraftmanWalletNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutCraftmanWalletInput>;
  create?: InputMaybe<OrderCreateWithoutCraftmanWalletInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutCraftmanWalletInput>;
  upsert?: InputMaybe<OrderUpsertWithoutCraftmanWalletInput>;
};

export type OrderUpdateOneWithoutPaimentHistoriesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaimentHistoriesInput>;
  create?: InputMaybe<OrderCreateWithoutPaimentHistoriesInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutPaimentHistoriesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPaimentHistoriesInput>;
};

export type OrderUpdateOneWithoutPhotosNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<OrderCreateWithoutPhotosInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutPhotosInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPhotosInput>;
};

export type OrderUpdateOneWithoutPricesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<OrderCreateWithoutPricesInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutPricesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPricesInput>;
};

export type OrderUpdateToOneWithWhereWithoutActionOrdersInput = {
  data: OrderUpdateWithoutActionOrdersInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutAskDeliveryManInput = {
  data: OrderUpdateWithoutAskDeliveryManInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutChatsInput = {
  data: OrderUpdateWithoutChatsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutCraftmanWalletInput = {
  data: OrderUpdateWithoutCraftmanWalletInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutNoticeOrdersInput = {
  data: OrderUpdateWithoutNoticeOrdersInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutOrderSizeInput = {
  data: OrderUpdateWithoutOrderSizeInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutPaimentHistoriesInput = {
  data: OrderUpdateWithoutPaimentHistoriesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutPhotosInput = {
  data: OrderUpdateWithoutPhotosInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutPricesInput = {
  data: OrderUpdateWithoutPricesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutValidOrderEvidenceInput = {
  data: OrderUpdateWithoutValidOrderEvidenceInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateWithWhereUniqueWithoutCategoriesInput = {
  data: OrderUpdateWithoutCategoriesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutCountryInput = {
  data: OrderUpdateWithoutCountryInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutCraftmanInput = {
  data: OrderUpdateWithoutCraftmanInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutDeliveryAdressInput = {
  data: OrderUpdateWithoutDeliveryAdressInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutItemTypesInput = {
  data: OrderUpdateWithoutItemTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutMaterialTypesInput = {
  data: OrderUpdateWithoutMaterialTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutActionOrdersInput = {
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCategoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutChatsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCountryInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCraftmanInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCraftmanWalletInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCustomerInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutDeliveryAdressInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutItemTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutMaterialTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutNoticeOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutOrderSizeInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPaimentHistoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPhotosInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPricesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutOrderNestedInput>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutOrderNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutOrdersNestedInput>;
  Chats?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  Country?: InputMaybe<CountryUpdateOneWithoutOrdersNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneWithoutCraftmanOrdersNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutOrderNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerOrdersNestedInput>;
  DeliveryAdress?: InputMaybe<UserAddressUpdateOneWithoutOrderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutOrdersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutOrdersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutOrderNestedInput>;
  OrderSize?: InputMaybe<OrderSizeUpdateManyWithoutOrderNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutOrderNestedInput>;
  Photos?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  Prices?: InputMaybe<OrderPriceUpdateManyWithoutOrderNestedInput>;
  ceedowCommissionCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  craftmanCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delivryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStatusFieldUpdateOperationsInput>;
  transporterCustomPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCategoriesInput = {
  create: OrderCreateWithoutCategoriesInput;
  update: OrderUpdateWithoutCategoriesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutCountryInput = {
  create: OrderCreateWithoutCountryInput;
  update: OrderUpdateWithoutCountryInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutCraftmanInput = {
  create: OrderCreateWithoutCraftmanInput;
  update: OrderUpdateWithoutCraftmanInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  update: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutDeliveryAdressInput = {
  create: OrderCreateWithoutDeliveryAdressInput;
  update: OrderUpdateWithoutDeliveryAdressInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutItemTypesInput = {
  create: OrderCreateWithoutItemTypesInput;
  update: OrderUpdateWithoutItemTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutMaterialTypesInput = {
  create: OrderCreateWithoutMaterialTypesInput;
  update: OrderUpdateWithoutMaterialTypesInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithoutActionOrdersInput = {
  create: OrderCreateWithoutActionOrdersInput;
  update: OrderUpdateWithoutActionOrdersInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutAskDeliveryManInput = {
  create: OrderCreateWithoutAskDeliveryManInput;
  update: OrderUpdateWithoutAskDeliveryManInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutChatsInput = {
  create: OrderCreateWithoutChatsInput;
  update: OrderUpdateWithoutChatsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutCraftmanWalletInput = {
  create: OrderCreateWithoutCraftmanWalletInput;
  update: OrderUpdateWithoutCraftmanWalletInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutNoticeOrdersInput = {
  create: OrderCreateWithoutNoticeOrdersInput;
  update: OrderUpdateWithoutNoticeOrdersInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutOrderSizeInput = {
  create: OrderCreateWithoutOrderSizeInput;
  update: OrderUpdateWithoutOrderSizeInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutPaimentHistoriesInput = {
  create: OrderCreateWithoutPaimentHistoriesInput;
  update: OrderUpdateWithoutPaimentHistoriesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutPhotosInput = {
  create: OrderCreateWithoutPhotosInput;
  update: OrderUpdateWithoutPhotosInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutPricesInput = {
  create: OrderCreateWithoutPricesInput;
  update: OrderUpdateWithoutPricesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutValidOrderEvidenceInput = {
  create: OrderCreateWithoutValidOrderEvidenceInput;
  update: OrderUpdateWithoutValidOrderEvidenceInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  ActionOrders?: InputMaybe<ActionOrderListRelationFilter>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  Chats?: InputMaybe<ChatListRelationFilter>;
  Country?: InputMaybe<CountryNullableRelationFilter>;
  Craftman?: InputMaybe<UserNullableRelationFilter>;
  CraftmanWallet?: InputMaybe<CraftmanWalletListRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  DeliveryAdress?: InputMaybe<UserAddressNullableRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  NoticeOrders?: InputMaybe<NoticeOrderListRelationFilter>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  OrderSize?: InputMaybe<OrderSizeListRelationFilter>;
  PaimentHistories?: InputMaybe<PaimentHistoryListRelationFilter>;
  Photos?: InputMaybe<FileListRelationFilter>;
  Prices?: InputMaybe<OrderPriceListRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  ceedowCommissionCustomPrice?: InputMaybe<FloatNullableFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  craftmanCustomPrice?: InputMaybe<FloatNullableFilter>;
  craftmanId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  deadline?: InputMaybe<DateTimeNullableFilter>;
  deliveryAdressId?: InputMaybe<IntNullableFilter>;
  delivryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  quantity?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  transporterCustomPrice?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  ActionOrders?: InputMaybe<ActionOrderListRelationFilter>;
  AskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  Chats?: InputMaybe<ChatListRelationFilter>;
  Country?: InputMaybe<CountryNullableRelationFilter>;
  Craftman?: InputMaybe<UserNullableRelationFilter>;
  CraftmanWallet?: InputMaybe<CraftmanWalletListRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  DeliveryAdress?: InputMaybe<UserAddressNullableRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  NoticeOrders?: InputMaybe<NoticeOrderListRelationFilter>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  OrderSize?: InputMaybe<OrderSizeListRelationFilter>;
  PaimentHistories?: InputMaybe<PaimentHistoryListRelationFilter>;
  Photos?: InputMaybe<FileListRelationFilter>;
  Prices?: InputMaybe<OrderPriceListRelationFilter>;
  ValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  ceedowCommissionCustomPrice?: InputMaybe<FloatNullableFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  craftmanCustomPrice?: InputMaybe<FloatNullableFilter>;
  craftmanId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  deadline?: InputMaybe<DateTimeNullableFilter>;
  deliveryAdressId?: InputMaybe<IntNullableFilter>;
  delivryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  quantity?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<EnumStatusFilter>;
  transporterCustomPrice?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaimentHistory = {
  __typename?: 'PaimentHistory';
  Customer?: Maybe<User>;
  Order?: Maybe<Order>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  status: PaimentStatus;
  userIP?: Maybe<Scalars['String']['output']>;
};


export type PaimentHistoryCustomerArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type PaimentHistoryOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type PaimentHistoryAvgAggregate = {
  __typename?: 'PaimentHistoryAvgAggregate';
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type PaimentHistoryAvgOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type PaimentHistoryCountAggregate = {
  __typename?: 'PaimentHistoryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  error: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  paymentId: Scalars['Int']['output'];
  paymentMode: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  userIP: Scalars['Int']['output'];
};

export type PaimentHistoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentMode?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userIP?: InputMaybe<SortOrder>;
};

export type PaimentHistoryCreateInput = {
  Customer?: InputMaybe<UserCreateNestedOneWithoutPaimentHistoriesInput>;
  Order?: InputMaybe<OrderCreateNestedOneWithoutPaimentHistoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryCreateManyCustomerInputEnvelope = {
  data: Array<PaimentHistoryCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaimentHistoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryCreateManyOrderInputEnvelope = {
  data: Array<PaimentHistoryCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaimentHistoryCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaimentHistoryCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<PaimentHistoryCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<PaimentHistoryCreateManyCustomerInputEnvelope>;
};

export type PaimentHistoryCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaimentHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaimentHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaimentHistoryCreateManyOrderInputEnvelope>;
};

export type PaimentHistoryCreateOrConnectWithoutCustomerInput = {
  create: PaimentHistoryCreateWithoutCustomerInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryCreateOrConnectWithoutOrderInput = {
  create: PaimentHistoryCreateWithoutOrderInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryCreateWithoutCustomerInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutPaimentHistoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryCreateWithoutOrderInput = {
  Customer?: InputMaybe<UserCreateNestedOneWithoutPaimentHistoriesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status: PaimentStatus;
  userIP?: InputMaybe<Scalars['String']['input']>;
};

export type PaimentHistoryGroupBy = {
  __typename?: 'PaimentHistoryGroupBy';
  _avg?: Maybe<PaimentHistoryAvgAggregate>;
  _count?: Maybe<PaimentHistoryCountAggregate>;
  _max?: Maybe<PaimentHistoryMaxAggregate>;
  _min?: Maybe<PaimentHistoryMinAggregate>;
  _sum?: Maybe<PaimentHistorySumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  status: PaimentStatus;
  userIP?: Maybe<Scalars['String']['output']>;
};

export type PaimentHistoryListRelationFilter = {
  every?: InputMaybe<PaimentHistoryWhereInput>;
  none?: InputMaybe<PaimentHistoryWhereInput>;
  some?: InputMaybe<PaimentHistoryWhereInput>;
};

export type PaimentHistoryMaxAggregate = {
  __typename?: 'PaimentHistoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaimentStatus>;
  userIP?: Maybe<Scalars['String']['output']>;
};

export type PaimentHistoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentMode?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userIP?: InputMaybe<SortOrder>;
};

export type PaimentHistoryMinAggregate = {
  __typename?: 'PaimentHistoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaimentStatus>;
  userIP?: Maybe<Scalars['String']['output']>;
};

export type PaimentHistoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  paymentMode?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  userIP?: InputMaybe<SortOrder>;
};

export type PaimentHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum PaimentHistoryOrderByRelevanceFieldEnum {
  Error = 'error',
  PaymentId = 'paymentId',
  PaymentMode = 'paymentMode',
  Provider = 'provider',
  UserIp = 'userIP'
}

export type PaimentHistoryOrderByRelevanceInput = {
  fields: Array<PaimentHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type PaimentHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaimentHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaimentHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<PaimentHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaimentHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaimentHistorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrderInput>;
  error?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  paymentId?: InputMaybe<SortOrderInput>;
  paymentMode?: InputMaybe<SortOrderInput>;
  provider?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  userIP?: InputMaybe<SortOrderInput>;
};

export type PaimentHistoryOrderByWithRelationAndSearchRelevanceInput = {
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<PaimentHistoryOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrderInput>;
  error?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrderInput>;
  paymentId?: InputMaybe<SortOrderInput>;
  paymentMode?: InputMaybe<SortOrderInput>;
  provider?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  userIP?: InputMaybe<SortOrderInput>;
};

export enum PaimentHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Error = 'error',
  Id = 'id',
  OrderId = 'orderId',
  PaymentId = 'paymentId',
  PaymentMode = 'paymentMode',
  Provider = 'provider',
  Status = 'status',
  UserIp = 'userIP'
}

export type PaimentHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<PaimentHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaimentHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<PaimentHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  paymentMode?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaimentStatusFilter>;
  userIP?: InputMaybe<StringNullableFilter>;
};

export type PaimentHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PaimentHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PaimentHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaimentHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  error?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntNullableWithAggregatesFilter>;
  paymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentMode?: InputMaybe<StringNullableWithAggregatesFilter>;
  provider?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumPaimentStatusWithAggregatesFilter>;
  userIP?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PaimentHistorySumAggregate = {
  __typename?: 'PaimentHistorySumAggregate';
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type PaimentHistorySumOrderByAggregateInput = {
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type PaimentHistoryUpdateInput = {
  Customer?: InputMaybe<UserUpdateOneWithoutPaimentHistoriesNestedInput>;
  Order?: InputMaybe<OrderUpdateOneWithoutPaimentHistoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaimentStatusFieldUpdateOperationsInput>;
  userIP?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaimentHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaimentStatusFieldUpdateOperationsInput>;
  userIP?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaimentHistoryUpdateManyWithWhereWithoutCustomerInput = {
  data: PaimentHistoryUpdateManyMutationInput;
  where: PaimentHistoryScalarWhereInput;
};

export type PaimentHistoryUpdateManyWithWhereWithoutOrderInput = {
  data: PaimentHistoryUpdateManyMutationInput;
  where: PaimentHistoryScalarWhereInput;
};

export type PaimentHistoryUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaimentHistoryCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<PaimentHistoryCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<PaimentHistoryCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaimentHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<PaimentHistoryUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<PaimentHistoryUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<PaimentHistoryUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type PaimentHistoryUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaimentHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaimentHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaimentHistoryCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaimentHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<PaimentHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<PaimentHistoryUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<PaimentHistoryUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<PaimentHistoryUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type PaimentHistoryUpdateWithWhereUniqueWithoutCustomerInput = {
  data: PaimentHistoryUpdateWithoutCustomerInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryUpdateWithWhereUniqueWithoutOrderInput = {
  data: PaimentHistoryUpdateWithoutOrderInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryUpdateWithoutCustomerInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutPaimentHistoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaimentStatusFieldUpdateOperationsInput>;
  userIP?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaimentHistoryUpdateWithoutOrderInput = {
  Customer?: InputMaybe<UserUpdateOneWithoutPaimentHistoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provider?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaimentStatusFieldUpdateOperationsInput>;
  userIP?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PaimentHistoryUpsertWithWhereUniqueWithoutCustomerInput = {
  create: PaimentHistoryCreateWithoutCustomerInput;
  update: PaimentHistoryUpdateWithoutCustomerInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryUpsertWithWhereUniqueWithoutOrderInput = {
  create: PaimentHistoryCreateWithoutOrderInput;
  update: PaimentHistoryUpdateWithoutOrderInput;
  where: PaimentHistoryWhereUniqueInput;
};

export type PaimentHistoryWhereInput = {
  AND?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  Customer?: InputMaybe<UserNullableRelationFilter>;
  NOT?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  OR?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntNullableFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  paymentMode?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaimentStatusFilter>;
  userIP?: InputMaybe<StringNullableFilter>;
};

export type PaimentHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  Customer?: InputMaybe<UserNullableRelationFilter>;
  NOT?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  OR?: InputMaybe<Array<PaimentHistoryWhereInput>>;
  Order?: InputMaybe<OrderNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntNullableFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  paymentMode?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaimentStatusFilter>;
  userIP?: InputMaybe<StringNullableFilter>;
};

export enum PaimentStatus {
  Cancel = 'CANCEL',
  Error = 'ERROR',
  Errorfromprovider = 'ERRORFROMPROVIDER',
  Notfoundorder = 'NOTFOUNDORDER',
  Orderidnotprovided = 'ORDERIDNOTPROVIDED',
  Tokennotprovided = 'TOKENNOTPROVIDED',
  Unauthenticated = 'UNAUTHENTICATED',
  Valid = 'VALID'
}

export type PaymentIntentResponse = {
  __typename?: 'PaymentIntentResponse';
  clientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

/** The type of the Platform */
export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PromptEngineer = {
  __typename?: 'PromptEngineer';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  prompt_en: Scalars['String']['output'];
  prompt_fr: Scalars['String']['output'];
  target: PromptTarget;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PromptEngineerAvgAggregate = {
  __typename?: 'PromptEngineerAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type PromptEngineerAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PromptEngineerCountAggregate = {
  __typename?: 'PromptEngineerCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  prompt_en: Scalars['Int']['output'];
  prompt_fr: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PromptEngineerCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt_en?: InputMaybe<SortOrder>;
  prompt_fr?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PromptEngineerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  prompt_en: Scalars['String']['input'];
  prompt_fr: Scalars['String']['input'];
  target?: InputMaybe<PromptTarget>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PromptEngineerCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  prompt_en: Scalars['String']['input'];
  prompt_fr: Scalars['String']['input'];
  target?: InputMaybe<PromptTarget>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PromptEngineerGroupBy = {
  __typename?: 'PromptEngineerGroupBy';
  _avg?: Maybe<PromptEngineerAvgAggregate>;
  _count?: Maybe<PromptEngineerCountAggregate>;
  _max?: Maybe<PromptEngineerMaxAggregate>;
  _min?: Maybe<PromptEngineerMinAggregate>;
  _sum?: Maybe<PromptEngineerSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  prompt_en: Scalars['String']['output'];
  prompt_fr: Scalars['String']['output'];
  target: PromptTarget;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PromptEngineerMaxAggregate = {
  __typename?: 'PromptEngineerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  prompt_en?: Maybe<Scalars['String']['output']>;
  prompt_fr?: Maybe<Scalars['String']['output']>;
  target?: Maybe<PromptTarget>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PromptEngineerMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt_en?: InputMaybe<SortOrder>;
  prompt_fr?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PromptEngineerMinAggregate = {
  __typename?: 'PromptEngineerMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  prompt_en?: Maybe<Scalars['String']['output']>;
  prompt_fr?: Maybe<Scalars['String']['output']>;
  target?: Maybe<PromptTarget>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PromptEngineerMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt_en?: InputMaybe<SortOrder>;
  prompt_fr?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PromptEngineerOrderByRelevanceFieldEnum {
  PromptEn = 'prompt_en',
  PromptFr = 'prompt_fr'
}

export type PromptEngineerOrderByRelevanceInput = {
  fields: Array<PromptEngineerOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type PromptEngineerOrderByWithAggregationInput = {
  _avg?: InputMaybe<PromptEngineerAvgOrderByAggregateInput>;
  _count?: InputMaybe<PromptEngineerCountOrderByAggregateInput>;
  _max?: InputMaybe<PromptEngineerMaxOrderByAggregateInput>;
  _min?: InputMaybe<PromptEngineerMinOrderByAggregateInput>;
  _sum?: InputMaybe<PromptEngineerSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt_en?: InputMaybe<SortOrder>;
  prompt_fr?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PromptEngineerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<PromptEngineerOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt_en?: InputMaybe<SortOrder>;
  prompt_fr?: InputMaybe<SortOrder>;
  target?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PromptEngineerScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  PromptEn = 'prompt_en',
  PromptFr = 'prompt_fr',
  Target = 'target',
  UpdatedAt = 'updatedAt'
}

export type PromptEngineerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PromptEngineerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PromptEngineerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PromptEngineerScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  prompt_en?: InputMaybe<StringWithAggregatesFilter>;
  prompt_fr?: InputMaybe<StringWithAggregatesFilter>;
  target?: InputMaybe<EnumPromptTargetWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PromptEngineerSumAggregate = {
  __typename?: 'PromptEngineerSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type PromptEngineerSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PromptEngineerUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  prompt_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  target?: InputMaybe<EnumPromptTargetFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PromptEngineerUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  prompt_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  target?: InputMaybe<EnumPromptTargetFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PromptEngineerWhereInput = {
  AND?: InputMaybe<Array<PromptEngineerWhereInput>>;
  NOT?: InputMaybe<Array<PromptEngineerWhereInput>>;
  OR?: InputMaybe<Array<PromptEngineerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  prompt_en?: InputMaybe<StringFilter>;
  prompt_fr?: InputMaybe<StringFilter>;
  target?: InputMaybe<EnumPromptTargetFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PromptEngineerWhereUniqueInput = {
  AND?: InputMaybe<Array<PromptEngineerWhereInput>>;
  NOT?: InputMaybe<Array<PromptEngineerWhereInput>>;
  OR?: InputMaybe<Array<PromptEngineerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  prompt_en?: InputMaybe<StringFilter>;
  prompt_fr?: InputMaybe<StringFilter>;
  target?: InputMaybe<EnumPromptTargetFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PromptTarget {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type PushTokens = {
  __typename?: 'PushTokens';
  User: User;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  platform: Platform;
  token: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type PushTokensAvgAggregate = {
  __typename?: 'PushTokensAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type PushTokensAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensCountAggregate = {
  __typename?: 'PushTokensCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  platform: Scalars['Int']['output'];
  token: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type PushTokensCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensCreateInput = {
  User: UserCreateNestedOneWithoutPushTokensInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
};

export type PushTokensCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type PushTokensCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
};

export type PushTokensCreateManyUserInputEnvelope = {
  data: Array<PushTokensCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PushTokensCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PushTokensWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PushTokensCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PushTokensCreateWithoutUserInput>>;
  createMany?: InputMaybe<PushTokensCreateManyUserInputEnvelope>;
};

export type PushTokensCreateOrConnectWithoutUserInput = {
  create: PushTokensCreateWithoutUserInput;
  where: PushTokensWhereUniqueInput;
};

export type PushTokensCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  platform: Platform;
  token: Scalars['String']['input'];
};

export type PushTokensGroupBy = {
  __typename?: 'PushTokensGroupBy';
  _avg?: Maybe<PushTokensAvgAggregate>;
  _count?: Maybe<PushTokensCountAggregate>;
  _max?: Maybe<PushTokensMaxAggregate>;
  _min?: Maybe<PushTokensMinAggregate>;
  _sum?: Maybe<PushTokensSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  platform: Platform;
  token: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type PushTokensListRelationFilter = {
  every?: InputMaybe<PushTokensWhereInput>;
  none?: InputMaybe<PushTokensWhereInput>;
  some?: InputMaybe<PushTokensWhereInput>;
};

export type PushTokensMaxAggregate = {
  __typename?: 'PushTokensMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Platform>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PushTokensMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensMinAggregate = {
  __typename?: 'PushTokensMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<Platform>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PushTokensMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum PushTokensOrderByRelevanceFieldEnum {
  Token = 'token'
}

export type PushTokensOrderByRelevanceInput = {
  fields: Array<PushTokensOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type PushTokensOrderByWithAggregationInput = {
  _avg?: InputMaybe<PushTokensAvgOrderByAggregateInput>;
  _count?: InputMaybe<PushTokensCountOrderByAggregateInput>;
  _max?: InputMaybe<PushTokensMaxOrderByAggregateInput>;
  _min?: InputMaybe<PushTokensMinOrderByAggregateInput>;
  _sum?: InputMaybe<PushTokensSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensOrderByWithRelationAndSearchRelevanceInput = {
  User?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<PushTokensOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  platform?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum PushTokensScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Platform = 'platform',
  Token = 'token',
  UserId = 'userId'
}

export type PushTokensScalarWhereInput = {
  AND?: InputMaybe<Array<PushTokensScalarWhereInput>>;
  NOT?: InputMaybe<Array<PushTokensScalarWhereInput>>;
  OR?: InputMaybe<Array<PushTokensScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  platform?: InputMaybe<EnumPlatformFilter>;
  token?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PushTokensScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PushTokensScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PushTokensScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PushTokensScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  platform?: InputMaybe<EnumPlatformWithAggregatesFilter>;
  token?: InputMaybe<StringWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type PushTokensSumAggregate = {
  __typename?: 'PushTokensSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type PushTokensSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PushTokensUpdateInput = {
  User?: InputMaybe<UserUpdateOneRequiredWithoutPushTokensNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumPlatformFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PushTokensUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumPlatformFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PushTokensUpdateManyWithWhereWithoutUserInput = {
  data: PushTokensUpdateManyMutationInput;
  where: PushTokensScalarWhereInput;
};

export type PushTokensUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PushTokensWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PushTokensCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PushTokensCreateWithoutUserInput>>;
  createMany?: InputMaybe<PushTokensCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PushTokensWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PushTokensScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PushTokensWhereUniqueInput>>;
  set?: InputMaybe<Array<PushTokensWhereUniqueInput>>;
  update?: InputMaybe<Array<PushTokensUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PushTokensUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PushTokensUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PushTokensUpdateWithWhereUniqueWithoutUserInput = {
  data: PushTokensUpdateWithoutUserInput;
  where: PushTokensWhereUniqueInput;
};

export type PushTokensUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumPlatformFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PushTokensUpsertWithWhereUniqueWithoutUserInput = {
  create: PushTokensCreateWithoutUserInput;
  update: PushTokensUpdateWithoutUserInput;
  where: PushTokensWhereUniqueInput;
};

export type PushTokensWhereInput = {
  AND?: InputMaybe<Array<PushTokensWhereInput>>;
  NOT?: InputMaybe<Array<PushTokensWhereInput>>;
  OR?: InputMaybe<Array<PushTokensWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  platform?: InputMaybe<EnumPlatformFilter>;
  token?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type PushTokensWhereUniqueInput = {
  AND?: InputMaybe<Array<PushTokensWhereInput>>;
  NOT?: InputMaybe<Array<PushTokensWhereInput>>;
  OR?: InputMaybe<Array<PushTokensWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<EnumPlatformFilter>;
  token?: InputMaybe<StringFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type Query = {
  __typename?: 'Query';
  actionOrder?: Maybe<ActionOrder>;
  actionOrders: Array<ActionOrder>;
  aggregateActionOrder: AggregateActionOrder;
  aggregateAskDeliveryMan: AggregateAskDeliveryMan;
  aggregateCategory: AggregateCategory;
  aggregateChat: AggregateChat;
  aggregateChatMessage: AggregateChatMessage;
  aggregateCountry: AggregateCountry;
  aggregateCraftmanWallet: AggregateCraftmanWallet;
  aggregateEmail: AggregateEmail;
  aggregateExchangeCurrency: AggregateExchangeCurrency;
  aggregateFaq: AggregateFaq;
  aggregateFavorites: AggregateFavorites;
  aggregateFile: AggregateFile;
  aggregateItemType: AggregateItemType;
  aggregateMaterialType: AggregateMaterialType;
  aggregateNoticeOrder: AggregateNoticeOrder;
  aggregateNotification: AggregateNotification;
  aggregateOrder: AggregateOrder;
  aggregateOrderPrice: AggregateOrderPrice;
  aggregateOrderSize: AggregateOrderSize;
  aggregatePaimentHistory: AggregatePaimentHistory;
  aggregatePromptEngineer: AggregatePromptEngineer;
  aggregatePushTokens: AggregatePushTokens;
  aggregateSegmentation: AggregateSegmentation;
  aggregateTransporter: AggregateTransporter;
  aggregateTransporterPrice: AggregateTransporterPrice;
  aggregateTransporterZone: AggregateTransporterZone;
  aggregateUser: AggregateUser;
  aggregateUserAddress: AggregateUserAddress;
  aggregateUserPrompt: AggregateUserPrompt;
  aggregateUserRestPassword: AggregateUserRestPassword;
  aggregateUserStory: AggregateUserStory;
  aggregateValidOrderEvidence: AggregateValidOrderEvidence;
  askDeliveryMan?: Maybe<AskDeliveryMan>;
  askDeliveryMen: Array<AskDeliveryMan>;
  categories: Array<Category>;
  category?: Maybe<Category>;
  chat?: Maybe<Chat>;
  chatMessage?: Maybe<ChatMessage>;
  chatMessages: Array<ChatMessage>;
  chats: Array<Chat>;
  countries: Array<Country>;
  country?: Maybe<Country>;
  craftmanStatisticBoard: CraftmanStatisticBoard;
  craftmanWallet?: Maybe<CraftmanWallet>;
  craftmanWallets: Array<CraftmanWallet>;
  craftmenFeed: CraftmenFeedResponse;
  email?: Maybe<Email>;
  emails: Array<Email>;
  exchangeCurrencies: Array<ExchangeCurrency>;
  exchangeCurrency?: Maybe<ExchangeCurrency>;
  faq?: Maybe<Faq>;
  faqs: Array<Faq>;
  file?: Maybe<File>;
  files: Array<File>;
  findFirstActionOrder?: Maybe<ActionOrder>;
  findFirstActionOrderOrThrow?: Maybe<ActionOrder>;
  findFirstAskDeliveryMan?: Maybe<AskDeliveryMan>;
  findFirstAskDeliveryManOrThrow?: Maybe<AskDeliveryMan>;
  findFirstCategory?: Maybe<Category>;
  findFirstCategoryOrThrow?: Maybe<Category>;
  findFirstChat?: Maybe<Chat>;
  findFirstChatMessage?: Maybe<ChatMessage>;
  findFirstChatMessageOrThrow?: Maybe<ChatMessage>;
  findFirstChatOrThrow?: Maybe<Chat>;
  findFirstCountry?: Maybe<Country>;
  findFirstCountryOrThrow?: Maybe<Country>;
  findFirstCraftmanWallet?: Maybe<CraftmanWallet>;
  findFirstCraftmanWalletOrThrow?: Maybe<CraftmanWallet>;
  findFirstEmail?: Maybe<Email>;
  findFirstEmailOrThrow?: Maybe<Email>;
  findFirstExchangeCurrency?: Maybe<ExchangeCurrency>;
  findFirstExchangeCurrencyOrThrow?: Maybe<ExchangeCurrency>;
  findFirstFaq?: Maybe<Faq>;
  findFirstFaqOrThrow?: Maybe<Faq>;
  findFirstFavorites?: Maybe<Favorites>;
  findFirstFavoritesOrThrow?: Maybe<Favorites>;
  findFirstFile?: Maybe<File>;
  findFirstFileOrThrow?: Maybe<File>;
  findFirstItemType?: Maybe<ItemType>;
  findFirstItemTypeOrThrow?: Maybe<ItemType>;
  findFirstMaterialType?: Maybe<MaterialType>;
  findFirstMaterialTypeOrThrow?: Maybe<MaterialType>;
  findFirstNoticeOrder?: Maybe<NoticeOrder>;
  findFirstNoticeOrderOrThrow?: Maybe<NoticeOrder>;
  findFirstNotification?: Maybe<Notification>;
  findFirstNotificationOrThrow?: Maybe<Notification>;
  findFirstOrder?: Maybe<Order>;
  findFirstOrderOrThrow?: Maybe<Order>;
  findFirstOrderPrice?: Maybe<OrderPrice>;
  findFirstOrderPriceOrThrow?: Maybe<OrderPrice>;
  findFirstOrderSize?: Maybe<OrderSize>;
  findFirstOrderSizeOrThrow?: Maybe<OrderSize>;
  findFirstPaimentHistory?: Maybe<PaimentHistory>;
  findFirstPaimentHistoryOrThrow?: Maybe<PaimentHistory>;
  findFirstPromptEngineer?: Maybe<PromptEngineer>;
  findFirstPromptEngineerOrThrow?: Maybe<PromptEngineer>;
  findFirstPushTokens?: Maybe<PushTokens>;
  findFirstPushTokensOrThrow?: Maybe<PushTokens>;
  findFirstSegmentation?: Maybe<Segmentation>;
  findFirstSegmentationOrThrow?: Maybe<Segmentation>;
  findFirstTransporter?: Maybe<Transporter>;
  findFirstTransporterOrThrow?: Maybe<Transporter>;
  findFirstTransporterPrice?: Maybe<TransporterPrice>;
  findFirstTransporterPriceOrThrow?: Maybe<TransporterPrice>;
  findFirstTransporterZone?: Maybe<TransporterZone>;
  findFirstTransporterZoneOrThrow?: Maybe<TransporterZone>;
  findFirstUser?: Maybe<User>;
  findFirstUserAddress?: Maybe<UserAddress>;
  findFirstUserAddressOrThrow?: Maybe<UserAddress>;
  findFirstUserOrThrow?: Maybe<User>;
  findFirstUserPrompt?: Maybe<UserPrompt>;
  findFirstUserPromptOrThrow?: Maybe<UserPrompt>;
  findFirstUserRestPassword?: Maybe<UserRestPassword>;
  findFirstUserRestPasswordOrThrow?: Maybe<UserRestPassword>;
  findFirstUserStory?: Maybe<UserStory>;
  findFirstUserStoryOrThrow?: Maybe<UserStory>;
  findFirstValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  findFirstValidOrderEvidenceOrThrow?: Maybe<ValidOrderEvidence>;
  findManyFavorites: Array<Favorites>;
  findManyPushTokens: Array<PushTokens>;
  findUniqueFavorites?: Maybe<Favorites>;
  findUniqueFavoritesOrThrow?: Maybe<Favorites>;
  findUniquePushTokens?: Maybe<PushTokens>;
  findUniquePushTokensOrThrow?: Maybe<PushTokens>;
  getActionOrder?: Maybe<ActionOrder>;
  getAskDeliveryMan?: Maybe<AskDeliveryMan>;
  getCategory?: Maybe<Category>;
  getChat?: Maybe<Chat>;
  getChatMessage?: Maybe<ChatMessage>;
  getCountry?: Maybe<Country>;
  getCraftmanWallet?: Maybe<CraftmanWallet>;
  getEmail?: Maybe<Email>;
  getExchangeCurrency?: Maybe<ExchangeCurrency>;
  getFaq?: Maybe<Faq>;
  getFile?: Maybe<File>;
  getHighRatedCraftmen: Array<User>;
  getItemType?: Maybe<ItemType>;
  getManyCraftmans: Array<User>;
  getMaterialType?: Maybe<MaterialType>;
  getNoticeOrder?: Maybe<NoticeOrder>;
  getNotification?: Maybe<Notification>;
  getOrder?: Maybe<Order>;
  getOrderPrice?: Maybe<OrderPrice>;
  getOrderShopCart: ShopCart;
  getOrderSize?: Maybe<OrderSize>;
  getPaimentHistory?: Maybe<PaimentHistory>;
  getPromptEngineer?: Maybe<PromptEngineer>;
  getSegmentation?: Maybe<Segmentation>;
  getTransporter?: Maybe<Transporter>;
  getTransporterPrice?: Maybe<TransporterPrice>;
  getTransporterZone?: Maybe<TransporterZone>;
  getUser?: Maybe<User>;
  getUserAddress?: Maybe<UserAddress>;
  getUserPrompt?: Maybe<UserPrompt>;
  getUserRestPassword?: Maybe<UserRestPassword>;
  getUserStory?: Maybe<UserStory>;
  getValidOrderEvidence?: Maybe<ValidOrderEvidence>;
  groupByActionOrder: Array<ActionOrderGroupBy>;
  groupByAskDeliveryMan: Array<AskDeliveryManGroupBy>;
  groupByCategory: Array<CategoryGroupBy>;
  groupByChat: Array<ChatGroupBy>;
  groupByChatMessage: Array<ChatMessageGroupBy>;
  groupByCountry: Array<CountryGroupBy>;
  groupByCraftmanWallet: Array<CraftmanWalletGroupBy>;
  groupByEmail: Array<EmailGroupBy>;
  groupByExchangeCurrency: Array<ExchangeCurrencyGroupBy>;
  groupByFaq: Array<FaqGroupBy>;
  groupByFavorites: Array<FavoritesGroupBy>;
  groupByFile: Array<FileGroupBy>;
  groupByItemType: Array<ItemTypeGroupBy>;
  groupByMaterialType: Array<MaterialTypeGroupBy>;
  groupByNoticeOrder: Array<NoticeOrderGroupBy>;
  groupByNotification: Array<NotificationGroupBy>;
  groupByOrder: Array<OrderGroupBy>;
  groupByOrderPrice: Array<OrderPriceGroupBy>;
  groupByOrderSize: Array<OrderSizeGroupBy>;
  groupByPaimentHistory: Array<PaimentHistoryGroupBy>;
  groupByPromptEngineer: Array<PromptEngineerGroupBy>;
  groupByPushTokens: Array<PushTokensGroupBy>;
  groupBySegmentation: Array<SegmentationGroupBy>;
  groupByTransporter: Array<TransporterGroupBy>;
  groupByTransporterPrice: Array<TransporterPriceGroupBy>;
  groupByTransporterZone: Array<TransporterZoneGroupBy>;
  groupByUser: Array<UserGroupBy>;
  groupByUserAddress: Array<UserAddressGroupBy>;
  groupByUserPrompt: Array<UserPromptGroupBy>;
  groupByUserRestPassword: Array<UserRestPasswordGroupBy>;
  groupByUserStory: Array<UserStoryGroupBy>;
  groupByValidOrderEvidence: Array<ValidOrderEvidenceGroupBy>;
  itemType?: Maybe<ItemType>;
  itemTypes: Array<ItemType>;
  materialType?: Maybe<MaterialType>;
  materialTypes: Array<MaterialType>;
  noticeOrder?: Maybe<NoticeOrder>;
  noticeOrders: Array<NoticeOrder>;
  notification?: Maybe<Notification>;
  notifications: Array<Notification>;
  order?: Maybe<Order>;
  orderPrice?: Maybe<OrderPrice>;
  orderPrices: Array<OrderPrice>;
  orderSize?: Maybe<OrderSize>;
  orderSizes: Array<OrderSize>;
  orders: Array<Order>;
  paimentHistories: Array<PaimentHistory>;
  paimentHistory?: Maybe<PaimentHistory>;
  promptEngineer?: Maybe<PromptEngineer>;
  promptEngineers: Array<PromptEngineer>;
  segmentation?: Maybe<Segmentation>;
  segmentations: Array<Segmentation>;
  translateText: Scalars['String']['output'];
  transporter?: Maybe<Transporter>;
  transporterPrice?: Maybe<TransporterPrice>;
  transporterPrices: Array<TransporterPrice>;
  transporterZone?: Maybe<TransporterZone>;
  transporterZones: Array<TransporterZone>;
  transporters: Array<Transporter>;
  user?: Maybe<User>;
  userAddress?: Maybe<UserAddress>;
  userAddresses: Array<UserAddress>;
  userPrompt?: Maybe<UserPrompt>;
  userPrompts: Array<UserPrompt>;
  userRestPassword?: Maybe<UserRestPassword>;
  userRestPasswords: Array<UserRestPassword>;
  userStories: Array<UserStory>;
  userStory?: Maybe<UserStory>;
  users: Array<User>;
  validOrderEvidence?: Maybe<ValidOrderEvidence>;
  validOrderEvidences: Array<ValidOrderEvidence>;
};


export type QueryActionOrderArgs = {
  where: ActionOrderWhereUniqueInput;
};


export type QueryActionOrdersArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActionOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type QueryAggregateActionOrderArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type QueryAggregateAskDeliveryManArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type QueryAggregateCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryAggregateChatArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryAggregateChatMessageArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type QueryAggregateCountryArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryAggregateCraftmanWalletArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type QueryAggregateEmailArgs = {
  cursor?: InputMaybe<EmailWhereUniqueInput>;
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type QueryAggregateExchangeCurrencyArgs = {
  cursor?: InputMaybe<ExchangeCurrencyWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ExchangeCurrencyOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type QueryAggregateFaqArgs = {
  cursor?: InputMaybe<FaqWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FaqOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryAggregateFavoritesArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type QueryAggregateFileArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryAggregateItemTypeArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type QueryAggregateMaterialTypeArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type QueryAggregateNoticeOrderArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type QueryAggregateNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryAggregateOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryAggregateOrderPriceArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type QueryAggregateOrderSizeArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type QueryAggregatePaimentHistoryArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type QueryAggregatePromptEngineerArgs = {
  cursor?: InputMaybe<PromptEngineerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PromptEngineerOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type QueryAggregatePushTokensArgs = {
  cursor?: InputMaybe<PushTokensWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type QueryAggregateSegmentationArgs = {
  cursor?: InputMaybe<SegmentationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type QueryAggregateTransporterArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};


export type QueryAggregateTransporterPriceArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type QueryAggregateTransporterZoneArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateUserAddressArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type QueryAggregateUserPromptArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type QueryAggregateUserRestPasswordArgs = {
  cursor?: InputMaybe<UserRestPasswordWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserRestPasswordOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type QueryAggregateUserStoryArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type QueryAggregateValidOrderEvidenceArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type QueryAskDeliveryManArgs = {
  where: AskDeliveryManWhereUniqueInput;
};


export type QueryAskDeliveryMenArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type QueryCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryChatArgs = {
  where: ChatWhereUniqueInput;
};


export type QueryChatMessageArgs = {
  where: ChatMessageWhereUniqueInput;
};


export type QueryChatMessagesArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type QueryChatsArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryCraftmanStatisticBoardArgs = {
  craftmanId: Scalars['Float']['input'];
};


export type QueryCraftmanWalletArgs = {
  where: CraftmanWalletWhereUniqueInput;
};


export type QueryCraftmanWalletsArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  distinct?: InputMaybe<Array<CraftmanWalletScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type QueryCraftmenFeedArgs = {
  orderBy?: InputMaybe<OrderByNoteInput>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CraftmenFeedWhereInput>;
};


export type QueryEmailArgs = {
  where: EmailWhereUniqueInput;
};


export type QueryEmailsArgs = {
  cursor?: InputMaybe<EmailWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type QueryExchangeCurrenciesArgs = {
  cursor?: InputMaybe<ExchangeCurrencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExchangeCurrencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExchangeCurrencyOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type QueryExchangeCurrencyArgs = {
  where: ExchangeCurrencyWhereUniqueInput;
};


export type QueryFaqArgs = {
  where: FaqWhereUniqueInput;
};


export type QueryFaqsArgs = {
  cursor?: InputMaybe<FaqWhereUniqueInput>;
  distinct?: InputMaybe<Array<FaqScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FaqOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstActionOrderArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActionOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type QueryFindFirstActionOrderOrThrowArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActionOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type QueryFindFirstAskDeliveryManArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type QueryFindFirstAskDeliveryManOrThrowArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type QueryFindFirstCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryFindFirstCategoryOrThrowArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryFindFirstChatArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryFindFirstChatMessageArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type QueryFindFirstChatMessageOrThrowArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type QueryFindFirstChatOrThrowArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryFindFirstCountryArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryFindFirstCountryOrThrowArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryFindFirstCraftmanWalletArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  distinct?: InputMaybe<Array<CraftmanWalletScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type QueryFindFirstCraftmanWalletOrThrowArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  distinct?: InputMaybe<Array<CraftmanWalletScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type QueryFindFirstEmailArgs = {
  cursor?: InputMaybe<EmailWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type QueryFindFirstEmailOrThrowArgs = {
  cursor?: InputMaybe<EmailWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type QueryFindFirstExchangeCurrencyArgs = {
  cursor?: InputMaybe<ExchangeCurrencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExchangeCurrencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExchangeCurrencyOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type QueryFindFirstExchangeCurrencyOrThrowArgs = {
  cursor?: InputMaybe<ExchangeCurrencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExchangeCurrencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExchangeCurrencyOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type QueryFindFirstFaqArgs = {
  cursor?: InputMaybe<FaqWhereUniqueInput>;
  distinct?: InputMaybe<Array<FaqScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FaqOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryFindFirstFaqOrThrowArgs = {
  cursor?: InputMaybe<FaqWhereUniqueInput>;
  distinct?: InputMaybe<Array<FaqScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FaqOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryFindFirstFavoritesArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoritesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type QueryFindFirstFavoritesOrThrowArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoritesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type QueryFindFirstFileArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstFileOrThrowArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryFindFirstItemTypeArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type QueryFindFirstItemTypeOrThrowArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type QueryFindFirstMaterialTypeArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type QueryFindFirstMaterialTypeOrThrowArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type QueryFindFirstNoticeOrderArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticeOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type QueryFindFirstNoticeOrderOrThrowArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticeOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type QueryFindFirstNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryFindFirstNotificationOrThrowArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryFindFirstOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstOrderOrThrowArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstOrderPriceArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type QueryFindFirstOrderPriceOrThrowArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type QueryFindFirstOrderSizeArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type QueryFindFirstOrderSizeOrThrowArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type QueryFindFirstPaimentHistoryArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaimentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type QueryFindFirstPaimentHistoryOrThrowArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaimentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type QueryFindFirstPromptEngineerArgs = {
  cursor?: InputMaybe<PromptEngineerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromptEngineerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromptEngineerOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type QueryFindFirstPromptEngineerOrThrowArgs = {
  cursor?: InputMaybe<PromptEngineerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromptEngineerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromptEngineerOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type QueryFindFirstPushTokensArgs = {
  cursor?: InputMaybe<PushTokensWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushTokensScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type QueryFindFirstPushTokensOrThrowArgs = {
  cursor?: InputMaybe<PushTokensWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushTokensScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type QueryFindFirstSegmentationArgs = {
  cursor?: InputMaybe<SegmentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<SegmentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type QueryFindFirstSegmentationOrThrowArgs = {
  cursor?: InputMaybe<SegmentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<SegmentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type QueryFindFirstTransporterArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};


export type QueryFindFirstTransporterOrThrowArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};


export type QueryFindFirstTransporterPriceArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type QueryFindFirstTransporterPriceOrThrowArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type QueryFindFirstTransporterZoneArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type QueryFindFirstTransporterZoneOrThrowArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstUserAddressArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type QueryFindFirstUserAddressOrThrowArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type QueryFindFirstUserOrThrowArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstUserPromptArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPromptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type QueryFindFirstUserPromptOrThrowArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPromptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type QueryFindFirstUserRestPasswordArgs = {
  cursor?: InputMaybe<UserRestPasswordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRestPasswordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRestPasswordOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type QueryFindFirstUserRestPasswordOrThrowArgs = {
  cursor?: InputMaybe<UserRestPasswordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRestPasswordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRestPasswordOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type QueryFindFirstUserStoryArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserStoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type QueryFindFirstUserStoryOrThrowArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserStoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type QueryFindFirstValidOrderEvidenceArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type QueryFindFirstValidOrderEvidenceOrThrowArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type QueryFindManyFavoritesArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoritesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type QueryFindManyPushTokensArgs = {
  cursor?: InputMaybe<PushTokensWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushTokensScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type QueryFindUniqueFavoritesArgs = {
  where: FavoritesWhereUniqueInput;
};


export type QueryFindUniqueFavoritesOrThrowArgs = {
  where: FavoritesWhereUniqueInput;
};


export type QueryFindUniquePushTokensArgs = {
  where: PushTokensWhereUniqueInput;
};


export type QueryFindUniquePushTokensOrThrowArgs = {
  where: PushTokensWhereUniqueInput;
};


export type QueryGetActionOrderArgs = {
  where: ActionOrderWhereUniqueInput;
};


export type QueryGetAskDeliveryManArgs = {
  where: AskDeliveryManWhereUniqueInput;
};


export type QueryGetCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryGetChatArgs = {
  where: ChatWhereUniqueInput;
};


export type QueryGetChatMessageArgs = {
  where: ChatMessageWhereUniqueInput;
};


export type QueryGetCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryGetCraftmanWalletArgs = {
  where: CraftmanWalletWhereUniqueInput;
};


export type QueryGetEmailArgs = {
  where: EmailWhereUniqueInput;
};


export type QueryGetExchangeCurrencyArgs = {
  where: ExchangeCurrencyWhereUniqueInput;
};


export type QueryGetFaqArgs = {
  where: FaqWhereUniqueInput;
};


export type QueryGetFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryGetHighRatedCraftmenArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetItemTypeArgs = {
  where: ItemTypeWhereUniqueInput;
};


export type QueryGetManyCraftmansArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGetMaterialTypeArgs = {
  where: MaterialTypeWhereUniqueInput;
};


export type QueryGetNoticeOrderArgs = {
  where: NoticeOrderWhereUniqueInput;
};


export type QueryGetNotificationArgs = {
  where: NotificationWhereUniqueInput;
};


export type QueryGetOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryGetOrderPriceArgs = {
  where: OrderPriceWhereUniqueInput;
};


export type QueryGetOrderShopCartArgs = {
  orderId: Scalars['Float']['input'];
};


export type QueryGetOrderSizeArgs = {
  where: OrderSizeWhereUniqueInput;
};


export type QueryGetPaimentHistoryArgs = {
  where: PaimentHistoryWhereUniqueInput;
};


export type QueryGetPromptEngineerArgs = {
  where: PromptEngineerWhereUniqueInput;
};


export type QueryGetSegmentationArgs = {
  where: SegmentationWhereUniqueInput;
};


export type QueryGetTransporterArgs = {
  where: TransporterWhereUniqueInput;
};


export type QueryGetTransporterPriceArgs = {
  where: TransporterPriceWhereUniqueInput;
};


export type QueryGetTransporterZoneArgs = {
  where: TransporterZoneWhereUniqueInput;
};


export type QueryGetUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryGetUserAddressArgs = {
  where: UserAddressWhereUniqueInput;
};


export type QueryGetUserPromptArgs = {
  where: UserPromptWhereUniqueInput;
};


export type QueryGetUserRestPasswordArgs = {
  where: UserRestPasswordWhereUniqueInput;
};


export type QueryGetUserStoryArgs = {
  where: UserStoryWhereUniqueInput;
};


export type QueryGetValidOrderEvidenceArgs = {
  where: ValidOrderEvidenceWhereUniqueInput;
};


export type QueryGroupByActionOrderArgs = {
  by: Array<ActionOrderScalarFieldEnum>;
  having?: InputMaybe<ActionOrderScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type QueryGroupByAskDeliveryManArgs = {
  by: Array<AskDeliveryManScalarFieldEnum>;
  having?: InputMaybe<AskDeliveryManScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type QueryGroupByCategoryArgs = {
  by: Array<CategoryScalarFieldEnum>;
  having?: InputMaybe<CategoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryGroupByChatArgs = {
  by: Array<ChatScalarFieldEnum>;
  having?: InputMaybe<ChatScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ChatOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryGroupByChatMessageArgs = {
  by: Array<ChatMessageScalarFieldEnum>;
  having?: InputMaybe<ChatMessageScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type QueryGroupByCountryArgs = {
  by: Array<CountryScalarFieldEnum>;
  having?: InputMaybe<CountryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CountryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryGroupByCraftmanWalletArgs = {
  by: Array<CraftmanWalletScalarFieldEnum>;
  having?: InputMaybe<CraftmanWalletScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type QueryGroupByEmailArgs = {
  by: Array<EmailScalarFieldEnum>;
  having?: InputMaybe<EmailScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<EmailOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type QueryGroupByExchangeCurrencyArgs = {
  by: Array<ExchangeCurrencyScalarFieldEnum>;
  having?: InputMaybe<ExchangeCurrencyScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ExchangeCurrencyOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExchangeCurrencyWhereInput>;
};


export type QueryGroupByFaqArgs = {
  by: Array<FaqScalarFieldEnum>;
  having?: InputMaybe<FaqScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FaqOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqWhereInput>;
};


export type QueryGroupByFavoritesArgs = {
  by: Array<FavoritesScalarFieldEnum>;
  having?: InputMaybe<FavoritesScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type QueryGroupByFileArgs = {
  by: Array<FileScalarFieldEnum>;
  having?: InputMaybe<FileScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FileOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryGroupByItemTypeArgs = {
  by: Array<ItemTypeScalarFieldEnum>;
  having?: InputMaybe<ItemTypeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type QueryGroupByMaterialTypeArgs = {
  by: Array<MaterialTypeScalarFieldEnum>;
  having?: InputMaybe<MaterialTypeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type QueryGroupByNoticeOrderArgs = {
  by: Array<NoticeOrderScalarFieldEnum>;
  having?: InputMaybe<NoticeOrderScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type QueryGroupByNotificationArgs = {
  by: Array<NotificationScalarFieldEnum>;
  having?: InputMaybe<NotificationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryGroupByOrderArgs = {
  by: Array<OrderScalarFieldEnum>;
  having?: InputMaybe<OrderScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryGroupByOrderPriceArgs = {
  by: Array<OrderPriceScalarFieldEnum>;
  having?: InputMaybe<OrderPriceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type QueryGroupByOrderSizeArgs = {
  by: Array<OrderSizeScalarFieldEnum>;
  having?: InputMaybe<OrderSizeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type QueryGroupByPaimentHistoryArgs = {
  by: Array<PaimentHistoryScalarFieldEnum>;
  having?: InputMaybe<PaimentHistoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type QueryGroupByPromptEngineerArgs = {
  by: Array<PromptEngineerScalarFieldEnum>;
  having?: InputMaybe<PromptEngineerScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PromptEngineerOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type QueryGroupByPushTokensArgs = {
  by: Array<PushTokensScalarFieldEnum>;
  having?: InputMaybe<PushTokensScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type QueryGroupBySegmentationArgs = {
  by: Array<SegmentationScalarFieldEnum>;
  having?: InputMaybe<SegmentationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type QueryGroupByTransporterArgs = {
  by: Array<TransporterScalarFieldEnum>;
  having?: InputMaybe<TransporterScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};


export type QueryGroupByTransporterPriceArgs = {
  by: Array<TransporterPriceScalarFieldEnum>;
  having?: InputMaybe<TransporterPriceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type QueryGroupByTransporterZoneArgs = {
  by: Array<TransporterZoneScalarFieldEnum>;
  having?: InputMaybe<TransporterZoneScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type QueryGroupByUserArgs = {
  by: Array<UserScalarFieldEnum>;
  having?: InputMaybe<UserScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGroupByUserAddressArgs = {
  by: Array<UserAddressScalarFieldEnum>;
  having?: InputMaybe<UserAddressScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type QueryGroupByUserPromptArgs = {
  by: Array<UserPromptScalarFieldEnum>;
  having?: InputMaybe<UserPromptScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type QueryGroupByUserRestPasswordArgs = {
  by: Array<UserRestPasswordScalarFieldEnum>;
  having?: InputMaybe<UserRestPasswordScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserRestPasswordOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type QueryGroupByUserStoryArgs = {
  by: Array<UserStoryScalarFieldEnum>;
  having?: InputMaybe<UserStoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type QueryGroupByValidOrderEvidenceArgs = {
  by: Array<ValidOrderEvidenceScalarFieldEnum>;
  having?: InputMaybe<ValidOrderEvidenceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type QueryItemTypeArgs = {
  where: ItemTypeWhereUniqueInput;
};


export type QueryItemTypesArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type QueryMaterialTypeArgs = {
  where: MaterialTypeWhereUniqueInput;
};


export type QueryMaterialTypesArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type QueryNoticeOrderArgs = {
  where: NoticeOrderWhereUniqueInput;
};


export type QueryNoticeOrdersArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticeOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type QueryNotificationArgs = {
  where: NotificationWhereUniqueInput;
};


export type QueryNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrderPriceArgs = {
  where: OrderPriceWhereUniqueInput;
};


export type QueryOrderPricesArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type QueryOrderSizeArgs = {
  where: OrderSizeWhereUniqueInput;
};


export type QueryOrderSizesArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryPaimentHistoriesArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaimentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type QueryPaimentHistoryArgs = {
  where: PaimentHistoryWhereUniqueInput;
};


export type QueryPromptEngineerArgs = {
  where: PromptEngineerWhereUniqueInput;
};


export type QueryPromptEngineersArgs = {
  cursor?: InputMaybe<PromptEngineerWhereUniqueInput>;
  distinct?: InputMaybe<Array<PromptEngineerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PromptEngineerOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptEngineerWhereInput>;
};


export type QuerySegmentationArgs = {
  where: SegmentationWhereUniqueInput;
};


export type QuerySegmentationsArgs = {
  cursor?: InputMaybe<SegmentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<SegmentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentationWhereInput>;
};


export type QueryTranslateTextArgs = {
  targetLang: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QueryTransporterArgs = {
  where: TransporterWhereUniqueInput;
};


export type QueryTransporterPriceArgs = {
  where: TransporterPriceWhereUniqueInput;
};


export type QueryTransporterPricesArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type QueryTransporterZoneArgs = {
  where: TransporterZoneWhereUniqueInput;
};


export type QueryTransporterZonesArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type QueryTransportersArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserAddressArgs = {
  where: UserAddressWhereUniqueInput;
};


export type QueryUserAddressesArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type QueryUserPromptArgs = {
  where: UserPromptWhereUniqueInput;
};


export type QueryUserPromptsArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPromptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type QueryUserRestPasswordArgs = {
  where: UserRestPasswordWhereUniqueInput;
};


export type QueryUserRestPasswordsArgs = {
  cursor?: InputMaybe<UserRestPasswordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRestPasswordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRestPasswordOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserRestPasswordWhereInput>;
};


export type QueryUserStoriesArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserStoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type QueryUserStoryArgs = {
  where: UserStoryWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryValidOrderEvidenceArgs = {
  where: ValidOrderEvidenceWhereUniqueInput;
};


export type QueryValidOrderEvidencesArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum Role {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  Craftman = 'CRAFTMAN',
  Customer = 'CUSTOMER',
  Yume = 'YUME'
}

export type Segmentation = {
  __typename?: 'Segmentation';
  Category: Array<Category>;
  _count?: Maybe<SegmentationCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type SegmentationCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};

export type SegmentationAvgAggregate = {
  __typename?: 'SegmentationAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
};

export type SegmentationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type SegmentationCount = {
  __typename?: 'SegmentationCount';
  Category: Scalars['Int']['output'];
};


export type SegmentationCountCategoryArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};

export type SegmentationCountAggregate = {
  __typename?: 'SegmentationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['Int']['output'];
  name_fr: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SegmentationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SegmentationCreateInput = {
  Category?: InputMaybe<CategoryCreateNestedManyWithoutSegmentationInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SegmentationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SegmentationCreateNestedOneWithoutCategoryInput = {
  connect?: InputMaybe<SegmentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SegmentationCreateOrConnectWithoutCategoryInput>;
  create?: InputMaybe<SegmentationCreateWithoutCategoryInput>;
};

export type SegmentationCreateOrConnectWithoutCategoryInput = {
  create: SegmentationCreateWithoutCategoryInput;
  where: SegmentationWhereUniqueInput;
};

export type SegmentationCreateWithoutCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name_en: Scalars['String']['input'];
  name_fr: Scalars['String']['input'];
  oldID?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SegmentationGroupBy = {
  __typename?: 'SegmentationGroupBy';
  _avg?: Maybe<SegmentationAvgAggregate>;
  _count?: Maybe<SegmentationCountAggregate>;
  _max?: Maybe<SegmentationMaxAggregate>;
  _min?: Maybe<SegmentationMinAggregate>;
  _sum?: Maybe<SegmentationSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name_en: Scalars['String']['output'];
  name_fr: Scalars['String']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SegmentationMaxAggregate = {
  __typename?: 'SegmentationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SegmentationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SegmentationMinAggregate = {
  __typename?: 'SegmentationMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name_en?: Maybe<Scalars['String']['output']>;
  name_fr?: Maybe<Scalars['String']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SegmentationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SegmentationOrderByRelevanceFieldEnum {
  NameEn = 'name_en',
  NameFr = 'name_fr'
}

export type SegmentationOrderByRelevanceInput = {
  fields: Array<SegmentationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type SegmentationOrderByWithAggregationInput = {
  _avg?: InputMaybe<SegmentationAvgOrderByAggregateInput>;
  _count?: InputMaybe<SegmentationCountOrderByAggregateInput>;
  _max?: InputMaybe<SegmentationMaxOrderByAggregateInput>;
  _min?: InputMaybe<SegmentationMinOrderByAggregateInput>;
  _sum?: InputMaybe<SegmentationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SegmentationOrderByWithRelationAndSearchRelevanceInput = {
  Category?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<SegmentationOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_fr?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SegmentationRelationFilter = {
  is?: InputMaybe<SegmentationWhereInput>;
  isNot?: InputMaybe<SegmentationWhereInput>;
};

export enum SegmentationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  NameEn = 'name_en',
  NameFr = 'name_fr',
  OldId = 'oldID',
  UpdatedAt = 'updatedAt'
}

export type SegmentationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SegmentationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SegmentationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SegmentationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name_en?: InputMaybe<StringWithAggregatesFilter>;
  name_fr?: InputMaybe<StringWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SegmentationSumAggregate = {
  __typename?: 'SegmentationSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
};

export type SegmentationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
};

export type SegmentationUpdateInput = {
  Category?: InputMaybe<CategoryUpdateManyWithoutSegmentationNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SegmentationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SegmentationUpdateOneRequiredWithoutCategoryNestedInput = {
  connect?: InputMaybe<SegmentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SegmentationCreateOrConnectWithoutCategoryInput>;
  create?: InputMaybe<SegmentationCreateWithoutCategoryInput>;
  update?: InputMaybe<SegmentationUpdateToOneWithWhereWithoutCategoryInput>;
  upsert?: InputMaybe<SegmentationUpsertWithoutCategoryInput>;
};

export type SegmentationUpdateToOneWithWhereWithoutCategoryInput = {
  data: SegmentationUpdateWithoutCategoryInput;
  where?: InputMaybe<SegmentationWhereInput>;
};

export type SegmentationUpdateWithoutCategoryInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name_en?: InputMaybe<StringFieldUpdateOperationsInput>;
  name_fr?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SegmentationUpsertWithoutCategoryInput = {
  create: SegmentationCreateWithoutCategoryInput;
  update: SegmentationUpdateWithoutCategoryInput;
  where?: InputMaybe<SegmentationWhereInput>;
};

export type SegmentationWhereInput = {
  AND?: InputMaybe<Array<SegmentationWhereInput>>;
  Category?: InputMaybe<CategoryListRelationFilter>;
  NOT?: InputMaybe<Array<SegmentationWhereInput>>;
  OR?: InputMaybe<Array<SegmentationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name_en?: InputMaybe<StringFilter>;
  name_fr?: InputMaybe<StringFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SegmentationWhereUniqueInput = {
  AND?: InputMaybe<Array<SegmentationWhereInput>>;
  Category?: InputMaybe<CategoryListRelationFilter>;
  NOT?: InputMaybe<Array<SegmentationWhereInput>>;
  OR?: InputMaybe<Array<SegmentationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_fr?: InputMaybe<Scalars['String']['input']>;
  oldID?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShopCart = {
  __typename?: 'ShopCart';
  countryId?: Maybe<Scalars['Float']['output']>;
  craftsmanAmount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  materiale: Scalars['String']['output'];
  matiere: Scalars['String']['output'];
  orderFee: Scalars['Float']['output'];
  paimenproPrice: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  serviceCharge: Scalars['Float']['output'];
  shippingCost: Scalars['Float']['output'];
};

export type SignupInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  itemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoAchievements?: InputMaybe<Array<NewFileInput>>;
  platform?: InputMaybe<PlatformType>;
  profilePhoto?: InputMaybe<NewFileInput>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  role: UserRoleType;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Float']['input']>;
};

/** The type of the social account */
export enum SocialAccountType {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google'
}

export type SocialCraftmaInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  itemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: PlatformType;
  profile?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  socialAccountType: SocialAccountType;
  socialID: Scalars['String']['input'];
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SocialCustomerInput = {
  email: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: PlatformType;
  profile?: InputMaybe<Scalars['String']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  socialAccountType: SocialAccountType;
  socialID: Scalars['String']['input'];
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Direction for sorting results */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export enum Status {
  Archive = 'ARCHIVE',
  Delivry = 'DELIVRY',
  Paid = 'PAID',
  Pending = 'PENDING',
  Valid = 'VALID'
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  editMessageSubscription: ChatMessage;
  newMessage: ChatMessage;
  newNotification: Notification;
  newStorySub: UserStory;
  toogleArchiveOrderSub: Order;
  updateWalletCraftmanSub: User;
  validCraftmanPaimentSub: CraftmanWallet;
  validOrderDelivrySub: Order;
  validPaimentSub: Order;
};


export type SubscriptionEditMessageSubscriptionArgs = {
  chatMessageId: Scalars['Float']['input'];
};


export type SubscriptionNewMessageArgs = {
  chatId: Scalars['Float']['input'];
};


export type SubscriptionNewNotificationArgs = {
  receiverId: Scalars['Float']['input'];
};


export type SubscriptionToogleArchiveOrderSubArgs = {
  orderId: Scalars['Float']['input'];
};


export type SubscriptionUpdateWalletCraftmanSubArgs = {
  craftmanId: Scalars['Float']['input'];
};


export type SubscriptionValidCraftmanPaimentSubArgs = {
  craftmanId: Scalars['Float']['input'];
};


export type SubscriptionValidOrderDelivrySubArgs = {
  orderId: Scalars['Float']['input'];
};


export type SubscriptionValidPaimentSubArgs = {
  orderId: Scalars['Float']['input'];
};

export type Transporter = {
  __typename?: 'Transporter';
  TransporterPrices: Array<TransporterPrice>;
  TransporterZones: Array<TransporterZone>;
  _count?: Maybe<TransporterCount>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  webSite?: Maybe<Scalars['String']['output']>;
};


export type TransporterTransporterPricesArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type TransporterTransporterZonesArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};

export type TransporterAvgAggregate = {
  __typename?: 'TransporterAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type TransporterAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransporterCount = {
  __typename?: 'TransporterCount';
  TransporterPrices: Scalars['Int']['output'];
  TransporterZones: Scalars['Int']['output'];
};


export type TransporterCountTransporterPricesArgs = {
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type TransporterCountTransporterZonesArgs = {
  where?: InputMaybe<TransporterZoneWhereInput>;
};

export type TransporterCountAggregate = {
  __typename?: 'TransporterCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isLocal: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  webSite: Scalars['Int']['output'];
};

export type TransporterCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLocal?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  webSite?: InputMaybe<SortOrder>;
};

export type TransporterCreateInput = {
  TransporterPrices?: InputMaybe<TransporterPriceCreateNestedManyWithoutTransportersInput>;
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutTransportersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type TransporterCreateManyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type TransporterCreateNestedManyWithoutTransporterPricesInput = {
  connect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterCreateOrConnectWithoutTransporterPricesInput>>;
  create?: InputMaybe<Array<TransporterCreateWithoutTransporterPricesInput>>;
};

export type TransporterCreateNestedManyWithoutTransporterZonesInput = {
  connect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<TransporterCreateWithoutTransporterZonesInput>>;
};

export type TransporterCreateOrConnectWithoutTransporterPricesInput = {
  create: TransporterCreateWithoutTransporterPricesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterCreateOrConnectWithoutTransporterZonesInput = {
  create: TransporterCreateWithoutTransporterZonesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterCreateWithoutTransporterPricesInput = {
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutTransportersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type TransporterCreateWithoutTransporterZonesInput = {
  TransporterPrices?: InputMaybe<TransporterPriceCreateNestedManyWithoutTransportersInput>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webSite?: InputMaybe<Scalars['String']['input']>;
};

export type TransporterGroupBy = {
  __typename?: 'TransporterGroupBy';
  _avg?: Maybe<TransporterAvgAggregate>;
  _count?: Maybe<TransporterCountAggregate>;
  _max?: Maybe<TransporterMaxAggregate>;
  _min?: Maybe<TransporterMinAggregate>;
  _sum?: Maybe<TransporterSumAggregate>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  webSite?: Maybe<Scalars['String']['output']>;
};

export type TransporterListRelationFilter = {
  every?: InputMaybe<TransporterWhereInput>;
  none?: InputMaybe<TransporterWhereInput>;
  some?: InputMaybe<TransporterWhereInput>;
};

export type TransporterMaxAggregate = {
  __typename?: 'TransporterMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  webSite?: Maybe<Scalars['String']['output']>;
};

export type TransporterMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLocal?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  webSite?: InputMaybe<SortOrder>;
};

export type TransporterMinAggregate = {
  __typename?: 'TransporterMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  webSite?: Maybe<Scalars['String']['output']>;
};

export type TransporterMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isLocal?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  webSite?: InputMaybe<SortOrder>;
};

export type TransporterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum TransporterOrderByRelevanceFieldEnum {
  Address = 'address',
  Email = 'email',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  WebSite = 'webSite'
}

export type TransporterOrderByRelevanceInput = {
  fields: Array<TransporterOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type TransporterOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransporterAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransporterCountOrderByAggregateInput>;
  _max?: InputMaybe<TransporterMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransporterMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransporterSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isLocal?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  webSite?: InputMaybe<SortOrderInput>;
};

export type TransporterOrderByWithRelationAndSearchRelevanceInput = {
  TransporterPrices?: InputMaybe<TransporterPriceOrderByRelationAggregateInput>;
  TransporterZones?: InputMaybe<TransporterZoneOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<TransporterOrderByRelevanceInput>;
  address?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isLocal?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  webSite?: InputMaybe<SortOrderInput>;
};

export type TransporterPrice = {
  __typename?: 'TransporterPrice';
  TransporterZones: Array<TransporterZone>;
  Transporters: Array<Transporter>;
  _count?: Maybe<TransporterPriceCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  weightMax: Scalars['Float']['output'];
  weightMin: Scalars['Float']['output'];
};


export type TransporterPriceTransporterZonesArgs = {
  cursor?: InputMaybe<TransporterZoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterZoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type TransporterPriceTransportersArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};

export type TransporterPriceAvgAggregate = {
  __typename?: 'TransporterPriceAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  weightMax?: Maybe<Scalars['Float']['output']>;
  weightMin?: Maybe<Scalars['Float']['output']>;
};

export type TransporterPriceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceCount = {
  __typename?: 'TransporterPriceCount';
  TransporterZones: Scalars['Int']['output'];
  Transporters: Scalars['Int']['output'];
};


export type TransporterPriceCountTransporterZonesArgs = {
  where?: InputMaybe<TransporterZoneWhereInput>;
};


export type TransporterPriceCountTransportersArgs = {
  where?: InputMaybe<TransporterWhereInput>;
};

export type TransporterPriceCountAggregate = {
  __typename?: 'TransporterPriceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weightMax: Scalars['Int']['output'];
  weightMin: Scalars['Int']['output'];
};

export type TransporterPriceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceCreateInput = {
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutTransporterPricesInput>;
  Transporters?: InputMaybe<TransporterCreateNestedManyWithoutTransporterPricesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weightMax: Scalars['Float']['input'];
  weightMin: Scalars['Float']['input'];
};

export type TransporterPriceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weightMax: Scalars['Float']['input'];
  weightMin: Scalars['Float']['input'];
};

export type TransporterPriceCreateNestedManyWithoutTransporterZonesInput = {
  connect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterPriceCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<TransporterPriceCreateWithoutTransporterZonesInput>>;
};

export type TransporterPriceCreateNestedManyWithoutTransportersInput = {
  connect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterPriceCreateOrConnectWithoutTransportersInput>>;
  create?: InputMaybe<Array<TransporterPriceCreateWithoutTransportersInput>>;
};

export type TransporterPriceCreateOrConnectWithoutTransporterZonesInput = {
  create: TransporterPriceCreateWithoutTransporterZonesInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceCreateOrConnectWithoutTransportersInput = {
  create: TransporterPriceCreateWithoutTransportersInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceCreateWithoutTransporterZonesInput = {
  Transporters?: InputMaybe<TransporterCreateNestedManyWithoutTransporterPricesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weightMax: Scalars['Float']['input'];
  weightMin: Scalars['Float']['input'];
};

export type TransporterPriceCreateWithoutTransportersInput = {
  TransporterZones?: InputMaybe<TransporterZoneCreateNestedManyWithoutTransporterPricesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  weightMax: Scalars['Float']['input'];
  weightMin: Scalars['Float']['input'];
};

export type TransporterPriceGroupBy = {
  __typename?: 'TransporterPriceGroupBy';
  _avg?: Maybe<TransporterPriceAvgAggregate>;
  _count?: Maybe<TransporterPriceCountAggregate>;
  _max?: Maybe<TransporterPriceMaxAggregate>;
  _min?: Maybe<TransporterPriceMinAggregate>;
  _sum?: Maybe<TransporterPriceSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  weightMax: Scalars['Float']['output'];
  weightMin: Scalars['Float']['output'];
};

export type TransporterPriceListRelationFilter = {
  every?: InputMaybe<TransporterPriceWhereInput>;
  none?: InputMaybe<TransporterPriceWhereInput>;
  some?: InputMaybe<TransporterPriceWhereInput>;
};

export type TransporterPriceMaxAggregate = {
  __typename?: 'TransporterPriceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  weightMax?: Maybe<Scalars['Float']['output']>;
  weightMin?: Maybe<Scalars['Float']['output']>;
};

export type TransporterPriceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceMinAggregate = {
  __typename?: 'TransporterPriceMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  weightMax?: Maybe<Scalars['Float']['output']>;
  weightMin?: Maybe<Scalars['Float']['output']>;
};

export type TransporterPriceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransporterPriceOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransporterPriceAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransporterPriceCountOrderByAggregateInput>;
  _max?: InputMaybe<TransporterPriceMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransporterPriceMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransporterPriceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceOrderByWithRelationAndSearchRelevanceInput = {
  TransporterZones?: InputMaybe<TransporterZoneOrderByRelationAggregateInput>;
  Transporters?: InputMaybe<TransporterOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export enum TransporterPriceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Price = 'price',
  UpdatedAt = 'updatedAt',
  WeightMax = 'weightMax',
  WeightMin = 'weightMin'
}

export type TransporterPriceScalarWhereInput = {
  AND?: InputMaybe<Array<TransporterPriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransporterPriceScalarWhereInput>>;
  OR?: InputMaybe<Array<TransporterPriceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightMax?: InputMaybe<FloatFilter>;
  weightMin?: InputMaybe<FloatFilter>;
};

export type TransporterPriceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TransporterPriceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TransporterPriceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TransporterPriceScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  price?: InputMaybe<FloatWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  weightMax?: InputMaybe<FloatWithAggregatesFilter>;
  weightMin?: InputMaybe<FloatWithAggregatesFilter>;
};

export type TransporterPriceSumAggregate = {
  __typename?: 'TransporterPriceSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  weightMax?: Maybe<Scalars['Float']['output']>;
  weightMin?: Maybe<Scalars['Float']['output']>;
};

export type TransporterPriceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  weightMax?: InputMaybe<SortOrder>;
  weightMin?: InputMaybe<SortOrder>;
};

export type TransporterPriceUpdateInput = {
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutTransporterPricesNestedInput>;
  Transporters?: InputMaybe<TransporterUpdateManyWithoutTransporterPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weightMax?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weightMin?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TransporterPriceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weightMax?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weightMin?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TransporterPriceUpdateManyWithWhereWithoutTransporterZonesInput = {
  data: TransporterPriceUpdateManyMutationInput;
  where: TransporterPriceScalarWhereInput;
};

export type TransporterPriceUpdateManyWithWhereWithoutTransportersInput = {
  data: TransporterPriceUpdateManyMutationInput;
  where: TransporterPriceScalarWhereInput;
};

export type TransporterPriceUpdateManyWithoutTransporterZonesNestedInput = {
  connect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterPriceCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<TransporterPriceCreateWithoutTransporterZonesInput>>;
  delete?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterPriceUpdateWithWhereUniqueWithoutTransporterZonesInput>>;
  updateMany?: InputMaybe<Array<TransporterPriceUpdateManyWithWhereWithoutTransporterZonesInput>>;
  upsert?: InputMaybe<Array<TransporterPriceUpsertWithWhereUniqueWithoutTransporterZonesInput>>;
};

export type TransporterPriceUpdateManyWithoutTransportersNestedInput = {
  connect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterPriceCreateOrConnectWithoutTransportersInput>>;
  create?: InputMaybe<Array<TransporterPriceCreateWithoutTransportersInput>>;
  delete?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterPriceUpdateWithWhereUniqueWithoutTransportersInput>>;
  updateMany?: InputMaybe<Array<TransporterPriceUpdateManyWithWhereWithoutTransportersInput>>;
  upsert?: InputMaybe<Array<TransporterPriceUpsertWithWhereUniqueWithoutTransportersInput>>;
};

export type TransporterPriceUpdateWithWhereUniqueWithoutTransporterZonesInput = {
  data: TransporterPriceUpdateWithoutTransporterZonesInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceUpdateWithWhereUniqueWithoutTransportersInput = {
  data: TransporterPriceUpdateWithoutTransportersInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceUpdateWithoutTransporterZonesInput = {
  Transporters?: InputMaybe<TransporterUpdateManyWithoutTransporterPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weightMax?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weightMin?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TransporterPriceUpdateWithoutTransportersInput = {
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutTransporterPricesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weightMax?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weightMin?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type TransporterPriceUpsertWithWhereUniqueWithoutTransporterZonesInput = {
  create: TransporterPriceCreateWithoutTransporterZonesInput;
  update: TransporterPriceUpdateWithoutTransporterZonesInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceUpsertWithWhereUniqueWithoutTransportersInput = {
  create: TransporterPriceCreateWithoutTransportersInput;
  update: TransporterPriceUpdateWithoutTransportersInput;
  where: TransporterPriceWhereUniqueInput;
};

export type TransporterPriceWhereInput = {
  AND?: InputMaybe<Array<TransporterPriceWhereInput>>;
  NOT?: InputMaybe<Array<TransporterPriceWhereInput>>;
  OR?: InputMaybe<Array<TransporterPriceWhereInput>>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  Transporters?: InputMaybe<TransporterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightMax?: InputMaybe<FloatFilter>;
  weightMin?: InputMaybe<FloatFilter>;
};

export type TransporterPriceWhereUniqueInput = {
  AND?: InputMaybe<Array<TransporterPriceWhereInput>>;
  NOT?: InputMaybe<Array<TransporterPriceWhereInput>>;
  OR?: InputMaybe<Array<TransporterPriceWhereInput>>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  Transporters?: InputMaybe<TransporterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<FloatFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weightMax?: InputMaybe<FloatFilter>;
  weightMin?: InputMaybe<FloatFilter>;
};

export enum TransporterScalarFieldEnum {
  Address = 'address',
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  IsLocal = 'isLocal',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt',
  WebSite = 'webSite'
}

export type TransporterScalarWhereInput = {
  AND?: InputMaybe<Array<TransporterScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransporterScalarWhereInput>>;
  OR?: InputMaybe<Array<TransporterScalarWhereInput>>;
  address?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isLocal?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  webSite?: InputMaybe<StringNullableFilter>;
};

export type TransporterScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TransporterScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TransporterScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TransporterScalarWhereWithAggregatesInput>>;
  address?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isLocal?: InputMaybe<BoolNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  webSite?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type TransporterSumAggregate = {
  __typename?: 'TransporterSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type TransporterSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransporterUpdateInput = {
  TransporterPrices?: InputMaybe<TransporterPriceUpdateManyWithoutTransportersNestedInput>;
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutTransportersNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isLocal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  webSite?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TransporterUpdateManyMutationInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isLocal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  webSite?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TransporterUpdateManyWithWhereWithoutTransporterPricesInput = {
  data: TransporterUpdateManyMutationInput;
  where: TransporterScalarWhereInput;
};

export type TransporterUpdateManyWithWhereWithoutTransporterZonesInput = {
  data: TransporterUpdateManyMutationInput;
  where: TransporterScalarWhereInput;
};

export type TransporterUpdateManyWithoutTransporterPricesNestedInput = {
  connect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterCreateOrConnectWithoutTransporterPricesInput>>;
  create?: InputMaybe<Array<TransporterCreateWithoutTransporterPricesInput>>;
  delete?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterUpdateWithWhereUniqueWithoutTransporterPricesInput>>;
  updateMany?: InputMaybe<Array<TransporterUpdateManyWithWhereWithoutTransporterPricesInput>>;
  upsert?: InputMaybe<Array<TransporterUpsertWithWhereUniqueWithoutTransporterPricesInput>>;
};

export type TransporterUpdateManyWithoutTransporterZonesNestedInput = {
  connect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterCreateOrConnectWithoutTransporterZonesInput>>;
  create?: InputMaybe<Array<TransporterCreateWithoutTransporterZonesInput>>;
  delete?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterUpdateWithWhereUniqueWithoutTransporterZonesInput>>;
  updateMany?: InputMaybe<Array<TransporterUpdateManyWithWhereWithoutTransporterZonesInput>>;
  upsert?: InputMaybe<Array<TransporterUpsertWithWhereUniqueWithoutTransporterZonesInput>>;
};

export type TransporterUpdateWithWhereUniqueWithoutTransporterPricesInput = {
  data: TransporterUpdateWithoutTransporterPricesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterUpdateWithWhereUniqueWithoutTransporterZonesInput = {
  data: TransporterUpdateWithoutTransporterZonesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterUpdateWithoutTransporterPricesInput = {
  TransporterZones?: InputMaybe<TransporterZoneUpdateManyWithoutTransportersNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isLocal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  webSite?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TransporterUpdateWithoutTransporterZonesInput = {
  TransporterPrices?: InputMaybe<TransporterPriceUpdateManyWithoutTransportersNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isLocal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  webSite?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TransporterUpsertWithWhereUniqueWithoutTransporterPricesInput = {
  create: TransporterCreateWithoutTransporterPricesInput;
  update: TransporterUpdateWithoutTransporterPricesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterUpsertWithWhereUniqueWithoutTransporterZonesInput = {
  create: TransporterCreateWithoutTransporterZonesInput;
  update: TransporterUpdateWithoutTransporterZonesInput;
  where: TransporterWhereUniqueInput;
};

export type TransporterWhereInput = {
  AND?: InputMaybe<Array<TransporterWhereInput>>;
  NOT?: InputMaybe<Array<TransporterWhereInput>>;
  OR?: InputMaybe<Array<TransporterWhereInput>>;
  TransporterPrices?: InputMaybe<TransporterPriceListRelationFilter>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isLocal?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  webSite?: InputMaybe<StringNullableFilter>;
};

export type TransporterWhereUniqueInput = {
  AND?: InputMaybe<Array<TransporterWhereInput>>;
  NOT?: InputMaybe<Array<TransporterWhereInput>>;
  OR?: InputMaybe<Array<TransporterWhereInput>>;
  TransporterPrices?: InputMaybe<TransporterPriceListRelationFilter>;
  TransporterZones?: InputMaybe<TransporterZoneListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isLocal?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  webSite?: InputMaybe<StringNullableFilter>;
};

export type TransporterZone = {
  __typename?: 'TransporterZone';
  Countries: Array<Country>;
  TransporterPrices: Array<TransporterPrice>;
  Transporters: Array<Transporter>;
  _count?: Maybe<TransporterZoneCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type TransporterZoneCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CountryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type TransporterZoneTransporterPricesArgs = {
  cursor?: InputMaybe<TransporterPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type TransporterZoneTransportersArgs = {
  cursor?: InputMaybe<TransporterWhereUniqueInput>;
  distinct?: InputMaybe<Array<TransporterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransporterWhereInput>;
};

export type TransporterZoneAvgAggregate = {
  __typename?: 'TransporterZoneAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type TransporterZoneAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransporterZoneCount = {
  __typename?: 'TransporterZoneCount';
  Countries: Scalars['Int']['output'];
  TransporterPrices: Scalars['Int']['output'];
  Transporters: Scalars['Int']['output'];
};


export type TransporterZoneCountCountriesArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type TransporterZoneCountTransporterPricesArgs = {
  where?: InputMaybe<TransporterPriceWhereInput>;
};


export type TransporterZoneCountTransportersArgs = {
  where?: InputMaybe<TransporterWhereInput>;
};

export type TransporterZoneCountAggregate = {
  __typename?: 'TransporterZoneCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TransporterZoneCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransporterZoneCreateInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutTransporterZonesInput>;
  TransporterPrices?: InputMaybe<TransporterPriceCreateNestedManyWithoutTransporterZonesInput>;
  Transporters?: InputMaybe<TransporterCreateNestedManyWithoutTransporterZonesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TransporterZoneCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TransporterZoneCreateNestedManyWithoutCountriesInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutCountriesInput>>;
};

export type TransporterZoneCreateNestedManyWithoutTransporterPricesInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutTransporterPricesInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutTransporterPricesInput>>;
};

export type TransporterZoneCreateNestedManyWithoutTransportersInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutTransportersInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutTransportersInput>>;
};

export type TransporterZoneCreateOrConnectWithoutCountriesInput = {
  create: TransporterZoneCreateWithoutCountriesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneCreateOrConnectWithoutTransporterPricesInput = {
  create: TransporterZoneCreateWithoutTransporterPricesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneCreateOrConnectWithoutTransportersInput = {
  create: TransporterZoneCreateWithoutTransportersInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneCreateWithoutCountriesInput = {
  TransporterPrices?: InputMaybe<TransporterPriceCreateNestedManyWithoutTransporterZonesInput>;
  Transporters?: InputMaybe<TransporterCreateNestedManyWithoutTransporterZonesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TransporterZoneCreateWithoutTransporterPricesInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutTransporterZonesInput>;
  Transporters?: InputMaybe<TransporterCreateNestedManyWithoutTransporterZonesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TransporterZoneCreateWithoutTransportersInput = {
  Countries?: InputMaybe<CountryCreateNestedManyWithoutTransporterZonesInput>;
  TransporterPrices?: InputMaybe<TransporterPriceCreateNestedManyWithoutTransporterZonesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type TransporterZoneGroupBy = {
  __typename?: 'TransporterZoneGroupBy';
  _avg?: Maybe<TransporterZoneAvgAggregate>;
  _count?: Maybe<TransporterZoneCountAggregate>;
  _max?: Maybe<TransporterZoneMaxAggregate>;
  _min?: Maybe<TransporterZoneMinAggregate>;
  _sum?: Maybe<TransporterZoneSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type TransporterZoneListRelationFilter = {
  every?: InputMaybe<TransporterZoneWhereInput>;
  none?: InputMaybe<TransporterZoneWhereInput>;
  some?: InputMaybe<TransporterZoneWhereInput>;
};

export type TransporterZoneMaxAggregate = {
  __typename?: 'TransporterZoneMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TransporterZoneMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransporterZoneMinAggregate = {
  __typename?: 'TransporterZoneMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TransporterZoneMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransporterZoneOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum TransporterZoneOrderByRelevanceFieldEnum {
  Name = 'name'
}

export type TransporterZoneOrderByRelevanceInput = {
  fields: Array<TransporterZoneOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type TransporterZoneOrderByWithAggregationInput = {
  _avg?: InputMaybe<TransporterZoneAvgOrderByAggregateInput>;
  _count?: InputMaybe<TransporterZoneCountOrderByAggregateInput>;
  _max?: InputMaybe<TransporterZoneMaxOrderByAggregateInput>;
  _min?: InputMaybe<TransporterZoneMinOrderByAggregateInput>;
  _sum?: InputMaybe<TransporterZoneSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransporterZoneOrderByWithRelationAndSearchRelevanceInput = {
  Countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  TransporterPrices?: InputMaybe<TransporterPriceOrderByRelationAggregateInput>;
  Transporters?: InputMaybe<TransporterOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<TransporterZoneOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TransporterZoneScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type TransporterZoneScalarWhereInput = {
  AND?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  OR?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TransporterZoneScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TransporterZoneScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TransporterZoneScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TransporterZoneScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type TransporterZoneSumAggregate = {
  __typename?: 'TransporterZoneSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type TransporterZoneSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TransporterZoneUpdateInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutTransporterZonesNestedInput>;
  TransporterPrices?: InputMaybe<TransporterPriceUpdateManyWithoutTransporterZonesNestedInput>;
  Transporters?: InputMaybe<TransporterUpdateManyWithoutTransporterZonesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TransporterZoneUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TransporterZoneUpdateManyWithWhereWithoutCountriesInput = {
  data: TransporterZoneUpdateManyMutationInput;
  where: TransporterZoneScalarWhereInput;
};

export type TransporterZoneUpdateManyWithWhereWithoutTransporterPricesInput = {
  data: TransporterZoneUpdateManyMutationInput;
  where: TransporterZoneScalarWhereInput;
};

export type TransporterZoneUpdateManyWithWhereWithoutTransportersInput = {
  data: TransporterZoneUpdateManyMutationInput;
  where: TransporterZoneScalarWhereInput;
};

export type TransporterZoneUpdateManyWithoutCountriesNestedInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutCountriesInput>>;
  delete?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterZoneUpdateWithWhereUniqueWithoutCountriesInput>>;
  updateMany?: InputMaybe<Array<TransporterZoneUpdateManyWithWhereWithoutCountriesInput>>;
  upsert?: InputMaybe<Array<TransporterZoneUpsertWithWhereUniqueWithoutCountriesInput>>;
};

export type TransporterZoneUpdateManyWithoutTransporterPricesNestedInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutTransporterPricesInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutTransporterPricesInput>>;
  delete?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterZoneUpdateWithWhereUniqueWithoutTransporterPricesInput>>;
  updateMany?: InputMaybe<Array<TransporterZoneUpdateManyWithWhereWithoutTransporterPricesInput>>;
  upsert?: InputMaybe<Array<TransporterZoneUpsertWithWhereUniqueWithoutTransporterPricesInput>>;
};

export type TransporterZoneUpdateManyWithoutTransportersNestedInput = {
  connect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransporterZoneCreateOrConnectWithoutTransportersInput>>;
  create?: InputMaybe<Array<TransporterZoneCreateWithoutTransportersInput>>;
  delete?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransporterZoneScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  set?: InputMaybe<Array<TransporterZoneWhereUniqueInput>>;
  update?: InputMaybe<Array<TransporterZoneUpdateWithWhereUniqueWithoutTransportersInput>>;
  updateMany?: InputMaybe<Array<TransporterZoneUpdateManyWithWhereWithoutTransportersInput>>;
  upsert?: InputMaybe<Array<TransporterZoneUpsertWithWhereUniqueWithoutTransportersInput>>;
};

export type TransporterZoneUpdateWithWhereUniqueWithoutCountriesInput = {
  data: TransporterZoneUpdateWithoutCountriesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneUpdateWithWhereUniqueWithoutTransporterPricesInput = {
  data: TransporterZoneUpdateWithoutTransporterPricesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneUpdateWithWhereUniqueWithoutTransportersInput = {
  data: TransporterZoneUpdateWithoutTransportersInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneUpdateWithoutCountriesInput = {
  TransporterPrices?: InputMaybe<TransporterPriceUpdateManyWithoutTransporterZonesNestedInput>;
  Transporters?: InputMaybe<TransporterUpdateManyWithoutTransporterZonesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TransporterZoneUpdateWithoutTransporterPricesInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutTransporterZonesNestedInput>;
  Transporters?: InputMaybe<TransporterUpdateManyWithoutTransporterZonesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TransporterZoneUpdateWithoutTransportersInput = {
  Countries?: InputMaybe<CountryUpdateManyWithoutTransporterZonesNestedInput>;
  TransporterPrices?: InputMaybe<TransporterPriceUpdateManyWithoutTransporterZonesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TransporterZoneUpsertWithWhereUniqueWithoutCountriesInput = {
  create: TransporterZoneCreateWithoutCountriesInput;
  update: TransporterZoneUpdateWithoutCountriesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneUpsertWithWhereUniqueWithoutTransporterPricesInput = {
  create: TransporterZoneCreateWithoutTransporterPricesInput;
  update: TransporterZoneUpdateWithoutTransporterPricesInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneUpsertWithWhereUniqueWithoutTransportersInput = {
  create: TransporterZoneCreateWithoutTransportersInput;
  update: TransporterZoneUpdateWithoutTransportersInput;
  where: TransporterZoneWhereUniqueInput;
};

export type TransporterZoneWhereInput = {
  AND?: InputMaybe<Array<TransporterZoneWhereInput>>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<TransporterZoneWhereInput>>;
  OR?: InputMaybe<Array<TransporterZoneWhereInput>>;
  TransporterPrices?: InputMaybe<TransporterPriceListRelationFilter>;
  Transporters?: InputMaybe<TransporterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TransporterZoneWhereUniqueInput = {
  AND?: InputMaybe<Array<TransporterZoneWhereInput>>;
  Countries?: InputMaybe<CountryListRelationFilter>;
  NOT?: InputMaybe<Array<TransporterZoneWhereInput>>;
  OR?: InputMaybe<Array<TransporterZoneWhereInput>>;
  TransporterPrices?: InputMaybe<TransporterPriceListRelationFilter>;
  Transporters?: InputMaybe<TransporterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UpdateUserInput = {
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhoto?: InputMaybe<NewFileInput>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  itemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoAchievementDeleteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  photoAchievements?: InputMaybe<Array<NewFileInput>>;
  platform?: InputMaybe<PlatformType>;
  profilePhoto?: InputMaybe<NewFileInput>;
  profilePhotoDeleteId?: InputMaybe<Scalars['Float']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  role: UserRoleType;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Float']['input']>;
};

export type User = {
  __typename?: 'User';
  ActionOrders: Array<ActionOrder>;
  BannerPhoto?: Maybe<File>;
  Categories: Array<Category>;
  CraftmanAskDeliveryMan: Array<AskDeliveryMan>;
  CraftmanFavorites: Array<Favorites>;
  CraftmanOrders: Array<Order>;
  CraftmanTenders: Array<Order>;
  CraftmanValidOrderEvidence: Array<ValidOrderEvidence>;
  CraftmanWallet: Array<CraftmanWallet>;
  CustomerAskDeliveryMan: Array<AskDeliveryMan>;
  CustomerFavorites: Array<Favorites>;
  CustomerInValidTenders: Array<Order>;
  CustomerOrderSize: Array<OrderSize>;
  CustomerOrders: Array<Order>;
  CustomerValidOrderEvidence: Array<ValidOrderEvidence>;
  CustomerValidTenders: Array<Order>;
  Emails: Array<Email>;
  ItemTypes: Array<ItemType>;
  MaterialTypes: Array<MaterialType>;
  NoticeOrders: Array<NoticeOrder>;
  Notifications: Array<Notification>;
  OrderPrices: Array<OrderPrice>;
  PaimentHistories: Array<PaimentHistory>;
  PhotoAchievements: Array<File>;
  ProfilePhoto?: Maybe<File>;
  PushTokens: Array<PushTokens>;
  ReceiverChatMessages: Array<ChatMessage>;
  SenderChatMessages: Array<ChatMessage>;
  UserAddresses: Array<UserAddress>;
  UserPrompts: Array<UserPrompt>;
  UserStories: Array<UserStory>;
  _count?: Maybe<UserCount>;
  active: Scalars['Boolean']['output'];
  activeNotif: Scalars['Boolean']['output'];
  appleID?: Maybe<Scalars['String']['output']>;
  banish: Scalars['Boolean']['output'];
  bannerPhotoId?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  completedProfilPercentage: Scalars['Float']['output'];
  countCraftmanTenders: Scalars['Float']['output'];
  countInValidTenderCustomer: Scalars['Float']['output'];
  countNewNotification: Scalars['Float']['output'];
  countNotification: Scalars['Float']['output'];
  countValidTenderCustomer: Scalars['Float']['output'];
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerNbOrder: Scalars['Float']['output'];
  customerNbOrderPaid: Scalars['Float']['output'];
  customerRole?: Maybe<Scalars['String']['output']>;
  cuurentUserHaveStory: Scalars['Boolean']['output'];
  dateOfLastConnexion?: Maybe<Scalars['DateTimeISO']['output']>;
  delete: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookID?: Maybe<Scalars['String']['output']>;
  googleID?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActiveAdmin: Scalars['Boolean']['output'];
  isCraftmanVisible: Scalars['Boolean']['output'];
  isFavoris: Scalars['Boolean']['output'];
  isInterestedInCertificate: Scalars['Boolean']['output'];
  jackpotCraftman: Scalars['Float']['output'];
  lang: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minPriceOrderByCurrency: Scalars['String']['output'];
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nbClickProfile: Scalars['Int']['output'];
  note: Scalars['Float']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePhotoId?: Maybe<Scalars['Int']['output']>;
  referrals: Array<User>;
  referredBy?: Maybe<User>;
  referredById?: Maybe<Scalars['Int']['output']>;
  role: Role;
  sponsorshipCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userNotifications: Array<Notification>;
  workshopName?: Maybe<Scalars['String']['output']>;
  yearOfExperience?: Maybe<Scalars['Int']['output']>;
};


export type UserActionOrdersArgs = {
  cursor?: InputMaybe<ActionOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ActionOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type UserBannerPhotoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type UserCraftmanAskDeliveryManArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type UserCraftmanFavoritesArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoritesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type UserCraftmanOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCraftmanTendersArgs = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type UserCraftmanValidOrderEvidenceArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type UserCraftmanWalletArgs = {
  cursor?: InputMaybe<CraftmanWalletWhereUniqueInput>;
  distinct?: InputMaybe<Array<CraftmanWalletScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type UserCustomerAskDeliveryManArgs = {
  cursor?: InputMaybe<AskDeliveryManWhereUniqueInput>;
  distinct?: InputMaybe<Array<AskDeliveryManScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type UserCustomerFavoritesArgs = {
  cursor?: InputMaybe<FavoritesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FavoritesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FavoritesOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FavoritesWhereInput>;
};


export type UserCustomerInValidTendersArgs = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type UserCustomerOrderSizeArgs = {
  cursor?: InputMaybe<OrderSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderSizeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type UserCustomerOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCustomerValidOrderEvidenceArgs = {
  cursor?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ValidOrderEvidenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type UserCustomerValidTendersArgs = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type UserEmailsArgs = {
  cursor?: InputMaybe<EmailWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
};


export type UserItemTypesArgs = {
  cursor?: InputMaybe<ItemTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type UserMaterialTypesArgs = {
  cursor?: InputMaybe<MaterialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type UserNoticeOrdersArgs = {
  cursor?: InputMaybe<NoticeOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoticeOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoticeOrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type UserNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserOrderPricesArgs = {
  cursor?: InputMaybe<OrderPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type UserPaimentHistoriesArgs = {
  cursor?: InputMaybe<PaimentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaimentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type UserPhotoAchievementsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type UserProfilePhotoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserPushTokensArgs = {
  cursor?: InputMaybe<PushTokensWhereUniqueInput>;
  distinct?: InputMaybe<Array<PushTokensScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PushTokensOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PushTokensWhereInput>;
};


export type UserReceiverChatMessagesArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type UserSenderChatMessagesArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type UserUserAddressesArgs = {
  cursor?: InputMaybe<UserAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAddressOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserAddressWhereInput>;
};


export type UserUserPromptsArgs = {
  cursor?: InputMaybe<UserPromptWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPromptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPromptOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserPromptWhereInput>;
};


export type UserUserStoriesArgs = {
  cursor?: InputMaybe<UserStoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserStoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserStoryOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserStoryWhereInput>;
};


export type UserCountryArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type UserReferralsArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type UserReferredByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type UserUserNotificationsArgs = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type UserAddress = {
  __typename?: 'UserAddress';
  Country: Country;
  Customer: User;
  Order: Array<Order>;
  _count?: Maybe<UserAddressCount>;
  address: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  zipCode: Scalars['String']['output'];
};


export type UserAddressOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type UserAddressAvgAggregate = {
  __typename?: 'UserAddressAvgAggregate';
  countryId?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type UserAddressAvgOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserAddressCount = {
  __typename?: 'UserAddressCount';
  Order: Scalars['Int']['output'];
};


export type UserAddressCountOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type UserAddressCountAggregate = {
  __typename?: 'UserAddressCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  cityName: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zipCode: Scalars['Int']['output'];
};

export type UserAddressCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipCode?: InputMaybe<SortOrder>;
};

export type UserAddressCreateInput = {
  Country: CountryCreateNestedOneWithoutUserAddressesInput;
  Customer: UserCreateNestedOneWithoutUserAddressesInput;
  Order?: InputMaybe<OrderCreateNestedManyWithoutDeliveryAdressInput>;
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateManyCountryInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateManyCountryInputEnvelope = {
  data: Array<UserAddressCreateManyCountryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAddressCreateManyCustomerInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateManyCustomerInputEnvelope = {
  data: Array<UserAddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAddressCreateManyInput = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAddressCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<UserAddressCreateWithoutCountryInput>>;
  createMany?: InputMaybe<UserAddressCreateManyCountryInputEnvelope>;
};

export type UserAddressCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<UserAddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<UserAddressCreateManyCustomerInputEnvelope>;
};

export type UserAddressCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserAddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserAddressCreateWithoutOrderInput>;
};

export type UserAddressCreateOrConnectWithoutCountryInput = {
  create: UserAddressCreateWithoutCountryInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressCreateOrConnectWithoutCustomerInput = {
  create: UserAddressCreateWithoutCustomerInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressCreateOrConnectWithoutOrderInput = {
  create: UserAddressCreateWithoutOrderInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressCreateWithoutCountryInput = {
  Customer: UserCreateNestedOneWithoutUserAddressesInput;
  Order?: InputMaybe<OrderCreateNestedManyWithoutDeliveryAdressInput>;
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateWithoutCustomerInput = {
  Country: CountryCreateNestedOneWithoutUserAddressesInput;
  Order?: InputMaybe<OrderCreateNestedManyWithoutDeliveryAdressInput>;
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressCreateWithoutOrderInput = {
  Country: CountryCreateNestedOneWithoutUserAddressesInput;
  Customer: UserCreateNestedOneWithoutUserAddressesInput;
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserAddressGroupBy = {
  __typename?: 'UserAddressGroupBy';
  _avg?: Maybe<UserAddressAvgAggregate>;
  _count?: Maybe<UserAddressCountAggregate>;
  _max?: Maybe<UserAddressMaxAggregate>;
  _min?: Maybe<UserAddressMinAggregate>;
  _sum?: Maybe<UserAddressSumAggregate>;
  address: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  zipCode: Scalars['String']['output'];
};

export type UserAddressListRelationFilter = {
  every?: InputMaybe<UserAddressWhereInput>;
  none?: InputMaybe<UserAddressWhereInput>;
  some?: InputMaybe<UserAddressWhereInput>;
};

export type UserAddressMaxAggregate = {
  __typename?: 'UserAddressMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserAddressMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipCode?: InputMaybe<SortOrder>;
};

export type UserAddressMinAggregate = {
  __typename?: 'UserAddressMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserAddressMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipCode?: InputMaybe<SortOrder>;
};

export type UserAddressNullableRelationFilter = {
  is?: InputMaybe<UserAddressWhereInput>;
  isNot?: InputMaybe<UserAddressWhereInput>;
};

export type UserAddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserAddressOrderByRelevanceFieldEnum {
  Address = 'address',
  CityName = 'cityName',
  ZipCode = 'zipCode'
}

export type UserAddressOrderByRelevanceInput = {
  fields: Array<UserAddressOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UserAddressOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserAddressAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserAddressCountOrderByAggregateInput>;
  _max?: InputMaybe<UserAddressMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserAddressMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserAddressSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipCode?: InputMaybe<SortOrder>;
};

export type UserAddressOrderByWithRelationAndSearchRelevanceInput = {
  Country?: InputMaybe<CountryOrderByWithRelationAndSearchRelevanceInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<UserAddressOrderByRelevanceInput>;
  address?: InputMaybe<SortOrder>;
  cityName?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zipCode?: InputMaybe<SortOrder>;
};

export enum UserAddressScalarFieldEnum {
  Address = 'address',
  CityName = 'cityName',
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  IsActive = 'isActive',
  UpdatedAt = 'updatedAt',
  ZipCode = 'zipCode'
}

export type UserAddressScalarWhereInput = {
  AND?: InputMaybe<Array<UserAddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserAddressScalarWhereInput>>;
  OR?: InputMaybe<Array<UserAddressScalarWhereInput>>;
  address?: InputMaybe<StringFilter>;
  cityName?: InputMaybe<StringFilter>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zipCode?: InputMaybe<StringFilter>;
};

export type UserAddressScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserAddressScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserAddressScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserAddressScalarWhereWithAggregatesInput>>;
  address?: InputMaybe<StringWithAggregatesFilter>;
  cityName?: InputMaybe<StringWithAggregatesFilter>;
  countryId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  zipCode?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserAddressSumAggregate = {
  __typename?: 'UserAddressSumAggregate';
  countryId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type UserAddressSumOrderByAggregateInput = {
  countryId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserAddressUpdateInput = {
  Country?: InputMaybe<CountryUpdateOneRequiredWithoutUserAddressesNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutUserAddressesNestedInput>;
  Order?: InputMaybe<OrderUpdateManyWithoutDeliveryAdressNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  cityName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zipCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserAddressUpdateManyMutationInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  cityName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zipCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserAddressUpdateManyWithWhereWithoutCountryInput = {
  data: UserAddressUpdateManyMutationInput;
  where: UserAddressScalarWhereInput;
};

export type UserAddressUpdateManyWithWhereWithoutCustomerInput = {
  data: UserAddressUpdateManyMutationInput;
  where: UserAddressScalarWhereInput;
};

export type UserAddressUpdateManyWithoutCountryNestedInput = {
  connect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAddressCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<UserAddressCreateWithoutCountryInput>>;
  createMany?: InputMaybe<UserAddressCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAddressUpdateWithWhereUniqueWithoutCountryInput>>;
  updateMany?: InputMaybe<Array<UserAddressUpdateManyWithWhereWithoutCountryInput>>;
  upsert?: InputMaybe<Array<UserAddressUpsertWithWhereUniqueWithoutCountryInput>>;
};

export type UserAddressUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<UserAddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<UserAddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<UserAddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<UserAddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type UserAddressUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserAddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserAddressCreateWithoutOrderInput>;
  delete?: InputMaybe<UserAddressWhereInput>;
  disconnect?: InputMaybe<UserAddressWhereInput>;
  update?: InputMaybe<UserAddressUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserAddressUpsertWithoutOrderInput>;
};

export type UserAddressUpdateToOneWithWhereWithoutOrderInput = {
  data: UserAddressUpdateWithoutOrderInput;
  where?: InputMaybe<UserAddressWhereInput>;
};

export type UserAddressUpdateWithWhereUniqueWithoutCountryInput = {
  data: UserAddressUpdateWithoutCountryInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: UserAddressUpdateWithoutCustomerInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressUpdateWithoutCountryInput = {
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutUserAddressesNestedInput>;
  Order?: InputMaybe<OrderUpdateManyWithoutDeliveryAdressNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  cityName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zipCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserAddressUpdateWithoutCustomerInput = {
  Country?: InputMaybe<CountryUpdateOneRequiredWithoutUserAddressesNestedInput>;
  Order?: InputMaybe<OrderUpdateManyWithoutDeliveryAdressNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  cityName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zipCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserAddressUpdateWithoutOrderInput = {
  Country?: InputMaybe<CountryUpdateOneRequiredWithoutUserAddressesNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutUserAddressesNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  cityName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zipCode?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserAddressUpsertWithWhereUniqueWithoutCountryInput = {
  create: UserAddressCreateWithoutCountryInput;
  update: UserAddressUpdateWithoutCountryInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: UserAddressCreateWithoutCustomerInput;
  update: UserAddressUpdateWithoutCustomerInput;
  where: UserAddressWhereUniqueInput;
};

export type UserAddressUpsertWithoutOrderInput = {
  create: UserAddressCreateWithoutOrderInput;
  update: UserAddressUpdateWithoutOrderInput;
  where?: InputMaybe<UserAddressWhereInput>;
};

export type UserAddressWhereInput = {
  AND?: InputMaybe<Array<UserAddressWhereInput>>;
  Country?: InputMaybe<CountryRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<UserAddressWhereInput>>;
  OR?: InputMaybe<Array<UserAddressWhereInput>>;
  Order?: InputMaybe<OrderListRelationFilter>;
  address?: InputMaybe<StringFilter>;
  cityName?: InputMaybe<StringFilter>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zipCode?: InputMaybe<StringFilter>;
};

export type UserAddressWhereUniqueInput = {
  AND?: InputMaybe<Array<UserAddressWhereInput>>;
  Country?: InputMaybe<CountryRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<UserAddressWhereInput>>;
  OR?: InputMaybe<Array<UserAddressWhereInput>>;
  Order?: InputMaybe<OrderListRelationFilter>;
  address?: InputMaybe<StringFilter>;
  cityName?: InputMaybe<StringFilter>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zipCode?: InputMaybe<StringFilter>;
};

export type UserAvgAggregate = {
  __typename?: 'UserAvgAggregate';
  bannerPhotoId?: Maybe<Scalars['Float']['output']>;
  countryId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  nbClickProfile?: Maybe<Scalars['Float']['output']>;
  oldID?: Maybe<Scalars['Float']['output']>;
  profilePhotoId?: Maybe<Scalars['Float']['output']>;
  referredById?: Maybe<Scalars['Float']['output']>;
  yearOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type UserAvgOrderByAggregateInput = {
  bannerPhotoId?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minPriceOrder?: InputMaybe<SortOrder>;
  minQuantityOrder?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  profilePhotoId?: InputMaybe<SortOrder>;
  referredById?: InputMaybe<SortOrder>;
  yearOfExperience?: InputMaybe<SortOrder>;
};

export type UserCount = {
  __typename?: 'UserCount';
  ActionOrders: Scalars['Int']['output'];
  Categories: Scalars['Int']['output'];
  CraftmanAskDeliveryMan: Scalars['Int']['output'];
  CraftmanFavorites: Scalars['Int']['output'];
  CraftmanOrders: Scalars['Int']['output'];
  CraftmanValidOrderEvidence: Scalars['Int']['output'];
  CraftmanWallet: Scalars['Int']['output'];
  CustomerAskDeliveryMan: Scalars['Int']['output'];
  CustomerFavorites: Scalars['Int']['output'];
  CustomerOrderSize: Scalars['Int']['output'];
  CustomerOrders: Scalars['Int']['output'];
  CustomerValidOrderEvidence: Scalars['Int']['output'];
  Emails: Scalars['Int']['output'];
  ItemTypes: Scalars['Int']['output'];
  MaterialTypes: Scalars['Int']['output'];
  NoticeOrders: Scalars['Int']['output'];
  Notifications: Scalars['Int']['output'];
  OrderPrices: Scalars['Int']['output'];
  PaimentHistories: Scalars['Int']['output'];
  PhotoAchievements: Scalars['Int']['output'];
  PushTokens: Scalars['Int']['output'];
  ReceiverChatMessages: Scalars['Int']['output'];
  SenderChatMessages: Scalars['Int']['output'];
  UserAddresses: Scalars['Int']['output'];
  UserPrompts: Scalars['Int']['output'];
  UserStories: Scalars['Int']['output'];
  referrals: Scalars['Int']['output'];
};


export type UserCountActionOrdersArgs = {
  where?: InputMaybe<ActionOrderWhereInput>;
};


export type UserCountCategoriesArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type UserCountCraftmanAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type UserCountCraftmanFavoritesArgs = {
  where?: InputMaybe<FavoritesWhereInput>;
};


export type UserCountCraftmanOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCountCraftmanValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type UserCountCraftmanWalletArgs = {
  where?: InputMaybe<CraftmanWalletWhereInput>;
};


export type UserCountCustomerAskDeliveryManArgs = {
  where?: InputMaybe<AskDeliveryManWhereInput>;
};


export type UserCountCustomerFavoritesArgs = {
  where?: InputMaybe<FavoritesWhereInput>;
};


export type UserCountCustomerOrderSizeArgs = {
  where?: InputMaybe<OrderSizeWhereInput>;
};


export type UserCountCustomerOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCountCustomerValidOrderEvidenceArgs = {
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};


export type UserCountEmailsArgs = {
  where?: InputMaybe<EmailWhereInput>;
};


export type UserCountItemTypesArgs = {
  where?: InputMaybe<ItemTypeWhereInput>;
};


export type UserCountMaterialTypesArgs = {
  where?: InputMaybe<MaterialTypeWhereInput>;
};


export type UserCountNoticeOrdersArgs = {
  where?: InputMaybe<NoticeOrderWhereInput>;
};


export type UserCountNotificationsArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserCountOrderPricesArgs = {
  where?: InputMaybe<OrderPriceWhereInput>;
};


export type UserCountPaimentHistoriesArgs = {
  where?: InputMaybe<PaimentHistoryWhereInput>;
};


export type UserCountPhotoAchievementsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserCountPushTokensArgs = {
  where?: InputMaybe<PushTokensWhereInput>;
};


export type UserCountReceiverChatMessagesArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type UserCountSenderChatMessagesArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type UserCountUserAddressesArgs = {
  where?: InputMaybe<UserAddressWhereInput>;
};


export type UserCountUserPromptsArgs = {
  where?: InputMaybe<UserPromptWhereInput>;
};


export type UserCountUserStoriesArgs = {
  where?: InputMaybe<UserStoryWhereInput>;
};


export type UserCountReferralsArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  activeNotif: Scalars['Int']['output'];
  appleID: Scalars['Int']['output'];
  banish: Scalars['Int']['output'];
  bannerPhotoId: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerRole: Scalars['Int']['output'];
  dateOfLastConnexion: Scalars['Int']['output'];
  delete: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  facebookID: Scalars['Int']['output'];
  googleID: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActiveAdmin: Scalars['Int']['output'];
  isInterestedInCertificate: Scalars['Int']['output'];
  lang: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  minPriceOrder: Scalars['Int']['output'];
  minQuantityOrder: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nbClickProfile: Scalars['Int']['output'];
  oldID: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  permissions: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  profilePhotoId: Scalars['Int']['output'];
  referredById: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
  sponsorshipCode: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workshopName: Scalars['Int']['output'];
  yearOfExperience: Scalars['Int']['output'];
};

export type UserCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  activeNotif?: InputMaybe<SortOrder>;
  appleID?: InputMaybe<SortOrder>;
  banish?: InputMaybe<SortOrder>;
  bannerPhotoId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerRole?: InputMaybe<SortOrder>;
  dateOfLastConnexion?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookID?: InputMaybe<SortOrder>;
  googleID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActiveAdmin?: InputMaybe<SortOrder>;
  isInterestedInCertificate?: InputMaybe<SortOrder>;
  lang?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  minPriceOrder?: InputMaybe<SortOrder>;
  minQuantityOrder?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  profilePhotoId?: InputMaybe<SortOrder>;
  referredById?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  sponsorshipCode?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workshopName?: InputMaybe<SortOrder>;
  yearOfExperience?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyBannerPhotoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhotoId?: InputMaybe<Scalars['Int']['input']>;
  referredById?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyBannerPhotoInputEnvelope = {
  data: Array<UserCreateManyBannerPhotoInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateManyCountryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhotoId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhotoId?: InputMaybe<Scalars['Int']['input']>;
  referredById?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyCountryInputEnvelope = {
  data: Array<UserCreateManyCountryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhotoId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhotoId?: InputMaybe<Scalars['Int']['input']>;
  referredById?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyProfilePhotoInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhotoId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referredById?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyProfilePhotoInputEnvelope = {
  data: Array<UserCreateManyProfilePhotoInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateManyReferredByInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhotoId?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhotoId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateManyReferredByInputEnvelope = {
  data: Array<UserCreateManyReferredByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateNestedManyWithoutBannerPhotoInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutBannerPhotoInput>>;
  create?: InputMaybe<Array<UserCreateWithoutBannerPhotoInput>>;
  createMany?: InputMaybe<UserCreateManyBannerPhotoInputEnvelope>;
};

export type UserCreateNestedManyWithoutCategoriesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCategoriesInput>>;
};

export type UserCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCountryInput>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
};

export type UserCreateNestedManyWithoutItemTypesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutItemTypesInput>>;
};

export type UserCreateNestedManyWithoutMaterialTypesInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutMaterialTypesInput>>;
};

export type UserCreateNestedManyWithoutProfilePhotoInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProfilePhotoInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProfilePhotoInput>>;
  createMany?: InputMaybe<UserCreateManyProfilePhotoInputEnvelope>;
};

export type UserCreateNestedManyWithoutReferredByInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutReferredByInput>>;
  create?: InputMaybe<Array<UserCreateWithoutReferredByInput>>;
  createMany?: InputMaybe<UserCreateManyReferredByInputEnvelope>;
};

export type UserCreateNestedOneWithoutActionOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActionOrdersInput>;
  create?: InputMaybe<UserCreateWithoutActionOrdersInput>;
};

export type UserCreateNestedOneWithoutCraftmanAskDeliveryManInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanAskDeliveryManInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanAskDeliveryManInput>;
};

export type UserCreateNestedOneWithoutCraftmanFavoritesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanFavoritesInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanFavoritesInput>;
};

export type UserCreateNestedOneWithoutCraftmanOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanOrdersInput>;
};

export type UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanValidOrderEvidenceInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanValidOrderEvidenceInput>;
};

export type UserCreateNestedOneWithoutCraftmanWalletInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanWalletInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanWalletInput>;
};

export type UserCreateNestedOneWithoutCustomerAskDeliveryManInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerAskDeliveryManInput>;
  create?: InputMaybe<UserCreateWithoutCustomerAskDeliveryManInput>;
};

export type UserCreateNestedOneWithoutCustomerFavoritesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerFavoritesInput>;
  create?: InputMaybe<UserCreateWithoutCustomerFavoritesInput>;
};

export type UserCreateNestedOneWithoutCustomerOrderSizeInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerOrderSizeInput>;
  create?: InputMaybe<UserCreateWithoutCustomerOrderSizeInput>;
};

export type UserCreateNestedOneWithoutCustomerOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCustomerOrdersInput>;
};

export type UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerValidOrderEvidenceInput>;
  create?: InputMaybe<UserCreateWithoutCustomerValidOrderEvidenceInput>;
};

export type UserCreateNestedOneWithoutEmailsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEmailsInput>;
  create?: InputMaybe<UserCreateWithoutEmailsInput>;
};

export type UserCreateNestedOneWithoutNoticeOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNoticeOrdersInput>;
  create?: InputMaybe<UserCreateWithoutNoticeOrdersInput>;
};

export type UserCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
};

export type UserCreateNestedOneWithoutOrderPricesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderPricesInput>;
  create?: InputMaybe<UserCreateWithoutOrderPricesInput>;
};

export type UserCreateNestedOneWithoutPaimentHistoriesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaimentHistoriesInput>;
  create?: InputMaybe<UserCreateWithoutPaimentHistoriesInput>;
};

export type UserCreateNestedOneWithoutPhotoAchievementsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPhotoAchievementsInput>;
  create?: InputMaybe<UserCreateWithoutPhotoAchievementsInput>;
};

export type UserCreateNestedOneWithoutPushTokensInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPushTokensInput>;
  create?: InputMaybe<UserCreateWithoutPushTokensInput>;
};

export type UserCreateNestedOneWithoutReceiverChatMessagesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReceiverChatMessagesInput>;
  create?: InputMaybe<UserCreateWithoutReceiverChatMessagesInput>;
};

export type UserCreateNestedOneWithoutReferralsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReferralsInput>;
  create?: InputMaybe<UserCreateWithoutReferralsInput>;
};

export type UserCreateNestedOneWithoutSenderChatMessagesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSenderChatMessagesInput>;
  create?: InputMaybe<UserCreateWithoutSenderChatMessagesInput>;
};

export type UserCreateNestedOneWithoutUserAddressesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserAddressesInput>;
  create?: InputMaybe<UserCreateWithoutUserAddressesInput>;
};

export type UserCreateNestedOneWithoutUserPromptsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPromptsInput>;
  create?: InputMaybe<UserCreateWithoutUserPromptsInput>;
};

export type UserCreateNestedOneWithoutUserStoriesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserStoriesInput>;
  create?: InputMaybe<UserCreateWithoutUserStoriesInput>;
};

export type UserCreateOrConnectWithoutActionOrdersInput = {
  create: UserCreateWithoutActionOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBannerPhotoInput = {
  create: UserCreateWithoutBannerPhotoInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCategoriesInput = {
  create: UserCreateWithoutCategoriesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCountryInput = {
  create: UserCreateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCraftmanAskDeliveryManInput = {
  create: UserCreateWithoutCraftmanAskDeliveryManInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCraftmanFavoritesInput = {
  create: UserCreateWithoutCraftmanFavoritesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCraftmanOrdersInput = {
  create: UserCreateWithoutCraftmanOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCraftmanValidOrderEvidenceInput = {
  create: UserCreateWithoutCraftmanValidOrderEvidenceInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCraftmanWalletInput = {
  create: UserCreateWithoutCraftmanWalletInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCustomerAskDeliveryManInput = {
  create: UserCreateWithoutCustomerAskDeliveryManInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCustomerFavoritesInput = {
  create: UserCreateWithoutCustomerFavoritesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCustomerOrderSizeInput = {
  create: UserCreateWithoutCustomerOrderSizeInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCustomerOrdersInput = {
  create: UserCreateWithoutCustomerOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCustomerValidOrderEvidenceInput = {
  create: UserCreateWithoutCustomerValidOrderEvidenceInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutEmailsInput = {
  create: UserCreateWithoutEmailsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutItemTypesInput = {
  create: UserCreateWithoutItemTypesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMaterialTypesInput = {
  create: UserCreateWithoutMaterialTypesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNoticeOrdersInput = {
  create: UserCreateWithoutNoticeOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderPricesInput = {
  create: UserCreateWithoutOrderPricesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPaimentHistoriesInput = {
  create: UserCreateWithoutPaimentHistoriesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPhotoAchievementsInput = {
  create: UserCreateWithoutPhotoAchievementsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProfilePhotoInput = {
  create: UserCreateWithoutProfilePhotoInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPushTokensInput = {
  create: UserCreateWithoutPushTokensInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReceiverChatMessagesInput = {
  create: UserCreateWithoutReceiverChatMessagesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReferralsInput = {
  create: UserCreateWithoutReferralsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReferredByInput = {
  create: UserCreateWithoutReferredByInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSenderChatMessagesInput = {
  create: UserCreateWithoutSenderChatMessagesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserAddressesInput = {
  create: UserCreateWithoutUserAddressesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserPromptsInput = {
  create: UserCreateWithoutUserPromptsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserStoriesInput = {
  create: UserCreateWithoutUserStoriesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutActionOrdersInput = {
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutBannerPhotoInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCategoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCountryInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCraftmanAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCraftmanFavoritesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCraftmanOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCraftmanValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCraftmanWalletInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCustomerAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCustomerFavoritesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCustomerOrderSizeInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCustomerOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutCustomerValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutEmailsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutItemTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutMaterialTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutNoticeOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutNotificationsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutOrderPricesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutPaimentHistoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutPhotoAchievementsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutProfilePhotoInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutPushTokensInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutReceiverChatMessagesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutReferralsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutReferredByInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutSenderChatMessagesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutUserAddressesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutUserPromptsInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserStories?: InputMaybe<UserStoryCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreateWithoutUserStoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderCreateNestedManyWithoutCreatorInput>;
  BannerPhoto?: InputMaybe<FileCreateNestedOneWithoutUserBannersInput>;
  Categories?: InputMaybe<CategoryCreateNestedManyWithoutUsersInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCraftmanInput>;
  CraftmanFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCraftmanInput>;
  CraftmanOrders?: InputMaybe<OrderCreateNestedManyWithoutCraftmanInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletCreateNestedManyWithoutCraftmanInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManCreateNestedManyWithoutCustomerInput>;
  CustomerFavorites?: InputMaybe<FavoritesCreateNestedManyWithoutCustomerInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeCreateNestedManyWithoutCustomerInput>;
  CustomerOrders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceCreateNestedManyWithoutCustomerInput>;
  Emails?: InputMaybe<EmailCreateNestedManyWithoutSenderInput>;
  ItemTypes?: InputMaybe<ItemTypeCreateNestedManyWithoutUsersInput>;
  MaterialTypes?: InputMaybe<MaterialTypeCreateNestedManyWithoutUsersInput>;
  NoticeOrders?: InputMaybe<NoticeOrderCreateNestedManyWithoutCustomerInput>;
  Notifications?: InputMaybe<NotificationCreateNestedManyWithoutReceiverInput>;
  OrderPrices?: InputMaybe<OrderPriceCreateNestedManyWithoutUserInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryCreateNestedManyWithoutCustomerInput>;
  PhotoAchievements?: InputMaybe<FileCreateNestedManyWithoutUserRealtionRealisationInput>;
  ProfilePhoto?: InputMaybe<FileCreateNestedOneWithoutUserRealtionProfilesInput>;
  PushTokens?: InputMaybe<PushTokensCreateNestedManyWithoutUserInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutReceiverInput>;
  SenderChatMessages?: InputMaybe<ChatMessageCreateNestedManyWithoutSenderInput>;
  UserAddresses?: InputMaybe<UserAddressCreateNestedManyWithoutCustomerInput>;
  UserPrompts?: InputMaybe<UserPromptCreateNestedManyWithoutUserInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNotif?: InputMaybe<Scalars['Boolean']['input']>;
  appleID?: InputMaybe<Scalars['String']['input']>;
  banish?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerRole?: InputMaybe<Scalars['String']['input']>;
  dateOfLastConnexion?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<Scalars['String']['input']>;
  googleID?: InputMaybe<Scalars['String']['input']>;
  isActiveAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isInterestedInCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minPriceOrder?: InputMaybe<Scalars['Float']['input']>;
  minQuantityOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nbClickProfile?: InputMaybe<Scalars['Int']['input']>;
  oldID?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserCreatepermissionsInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<UserCreateNestedManyWithoutReferredByInput>;
  referredBy?: InputMaybe<UserCreateNestedOneWithoutReferralsInput>;
  role?: InputMaybe<Role>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  workshopName?: InputMaybe<Scalars['String']['input']>;
  yearOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreatepermissionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserGroupBy = {
  __typename?: 'UserGroupBy';
  _avg?: Maybe<UserAvgAggregate>;
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
  _sum?: Maybe<UserSumAggregate>;
  active: Scalars['Boolean']['output'];
  activeNotif: Scalars['Boolean']['output'];
  appleID?: Maybe<Scalars['String']['output']>;
  banish: Scalars['Boolean']['output'];
  bannerPhotoId?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerRole?: Maybe<Scalars['String']['output']>;
  dateOfLastConnexion?: Maybe<Scalars['DateTimeISO']['output']>;
  delete: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookID?: Maybe<Scalars['String']['output']>;
  googleID?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActiveAdmin: Scalars['Boolean']['output'];
  isInterestedInCertificate: Scalars['Boolean']['output'];
  lang: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nbClickProfile: Scalars['Int']['output'];
  oldID?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePhotoId?: Maybe<Scalars['Int']['output']>;
  referredById?: Maybe<Scalars['Int']['output']>;
  role: Role;
  sponsorshipCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  workshopName?: Maybe<Scalars['String']['output']>;
  yearOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserLoginInput = {
  email: Scalars['String']['input'];
  isBO?: InputMaybe<Scalars['Boolean']['input']>;
  isPhone?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  platform?: InputMaybe<PlatformType>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  role: UserRoleType;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  activeNotif?: Maybe<Scalars['Boolean']['output']>;
  appleID?: Maybe<Scalars['String']['output']>;
  banish?: Maybe<Scalars['Boolean']['output']>;
  bannerPhotoId?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerRole?: Maybe<Scalars['String']['output']>;
  dateOfLastConnexion?: Maybe<Scalars['DateTimeISO']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookID?: Maybe<Scalars['String']['output']>;
  googleID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActiveAdmin?: Maybe<Scalars['Boolean']['output']>;
  isInterestedInCertificate?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbClickProfile?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePhotoId?: Maybe<Scalars['Int']['output']>;
  referredById?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
  sponsorshipCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  workshopName?: Maybe<Scalars['String']['output']>;
  yearOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type UserMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  activeNotif?: InputMaybe<SortOrder>;
  appleID?: InputMaybe<SortOrder>;
  banish?: InputMaybe<SortOrder>;
  bannerPhotoId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerRole?: InputMaybe<SortOrder>;
  dateOfLastConnexion?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookID?: InputMaybe<SortOrder>;
  googleID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActiveAdmin?: InputMaybe<SortOrder>;
  isInterestedInCertificate?: InputMaybe<SortOrder>;
  lang?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  minPriceOrder?: InputMaybe<SortOrder>;
  minQuantityOrder?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  profilePhotoId?: InputMaybe<SortOrder>;
  referredById?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  sponsorshipCode?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workshopName?: InputMaybe<SortOrder>;
  yearOfExperience?: InputMaybe<SortOrder>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  activeNotif?: Maybe<Scalars['Boolean']['output']>;
  appleID?: Maybe<Scalars['String']['output']>;
  banish?: Maybe<Scalars['Boolean']['output']>;
  bannerPhotoId?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerRole?: Maybe<Scalars['String']['output']>;
  dateOfLastConnexion?: Maybe<Scalars['DateTimeISO']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookID?: Maybe<Scalars['String']['output']>;
  googleID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isActiveAdmin?: Maybe<Scalars['Boolean']['output']>;
  isInterestedInCertificate?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbClickProfile?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePhotoId?: Maybe<Scalars['Int']['output']>;
  referredById?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
  sponsorshipCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  workshopName?: Maybe<Scalars['String']['output']>;
  yearOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type UserMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  activeNotif?: InputMaybe<SortOrder>;
  appleID?: InputMaybe<SortOrder>;
  banish?: InputMaybe<SortOrder>;
  bannerPhotoId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerRole?: InputMaybe<SortOrder>;
  dateOfLastConnexion?: InputMaybe<SortOrder>;
  delete?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookID?: InputMaybe<SortOrder>;
  googleID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActiveAdmin?: InputMaybe<SortOrder>;
  isInterestedInCertificate?: InputMaybe<SortOrder>;
  lang?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  minPriceOrder?: InputMaybe<SortOrder>;
  minQuantityOrder?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  profilePhotoId?: InputMaybe<SortOrder>;
  referredById?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  sponsorshipCode?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workshopName?: InputMaybe<SortOrder>;
  yearOfExperience?: InputMaybe<SortOrder>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserOrderByRelevanceFieldEnum {
  AppleId = 'appleID',
  City = 'city',
  CustomerRole = 'customerRole',
  Description = 'description',
  Email = 'email',
  FacebookId = 'facebookID',
  GoogleId = 'googleID',
  Lang = 'lang',
  LastName = 'lastName',
  Name = 'name',
  Password = 'password',
  Permissions = 'permissions',
  PhoneNumber = 'phoneNumber',
  SponsorshipCode = 'sponsorshipCode',
  WorkshopName = 'workshopName'
}

export type UserOrderByRelevanceInput = {
  fields: Array<UserOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UserOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserCountOrderByAggregateInput>;
  _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserSumOrderByAggregateInput>;
  active?: InputMaybe<SortOrder>;
  activeNotif?: InputMaybe<SortOrder>;
  appleID?: InputMaybe<SortOrderInput>;
  banish?: InputMaybe<SortOrder>;
  bannerPhotoId?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrderInput>;
  countryId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerRole?: InputMaybe<SortOrderInput>;
  dateOfLastConnexion?: InputMaybe<SortOrderInput>;
  delete?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  facebookID?: InputMaybe<SortOrderInput>;
  googleID?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActiveAdmin?: InputMaybe<SortOrder>;
  isInterestedInCertificate?: InputMaybe<SortOrder>;
  lang?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  minPriceOrder?: InputMaybe<SortOrderInput>;
  minQuantityOrder?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  profilePhotoId?: InputMaybe<SortOrderInput>;
  referredById?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  sponsorshipCode?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workshopName?: InputMaybe<SortOrderInput>;
  yearOfExperience?: InputMaybe<SortOrderInput>;
};

export type UserOrderByWithRelationAndSearchRelevanceInput = {
  ActionOrders?: InputMaybe<ActionOrderOrderByRelationAggregateInput>;
  BannerPhoto?: InputMaybe<FileOrderByWithRelationAndSearchRelevanceInput>;
  Categories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManOrderByRelationAggregateInput>;
  CraftmanFavorites?: InputMaybe<FavoritesOrderByRelationAggregateInput>;
  CraftmanOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceOrderByRelationAggregateInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletOrderByRelationAggregateInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManOrderByRelationAggregateInput>;
  CustomerFavorites?: InputMaybe<FavoritesOrderByRelationAggregateInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeOrderByRelationAggregateInput>;
  CustomerOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceOrderByRelationAggregateInput>;
  Emails?: InputMaybe<EmailOrderByRelationAggregateInput>;
  ItemTypes?: InputMaybe<ItemTypeOrderByRelationAggregateInput>;
  MaterialTypes?: InputMaybe<MaterialTypeOrderByRelationAggregateInput>;
  NoticeOrders?: InputMaybe<NoticeOrderOrderByRelationAggregateInput>;
  Notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  OrderPrices?: InputMaybe<OrderPriceOrderByRelationAggregateInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryOrderByRelationAggregateInput>;
  PhotoAchievements?: InputMaybe<FileOrderByRelationAggregateInput>;
  ProfilePhoto?: InputMaybe<FileOrderByWithRelationAndSearchRelevanceInput>;
  PushTokens?: InputMaybe<PushTokensOrderByRelationAggregateInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  SenderChatMessages?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  UserAddresses?: InputMaybe<UserAddressOrderByRelationAggregateInput>;
  UserPrompts?: InputMaybe<UserPromptOrderByRelationAggregateInput>;
  UserStories?: InputMaybe<UserStoryOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<UserOrderByRelevanceInput>;
  active?: InputMaybe<SortOrder>;
  activeNotif?: InputMaybe<SortOrder>;
  appleID?: InputMaybe<SortOrderInput>;
  banish?: InputMaybe<SortOrder>;
  bannerPhotoId?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrderInput>;
  country?: InputMaybe<CountryOrderByWithRelationAndSearchRelevanceInput>;
  countryId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerRole?: InputMaybe<SortOrderInput>;
  dateOfLastConnexion?: InputMaybe<SortOrderInput>;
  delete?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  facebookID?: InputMaybe<SortOrderInput>;
  googleID?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActiveAdmin?: InputMaybe<SortOrder>;
  isInterestedInCertificate?: InputMaybe<SortOrder>;
  lang?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  minPriceOrder?: InputMaybe<SortOrderInput>;
  minQuantityOrder?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  permissions?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  profilePhotoId?: InputMaybe<SortOrderInput>;
  referrals?: InputMaybe<UserOrderByRelationAggregateInput>;
  referredBy?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  referredById?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  sponsorshipCode?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workshopName?: InputMaybe<SortOrderInput>;
  yearOfExperience?: InputMaybe<SortOrderInput>;
};

export type UserPrompt = {
  __typename?: 'UserPrompt';
  User: User;
  _count?: Maybe<UserPromptCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  resultFile: Array<File>;
  resultLimit?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};


export type UserPromptResultFileArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};

export type UserPromptAvgAggregate = {
  __typename?: 'UserPromptAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  resultLimit?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type UserPromptAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptCount = {
  __typename?: 'UserPromptCount';
  resultFile: Scalars['Int']['output'];
};


export type UserPromptCountResultFileArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type UserPromptCountAggregate = {
  __typename?: 'UserPromptCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  prompt: Scalars['Int']['output'];
  resultLimit: Scalars['Int']['output'];
  resultText: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserPromptCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrder>;
  resultText?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptCreateInput = {
  User: UserCreateNestedOneWithoutUserPromptsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  prompt: Scalars['String']['input'];
  resultFile?: InputMaybe<FileCreateNestedManyWithoutUserPromptsInput>;
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
  resultText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPromptCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
  resultText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type UserPromptCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  prompt: Scalars['String']['input'];
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
  resultText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPromptCreateManyUserInputEnvelope = {
  data: Array<UserPromptCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPromptCreateNestedManyWithoutResultFileInput = {
  connect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPromptCreateOrConnectWithoutResultFileInput>>;
  create?: InputMaybe<Array<UserPromptCreateWithoutResultFileInput>>;
};

export type UserPromptCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPromptCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPromptCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPromptCreateManyUserInputEnvelope>;
};

export type UserPromptCreateOrConnectWithoutResultFileInput = {
  create: UserPromptCreateWithoutResultFileInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptCreateOrConnectWithoutUserInput = {
  create: UserPromptCreateWithoutUserInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptCreateWithoutResultFileInput = {
  User: UserCreateNestedOneWithoutUserPromptsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  prompt: Scalars['String']['input'];
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
  resultText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPromptCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  prompt: Scalars['String']['input'];
  resultFile?: InputMaybe<FileCreateNestedManyWithoutUserPromptsInput>;
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
  resultText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserPromptGroupBy = {
  __typename?: 'UserPromptGroupBy';
  _avg?: Maybe<UserPromptAvgAggregate>;
  _count?: Maybe<UserPromptCountAggregate>;
  _max?: Maybe<UserPromptMaxAggregate>;
  _min?: Maybe<UserPromptMinAggregate>;
  _sum?: Maybe<UserPromptSumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  resultLimit?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};

export type UserPromptListRelationFilter = {
  every?: InputMaybe<UserPromptWhereInput>;
  none?: InputMaybe<UserPromptWhereInput>;
  some?: InputMaybe<UserPromptWhereInput>;
};

export type UserPromptMaxAggregate = {
  __typename?: 'UserPromptMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  resultLimit?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserPromptMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrder>;
  resultText?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptMinAggregate = {
  __typename?: 'UserPromptMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  resultLimit?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserPromptMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrder>;
  resultText?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserPromptOrderByRelevanceFieldEnum {
  Prompt = 'prompt',
  ResultText = 'resultText'
}

export type UserPromptOrderByRelevanceInput = {
  fields: Array<UserPromptOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UserPromptOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserPromptAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserPromptCountOrderByAggregateInput>;
  _max?: InputMaybe<UserPromptMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserPromptMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserPromptSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrderInput>;
  resultText?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptOrderByWithRelationAndSearchRelevanceInput = {
  User?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  _relevance?: InputMaybe<UserPromptOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  prompt?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<FileOrderByRelationAggregateInput>;
  resultLimit?: InputMaybe<SortOrderInput>;
  resultText?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserPromptScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Prompt = 'prompt',
  ResultLimit = 'resultLimit',
  ResultText = 'resultText',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserPromptScalarWhereInput = {
  AND?: InputMaybe<Array<UserPromptScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserPromptScalarWhereInput>>;
  OR?: InputMaybe<Array<UserPromptScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  prompt?: InputMaybe<StringFilter>;
  resultLimit?: InputMaybe<IntNullableFilter>;
  resultText?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserPromptScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserPromptScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserPromptScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserPromptScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  prompt?: InputMaybe<StringWithAggregatesFilter>;
  resultLimit?: InputMaybe<IntNullableWithAggregatesFilter>;
  resultText?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type UserPromptSumAggregate = {
  __typename?: 'UserPromptSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  resultLimit?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserPromptSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  resultLimit?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPromptUpdateInput = {
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserPromptsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultFile?: InputMaybe<FileUpdateManyWithoutUserPromptsNestedInput>;
  resultLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  resultText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPromptUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  resultText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPromptUpdateManyWithWhereWithoutResultFileInput = {
  data: UserPromptUpdateManyMutationInput;
  where: UserPromptScalarWhereInput;
};

export type UserPromptUpdateManyWithWhereWithoutUserInput = {
  data: UserPromptUpdateManyMutationInput;
  where: UserPromptScalarWhereInput;
};

export type UserPromptUpdateManyWithoutResultFileNestedInput = {
  connect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPromptCreateOrConnectWithoutResultFileInput>>;
  create?: InputMaybe<Array<UserPromptCreateWithoutResultFileInput>>;
  delete?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserPromptScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  set?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  update?: InputMaybe<Array<UserPromptUpdateWithWhereUniqueWithoutResultFileInput>>;
  updateMany?: InputMaybe<Array<UserPromptUpdateManyWithWhereWithoutResultFileInput>>;
  upsert?: InputMaybe<Array<UserPromptUpsertWithWhereUniqueWithoutResultFileInput>>;
};

export type UserPromptUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPromptCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPromptCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPromptCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserPromptScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  set?: InputMaybe<Array<UserPromptWhereUniqueInput>>;
  update?: InputMaybe<Array<UserPromptUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserPromptUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserPromptUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserPromptUpdateWithWhereUniqueWithoutResultFileInput = {
  data: UserPromptUpdateWithoutResultFileInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptUpdateWithWhereUniqueWithoutUserInput = {
  data: UserPromptUpdateWithoutUserInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptUpdateWithoutResultFileInput = {
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserPromptsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  resultText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPromptUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  prompt?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultFile?: InputMaybe<FileUpdateManyWithoutUserPromptsNestedInput>;
  resultLimit?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  resultText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserPromptUpsertWithWhereUniqueWithoutResultFileInput = {
  create: UserPromptCreateWithoutResultFileInput;
  update: UserPromptUpdateWithoutResultFileInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptUpsertWithWhereUniqueWithoutUserInput = {
  create: UserPromptCreateWithoutUserInput;
  update: UserPromptUpdateWithoutUserInput;
  where: UserPromptWhereUniqueInput;
};

export type UserPromptWhereInput = {
  AND?: InputMaybe<Array<UserPromptWhereInput>>;
  NOT?: InputMaybe<Array<UserPromptWhereInput>>;
  OR?: InputMaybe<Array<UserPromptWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  prompt?: InputMaybe<StringFilter>;
  resultFile?: InputMaybe<FileListRelationFilter>;
  resultLimit?: InputMaybe<IntNullableFilter>;
  resultText?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserPromptWhereUniqueInput = {
  AND?: InputMaybe<Array<UserPromptWhereInput>>;
  NOT?: InputMaybe<Array<UserPromptWhereInput>>;
  OR?: InputMaybe<Array<UserPromptWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<StringFilter>;
  resultFile?: InputMaybe<FileListRelationFilter>;
  resultLimit?: InputMaybe<IntNullableFilter>;
  resultText?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserRestPassword = {
  __typename?: 'UserRestPassword';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UserRestPasswordAvgAggregate = {
  __typename?: 'UserRestPasswordAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type UserRestPasswordAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type UserRestPasswordCountAggregate = {
  __typename?: 'UserRestPasswordCountAggregate';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type UserRestPasswordCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserRestPasswordCreateInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
};

export type UserRestPasswordCreateManyInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRestPasswordGroupBy = {
  __typename?: 'UserRestPasswordGroupBy';
  _avg?: Maybe<UserRestPasswordAvgAggregate>;
  _count?: Maybe<UserRestPasswordCountAggregate>;
  _max?: Maybe<UserRestPasswordMaxAggregate>;
  _min?: Maybe<UserRestPasswordMinAggregate>;
  _sum?: Maybe<UserRestPasswordSumAggregate>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UserRestPasswordMaxAggregate = {
  __typename?: 'UserRestPasswordMaxAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type UserRestPasswordMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserRestPasswordMinAggregate = {
  __typename?: 'UserRestPasswordMinAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type UserRestPasswordMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum UserRestPasswordOrderByRelevanceFieldEnum {
  Code = 'code',
  Email = 'email'
}

export type UserRestPasswordOrderByRelevanceInput = {
  fields: Array<UserRestPasswordOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UserRestPasswordOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserRestPasswordAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserRestPasswordCountOrderByAggregateInput>;
  _max?: InputMaybe<UserRestPasswordMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserRestPasswordMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserRestPasswordSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserRestPasswordOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<UserRestPasswordOrderByRelevanceInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum UserRestPasswordScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id'
}

export type UserRestPasswordScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserRestPasswordScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserRestPasswordScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserRestPasswordScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
};

export type UserRestPasswordSumAggregate = {
  __typename?: 'UserRestPasswordSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type UserRestPasswordSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type UserRestPasswordUpdateInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserRestPasswordUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserRestPasswordWhereInput = {
  AND?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  NOT?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  OR?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
};

export type UserRestPasswordWhereUniqueInput = {
  AND?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  NOT?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  OR?: InputMaybe<Array<UserRestPasswordWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of the user role */
export enum UserRoleType {
  Admin = 'ADMIN',
  Craftman = 'CRAFTMAN',
  Customer = 'CUSTOMER',
  Yume = 'YUME'
}

export enum UserScalarFieldEnum {
  Active = 'active',
  ActiveNotif = 'activeNotif',
  AppleId = 'appleID',
  Banish = 'banish',
  BannerPhotoId = 'bannerPhotoId',
  City = 'city',
  CountryId = 'countryId',
  CreatedAt = 'createdAt',
  CustomerRole = 'customerRole',
  DateOfLastConnexion = 'dateOfLastConnexion',
  Delete = 'delete',
  Description = 'description',
  Email = 'email',
  FacebookId = 'facebookID',
  GoogleId = 'googleID',
  Id = 'id',
  IsActiveAdmin = 'isActiveAdmin',
  IsInterestedInCertificate = 'isInterestedInCertificate',
  Lang = 'lang',
  LastName = 'lastName',
  MinPriceOrder = 'minPriceOrder',
  MinQuantityOrder = 'minQuantityOrder',
  Name = 'name',
  NbClickProfile = 'nbClickProfile',
  OldId = 'oldID',
  Password = 'password',
  Permissions = 'permissions',
  PhoneNumber = 'phoneNumber',
  ProfilePhotoId = 'profilePhotoId',
  ReferredById = 'referredById',
  Role = 'role',
  SponsorshipCode = 'sponsorshipCode',
  UpdatedAt = 'updatedAt',
  WorkshopName = 'workshopName',
  YearOfExperience = 'yearOfExperience'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  activeNotif?: InputMaybe<BoolFilter>;
  appleID?: InputMaybe<StringNullableFilter>;
  banish?: InputMaybe<BoolFilter>;
  bannerPhotoId?: InputMaybe<IntNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerRole?: InputMaybe<StringNullableFilter>;
  dateOfLastConnexion?: InputMaybe<DateTimeNullableFilter>;
  delete?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  facebookID?: InputMaybe<StringNullableFilter>;
  googleID?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isActiveAdmin?: InputMaybe<BoolFilter>;
  isInterestedInCertificate?: InputMaybe<BoolFilter>;
  lang?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  minPriceOrder?: InputMaybe<FloatNullableFilter>;
  minQuantityOrder?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nbClickProfile?: InputMaybe<IntFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  profilePhotoId?: InputMaybe<IntNullableFilter>;
  referredById?: InputMaybe<IntNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  sponsorshipCode?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workshopName?: InputMaybe<StringNullableFilter>;
  yearOfExperience?: InputMaybe<IntNullableFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserScalarWhereWithAggregatesInput>>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  activeNotif?: InputMaybe<BoolWithAggregatesFilter>;
  appleID?: InputMaybe<StringNullableWithAggregatesFilter>;
  banish?: InputMaybe<BoolWithAggregatesFilter>;
  bannerPhotoId?: InputMaybe<IntNullableWithAggregatesFilter>;
  city?: InputMaybe<StringNullableWithAggregatesFilter>;
  countryId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerRole?: InputMaybe<StringNullableWithAggregatesFilter>;
  dateOfLastConnexion?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  delete?: InputMaybe<BoolWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  facebookID?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleID?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isActiveAdmin?: InputMaybe<BoolWithAggregatesFilter>;
  isInterestedInCertificate?: InputMaybe<BoolWithAggregatesFilter>;
  lang?: InputMaybe<StringWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  minPriceOrder?: InputMaybe<FloatNullableWithAggregatesFilter>;
  minQuantityOrder?: InputMaybe<FloatNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  nbClickProfile?: InputMaybe<IntWithAggregatesFilter>;
  oldID?: InputMaybe<IntNullableWithAggregatesFilter>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  profilePhotoId?: InputMaybe<IntNullableWithAggregatesFilter>;
  referredById?: InputMaybe<IntNullableWithAggregatesFilter>;
  role?: InputMaybe<EnumRoleWithAggregatesFilter>;
  sponsorshipCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  workshopName?: InputMaybe<StringNullableWithAggregatesFilter>;
  yearOfExperience?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type UserStory = {
  __typename?: 'UserStory';
  User: User;
  createdAt: Scalars['DateTimeISO']['output'];
  duration: Scalars['Int']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  file: File;
  fileId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};

export type UserStoryAvgAggregate = {
  __typename?: 'UserStoryAvgAggregate';
  duration?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type UserStoryAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryCountAggregate = {
  __typename?: 'UserStoryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  fileId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserStoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryCreateInput = {
  User: UserCreateNestedOneWithoutUserStoriesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  file: FileCreateNestedOneWithoutUserStoriesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserStoryCreateManyFileInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type UserStoryCreateManyFileInputEnvelope = {
  data: Array<UserStoryCreateManyFileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserStoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fileId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['Int']['input'];
};

export type UserStoryCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fileId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserStoryCreateManyUserInputEnvelope = {
  data: Array<UserStoryCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserStoryCreateNestedManyWithoutFileInput = {
  connect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoryCreateOrConnectWithoutFileInput>>;
  create?: InputMaybe<Array<UserStoryCreateWithoutFileInput>>;
  createMany?: InputMaybe<UserStoryCreateManyFileInputEnvelope>;
};

export type UserStoryCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoryCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserStoryCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserStoryCreateManyUserInputEnvelope>;
};

export type UserStoryCreateOrConnectWithoutFileInput = {
  create: UserStoryCreateWithoutFileInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryCreateOrConnectWithoutUserInput = {
  create: UserStoryCreateWithoutUserInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryCreateWithoutFileInput = {
  User: UserCreateNestedOneWithoutUserStoriesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserStoryCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  file: FileCreateNestedOneWithoutUserStoriesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UserStoryGroupBy = {
  __typename?: 'UserStoryGroupBy';
  _avg?: Maybe<UserStoryAvgAggregate>;
  _count?: Maybe<UserStoryCountAggregate>;
  _max?: Maybe<UserStoryMaxAggregate>;
  _min?: Maybe<UserStoryMinAggregate>;
  _sum?: Maybe<UserStorySumAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  duration: Scalars['Int']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  fileId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['Int']['output'];
};

export type UserStoryListRelationFilter = {
  every?: InputMaybe<UserStoryWhereInput>;
  none?: InputMaybe<UserStoryWhereInput>;
  some?: InputMaybe<UserStoryWhereInput>;
};

export type UserStoryMaxAggregate = {
  __typename?: 'UserStoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryMinAggregate = {
  __typename?: 'UserStoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserStoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserStoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserStoryCountOrderByAggregateInput>;
  _max?: InputMaybe<UserStoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserStoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserStorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryOrderByWithRelationAndSearchRelevanceInput = {
  User?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderByWithRelationAndSearchRelevanceInput>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserStoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Duration = 'duration',
  ExpiresAt = 'expiresAt',
  FileId = 'fileId',
  Id = 'id',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserStoryScalarWhereInput = {
  AND?: InputMaybe<Array<UserStoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserStoryScalarWhereInput>>;
  OR?: InputMaybe<Array<UserStoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  fileId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserStoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserStoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserStoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserStoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  duration?: InputMaybe<IntWithAggregatesFilter>;
  expiresAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  fileId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<IntWithAggregatesFilter>;
};

export type UserStorySumAggregate = {
  __typename?: 'UserStorySumAggregate';
  duration?: Maybe<Scalars['Int']['output']>;
  fileId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserStorySumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserStoryUpdateInput = {
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserStoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneRequiredWithoutUserStoriesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserStoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserStoryUpdateManyWithWhereWithoutFileInput = {
  data: UserStoryUpdateManyMutationInput;
  where: UserStoryScalarWhereInput;
};

export type UserStoryUpdateManyWithWhereWithoutUserInput = {
  data: UserStoryUpdateManyMutationInput;
  where: UserStoryScalarWhereInput;
};

export type UserStoryUpdateManyWithoutFileNestedInput = {
  connect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoryCreateOrConnectWithoutFileInput>>;
  create?: InputMaybe<Array<UserStoryCreateWithoutFileInput>>;
  createMany?: InputMaybe<UserStoryCreateManyFileInputEnvelope>;
  delete?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserStoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  set?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  update?: InputMaybe<Array<UserStoryUpdateWithWhereUniqueWithoutFileInput>>;
  updateMany?: InputMaybe<Array<UserStoryUpdateManyWithWhereWithoutFileInput>>;
  upsert?: InputMaybe<Array<UserStoryUpsertWithWhereUniqueWithoutFileInput>>;
};

export type UserStoryUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoryCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserStoryCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserStoryCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserStoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  set?: InputMaybe<Array<UserStoryWhereUniqueInput>>;
  update?: InputMaybe<Array<UserStoryUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserStoryUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserStoryUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserStoryUpdateWithWhereUniqueWithoutFileInput = {
  data: UserStoryUpdateWithoutFileInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryUpdateWithWhereUniqueWithoutUserInput = {
  data: UserStoryUpdateWithoutUserInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryUpdateWithoutFileInput = {
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserStoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserStoryUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<IntFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneRequiredWithoutUserStoriesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserStoryUpsertWithWhereUniqueWithoutFileInput = {
  create: UserStoryCreateWithoutFileInput;
  update: UserStoryUpdateWithoutFileInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryUpsertWithWhereUniqueWithoutUserInput = {
  create: UserStoryCreateWithoutUserInput;
  update: UserStoryUpdateWithoutUserInput;
  where: UserStoryWhereUniqueInput;
};

export type UserStoryWhereInput = {
  AND?: InputMaybe<Array<UserStoryWhereInput>>;
  NOT?: InputMaybe<Array<UserStoryWhereInput>>;
  OR?: InputMaybe<Array<UserStoryWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileRelationFilter>;
  fileId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserStoryWhereUniqueInput = {
  AND?: InputMaybe<Array<UserStoryWhereInput>>;
  NOT?: InputMaybe<Array<UserStoryWhereInput>>;
  OR?: InputMaybe<Array<UserStoryWhereInput>>;
  User?: InputMaybe<UserRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileRelationFilter>;
  fileId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserSumAggregate = {
  __typename?: 'UserSumAggregate';
  bannerPhotoId?: Maybe<Scalars['Int']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minPriceOrder?: Maybe<Scalars['Float']['output']>;
  minQuantityOrder?: Maybe<Scalars['Float']['output']>;
  nbClickProfile?: Maybe<Scalars['Int']['output']>;
  oldID?: Maybe<Scalars['Int']['output']>;
  profilePhotoId?: Maybe<Scalars['Int']['output']>;
  referredById?: Maybe<Scalars['Int']['output']>;
  yearOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type UserSumOrderByAggregateInput = {
  bannerPhotoId?: InputMaybe<SortOrder>;
  countryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minPriceOrder?: InputMaybe<SortOrder>;
  minQuantityOrder?: InputMaybe<SortOrder>;
  nbClickProfile?: InputMaybe<SortOrder>;
  oldID?: InputMaybe<SortOrder>;
  profilePhotoId?: InputMaybe<SortOrder>;
  referredById?: InputMaybe<SortOrder>;
  yearOfExperience?: InputMaybe<SortOrder>;
};

export type UserUpdateInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutBannerPhotoInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutCategoriesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutCountryInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutItemTypesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutMaterialTypesInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutProfilePhotoInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutReferredByInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutBannerPhotoNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutBannerPhotoInput>>;
  create?: InputMaybe<Array<UserCreateWithoutBannerPhotoInput>>;
  createMany?: InputMaybe<UserCreateManyBannerPhotoInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutBannerPhotoInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutBannerPhotoInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutBannerPhotoInput>>;
};

export type UserUpdateManyWithoutCategoriesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCategoriesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCategoriesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutCategoriesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutCategoriesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutCategoriesInput>>;
};

export type UserUpdateManyWithoutCountryNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCountryInput>>;
  createMany?: InputMaybe<UserCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutCountryInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutCountryInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutCountryInput>>;
};

export type UserUpdateManyWithoutItemTypesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutItemTypesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutItemTypesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutItemTypesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutItemTypesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutItemTypesInput>>;
};

export type UserUpdateManyWithoutMaterialTypesNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutMaterialTypesInput>>;
  create?: InputMaybe<Array<UserCreateWithoutMaterialTypesInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutMaterialTypesInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutMaterialTypesInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutMaterialTypesInput>>;
};

export type UserUpdateManyWithoutProfilePhotoNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutProfilePhotoInput>>;
  create?: InputMaybe<Array<UserCreateWithoutProfilePhotoInput>>;
  createMany?: InputMaybe<UserCreateManyProfilePhotoInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutProfilePhotoInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutProfilePhotoInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutProfilePhotoInput>>;
};

export type UserUpdateManyWithoutReferredByNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutReferredByInput>>;
  create?: InputMaybe<Array<UserCreateWithoutReferredByInput>>;
  createMany?: InputMaybe<UserCreateManyReferredByInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutReferredByInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutReferredByInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutReferredByInput>>;
};

export type UserUpdateOneRequiredWithoutActionOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActionOrdersInput>;
  create?: InputMaybe<UserCreateWithoutActionOrdersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutActionOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutActionOrdersInput>;
};

export type UserUpdateOneRequiredWithoutCraftmanAskDeliveryManNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanAskDeliveryManInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanAskDeliveryManInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCraftmanAskDeliveryManInput>;
  upsert?: InputMaybe<UserUpsertWithoutCraftmanAskDeliveryManInput>;
};

export type UserUpdateOneRequiredWithoutCraftmanFavoritesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanFavoritesInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanFavoritesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCraftmanFavoritesInput>;
  upsert?: InputMaybe<UserUpsertWithoutCraftmanFavoritesInput>;
};

export type UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanValidOrderEvidenceInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanValidOrderEvidenceInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCraftmanValidOrderEvidenceInput>;
  upsert?: InputMaybe<UserUpsertWithoutCraftmanValidOrderEvidenceInput>;
};

export type UserUpdateOneRequiredWithoutCraftmanWalletNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanWalletInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanWalletInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCraftmanWalletInput>;
  upsert?: InputMaybe<UserUpsertWithoutCraftmanWalletInput>;
};

export type UserUpdateOneRequiredWithoutCustomerAskDeliveryManNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerAskDeliveryManInput>;
  create?: InputMaybe<UserCreateWithoutCustomerAskDeliveryManInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCustomerAskDeliveryManInput>;
  upsert?: InputMaybe<UserUpsertWithoutCustomerAskDeliveryManInput>;
};

export type UserUpdateOneRequiredWithoutCustomerOrderSizeNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerOrderSizeInput>;
  create?: InputMaybe<UserCreateWithoutCustomerOrderSizeInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCustomerOrderSizeInput>;
  upsert?: InputMaybe<UserUpsertWithoutCustomerOrderSizeInput>;
};

export type UserUpdateOneRequiredWithoutCustomerOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCustomerOrdersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCustomerOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutCustomerOrdersInput>;
};

export type UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerValidOrderEvidenceInput>;
  create?: InputMaybe<UserCreateWithoutCustomerValidOrderEvidenceInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCustomerValidOrderEvidenceInput>;
  upsert?: InputMaybe<UserUpsertWithoutCustomerValidOrderEvidenceInput>;
};

export type UserUpdateOneRequiredWithoutEmailsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutEmailsInput>;
  create?: InputMaybe<UserCreateWithoutEmailsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutEmailsInput>;
  upsert?: InputMaybe<UserUpsertWithoutEmailsInput>;
};

export type UserUpdateOneRequiredWithoutNoticeOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNoticeOrdersInput>;
  create?: InputMaybe<UserCreateWithoutNoticeOrdersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNoticeOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutNoticeOrdersInput>;
};

export type UserUpdateOneRequiredWithoutNotificationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationsInput>;
};

export type UserUpdateOneRequiredWithoutOrderPricesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderPricesInput>;
  create?: InputMaybe<UserCreateWithoutOrderPricesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderPricesInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderPricesInput>;
};

export type UserUpdateOneRequiredWithoutPushTokensNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPushTokensInput>;
  create?: InputMaybe<UserCreateWithoutPushTokensInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPushTokensInput>;
  upsert?: InputMaybe<UserUpsertWithoutPushTokensInput>;
};

export type UserUpdateOneRequiredWithoutReceiverChatMessagesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReceiverChatMessagesInput>;
  create?: InputMaybe<UserCreateWithoutReceiverChatMessagesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutReceiverChatMessagesInput>;
  upsert?: InputMaybe<UserUpsertWithoutReceiverChatMessagesInput>;
};

export type UserUpdateOneRequiredWithoutSenderChatMessagesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSenderChatMessagesInput>;
  create?: InputMaybe<UserCreateWithoutSenderChatMessagesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSenderChatMessagesInput>;
  upsert?: InputMaybe<UserUpsertWithoutSenderChatMessagesInput>;
};

export type UserUpdateOneRequiredWithoutUserAddressesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserAddressesInput>;
  create?: InputMaybe<UserCreateWithoutUserAddressesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserAddressesInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserAddressesInput>;
};

export type UserUpdateOneRequiredWithoutUserPromptsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPromptsInput>;
  create?: InputMaybe<UserCreateWithoutUserPromptsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserPromptsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserPromptsInput>;
};

export type UserUpdateOneRequiredWithoutUserStoriesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserStoriesInput>;
  create?: InputMaybe<UserCreateWithoutUserStoriesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserStoriesInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserStoriesInput>;
};

export type UserUpdateOneWithoutCraftmanOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCraftmanOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCraftmanOrdersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCraftmanOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutCraftmanOrdersInput>;
};

export type UserUpdateOneWithoutCustomerFavoritesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCustomerFavoritesInput>;
  create?: InputMaybe<UserCreateWithoutCustomerFavoritesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCustomerFavoritesInput>;
  upsert?: InputMaybe<UserUpsertWithoutCustomerFavoritesInput>;
};

export type UserUpdateOneWithoutPaimentHistoriesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaimentHistoriesInput>;
  create?: InputMaybe<UserCreateWithoutPaimentHistoriesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPaimentHistoriesInput>;
  upsert?: InputMaybe<UserUpsertWithoutPaimentHistoriesInput>;
};

export type UserUpdateOneWithoutPhotoAchievementsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPhotoAchievementsInput>;
  create?: InputMaybe<UserCreateWithoutPhotoAchievementsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPhotoAchievementsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPhotoAchievementsInput>;
};

export type UserUpdateOneWithoutReferralsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReferralsInput>;
  create?: InputMaybe<UserCreateWithoutReferralsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutReferralsInput>;
  upsert?: InputMaybe<UserUpsertWithoutReferralsInput>;
};

export type UserUpdateToOneWithWhereWithoutActionOrdersInput = {
  data: UserUpdateWithoutActionOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCraftmanAskDeliveryManInput = {
  data: UserUpdateWithoutCraftmanAskDeliveryManInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCraftmanFavoritesInput = {
  data: UserUpdateWithoutCraftmanFavoritesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCraftmanOrdersInput = {
  data: UserUpdateWithoutCraftmanOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCraftmanValidOrderEvidenceInput = {
  data: UserUpdateWithoutCraftmanValidOrderEvidenceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCraftmanWalletInput = {
  data: UserUpdateWithoutCraftmanWalletInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCustomerAskDeliveryManInput = {
  data: UserUpdateWithoutCustomerAskDeliveryManInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCustomerFavoritesInput = {
  data: UserUpdateWithoutCustomerFavoritesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCustomerOrderSizeInput = {
  data: UserUpdateWithoutCustomerOrderSizeInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCustomerOrdersInput = {
  data: UserUpdateWithoutCustomerOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCustomerValidOrderEvidenceInput = {
  data: UserUpdateWithoutCustomerValidOrderEvidenceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutEmailsInput = {
  data: UserUpdateWithoutEmailsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNoticeOrdersInput = {
  data: UserUpdateWithoutNoticeOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotificationsInput = {
  data: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderPricesInput = {
  data: UserUpdateWithoutOrderPricesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPaimentHistoriesInput = {
  data: UserUpdateWithoutPaimentHistoriesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPhotoAchievementsInput = {
  data: UserUpdateWithoutPhotoAchievementsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPushTokensInput = {
  data: UserUpdateWithoutPushTokensInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutReceiverChatMessagesInput = {
  data: UserUpdateWithoutReceiverChatMessagesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutReferralsInput = {
  data: UserUpdateWithoutReferralsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSenderChatMessagesInput = {
  data: UserUpdateWithoutSenderChatMessagesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserAddressesInput = {
  data: UserUpdateWithoutUserAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserPromptsInput = {
  data: UserUpdateWithoutUserPromptsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserStoriesInput = {
  data: UserUpdateWithoutUserStoriesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutBannerPhotoInput = {
  data: UserUpdateWithoutBannerPhotoInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutCategoriesInput = {
  data: UserUpdateWithoutCategoriesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutCountryInput = {
  data: UserUpdateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutItemTypesInput = {
  data: UserUpdateWithoutItemTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutMaterialTypesInput = {
  data: UserUpdateWithoutMaterialTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutProfilePhotoInput = {
  data: UserUpdateWithoutProfilePhotoInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutReferredByInput = {
  data: UserUpdateWithoutReferredByInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutActionOrdersInput = {
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutBannerPhotoInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCategoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCountryInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCraftmanAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCraftmanFavoritesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCraftmanOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCraftmanValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCraftmanWalletInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCustomerAskDeliveryManInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCustomerFavoritesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCustomerOrderSizeInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCustomerOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCustomerValidOrderEvidenceInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutEmailsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutItemTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutMaterialTypesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutNoticeOrdersInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutNotificationsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrderPricesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPaimentHistoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPhotoAchievementsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutProfilePhotoInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPushTokensInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutReceiverChatMessagesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutReferralsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutReferredByInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutSenderChatMessagesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUserAddressesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUserPromptsInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserStories?: InputMaybe<UserStoryUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUserStoriesInput = {
  ActionOrders?: InputMaybe<ActionOrderUpdateManyWithoutCreatorNestedInput>;
  BannerPhoto?: InputMaybe<FileUpdateOneWithoutUserBannersNestedInput>;
  Categories?: InputMaybe<CategoryUpdateManyWithoutUsersNestedInput>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCraftmanNestedInput>;
  CraftmanFavorites?: InputMaybe<FavoritesUpdateManyWithoutCraftmanNestedInput>;
  CraftmanOrders?: InputMaybe<OrderUpdateManyWithoutCraftmanNestedInput>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput>;
  CraftmanWallet?: InputMaybe<CraftmanWalletUpdateManyWithoutCraftmanNestedInput>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManUpdateManyWithoutCustomerNestedInput>;
  CustomerFavorites?: InputMaybe<FavoritesUpdateManyWithoutCustomerNestedInput>;
  CustomerOrderSize?: InputMaybe<OrderSizeUpdateManyWithoutCustomerNestedInput>;
  CustomerOrders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput>;
  Emails?: InputMaybe<EmailUpdateManyWithoutSenderNestedInput>;
  ItemTypes?: InputMaybe<ItemTypeUpdateManyWithoutUsersNestedInput>;
  MaterialTypes?: InputMaybe<MaterialTypeUpdateManyWithoutUsersNestedInput>;
  NoticeOrders?: InputMaybe<NoticeOrderUpdateManyWithoutCustomerNestedInput>;
  Notifications?: InputMaybe<NotificationUpdateManyWithoutReceiverNestedInput>;
  OrderPrices?: InputMaybe<OrderPriceUpdateManyWithoutUserNestedInput>;
  PaimentHistories?: InputMaybe<PaimentHistoryUpdateManyWithoutCustomerNestedInput>;
  PhotoAchievements?: InputMaybe<FileUpdateManyWithoutUserRealtionRealisationNestedInput>;
  ProfilePhoto?: InputMaybe<FileUpdateOneWithoutUserRealtionProfilesNestedInput>;
  PushTokens?: InputMaybe<PushTokensUpdateManyWithoutUserNestedInput>;
  ReceiverChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutReceiverNestedInput>;
  SenderChatMessages?: InputMaybe<ChatMessageUpdateManyWithoutSenderNestedInput>;
  UserAddresses?: InputMaybe<UserAddressUpdateManyWithoutCustomerNestedInput>;
  UserPrompts?: InputMaybe<UserPromptUpdateManyWithoutUserNestedInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeNotif?: InputMaybe<BoolFieldUpdateOperationsInput>;
  appleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  banish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<CountryUpdateOneWithoutUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerRole?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateOfLastConnexion?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delete?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  facebookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActiveAdmin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInterestedInCertificate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lang?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minPriceOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  minQuantityOrder?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nbClickProfile?: InputMaybe<IntFieldUpdateOperationsInput>;
  oldID?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserUpdatepermissionsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  referrals?: InputMaybe<UserUpdateManyWithoutReferredByNestedInput>;
  referredBy?: InputMaybe<UserUpdateOneWithoutReferralsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sponsorshipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workshopName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  yearOfExperience?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type UserUpdatepermissionsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpsertWithWhereUniqueWithoutBannerPhotoInput = {
  create: UserCreateWithoutBannerPhotoInput;
  update: UserUpdateWithoutBannerPhotoInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutCategoriesInput = {
  create: UserCreateWithoutCategoriesInput;
  update: UserUpdateWithoutCategoriesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutCountryInput = {
  create: UserCreateWithoutCountryInput;
  update: UserUpdateWithoutCountryInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutItemTypesInput = {
  create: UserCreateWithoutItemTypesInput;
  update: UserUpdateWithoutItemTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutMaterialTypesInput = {
  create: UserCreateWithoutMaterialTypesInput;
  update: UserUpdateWithoutMaterialTypesInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutProfilePhotoInput = {
  create: UserCreateWithoutProfilePhotoInput;
  update: UserUpdateWithoutProfilePhotoInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutReferredByInput = {
  create: UserCreateWithoutReferredByInput;
  update: UserUpdateWithoutReferredByInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutActionOrdersInput = {
  create: UserCreateWithoutActionOrdersInput;
  update: UserUpdateWithoutActionOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCraftmanAskDeliveryManInput = {
  create: UserCreateWithoutCraftmanAskDeliveryManInput;
  update: UserUpdateWithoutCraftmanAskDeliveryManInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCraftmanFavoritesInput = {
  create: UserCreateWithoutCraftmanFavoritesInput;
  update: UserUpdateWithoutCraftmanFavoritesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCraftmanOrdersInput = {
  create: UserCreateWithoutCraftmanOrdersInput;
  update: UserUpdateWithoutCraftmanOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCraftmanValidOrderEvidenceInput = {
  create: UserCreateWithoutCraftmanValidOrderEvidenceInput;
  update: UserUpdateWithoutCraftmanValidOrderEvidenceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCraftmanWalletInput = {
  create: UserCreateWithoutCraftmanWalletInput;
  update: UserUpdateWithoutCraftmanWalletInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCustomerAskDeliveryManInput = {
  create: UserCreateWithoutCustomerAskDeliveryManInput;
  update: UserUpdateWithoutCustomerAskDeliveryManInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCustomerFavoritesInput = {
  create: UserCreateWithoutCustomerFavoritesInput;
  update: UserUpdateWithoutCustomerFavoritesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCustomerOrderSizeInput = {
  create: UserCreateWithoutCustomerOrderSizeInput;
  update: UserUpdateWithoutCustomerOrderSizeInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCustomerOrdersInput = {
  create: UserCreateWithoutCustomerOrdersInput;
  update: UserUpdateWithoutCustomerOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCustomerValidOrderEvidenceInput = {
  create: UserCreateWithoutCustomerValidOrderEvidenceInput;
  update: UserUpdateWithoutCustomerValidOrderEvidenceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutEmailsInput = {
  create: UserCreateWithoutEmailsInput;
  update: UserUpdateWithoutEmailsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNoticeOrdersInput = {
  create: UserCreateWithoutNoticeOrdersInput;
  update: UserUpdateWithoutNoticeOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  update: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderPricesInput = {
  create: UserCreateWithoutOrderPricesInput;
  update: UserUpdateWithoutOrderPricesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPaimentHistoriesInput = {
  create: UserCreateWithoutPaimentHistoriesInput;
  update: UserUpdateWithoutPaimentHistoriesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPhotoAchievementsInput = {
  create: UserCreateWithoutPhotoAchievementsInput;
  update: UserUpdateWithoutPhotoAchievementsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPushTokensInput = {
  create: UserCreateWithoutPushTokensInput;
  update: UserUpdateWithoutPushTokensInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutReceiverChatMessagesInput = {
  create: UserCreateWithoutReceiverChatMessagesInput;
  update: UserUpdateWithoutReceiverChatMessagesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutReferralsInput = {
  create: UserCreateWithoutReferralsInput;
  update: UserUpdateWithoutReferralsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSenderChatMessagesInput = {
  create: UserCreateWithoutSenderChatMessagesInput;
  update: UserUpdateWithoutSenderChatMessagesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserAddressesInput = {
  create: UserCreateWithoutUserAddressesInput;
  update: UserUpdateWithoutUserAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserPromptsInput = {
  create: UserCreateWithoutUserPromptsInput;
  update: UserUpdateWithoutUserPromptsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserStoriesInput = {
  create: UserCreateWithoutUserStoriesInput;
  update: UserUpdateWithoutUserStoriesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ActionOrders?: InputMaybe<ActionOrderListRelationFilter>;
  BannerPhoto?: InputMaybe<FileNullableRelationFilter>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  CraftmanFavorites?: InputMaybe<FavoritesListRelationFilter>;
  CraftmanOrders?: InputMaybe<OrderListRelationFilter>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  CraftmanWallet?: InputMaybe<CraftmanWalletListRelationFilter>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  CustomerFavorites?: InputMaybe<FavoritesListRelationFilter>;
  CustomerOrderSize?: InputMaybe<OrderSizeListRelationFilter>;
  CustomerOrders?: InputMaybe<OrderListRelationFilter>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  Emails?: InputMaybe<EmailListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  NoticeOrders?: InputMaybe<NoticeOrderListRelationFilter>;
  Notifications?: InputMaybe<NotificationListRelationFilter>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  OrderPrices?: InputMaybe<OrderPriceListRelationFilter>;
  PaimentHistories?: InputMaybe<PaimentHistoryListRelationFilter>;
  PhotoAchievements?: InputMaybe<FileListRelationFilter>;
  ProfilePhoto?: InputMaybe<FileNullableRelationFilter>;
  PushTokens?: InputMaybe<PushTokensListRelationFilter>;
  ReceiverChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  SenderChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  UserAddresses?: InputMaybe<UserAddressListRelationFilter>;
  UserPrompts?: InputMaybe<UserPromptListRelationFilter>;
  UserStories?: InputMaybe<UserStoryListRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  activeNotif?: InputMaybe<BoolFilter>;
  appleID?: InputMaybe<StringNullableFilter>;
  banish?: InputMaybe<BoolFilter>;
  bannerPhotoId?: InputMaybe<IntNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<CountryNullableRelationFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerRole?: InputMaybe<StringNullableFilter>;
  dateOfLastConnexion?: InputMaybe<DateTimeNullableFilter>;
  delete?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  facebookID?: InputMaybe<StringNullableFilter>;
  googleID?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isActiveAdmin?: InputMaybe<BoolFilter>;
  isInterestedInCertificate?: InputMaybe<BoolFilter>;
  lang?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  minPriceOrder?: InputMaybe<FloatNullableFilter>;
  minQuantityOrder?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nbClickProfile?: InputMaybe<IntFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  profilePhotoId?: InputMaybe<IntNullableFilter>;
  referrals?: InputMaybe<UserListRelationFilter>;
  referredBy?: InputMaybe<UserNullableRelationFilter>;
  referredById?: InputMaybe<IntNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  sponsorshipCode?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workshopName?: InputMaybe<StringNullableFilter>;
  yearOfExperience?: InputMaybe<IntNullableFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  ActionOrders?: InputMaybe<ActionOrderListRelationFilter>;
  BannerPhoto?: InputMaybe<FileNullableRelationFilter>;
  Categories?: InputMaybe<CategoryListRelationFilter>;
  CraftmanAskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  CraftmanFavorites?: InputMaybe<FavoritesListRelationFilter>;
  CraftmanOrders?: InputMaybe<OrderListRelationFilter>;
  CraftmanValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  CraftmanWallet?: InputMaybe<CraftmanWalletListRelationFilter>;
  CustomerAskDeliveryMan?: InputMaybe<AskDeliveryManListRelationFilter>;
  CustomerFavorites?: InputMaybe<FavoritesListRelationFilter>;
  CustomerOrderSize?: InputMaybe<OrderSizeListRelationFilter>;
  CustomerOrders?: InputMaybe<OrderListRelationFilter>;
  CustomerValidOrderEvidence?: InputMaybe<ValidOrderEvidenceListRelationFilter>;
  Emails?: InputMaybe<EmailListRelationFilter>;
  ItemTypes?: InputMaybe<ItemTypeListRelationFilter>;
  MaterialTypes?: InputMaybe<MaterialTypeListRelationFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  NoticeOrders?: InputMaybe<NoticeOrderListRelationFilter>;
  Notifications?: InputMaybe<NotificationListRelationFilter>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  OrderPrices?: InputMaybe<OrderPriceListRelationFilter>;
  PaimentHistories?: InputMaybe<PaimentHistoryListRelationFilter>;
  PhotoAchievements?: InputMaybe<FileListRelationFilter>;
  ProfilePhoto?: InputMaybe<FileNullableRelationFilter>;
  PushTokens?: InputMaybe<PushTokensListRelationFilter>;
  ReceiverChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  SenderChatMessages?: InputMaybe<ChatMessageListRelationFilter>;
  UserAddresses?: InputMaybe<UserAddressListRelationFilter>;
  UserPrompts?: InputMaybe<UserPromptListRelationFilter>;
  UserStories?: InputMaybe<UserStoryListRelationFilter>;
  active?: InputMaybe<BoolFilter>;
  activeNotif?: InputMaybe<BoolFilter>;
  appleID?: InputMaybe<StringNullableFilter>;
  banish?: InputMaybe<BoolFilter>;
  bannerPhotoId?: InputMaybe<IntNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<CountryNullableRelationFilter>;
  countryId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerRole?: InputMaybe<StringNullableFilter>;
  dateOfLastConnexion?: InputMaybe<DateTimeNullableFilter>;
  delete?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookID?: InputMaybe<StringNullableFilter>;
  googleID?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActiveAdmin?: InputMaybe<BoolFilter>;
  isInterestedInCertificate?: InputMaybe<BoolFilter>;
  lang?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  minPriceOrder?: InputMaybe<FloatNullableFilter>;
  minQuantityOrder?: InputMaybe<FloatNullableFilter>;
  name?: InputMaybe<StringFilter>;
  nbClickProfile?: InputMaybe<IntFilter>;
  oldID?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePhotoId?: InputMaybe<IntNullableFilter>;
  referrals?: InputMaybe<UserListRelationFilter>;
  referredBy?: InputMaybe<UserNullableRelationFilter>;
  referredById?: InputMaybe<IntNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  sponsorshipCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workshopName?: InputMaybe<StringNullableFilter>;
  yearOfExperience?: InputMaybe<IntNullableFilter>;
};

export type UserWithNote = {
  __typename?: 'UserWithNote';
  /** Average note calculated from NoticeOrders */
  averageNote: Scalars['Float']['output'];
  /** The user object */
  user: User;
};

export type ValidOrderEvidence = {
  __typename?: 'ValidOrderEvidence';
  ChatMessage: Array<ChatMessage>;
  Craftman: User;
  Customer: User;
  Order: Order;
  _count?: Maybe<ValidOrderEvidenceCount>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  photos: Array<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type ValidOrderEvidenceChatMessageArgs = {
  cursor?: InputMaybe<ChatMessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatMessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type ValidOrderEvidencePhotosArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationAndSearchRelevanceInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};

export type ValidOrderEvidenceAvgAggregate = {
  __typename?: 'ValidOrderEvidenceAvgAggregate';
  craftmanId?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

export type ValidOrderEvidenceAvgOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceCount = {
  __typename?: 'ValidOrderEvidenceCount';
  ChatMessage: Scalars['Int']['output'];
  photos: Scalars['Int']['output'];
};


export type ValidOrderEvidenceCountChatMessageArgs = {
  where?: InputMaybe<ChatMessageWhereInput>;
};


export type ValidOrderEvidenceCountPhotosArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type ValidOrderEvidenceCountAggregate = {
  __typename?: 'ValidOrderEvidenceCountAggregate';
  _all: Scalars['Int']['output'];
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ValidOrderEvidenceCountOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceCreateInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput;
  Customer: UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput;
  Order: OrderCreateNestedOneWithoutValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutValidOrderEvidenceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateManyCraftmanInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateManyCraftmanInputEnvelope = {
  data: Array<ValidOrderEvidenceCreateManyCraftmanInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ValidOrderEvidenceCreateManyCustomerInput = {
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateManyCustomerInputEnvelope = {
  data: Array<ValidOrderEvidenceCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ValidOrderEvidenceCreateManyInput = {
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateManyOrderInput = {
  craftmanId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateManyOrderInputEnvelope = {
  data: Array<ValidOrderEvidenceCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ValidOrderEvidenceCreateNestedManyWithoutCraftmanInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyCraftmanInputEnvelope>;
};

export type ValidOrderEvidenceCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyCustomerInputEnvelope>;
};

export type ValidOrderEvidenceCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyOrderInputEnvelope>;
};

export type ValidOrderEvidenceCreateNestedOneWithoutChatMessageInput = {
  connect?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValidOrderEvidenceCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<ValidOrderEvidenceCreateWithoutChatMessageInput>;
};

export type ValidOrderEvidenceCreateNestedOneWithoutPhotosInput = {
  connect?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValidOrderEvidenceCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<ValidOrderEvidenceCreateWithoutPhotosInput>;
};

export type ValidOrderEvidenceCreateOrConnectWithoutChatMessageInput = {
  create: ValidOrderEvidenceCreateWithoutChatMessageInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceCreateOrConnectWithoutCraftmanInput = {
  create: ValidOrderEvidenceCreateWithoutCraftmanInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceCreateOrConnectWithoutCustomerInput = {
  create: ValidOrderEvidenceCreateWithoutCustomerInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceCreateOrConnectWithoutOrderInput = {
  create: ValidOrderEvidenceCreateWithoutOrderInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceCreateOrConnectWithoutPhotosInput = {
  create: ValidOrderEvidenceCreateWithoutPhotosInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceCreateWithoutChatMessageInput = {
  Craftman: UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput;
  Customer: UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput;
  Order: OrderCreateNestedOneWithoutValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutValidOrderEvidenceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateWithoutCraftmanInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput>;
  Customer: UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput;
  Order: OrderCreateNestedOneWithoutValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutValidOrderEvidenceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput;
  Order: OrderCreateNestedOneWithoutValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutValidOrderEvidenceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput;
  Customer: UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  photos?: InputMaybe<FileCreateNestedManyWithoutValidOrderEvidenceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceCreateWithoutPhotosInput = {
  ChatMessage?: InputMaybe<ChatMessageCreateNestedManyWithoutValidOrderEvidenceInput>;
  Craftman: UserCreateNestedOneWithoutCraftmanValidOrderEvidenceInput;
  Customer: UserCreateNestedOneWithoutCustomerValidOrderEvidenceInput;
  Order: OrderCreateNestedOneWithoutValidOrderEvidenceInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ValidOrderEvidenceGroupBy = {
  __typename?: 'ValidOrderEvidenceGroupBy';
  _avg?: Maybe<ValidOrderEvidenceAvgAggregate>;
  _count?: Maybe<ValidOrderEvidenceCountAggregate>;
  _max?: Maybe<ValidOrderEvidenceMaxAggregate>;
  _min?: Maybe<ValidOrderEvidenceMinAggregate>;
  _sum?: Maybe<ValidOrderEvidenceSumAggregate>;
  craftmanId: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ValidOrderEvidenceListRelationFilter = {
  every?: InputMaybe<ValidOrderEvidenceWhereInput>;
  none?: InputMaybe<ValidOrderEvidenceWhereInput>;
  some?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceMaxAggregate = {
  __typename?: 'ValidOrderEvidenceMaxAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ValidOrderEvidenceMaxOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceMinAggregate = {
  __typename?: 'ValidOrderEvidenceMinAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ValidOrderEvidenceMinOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceNullableRelationFilter = {
  is?: InputMaybe<ValidOrderEvidenceWhereInput>;
  isNot?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceOrderByWithAggregationInput = {
  _avg?: InputMaybe<ValidOrderEvidenceAvgOrderByAggregateInput>;
  _count?: InputMaybe<ValidOrderEvidenceCountOrderByAggregateInput>;
  _max?: InputMaybe<ValidOrderEvidenceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ValidOrderEvidenceMinOrderByAggregateInput>;
  _sum?: InputMaybe<ValidOrderEvidenceSumOrderByAggregateInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceOrderByWithRelationAndSearchRelevanceInput = {
  ChatMessage?: InputMaybe<ChatMessageOrderByRelationAggregateInput>;
  Craftman?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Customer?: InputMaybe<UserOrderByWithRelationAndSearchRelevanceInput>;
  Order?: InputMaybe<OrderOrderByWithRelationAndSearchRelevanceInput>;
  craftmanId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<FileOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ValidOrderEvidenceScalarFieldEnum {
  CraftmanId = 'craftmanId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  OrderId = 'orderId',
  UpdatedAt = 'updatedAt'
}

export type ValidOrderEvidenceScalarWhereInput = {
  AND?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  NOT?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  OR?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ValidOrderEvidenceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ValidOrderEvidenceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ValidOrderEvidenceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ValidOrderEvidenceScalarWhereWithAggregatesInput>>;
  craftmanId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  orderId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ValidOrderEvidenceSumAggregate = {
  __typename?: 'ValidOrderEvidenceSumAggregate';
  craftmanId?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type ValidOrderEvidenceSumOrderByAggregateInput = {
  craftmanId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
};

export type ValidOrderEvidenceUpdateInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutValidOrderEvidenceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateManyWithWhereWithoutCraftmanInput = {
  data: ValidOrderEvidenceUpdateManyMutationInput;
  where: ValidOrderEvidenceScalarWhereInput;
};

export type ValidOrderEvidenceUpdateManyWithWhereWithoutCustomerInput = {
  data: ValidOrderEvidenceUpdateManyMutationInput;
  where: ValidOrderEvidenceScalarWhereInput;
};

export type ValidOrderEvidenceUpdateManyWithWhereWithoutOrderInput = {
  data: ValidOrderEvidenceUpdateManyMutationInput;
  where: ValidOrderEvidenceScalarWhereInput;
};

export type ValidOrderEvidenceUpdateManyWithoutCraftmanNestedInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutCraftmanInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutCraftmanInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyCraftmanInputEnvelope>;
  delete?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  set?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  update?: InputMaybe<Array<ValidOrderEvidenceUpdateWithWhereUniqueWithoutCraftmanInput>>;
  updateMany?: InputMaybe<Array<ValidOrderEvidenceUpdateManyWithWhereWithoutCraftmanInput>>;
  upsert?: InputMaybe<Array<ValidOrderEvidenceUpsertWithWhereUniqueWithoutCraftmanInput>>;
};

export type ValidOrderEvidenceUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  set?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  update?: InputMaybe<Array<ValidOrderEvidenceUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<ValidOrderEvidenceUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<ValidOrderEvidenceUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type ValidOrderEvidenceUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ValidOrderEvidenceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ValidOrderEvidenceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ValidOrderEvidenceCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ValidOrderEvidenceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  set?: InputMaybe<Array<ValidOrderEvidenceWhereUniqueInput>>;
  update?: InputMaybe<Array<ValidOrderEvidenceUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ValidOrderEvidenceUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ValidOrderEvidenceUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ValidOrderEvidenceUpdateOneWithoutChatMessageNestedInput = {
  connect?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValidOrderEvidenceCreateOrConnectWithoutChatMessageInput>;
  create?: InputMaybe<ValidOrderEvidenceCreateWithoutChatMessageInput>;
  delete?: InputMaybe<ValidOrderEvidenceWhereInput>;
  disconnect?: InputMaybe<ValidOrderEvidenceWhereInput>;
  update?: InputMaybe<ValidOrderEvidenceUpdateToOneWithWhereWithoutChatMessageInput>;
  upsert?: InputMaybe<ValidOrderEvidenceUpsertWithoutChatMessageInput>;
};

export type ValidOrderEvidenceUpdateOneWithoutPhotosNestedInput = {
  connect?: InputMaybe<ValidOrderEvidenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValidOrderEvidenceCreateOrConnectWithoutPhotosInput>;
  create?: InputMaybe<ValidOrderEvidenceCreateWithoutPhotosInput>;
  delete?: InputMaybe<ValidOrderEvidenceWhereInput>;
  disconnect?: InputMaybe<ValidOrderEvidenceWhereInput>;
  update?: InputMaybe<ValidOrderEvidenceUpdateToOneWithWhereWithoutPhotosInput>;
  upsert?: InputMaybe<ValidOrderEvidenceUpsertWithoutPhotosInput>;
};

export type ValidOrderEvidenceUpdateToOneWithWhereWithoutChatMessageInput = {
  data: ValidOrderEvidenceUpdateWithoutChatMessageInput;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceUpdateToOneWithWhereWithoutPhotosInput = {
  data: ValidOrderEvidenceUpdateWithoutPhotosInput;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceUpdateWithWhereUniqueWithoutCraftmanInput = {
  data: ValidOrderEvidenceUpdateWithoutCraftmanInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpdateWithWhereUniqueWithoutCustomerInput = {
  data: ValidOrderEvidenceUpdateWithoutCustomerInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpdateWithWhereUniqueWithoutOrderInput = {
  data: ValidOrderEvidenceUpdateWithoutOrderInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpdateWithoutChatMessageInput = {
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutValidOrderEvidenceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateWithoutCraftmanInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutValidOrderEvidenceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateWithoutCustomerInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutValidOrderEvidenceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateWithoutOrderInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  photos?: InputMaybe<FileUpdateManyWithoutValidOrderEvidenceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpdateWithoutPhotosInput = {
  ChatMessage?: InputMaybe<ChatMessageUpdateManyWithoutValidOrderEvidenceNestedInput>;
  Craftman?: InputMaybe<UserUpdateOneRequiredWithoutCraftmanValidOrderEvidenceNestedInput>;
  Customer?: InputMaybe<UserUpdateOneRequiredWithoutCustomerValidOrderEvidenceNestedInput>;
  Order?: InputMaybe<OrderUpdateOneRequiredWithoutValidOrderEvidenceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ValidOrderEvidenceUpsertWithWhereUniqueWithoutCraftmanInput = {
  create: ValidOrderEvidenceCreateWithoutCraftmanInput;
  update: ValidOrderEvidenceUpdateWithoutCraftmanInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpsertWithWhereUniqueWithoutCustomerInput = {
  create: ValidOrderEvidenceCreateWithoutCustomerInput;
  update: ValidOrderEvidenceUpdateWithoutCustomerInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpsertWithWhereUniqueWithoutOrderInput = {
  create: ValidOrderEvidenceCreateWithoutOrderInput;
  update: ValidOrderEvidenceUpdateWithoutOrderInput;
  where: ValidOrderEvidenceWhereUniqueInput;
};

export type ValidOrderEvidenceUpsertWithoutChatMessageInput = {
  create: ValidOrderEvidenceCreateWithoutChatMessageInput;
  update: ValidOrderEvidenceUpdateWithoutChatMessageInput;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceUpsertWithoutPhotosInput = {
  create: ValidOrderEvidenceCreateWithoutPhotosInput;
  update: ValidOrderEvidenceUpdateWithoutPhotosInput;
  where?: InputMaybe<ValidOrderEvidenceWhereInput>;
};

export type ValidOrderEvidenceWhereInput = {
  AND?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  OR?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<IntFilter>;
  photos?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ValidOrderEvidenceWhereUniqueInput = {
  AND?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  ChatMessage?: InputMaybe<ChatMessageListRelationFilter>;
  Craftman?: InputMaybe<UserRelationFilter>;
  Customer?: InputMaybe<UserRelationFilter>;
  NOT?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  OR?: InputMaybe<Array<ValidOrderEvidenceWhereInput>>;
  Order?: InputMaybe<OrderRelationFilter>;
  craftmanId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<IntFilter>;
  photos?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum WalletType {
  Bank = 'BANK',
  Mobile = 'MOBILE',
  Paypal = 'PAYPAL'
}

export type SignupUserMutationVariables = Exact<{
  signupInput: SignupInput;
}>;


export type SignupUserMutation = { __typename?: 'Mutation', signupUser: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, permissions: Array<string>, isActiveAdmin: boolean, ProfilePhoto?: { __typename?: 'File', name: string, url: string, id: number } | null } } };

export type UpdateAdminMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateAdminMutation = { __typename?: 'Mutation', updateUserAccount: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, permissions: Array<string>, isActiveAdmin: boolean, ProfilePhoto?: { __typename?: 'File', url: string, id: number, name: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string } | null } } };

export type GetOneAdminQueryQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetOneAdminQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, permissions: Array<string>, isActiveAdmin: boolean, ProfilePhoto?: { __typename?: 'File', id: number, url: string, name: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string } | null } | null };

export type AdminsQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminsQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, name: string, lastName?: string | null, role: Role, isActiveAdmin: boolean, ProfilePhoto?: { __typename?: 'File', url: string, id: number } | null, country?: { __typename?: 'Country', id: number, name_fr: string } | null }>, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type DeleteOneAdminMutationVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type DeleteOneAdminMutation = { __typename?: 'Mutation', deleteOneUser?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, name: string, lastName?: string | null, role: Role } | null };

export type CreateOneCategoryMutationVariables = Exact<{
  data: CategoryCreateInput;
}>;


export type CreateOneCategoryMutation = { __typename?: 'Mutation', createOneCategory: { __typename?: 'Category', id: number, name_fr: string, name_en: string, Segmentation: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } };

export type GetDetailCategoryQueryQueryVariables = Exact<{
  where: CategoryWhereUniqueInput;
  aggregateItemTypeWhere2?: InputMaybe<ItemTypeWhereInput>;
  aggregateMaterialTypeWhere2?: InputMaybe<MaterialTypeWhereInput>;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetDetailCategoryQueryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, name_fr: string, name_en: string, Segmentation: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_en: string }> } | null, aggregateItemType: { __typename?: 'AggregateItemType', _count?: { __typename?: 'ItemTypeCountAggregate', id: number } | null }, aggregateMaterialType: { __typename?: 'AggregateMaterialType', _count?: { __typename?: 'MaterialTypeCountAggregate', id: number } | null }, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', id: number } | null }, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', id: number } | null } };

export type GetCraftmenQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type GetCraftmenQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, email?: string | null, lastName?: string | null }> };

export type EditCategoryMutationMutationVariables = Exact<{
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
}>;


export type EditCategoryMutationMutation = { __typename?: 'Mutation', updateOneCategory?: { __typename?: 'Category', id: number, name_fr: string, name_en: string, Segmentation: { __typename?: 'Segmentation', name_fr: string, id: number, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } | null };

export type GetOneCategoryQueryQueryVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type GetOneCategoryQueryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, name_fr: string, name_en: string, Segmentation: { __typename?: 'Segmentation', name_fr: string, id: number, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } | null };

export type CategoriesQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput> | CategoryOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string, isVisible: boolean, Segmentation: { __typename?: 'Segmentation', name_fr: string, id: number, name_en: string } }>, aggregateCategory: { __typename?: 'AggregateCategory', _count?: { __typename?: 'CategoryCountAggregate', _all: number } | null } };

export type DeleteOneCategoryMutationVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type DeleteOneCategoryMutation = { __typename?: 'Mutation', deleteOneCategory?: { __typename?: 'Category', id: number, name_fr: string, name_en: string, Segmentation: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string } } | null };

export type FiltersListCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type FiltersListCategoryQuery = { __typename?: 'Query', segmentations: Array<{ __typename?: 'Segmentation', id: number, name_fr: string }> };

export type CategoriesListQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput> | CategoryOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type CategoriesListQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }> };

export type ListCountriesQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput> | CountryOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: number, name_fr: string, name_en: string }> };

export type GetItemTypesQueryVariables = Exact<{
  where?: InputMaybe<ItemTypeWhereInput>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput> | ItemTypeOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetItemTypesQuery = { __typename?: 'Query', itemTypes: Array<{ __typename?: 'ItemType', name_fr: string, name_en: string, id: number }> };

export type GetMaterialTypesQueryVariables = Exact<{
  where?: InputMaybe<MaterialTypeWhereInput>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput> | MaterialTypeOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMaterialTypesQuery = { __typename?: 'Query', materialTypes: Array<{ __typename?: 'MaterialType', name_fr: string, name_en: string, id: number }> };

export type Segmentations_TotalQueryVariables = Exact<{
  where?: InputMaybe<SegmentationWhereInput>;
  orderBy?: InputMaybe<Array<SegmentationOrderByWithRelationAndSearchRelevanceInput> | SegmentationOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Segmentations_TotalQuery = { __typename?: 'Query', aggregateSegmentation: { __typename?: 'AggregateSegmentation', _count?: { __typename?: 'SegmentationCountAggregate', _all: number } | null }, segmentations: Array<{ __typename?: 'Segmentation', id: number, name_fr: string, name_en: string }> };

export type ListTransporterQueryVariables = Exact<{
  where?: InputMaybe<TransporterWhereInput>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput> | TransporterOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTransporterQuery = { __typename?: 'Query', transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> };

export type ListTransporterZonesQueryVariables = Exact<{
  where?: InputMaybe<TransporterZoneWhereInput>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput> | TransporterZoneOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTransporterZonesQuery = { __typename?: 'Query', transporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string, name_en: string }> }> };

export type UsersListQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type UsersListQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, name: string, lastName?: string | null }> };

export type UpdateOneFaqVisibilityMutationVariables = Exact<{
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
}>;


export type UpdateOneFaqVisibilityMutation = { __typename?: 'Mutation', updateOneFaq?: { __typename?: 'Faq', id: number, isShowOnCraftman: boolean, isShowOnCustomer: boolean, priority: number } | null };

export type UpdateOneCategoryMutationVariables = Exact<{
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
}>;


export type UpdateOneCategoryMutation = { __typename?: 'Mutation', updateOneCategory?: { __typename?: 'Category', id: number, isVisible: boolean } | null };

export type UpdateOneFaqPriorityMutationVariables = Exact<{
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
}>;


export type UpdateOneFaqPriorityMutation = { __typename?: 'Mutation', updateOneFaq?: { __typename?: 'Faq', id: number, priority: number } | null };

export type AddCountryMutationVariables = Exact<{
  data: CountryCreateInput;
}>;


export type AddCountryMutation = { __typename?: 'Mutation', createOneCountry: { __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, currency?: string | null, isOpen?: boolean | null, ceedowCommission?: number | null } };

export type CountryQueryVariables = Exact<{
  where: CountryWhereUniqueInput;
  usersWhere2?: InputMaybe<UserWhereInput>;
}>;


export type CountryQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, ceedowCommission?: number | null, currency?: string | null, _count?: { __typename?: 'CountryCount', Orders: number, Users: number } | null } | null };

export type GetCraftmensQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
}>;


export type GetCraftmensQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, email?: string | null, lastName?: string | null }>, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', id: number } | null } };

export type UpdateOneCountryMutationVariables = Exact<{
  data: CountryUpdateInput;
  where: CountryWhereUniqueInput;
}>;


export type UpdateOneCountryMutation = { __typename?: 'Mutation', updateOneCountry?: { __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, currency?: string | null, isOpen?: boolean | null, minPrice?: number | null, ceedowCommission?: number | null } | null };

export type GetOneCountryQueryQueryVariables = Exact<{
  where: CountryWhereUniqueInput;
}>;


export type GetOneCountryQueryQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id: number, name_en: string, name_fr: string, alpha2?: string | null, alpha3?: string | null, isOpen?: boolean | null, currency?: string | null, minPrice?: number | null, ceedowCommission?: number | null } | null };

export type CountriesQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput> | CountryOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, currency?: string | null, isOpen?: boolean | null, ceedowCommission?: number | null }>, aggregateCountry: { __typename?: 'AggregateCountry', _count?: { __typename?: 'CountryCountAggregate', _all: number } | null } };

export type DeleteOneCountryMutationVariables = Exact<{
  where: CountryWhereUniqueInput;
}>;


export type DeleteOneCountryMutation = { __typename?: 'Mutation', deleteOneCountry?: { __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, currency?: string | null } | null };

export type CountriesCraftmanQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
  orderBy?: InputMaybe<Array<CountryOrderByWithRelationAndSearchRelevanceInput> | CountryOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregateCountryWhere2?: InputMaybe<CountryWhereInput>;
}>;


export type CountriesCraftmanQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: number, name_fr: string, name_en: string, alpha2?: string | null, alpha3?: string | null, currency?: string | null }>, aggregateCountry: { __typename?: 'AggregateCountry', _count?: { __typename?: 'CountryCountAggregate', _all: number } | null } };

export type SignupCrafmanMutationVariables = Exact<{
  signupInput: SignupInput;
}>;


export type SignupCrafmanMutation = { __typename?: 'Mutation', signupUser: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, yearOfExperience?: number | null, minQuantityOrder?: number | null, ProfilePhoto?: { __typename?: 'File', url: string } | null, PhotoAchievements: Array<{ __typename?: 'File', url: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null } } };

export type GetDetailCraftmanQueryQueryVariables = Exact<{
  where: UserWhereUniqueInput;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
  aggregateNoticeOrderWhere2?: InputMaybe<NoticeOrderWhereInput>;
}>;


export type GetDetailCraftmanQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, active: boolean, yearOfExperience?: number | null, ProfilePhoto?: { __typename?: 'File', id: number, url: string } | null, PhotoAchievements: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null, name_en: string } | null } | null, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null }, aggregateNoticeOrder: { __typename?: 'AggregateNoticeOrder', _count?: { __typename?: 'NoticeOrderCountAggregate', _all: number } | null, _avg?: { __typename?: 'NoticeOrderAvgAggregate', note?: number | null } | null } };

export type UpdateOneUserMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateOneUserMutation = { __typename?: 'Mutation', updateOneUser?: { __typename?: 'User', id: number, active: boolean } | null };

export type UpdateCraftmanMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateCraftmanMutation = { __typename?: 'Mutation', updateUserAccount: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, yearOfExperience?: number | null, minQuantityOrder?: number | null, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string } | null, PhotoAchievements: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string, currency?: string | null } | null } } };

export type GetOneCraftmanQueryQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetOneCraftmanQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, yearOfExperience?: number | null, minQuantityOrder?: number | null, description?: string | null, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string } | null, PhotoAchievements: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null, name_en: string } | null } | null };

export type CraftmansQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CraftmansQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, oldID?: number | null, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, workshopName?: string | null, active: boolean, yearOfExperience?: number | null, createdAt: any, dateOfLastConnexion?: any | null, jackpotCraftman: number, completedProfilPercentage: number, ProfilePhoto?: { __typename?: 'File', url: string } | null, PhotoAchievements: Array<{ __typename?: 'File', id: number, url: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null, name_en: string } | null }>, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type DeleteOneCraftmanMutationVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type DeleteOneCraftmanMutation = { __typename?: 'Mutation', deleteOneUser?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, name: string, lastName?: string | null, role: Role } | null };

export type FiltersListCraftmanQueryVariables = Exact<{
  whereCountry?: InputMaybe<CountryWhereInput>;
}>;


export type FiltersListCraftmanQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, itemTypes: Array<{ __typename?: 'ItemType', name_fr: string, name_en: string, id: number }>, materialTypes: Array<{ __typename?: 'MaterialType', name_fr: string, name_en: string, id: number }>, countries: Array<{ __typename?: 'Country', name_fr: string, name_en: string, id: number }> };

export type CraftmanActionWalletsQueryVariables = Exact<{
  where?: InputMaybe<CraftmanWalletWhereInput>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput> | CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregateCraftmanWalletWhere2?: InputMaybe<CraftmanWalletWhereInput>;
}>;


export type CraftmanActionWalletsQuery = { __typename?: 'Query', craftmanWallets: Array<{ __typename?: 'CraftmanWallet', id: number, price?: number | null, description?: string | null, action: ActionTransaction, createdAt: any, Craftman: { __typename?: 'User', id: number, country?: { __typename?: 'Country', id: number, currency?: string | null } | null } }>, aggregateCraftmanWallet: { __typename?: 'AggregateCraftmanWallet', _count?: { __typename?: 'CraftmanWalletCountAggregate', _all: number } | null } };

export type CreateCraftmanWalletMutationVariables = Exact<{
  action: ActionTransaction;
  craftmanId: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
}>;


export type CreateCraftmanWalletMutation = { __typename?: 'Mutation', createCraftmanWallet: { __typename?: 'CraftmanWallet', id: number } };

export type GetOneCraftmanWalletQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetOneCraftmanWalletQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, jackpotCraftman: number, lastName?: string | null, workshopName?: string | null, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null } | null };

export type GetStatisticOneQueryVariables = Exact<{
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetStatisticOneQuery = { __typename?: 'Query', aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null }, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type GetStatisticTwoQueryVariables = Exact<{
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetStatisticTwoQuery = { __typename?: 'Query', aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null }, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type GetStatisticArchiveQueryVariables = Exact<{
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetStatisticArchiveQuery = { __typename?: 'Query', aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null }, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type GetStatisticAllPaidQueryVariables = Exact<{
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetStatisticAllPaidQuery = { __typename?: 'Query', aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null } };

export type AskDeliveryMenQueryVariables = Exact<{
  where?: InputMaybe<AskDeliveryManWhereInput>;
  orderBy?: InputMaybe<Array<AskDeliveryManOrderByWithRelationAndSearchRelevanceInput> | AskDeliveryManOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregateAskDeliveryManWhere2?: InputMaybe<AskDeliveryManWhereInput>;
}>;


export type AskDeliveryMenQuery = { __typename?: 'Query', askDeliveryMen: Array<{ __typename?: 'AskDeliveryMan', id: number, craftmanId: number, address: string, codeTracking?: string | null, customerId: number, orderId: number, delivryDate: any, createdAt: any, photos: Array<{ __typename?: 'File', id: number, url: string }> }>, aggregateAskDeliveryMan: { __typename?: 'AggregateAskDeliveryMan', _count?: { __typename?: 'AskDeliveryManCountAggregate', _all: number } | null } };

export type CraftmanWalletsQueryVariables = Exact<{
  where?: InputMaybe<CraftmanWalletWhereInput>;
  orderBy?: InputMaybe<Array<CraftmanWalletOrderByWithRelationAndSearchRelevanceInput> | CraftmanWalletOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregateCraftmanWalletWhere2?: InputMaybe<CraftmanWalletWhereInput>;
}>;


export type CraftmanWalletsQuery = { __typename?: 'Query', craftmanWallets: Array<{ __typename?: 'CraftmanWallet', id: number, craftmanId: number, operator?: string | null, orderId?: number | null, createdAt: any, price?: number | null, phoneNumber?: string | null, rib?: string | null, walletType: WalletType, accountNumber?: string | null, username?: string | null, action: ActionTransaction, description?: string | null, Craftman: { __typename?: 'User', id: number, country?: { __typename?: 'Country', id: number, currency?: string | null } | null } }>, aggregateCraftmanWallet: { __typename?: 'AggregateCraftmanWallet', _count?: { __typename?: 'CraftmanWalletCountAggregate', _all: number } | null } };

export type ValidCraftmanPaimentMutationVariables = Exact<{
  paimentId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
}>;


export type ValidCraftmanPaimentMutation = { __typename?: 'Mutation', validCraftmanPaiment: { __typename?: 'CraftmanWallet', id: number } };

export type EmailQueryVariables = Exact<{
  where: EmailWhereUniqueInput;
}>;


export type EmailQuery = { __typename?: 'Query', email?: { __typename?: 'Email', id: number, contentHtml?: string | null, subject: string } | null };

export type EmailsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<EmailOrderByWithRelationAndSearchRelevanceInput> | EmailOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EmailWhereInput>;
  aggregateEmailWhere2?: InputMaybe<EmailWhereInput>;
}>;


export type EmailsQuery = { __typename?: 'Query', emails: Array<{ __typename?: 'Email', id: number, subject: string, content: string, createdAt: any, Sender: { __typename?: 'User', lastName?: string | null, email?: string | null } }>, aggregateEmail: { __typename?: 'AggregateEmail', _count?: { __typename?: 'EmailCountAggregate', _all: number } | null } };

export type CreateOneFaqMutationVariables = Exact<{
  data: FaqCreateInput;
}>;


export type CreateOneFaqMutation = { __typename?: 'Mutation', createOneFaq: { __typename?: 'Faq', createdAt: any, description_en: string, id: number, title_en: string, title_fr: string, updatedAt: any, description_fr: string } };

export type UpdateOneFaqMutationVariables = Exact<{
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
}>;


export type UpdateOneFaqMutation = { __typename?: 'Mutation', updateOneFaq?: { __typename?: 'Faq', id: number, createdAt: any, description_en: string, title_en: string, title_fr: string, updatedAt: any, description_fr: string } | null };

export type GetFaqQueryVariables = Exact<{
  where: FaqWhereUniqueInput;
}>;


export type GetFaqQuery = { __typename?: 'Query', getFaq?: { __typename?: 'Faq', id: number, createdAt: any, description_en: string, title_en: string, title_fr: string, updatedAt: any, description_fr: string } | null };

export type FaqsQueryVariables = Exact<{
  where?: InputMaybe<FaqWhereInput>;
  orderBy?: InputMaybe<Array<FaqOrderByWithRelationAndSearchRelevanceInput> | FaqOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FaqsQuery = { __typename?: 'Query', faqs: Array<{ __typename?: 'Faq', id: number, createdAt: any, description_en: string, title_en: string, title_fr: string, updatedAt: any, description_fr: string, priority: number, isShowOnCraftman: boolean, isShowOnCustomer: boolean }>, aggregateFaq: { __typename?: 'AggregateFaq', _count?: { __typename?: 'FaqCountAggregate', _all: number } | null } };

export type DeleteOneFaqMutationVariables = Exact<{
  where: FaqWhereUniqueInput;
}>;


export type DeleteOneFaqMutation = { __typename?: 'Mutation', deleteOneFaq?: { __typename?: 'Faq', id: number } | null };

export type CreateOneItemTypeMutationVariables = Exact<{
  data: ItemTypeCreateInput;
}>;


export type CreateOneItemTypeMutation = { __typename?: 'Mutation', createOneItemType: { __typename?: 'ItemType', id: number, name_fr: string, name_en: string, weight?: number | null, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } };

export type GetDetailItemTypeQueryQueryVariables = Exact<{
  where: ItemTypeWhereUniqueInput;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetDetailItemTypeQueryQuery = { __typename?: 'Query', itemType?: { __typename?: 'ItemType', id: number, name_fr: string, name_en: string, Countries: Array<{ __typename?: 'Country', id: number, name_en: string, name_fr: string }>, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string } } | null, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', id: number } | null }, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', id: number } | null } };

export type EditItemTypeMutationMutationVariables = Exact<{
  data: ItemTypeUpdateInput;
  where: ItemTypeWhereUniqueInput;
}>;


export type EditItemTypeMutationMutation = { __typename?: 'Mutation', updateOneItemType?: { __typename?: 'ItemType', id: number, name_fr: string, name_en: string, weight?: number | null, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }>, Category: { __typename?: 'Category', name_fr: string, id: number, name_en: string } } | null };

export type GetOneItemTypeQueryQueryVariables = Exact<{
  where: ItemTypeWhereUniqueInput;
}>;


export type GetOneItemTypeQueryQuery = { __typename?: 'Query', itemType?: { __typename?: 'ItemType', id: number, name_fr: string, name_en: string, weight?: number | null, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }>, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string } } | null };

export type ItemTypesQueryVariables = Exact<{
  where?: InputMaybe<ItemTypeWhereInput>;
  orderBy?: InputMaybe<Array<ItemTypeOrderByWithRelationAndSearchRelevanceInput> | ItemTypeOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ItemTypesQuery = { __typename?: 'Query', itemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string, weight?: number | null, Category: { __typename?: 'Category', name_fr: string, id: number, name_en: string } }>, aggregateItemType: { __typename?: 'AggregateItemType', _count?: { __typename?: 'ItemTypeCountAggregate', _all: number } | null } };

export type DeleteOneItemTypeMutationVariables = Exact<{
  where: ItemTypeWhereUniqueInput;
}>;


export type DeleteOneItemTypeMutation = { __typename?: 'Mutation', deleteOneItemType?: { __typename?: 'ItemType', id: number, name_fr: string, name_en: string } | null };

export type FiltersListItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type FiltersListItemsQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name_fr: string }> };

export type CountNewNotificationQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type CountNewNotificationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, countNewNotification: number, countNotification: number } | null };

export type UserNotificationQueryVariables = Exact<{
  where: UserWhereUniqueInput;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationAndSearchRelevanceInput> | NotificationOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  notificationsWhere2?: InputMaybe<NotificationWhereInput>;
}>;


export type UserNotificationQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, countNotification: number, Notifications: Array<{ __typename?: 'Notification', body_en: string, body_fr: string, data: any, id: number, read: boolean, title_en: string, receiverId: number, title_fr: string, type: NotificationDataType, createdAt: any }> } | null };

export type ViewNotificationMutationVariables = Exact<{
  data: NotificationUpdateInput;
  where: NotificationWhereUniqueInput;
}>;


export type ViewNotificationMutation = { __typename?: 'Mutation', updateOneNotification?: { __typename?: 'Notification', id: number, read: boolean, body_en: string, body_fr: string, createdAt: any, data: any, receiverId: number, title_en: string, title_fr: string, type: NotificationDataType } | null };

export type NewNotificationSubcriptionSubscriptionVariables = Exact<{
  receiverId: Scalars['Float']['input'];
}>;


export type NewNotificationSubcriptionSubscription = { __typename?: 'Subscription', newNotification: { __typename?: 'Notification', body_en: string, body_fr: string, createdAt: any, data: any, id: number, read: boolean, receiverId: number, title_en: string, title_fr: string, type: NotificationDataType } };

export type LoginMutationVariables = Exact<{
  userLoginInput: UserLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, email?: string | null, lastName?: string | null, name: string, permissions: Array<string>, country?: { __typename?: 'Country', id: number } | null } } };

export type CreateOneMaterialTypeMutationVariables = Exact<{
  data: MaterialTypeCreateInput;
}>;


export type CreateOneMaterialTypeMutation = { __typename?: 'Mutation', createOneMaterialType: { __typename?: 'MaterialType', id: number, name_fr: string, name_en: string, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string }, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } };

export type GetDetailMaterialTypeQueryQueryVariables = Exact<{
  where: MaterialTypeWhereUniqueInput;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetDetailMaterialTypeQueryQuery = { __typename?: 'Query', materialType?: { __typename?: 'MaterialType', id: number, name_fr: string, name_en: string, Countries: Array<{ __typename?: 'Country', id: number, name_en: string }>, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string } } | null, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', id: number } | null }, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', id: number } | null } };

export type EditMaterialTypeMutationMutationVariables = Exact<{
  data: MaterialTypeUpdateInput;
  where: MaterialTypeWhereUniqueInput;
}>;


export type EditMaterialTypeMutationMutation = { __typename?: 'Mutation', updateOneMaterialType?: { __typename?: 'MaterialType', id: number, name_fr: string, name_en: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }>, Category: { __typename?: 'Category', name_fr: string, id: number, name_en: string } } | null };

export type GetOneMaterialTypeQueryQueryVariables = Exact<{
  where: MaterialTypeWhereUniqueInput;
}>;


export type GetOneMaterialTypeQueryQuery = { __typename?: 'Query', materialType?: { __typename?: 'MaterialType', id: number, name_fr: string, name_en: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }>, Category: { __typename?: 'Category', id: number, name_fr: string, name_en: string } } | null };

export type MaterialTypesQueryVariables = Exact<{
  where?: InputMaybe<MaterialTypeWhereInput>;
  orderBy?: InputMaybe<Array<MaterialTypeOrderByWithRelationAndSearchRelevanceInput> | MaterialTypeOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MaterialTypesQuery = { __typename?: 'Query', materialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string, Category: { __typename?: 'Category', name_fr: string, id: number, name_en: string } }>, aggregateMaterialType: { __typename?: 'AggregateMaterialType', _count?: { __typename?: 'MaterialTypeCountAggregate', _all: number } | null } };

export type DeleteOneMaterialTypeMutationVariables = Exact<{
  where: MaterialTypeWhereUniqueInput;
}>;


export type DeleteOneMaterialTypeMutation = { __typename?: 'Mutation', deleteOneMaterialType?: { __typename?: 'MaterialType', id: number, name_fr: string, name_en: string } | null };

export type CreateNewOrderMutationVariables = Exact<{
  photos: Array<NewFileInput> | NewFileInput;
  price: Scalars['Float']['input'];
  categoryId: Scalars['Float']['input'];
  materialId: Scalars['Float']['input'];
  itemId: Scalars['Float']['input'];
  customerId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  message: Scalars['String']['input'];
}>;


export type CreateNewOrderMutation = { __typename?: 'Mutation', createNewOrder: { __typename?: 'Order', id: number, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, craftmanCustomPrice?: number | null, transporterCustomPrice?: number | null, ceedowCommissionCustomPrice?: number | null, quantity?: number | null, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null }, Craftman?: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null } | null, Country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }> } };

export type ChatMessagesQueryVariables = Exact<{
  where: ChatWhereUniqueInput;
  orderBy?: InputMaybe<Array<ChatMessageOrderByWithRelationAndSearchRelevanceInput> | ChatMessageOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatMessagesQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', id: number, orderId: number, createdAt: any, updatedAt: any, Order: { __typename?: 'Order', id: number, status: Status, Customer: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } }, ChatMessages: Array<{ __typename?: 'ChatMessage', id: number, chatId?: number | null, createdAt: any, updatedAt: any, content?: string | null, receiverId: number, isDelete: boolean, senderId: number, contentType?: ContentMessageType | null, Files: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string, size?: number | null }>, Sender: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, Receiver: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, OrderPrice?: { __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string, createdAt: any, updatedAt: any } | null, OrderSize?: { __typename?: 'OrderSize', id: number, depth?: string | null, height?: string | null, length?: string | null, weight?: string | null, width?: string | null } | null, AskDeliveryMan?: { __typename?: 'AskDeliveryMan', id: number, address: string, delivryDate: any, codeTracking?: string | null, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null, ValidOrderEvidence?: { __typename?: 'ValidOrderEvidence', id: number, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null }>, _count?: { __typename?: 'ChatCount', ChatMessages: number } | null } | null };

export type SendNewMessageMutationVariables = Exact<{
  photos: Array<NewFileInput> | NewFileInput;
  receiverId: Scalars['Float']['input'];
  content: Scalars['String']['input'];
  chatId: Scalars['Float']['input'];
}>;


export type SendNewMessageMutation = { __typename?: 'Mutation', sendNewMessage: { __typename?: 'ChatMessage', id: number, chatId?: number | null, createdAt: any, updatedAt: any, isDelete: boolean, content?: string | null, receiverId: number, senderId: number, contentType?: ContentMessageType | null, Files: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string, size?: number | null }>, Sender: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, Receiver: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, OrderPrice?: { __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string, createdAt: any, updatedAt: any } | null, OrderSize?: { __typename?: 'OrderSize', id: number, depth?: string | null, height?: string | null, length?: string | null, weight?: string | null, width?: string | null } | null, AskDeliveryMan?: { __typename?: 'AskDeliveryMan', id: number, address: string, delivryDate: any, codeTracking?: string | null, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null, ValidOrderEvidence?: { __typename?: 'ValidOrderEvidence', id: number, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null } };

export type NewMessageSubscriptionVariables = Exact<{
  chatId: Scalars['Float']['input'];
}>;


export type NewMessageSubscription = { __typename?: 'Subscription', newMessage: { __typename?: 'ChatMessage', id: number, chatId?: number | null, createdAt: any, updatedAt: any, content?: string | null, receiverId: number, senderId: number, isDelete: boolean, contentType?: ContentMessageType | null, Files: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string, size?: number | null }>, Sender: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, Receiver: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, OrderPrice?: { __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string, createdAt: any, updatedAt: any } | null, OrderSize?: { __typename?: 'OrderSize', id: number, depth?: string | null, height?: string | null, length?: string | null, weight?: string | null, width?: string | null } | null, AskDeliveryMan?: { __typename?: 'AskDeliveryMan', id: number, address: string, delivryDate: any, codeTracking?: string | null, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null, ValidOrderEvidence?: { __typename?: 'ValidOrderEvidence', id: number, photos: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string }> } | null } };

export type ToogleArchiveOrderSubSubscriptionVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ToogleArchiveOrderSubSubscription = { __typename?: 'Subscription', toogleArchiveOrderSub: { __typename?: 'Order', id: number, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type ValidPaimentSubSubscriptionVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ValidPaimentSubSubscription = { __typename?: 'Subscription', validPaimentSub: { __typename?: 'Order', id: number, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type ValidOrderDelivrySubSubscriptionVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ValidOrderDelivrySubSubscription = { __typename?: 'Subscription', validOrderDelivrySub: { __typename?: 'Order', id: number, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type DesArchiveOrderMutationVariables = Exact<{
  isToogle?: InputMaybe<Scalars['Boolean']['input']>;
  toogleArchiveOrderId: Scalars['Float']['input'];
}>;


export type DesArchiveOrderMutation = { __typename?: 'Mutation', toogleArchiveOrder: { __typename?: 'Order', id: number } };

export type AskDeliveryManMutationVariables = Exact<{
  photos: Array<NewFileInput> | NewFileInput;
  address: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  delivryDate: Scalars['DateTimeISO']['input'];
  customerId: Scalars['Float']['input'];
  chatId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
}>;


export type AskDeliveryManMutation = { __typename?: 'Mutation', askDeliveryMan: { __typename?: 'ChatMessage', id: number, chatId?: number | null, Chat?: { __typename?: 'Chat', id: number, Order: { __typename?: 'Order', delivryDate?: any | null, id: number } } | null } };

export type AdviceNewOrderPriceMutationVariables = Exact<{
  receiverId: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  orderId: Scalars['Float']['input'];
  chatId: Scalars['Float']['input'];
}>;


export type AdviceNewOrderPriceMutation = { __typename?: 'Mutation', adviceNewOrderPrice: { __typename?: 'ChatMessage', id: number, chatId?: number | null, createdAt: any, updatedAt: any, content?: string | null, receiverId: number, senderId: number, contentType?: ContentMessageType | null, Files: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string, size?: number | null }>, Sender: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, Receiver: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, OrderPrice?: { __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string, createdAt: any, updatedAt: any } | null } };

export type ToogleArchiveOrderMutationVariables = Exact<{
  toogleArchiveOrderId: Scalars['Float']['input'];
}>;


export type ToogleArchiveOrderMutation = { __typename?: 'Mutation', toogleArchiveOrder: { __typename?: 'Order', id: number, createdAt: any, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type ValidOrderPaimentMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
  chatId: Scalars['Float']['input'];
}>;


export type ValidOrderPaimentMutation = { __typename?: 'Mutation', validOrderPaiment: { __typename?: 'Order', id: number, createdAt: any, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type ValidOrderDelivryMutationVariables = Exact<{
  orderId: Scalars['Float']['input'];
}>;


export type ValidOrderDelivryMutation = { __typename?: 'Mutation', validOrderDelivry: { __typename?: 'Order', id: number, createdAt: any, status: Status, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean } } };

export type EditContentMessageMutationVariables = Exact<{
  chatMessageId: Scalars['Float']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditContentMessageMutation = { __typename?: 'Mutation', editContentMessage: { __typename?: 'ChatMessage', id: number, content?: string | null, updatedAt: any, createdAt: any, isDelete: boolean } };

export type ValidAdviceOrderPriceMutationVariables = Exact<{
  receiverId: Scalars['Float']['input'];
  orderPriceId: Scalars['Float']['input'];
  chatId: Scalars['Float']['input'];
}>;


export type ValidAdviceOrderPriceMutation = { __typename?: 'Mutation', validAdviceOrderPrice: { __typename?: 'ChatMessage', id: number, chatId?: number | null, createdAt: any, updatedAt: any, content?: string | null, receiverId: number, senderId: number, contentType?: ContentMessageType | null, Files: Array<{ __typename?: 'File', id: number, name: string, url: string, type: string, size?: number | null }>, Sender: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, Receiver: { __typename?: 'User', id: number, workshopName?: string | null, name: string, lastName?: string | null, role: Role, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string, type: string } | null }, OrderPrice?: { __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string, createdAt: any, updatedAt: any } | null } };

export type GetOrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput> | OrderPriceOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: number, status: Status, createdAt: any, delivryDate?: any | null, quantity?: number | null, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean }, Country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string } | null, Customer: { __typename?: 'User', id: number, name: string, lastName?: string | null, dateOfLastConnexion?: any | null, phoneNumber?: string | null }, Craftman?: { __typename?: 'User', id: number, name: string, lastName?: string | null, dateOfLastConnexion?: any | null, phoneNumber?: string | null } | null, Prices: Array<{ __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string }>, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, Photos: Array<{ __typename?: 'File', id: number, url: string, name: string }>, Chats: Array<{ __typename?: 'Chat', id: number, orderId: number }> } | null };

export type SendEmailMessagePendingMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SendEmailMessagePendingMutation = { __typename?: 'Mutation', sendEmailMessagePending: boolean };

export type SendEmailValidOrderDeliveryMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  craftmanId: Scalars['Int']['input'];
}>;


export type SendEmailValidOrderDeliveryMutation = { __typename?: 'Mutation', sendEmailValidOrderDelivery: boolean };

export type UpdateCustomerOrderMutationVariables = Exact<{
  photosDeleteIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  photosOrders: Array<NewFileInput> | NewFileInput;
  categoryId: Scalars['Float']['input'];
  materialId: Scalars['Float']['input'];
  itemId: Scalars['Float']['input'];
  craftmanId: Scalars['Float']['input'];
  updateCustomerOrderId: Scalars['Float']['input'];
  customerId?: InputMaybe<Scalars['Float']['input']>;
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  craftmanCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  ceedowCommissionCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  transporterCustomPrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateCustomerOrderMutation = { __typename?: 'Mutation', updateCustomerOrder: { __typename?: 'Order', id: number, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, quantity?: number | null, craftmanCustomPrice?: number | null, transporterCustomPrice?: number | null, ceedowCommissionCustomPrice?: number | null, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null }, Craftman?: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null } | null, Country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }> } };

export type GetNewOrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type GetNewOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: number, deadline?: any | null, craftmanCustomPrice?: number | null, transporterCustomPrice?: number | null, ceedowCommissionCustomPrice?: number | null, quantity?: number | null, Customer: { __typename?: 'User', id: number, name: string, lastName?: string | null }, Craftman?: { __typename?: 'User', id: number, name: string, lastName?: string | null } | null, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string, name_en: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string, name_en: string }> } | null };

export type ActionOrdersQueryVariables = Exact<{
  where?: InputMaybe<ActionOrderWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionOrderOrderByWithRelationAndSearchRelevanceInput> | ActionOrderOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregateActionOrderWhere2?: InputMaybe<ActionOrderWhereInput>;
}>;


export type ActionOrdersQuery = { __typename?: 'Query', actionOrders: Array<{ __typename?: 'ActionOrder', action: Action, fieldsEdited: Array<string>, createdAt: any, id: number, Creator: { __typename?: 'User', id: number, email?: string | null, role: Role, name: string, lastName?: string | null }, Order: { __typename?: 'Order', id: number } }>, aggregateActionOrder: { __typename?: 'AggregateActionOrder', _count?: { __typename?: 'ActionOrderCountAggregate', _all: number } | null } };

export type OrdersListQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput> | OrderOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  pricesOrderBy2?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput> | OrderPriceOrderByWithRelationAndSearchRelevanceInput>;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type OrdersListQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: number, oldID?: number | null, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, delivryDate?: any | null, NoticeOrders: Array<{ __typename?: 'NoticeOrder', id: number, description?: string | null, note: number }>, DeliveryAdress?: { __typename?: 'UserAddress', address: string, cityName: string, zipCode: string, Country: { __typename?: 'Country', name_fr: string } } | null, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean }, orderInvoice: { __typename?: 'ShopCart', matiere: string, materiale: string, quantity: number, craftsmanAmount: number, shippingCost: number, serviceCharge: number, orderFee: number, currency?: string | null, paimenproPrice: number }, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', currency?: string | null } | null }, Craftman?: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', id: number, name_fr: string, name_en: string } | null } | null, Country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Prices: Array<{ __typename?: 'OrderPrice', price: number }> }>, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null } };

export type DeleteOneOrderMutationVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type DeleteOneOrderMutation = { __typename?: 'Mutation', deleteOneOrder?: { __typename?: 'Order', id: number } | null };

export type FiltersListOrderQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
}>;


export type FiltersListOrderQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, name_fr: string, name_en: string }>, itemTypes: Array<{ __typename?: 'ItemType', name_fr: string, name_en: string, id: number }>, materialTypes: Array<{ __typename?: 'MaterialType', name_fr: string, name_en: string, id: number }>, countries: Array<{ __typename?: 'Country', name_fr: string, name_en: string, id: number }> };

export type UpdateManyOrderMutationVariables = Exact<{
  data: OrderUpdateManyMutationInput;
  where?: InputMaybe<OrderWhereInput>;
}>;


export type UpdateManyOrderMutation = { __typename?: 'Mutation', updateManyOrder: { __typename?: 'AffectedRowsOutput', count: number } };

export type PaimentHistoriesQueryVariables = Exact<{
  where?: InputMaybe<PaimentHistoryWhereInput>;
  orderBy?: InputMaybe<Array<PaimentHistoryOrderByWithRelationAndSearchRelevanceInput> | PaimentHistoryOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  aggregatePaimentHistoryWhere2?: InputMaybe<PaimentHistoryWhereInput>;
}>;


export type PaimentHistoriesQuery = { __typename?: 'Query', paimentHistories: Array<{ __typename?: 'PaimentHistory', paymentId?: string | null, id: number, status: PaimentStatus, userIP?: string | null, createdAt: any, Customer?: { __typename?: 'User', id: number } | null, Order?: { __typename?: 'Order', id: number } | null }>, aggregatePaimentHistory: { __typename?: 'AggregatePaimentHistory', _count?: { __typename?: 'PaimentHistoryCountAggregate', _all: number } | null } };

export type AddSegmentationMutationVariables = Exact<{
  data: SegmentationCreateInput;
}>;


export type AddSegmentationMutation = { __typename?: 'Mutation', createOneSegmentation: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string } };

export type GetDetailCategoriesQueryQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationAndSearchRelevanceInput> | CategoryOrderByWithRelationAndSearchRelevanceInput>;
  categoriesWhere?: InputMaybe<CategoryWhereInput>;
  aggregateCategoryWhere?: InputMaybe<CategoryWhereInput>;
}>;


export type GetDetailCategoriesQueryQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', name_fr: string, name_en: string, id: number }>, aggregateCategory: { __typename?: 'AggregateCategory', _count?: { __typename?: 'CategoryCountAggregate', id: number } | null } };

export type GetSegmentationQueryQueryVariables = Exact<{
  where: SegmentationWhereUniqueInput;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetSegmentationQueryQuery = { __typename?: 'Query', segmentation?: { __typename?: 'Segmentation', id: number, name_en: string, name_fr: string, updatedAt: any, createdAt: any } | null, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', id: number } | null } };

export type UpdateOneSegmentationMutationVariables = Exact<{
  data: SegmentationUpdateInput;
  where: SegmentationWhereUniqueInput;
}>;


export type UpdateOneSegmentationMutation = { __typename?: 'Mutation', updateOneSegmentation?: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string } | null };

export type GetOneSegmentationQueryQueryVariables = Exact<{
  where: SegmentationWhereUniqueInput;
}>;


export type GetOneSegmentationQueryQuery = { __typename?: 'Query', segmentation?: { __typename?: 'Segmentation', id: number, name_en: string, name_fr: string } | null };

export type DeleteOneSegmentationMutationVariables = Exact<{
  where: SegmentationWhereUniqueInput;
}>;


export type DeleteOneSegmentationMutation = { __typename?: 'Mutation', deleteOneSegmentation?: { __typename?: 'Segmentation', id: number, name_fr: string, name_en: string } | null };

export type CreateNewTenderMutationVariables = Exact<{
  photos: Array<NewFileInput> | NewFileInput;
  price: Scalars['Float']['input'];
  categoryId: Scalars['Float']['input'];
  materialId: Scalars['Float']['input'];
  itemId: Scalars['Float']['input'];
  customerId: Scalars['Float']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
  message: Scalars['String']['input'];
}>;


export type CreateNewTenderMutation = { __typename?: 'Mutation', createNewOrder: { __typename?: 'Order', id: number, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null }, Craftman?: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null } | null, Country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }> } };

export type GetTenderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
  orderBy?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput> | OrderPriceOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type GetTenderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: number, status: Status, createdAt: any, deadline?: any | null, orderStatus: { __typename?: 'OrderAllStatus', haveAmountNotPaid: boolean, haveAmountPaid: boolean, notPaid: boolean }, Customer: { __typename?: 'User', id: number, name: string, lastName?: string | null }, Prices: Array<{ __typename?: 'OrderPrice', id: number, price: number, status: Status, currenctUserPrice: string }>, Categories: Array<{ __typename?: 'Category', name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, url: string, name: string }> } | null };

export type UpdateCustomerTenderMutationVariables = Exact<{
  photosDeleteIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  photosOrders: Array<NewFileInput> | NewFileInput;
  categoryId: Scalars['Float']['input'];
  materialId: Scalars['Float']['input'];
  itemId: Scalars['Float']['input'];
  updateCustomerOrderId: Scalars['Float']['input'];
  deadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  countryId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdateCustomerTenderMutation = { __typename?: 'Mutation', updateCustomerOrder: { __typename?: 'Order', id: number, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null }, Country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }> } };

export type GetNewTenderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type GetNewTenderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: number, deadline?: any | null, Customer: { __typename?: 'User', id: number, name: string, lastName?: string | null }, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Country?: { __typename?: 'Country', id: number, name_fr: string } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }> } | null };

export type TendersListQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationAndSearchRelevanceInput> | OrderOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  pricesOrderBy2?: InputMaybe<Array<OrderPriceOrderByWithRelationAndSearchRelevanceInput> | OrderPriceOrderByWithRelationAndSearchRelevanceInput>;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type TendersListQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: number, deadline?: any | null, status: Status, createdAt: any, updatedAt: any, Customer: { __typename?: 'User', id: number, email?: string | null, name: string, lastName?: string | null, phoneNumber?: string | null, country?: { __typename?: 'Country', currency?: string | null } | null }, Country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null, Categories: Array<{ __typename?: 'Category', id: number, name_fr: string }>, ItemTypes: Array<{ __typename?: 'ItemType', id: number, name_fr: string }>, MaterialTypes: Array<{ __typename?: 'MaterialType', id: number, name_fr: string }>, Photos: Array<{ __typename?: 'File', id: number, name: string, url: string }>, Prices: Array<{ __typename?: 'OrderPrice', price: number }> }>, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null } };

export type AddTransporterMutationVariables = Exact<{
  data: TransporterCreateInput;
}>;


export type AddTransporterMutation = { __typename?: 'Mutation', createOneTransporter: { __typename?: 'Transporter', id: number, name: string, phoneNumber?: string | null, email?: string | null, webSite?: string | null, address?: string | null, isLocal?: boolean | null, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }> } };

export type UpdateOneTransporterMutationVariables = Exact<{
  data: TransporterUpdateInput;
  where: TransporterWhereUniqueInput;
}>;


export type UpdateOneTransporterMutation = { __typename?: 'Mutation', updateOneTransporter?: { __typename?: 'Transporter', id: number, name: string, phoneNumber?: string | null, email?: string | null, webSite?: string | null, address?: string | null, isLocal?: boolean | null, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }> } | null };

export type GetOneTransporterQueryQueryVariables = Exact<{
  where: TransporterWhereUniqueInput;
}>;


export type GetOneTransporterQueryQuery = { __typename?: 'Query', transporter?: { __typename?: 'Transporter', id: number, name: string, phoneNumber?: string | null, email?: string | null, webSite?: string | null, address?: string | null, isLocal?: boolean | null, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }> } | null };

export type Transporters_TotalQueryVariables = Exact<{
  where?: InputMaybe<TransporterWhereInput>;
  where2?: InputMaybe<TransporterWhereInput>;
  orderBy?: InputMaybe<Array<TransporterOrderByWithRelationAndSearchRelevanceInput> | TransporterOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Transporters_TotalQuery = { __typename?: 'Query', aggregateTransporter: { __typename?: 'AggregateTransporter', _count?: { __typename?: 'TransporterCountAggregate', _all: number } | null }, transporters: Array<{ __typename?: 'Transporter', id: number, name: string, phoneNumber?: string | null, email?: string | null, webSite?: string | null, address?: string | null, isLocal?: boolean | null, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }> }> };

export type DeleteOneTransporterMutationVariables = Exact<{
  where: TransporterWhereUniqueInput;
}>;


export type DeleteOneTransporterMutation = { __typename?: 'Mutation', deleteOneTransporter?: { __typename?: 'Transporter', id: number, name: string, phoneNumber?: string | null, email?: string | null } | null };

export type FiltersListTransportersQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
  transporterZonesWhere2?: InputMaybe<TransporterZoneWhereInput>;
}>;


export type FiltersListTransportersQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', name_fr: string, id: number }>, transporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string }> };

export type AddTransporterPriceMutationVariables = Exact<{
  data: TransporterPriceCreateInput;
}>;


export type AddTransporterPriceMutation = { __typename?: 'Mutation', createOneTransporterPrice: { __typename?: 'TransporterPrice', id: number, weightMin: number, weightMax: number, price: number, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }>, Transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> } };

export type UpdateOneTransporterPriceMutationVariables = Exact<{
  data: TransporterPriceUpdateInput;
  where: TransporterPriceWhereUniqueInput;
}>;


export type UpdateOneTransporterPriceMutation = { __typename?: 'Mutation', updateOneTransporterPrice?: { __typename?: 'TransporterPrice', id: number, weightMin: number, weightMax: number, price: number, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }>, Transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> } | null };

export type GetOneTransporterPriceQueryQueryVariables = Exact<{
  where: TransporterPriceWhereUniqueInput;
}>;


export type GetOneTransporterPriceQueryQuery = { __typename?: 'Query', transporterPrice?: { __typename?: 'TransporterPrice', id: number, weightMin: number, weightMax: number, price: number, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }>, Transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> } | null };

export type TransporterPrices_TotalQueryVariables = Exact<{
  where?: InputMaybe<TransporterPriceWhereInput>;
  orderBy?: InputMaybe<Array<TransporterPriceOrderByWithRelationAndSearchRelevanceInput> | TransporterPriceOrderByWithRelationAndSearchRelevanceInput>;
  where2?: InputMaybe<TransporterPriceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TransporterPrices_TotalQuery = { __typename?: 'Query', aggregateTransporterPrice: { __typename?: 'AggregateTransporterPrice', _count?: { __typename?: 'TransporterPriceCountAggregate', _all: number } | null }, transporterPrices: Array<{ __typename?: 'TransporterPrice', id: number, weightMin: number, weightMax: number, price: number, TransporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> }>, Transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> }> };

export type DeleteOneTransporterPriceMutationVariables = Exact<{
  where: TransporterPriceWhereUniqueInput;
}>;


export type DeleteOneTransporterPriceMutation = { __typename?: 'Mutation', deleteOneTransporterPrice?: { __typename?: 'TransporterPrice', id: number, weightMin: number, weightMax: number, price: number } | null };

export type FiltersListTransporterPriceQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
  transporterZonesWhere2?: InputMaybe<TransporterZoneWhereInput>;
  transportersWhere2?: InputMaybe<TransporterWhereInput>;
}>;


export type FiltersListTransporterPriceQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', name_fr: string, id: number }>, transporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string }>, transporters: Array<{ __typename?: 'Transporter', id: number, name: string }> };

export type AddTransporterZoneMutationVariables = Exact<{
  data: TransporterZoneCreateInput;
}>;


export type AddTransporterZoneMutation = { __typename?: 'Mutation', createOneTransporterZone: { __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } };

export type UpdateOneTransporterZoneMutationVariables = Exact<{
  data: TransporterZoneUpdateInput;
  where: TransporterZoneWhereUniqueInput;
}>;


export type UpdateOneTransporterZoneMutation = { __typename?: 'Mutation', updateOneTransporterZone?: { __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } | null };

export type GetOneTransporterZoneQueryQueryVariables = Exact<{
  where: TransporterZoneWhereUniqueInput;
}>;


export type GetOneTransporterZoneQueryQuery = { __typename?: 'Query', transporterZone?: { __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string }> } | null };

export type TransporterZones_TotalQueryVariables = Exact<{
  where?: InputMaybe<TransporterZoneWhereInput>;
  orderBy?: InputMaybe<Array<TransporterZoneOrderByWithRelationAndSearchRelevanceInput> | TransporterZoneOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TransporterZones_TotalQuery = { __typename?: 'Query', aggregateTransporterZone: { __typename?: 'AggregateTransporterZone', _count?: { __typename?: 'TransporterZoneCountAggregate', _all: number } | null }, transporterZones: Array<{ __typename?: 'TransporterZone', id: number, name: string, Countries: Array<{ __typename?: 'Country', id: number, name_fr: string, name_en: string }> }> };

export type DeleteOneTransporterZoneMutationVariables = Exact<{
  where: TransporterZoneWhereUniqueInput;
}>;


export type DeleteOneTransporterZoneMutation = { __typename?: 'Mutation', deleteOneTransporterZone?: { __typename?: 'TransporterZone', id: number, name: string } | null };

export type FiltersListTransporterZoneQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
}>;


export type FiltersListTransporterZoneQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', name_fr: string, name_en: string, id: number }> };

export type SignupCustomerMutationVariables = Exact<{
  signupInput: SignupInput;
}>;


export type SignupCustomerMutation = { __typename?: 'Mutation', signupUser: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, ProfilePhoto?: { __typename?: 'File', url: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null } } };

export type GetDetailCustomerQueryQueryVariables = Exact<{
  where: UserWhereUniqueInput;
  aggregateOrderWhere2?: InputMaybe<OrderWhereInput>;
}>;


export type GetDetailCustomerQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, ProfilePhoto?: { __typename?: 'File', url: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null } | null, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null } };

export type UpdateCustomerMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateUserAccount: { __typename?: 'AuthPayload', token: string, user: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, ProfilePhoto?: { __typename?: 'File', url: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string } | null } } };

export type GetOneCustomerQueryQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetOneCustomerQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, ProfilePhoto?: { __typename?: 'File', id: number, name: string, url: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null } | null };

export type CustomersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  aggregateUserWhere2?: InputMaybe<UserWhereInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationAndSearchRelevanceInput> | UserOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, role: Role, name: string, lastName?: string | null, lang: string, customerRole?: string | null, customerNbOrderPaid: number, customerNbOrder: number, createdAt: any, dateOfLastConnexion?: any | null, ProfilePhoto?: { __typename?: 'File', url: string } | null, country?: { __typename?: 'Country', id: number, name_fr: string, currency?: string | null } | null }>, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type DeleteOneCustomerMutationVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type DeleteOneCustomerMutation = { __typename?: 'Mutation', deleteOneUser?: { __typename?: 'User', id: number, phoneNumber?: string | null, email?: string | null, name: string, lastName?: string | null, role: Role } | null };

export type FiltersListCustomerQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
}>;


export type FiltersListCustomerQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', name_fr: string, id: number }> };


export const SignupUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignupUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"signupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"isActiveAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignupUserMutation, SignupUserMutationVariables>;
export const UpdateAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"isActiveAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAdminMutation, UpdateAdminMutationVariables>;
export const GetOneAdminQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneAdminQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"isActiveAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneAdminQueryQuery, GetOneAdminQueryQueryVariables>;
export const AdminsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Admins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isActiveAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AdminsQuery, AdminsQueryVariables>;
export const DeleteOneAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<DeleteOneAdminMutation, DeleteOneAdminMutationVariables>;
export const CreateOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneCategoryMutation, CreateOneCategoryMutationVariables>;
export const GetDetailCategoryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDetailCategoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateItemTypeWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateMaterialTypeWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateItemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateItemTypeWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMaterialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateMaterialTypeWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailCategoryQueryQuery, GetDetailCategoryQueryQueryVariables>;
export const GetCraftmenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCraftmen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<GetCraftmenQuery, GetCraftmenQueryVariables>;
export const EditCategoryMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editCategoryMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<EditCategoryMutationMutation, EditCategoryMutationMutationVariables>;
export const GetOneCategoryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneCategoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneCategoryQueryQuery, GetOneCategoryQueryQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const DeleteOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Segmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOneCategoryMutation, DeleteOneCategoryMutationVariables>;
export const FiltersListCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]} as unknown as DocumentNode<FiltersListCategoryQuery, FiltersListCategoryQueryVariables>;
export const CategoriesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoriesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<CategoriesListQuery, CategoriesListQueryVariables>;
export const ListCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<ListCountriesQuery, ListCountriesQueryVariables>;
export const GetItemTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getItemTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetItemTypesQuery, GetItemTypesQueryVariables>;
export const GetMaterialTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMaterialTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetMaterialTypesQuery, GetMaterialTypesQueryVariables>;
export const Segmentations_TotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"segmentations_total"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateSegmentation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<Segmentations_TotalQuery, Segmentations_TotalQueryVariables>;
export const ListTransporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListTransporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transporters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ListTransporterQuery, ListTransporterQueryVariables>;
export const ListTransporterZonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListTransporterZones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transporterZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<ListTransporterZonesQuery, ListTransporterZonesQueryVariables>;
export const UsersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<UsersListQuery, UsersListQueryVariables>;
export const UpdateOneFaqVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneFaqVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isShowOnCraftman"}},{"kind":"Field","name":{"kind":"Name","value":"isShowOnCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]} as unknown as DocumentNode<UpdateOneFaqVisibilityMutation, UpdateOneFaqVisibilityMutationVariables>;
export const UpdateOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isVisible"}}]}}]}}]} as unknown as DocumentNode<UpdateOneCategoryMutation, UpdateOneCategoryMutationVariables>;
export const UpdateOneFaqPriorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneFaqPriority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}}]}}]}}]} as unknown as DocumentNode<UpdateOneFaqPriorityMutation, UpdateOneFaqPriorityMutationVariables>;
export const AddCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCountry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommission"}}]}}]}}]} as unknown as DocumentNode<AddCountryMutation, AddCountryMutationVariables>;
export const CountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Country"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usersWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommission"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Orders"}},{"kind":"Field","name":{"kind":"Name","value":"Users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usersWhere2"}}}]}]}}]}}]}}]} as unknown as DocumentNode<CountryQuery, CountryQueryVariables>;
export const GetCraftmensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCraftmens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCraftmensQuery, GetCraftmensQueryVariables>;
export const UpdateOneCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneCountry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommission"}}]}}]}}]} as unknown as DocumentNode<UpdateOneCountryMutation, UpdateOneCountryMutationVariables>;
export const GetOneCountryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneCountryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommission"}}]}}]}}]} as unknown as DocumentNode<GetOneCountryQueryQuery, GetOneCountryQueryQueryVariables>;
export const CountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Countries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCountry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CountriesQuery, CountriesQueryVariables>;
export const DeleteOneCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCountry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCountryMutation, DeleteOneCountryMutationVariables>;
export const CountriesCraftmanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountriesCraftman"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCountryWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"alpha3"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCountryWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CountriesCraftmanQuery, CountriesCraftmanQueryVariables>;
export const SignupCrafmanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignupCrafman"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"signupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"minQuantityOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PhotoAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignupCrafmanMutation, SignupCrafmanMutationVariables>;
export const GetDetailCraftmanQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDetailCraftmanQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateNoticeOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticeOrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PhotoAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateNoticeOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateNoticeOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailCraftmanQueryQuery, GetDetailCraftmanQueryQueryVariables>;
export const UpdateOneUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateOneUserMutation, UpdateOneUserMutationVariables>;
export const UpdateCraftmanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCraftman"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"minQuantityOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PhotoAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCraftmanMutation, UpdateCraftmanMutationVariables>;
export const GetOneCraftmanQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneCraftmanQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"minQuantityOrder"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PhotoAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneCraftmanQueryQuery, GetOneCraftmanQueryQueryVariables>;
export const CraftmansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Craftmans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oldID"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"yearOfExperience"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLastConnexion"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotCraftman"}},{"kind":"Field","name":{"kind":"Name","value":"completedProfilPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PhotoAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CraftmansQuery, CraftmansQueryVariables>;
export const DeleteOneCraftmanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCraftman"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCraftmanMutation, DeleteOneCraftmanMutationVariables>;
export const FiltersListCraftmanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListCraftman"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereCountry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"materialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereCountry"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FiltersListCraftmanQuery, FiltersListCraftmanQueryVariables>;
export const CraftmanActionWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CraftmanActionWallets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCraftmanWalletWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftmanWallets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCraftmanWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCraftmanWalletWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CraftmanActionWalletsQuery, CraftmanActionWalletsQueryVariables>;
export const CreateCraftmanWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraftmanWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionTransaction"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCraftmanWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCraftmanWalletMutation, CreateCraftmanWalletMutationVariables>;
export const GetOneCraftmanWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneCraftmanWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jackpotCraftman"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneCraftmanWalletQuery, GetOneCraftmanWalletQueryVariables>;
export const GetStatisticOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatisticOneQuery, GetStatisticOneQueryVariables>;
export const GetStatisticTwoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticTwo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatisticTwoQuery, GetStatisticTwoQueryVariables>;
export const GetStatisticArchiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticArchive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatisticArchiveQuery, GetStatisticArchiveQueryVariables>;
export const GetStatisticAllPaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatisticAllPaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatisticAllPaidQuery, GetStatisticAllPaidQueryVariables>;
export const AskDeliveryMenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AskDeliveryMen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AskDeliveryManWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AskDeliveryManOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateAskDeliveryManWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AskDeliveryManWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askDeliveryMen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftmanId"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"codeTracking"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateAskDeliveryMan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateAskDeliveryManWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AskDeliveryMenQuery, AskDeliveryMenQueryVariables>;
export const CraftmanWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CraftmanWallets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCraftmanWalletWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftmanWalletWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftmanWallets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftmanId"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rib"}},{"kind":"Field","name":{"kind":"Name","value":"walletType"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCraftmanWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCraftmanWalletWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CraftmanWalletsQuery, CraftmanWalletsQueryVariables>;
export const ValidCraftmanPaimentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidCraftmanPaiment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paimentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validCraftmanPaiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paimentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paimentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ValidCraftmanPaimentMutation, ValidCraftmanPaimentMutationVariables>;
export const EmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Email"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentHtml"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}}]}}]} as unknown as DocumentNode<EmailQuery, EmailQueryVariables>;
export const EmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Emails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateEmailWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateEmailWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<EmailsQuery, EmailsQueryVariables>;
export const CreateOneFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneFaq"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}}]}}]}}]} as unknown as DocumentNode<CreateOneFaqMutation, CreateOneFaqMutationVariables>;
export const UpdateOneFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneFaq"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}}]}}]}}]} as unknown as DocumentNode<UpdateOneFaqMutation, UpdateOneFaqMutationVariables>;
export const GetFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFaq"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}}]}}]}}]} as unknown as DocumentNode<GetFaqQuery, GetFaqQueryVariables>;
export const FaqsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Faqs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faqs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"isShowOnCraftman"}},{"kind":"Field","name":{"kind":"Name","value":"isShowOnCustomer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateFaq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<FaqsQuery, FaqsQueryVariables>;
export const DeleteOneFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneFaq"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FaqWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneFaq"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneFaqMutation, DeleteOneFaqMutationVariables>;
export const CreateOneItemTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneItemType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneItemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneItemTypeMutation, CreateOneItemTypeMutationVariables>;
export const GetDetailItemTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDetailItemTypeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailItemTypeQueryQuery, GetDetailItemTypeQueryQueryVariables>;
export const EditItemTypeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editItemTypeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneItemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<EditItemTypeMutationMutation, EditItemTypeMutationMutationVariables>;
export const GetOneItemTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneItemTypeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneItemTypeQueryQuery, GetOneItemTypeQueryQueryVariables>;
export const ItemTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ItemTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateItemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<ItemTypesQuery, ItemTypesQueryVariables>;
export const DeleteOneItemTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneItemType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneItemType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<DeleteOneItemTypeMutation, DeleteOneItemTypeMutationVariables>;
export const FiltersListItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]} as unknown as DocumentNode<FiltersListItemsQuery, FiltersListItemsQueryVariables>;
export const CountNewNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountNewNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countNewNotification"}},{"kind":"Field","name":{"kind":"Name","value":"countNotification"}}]}}]}}]} as unknown as DocumentNode<CountNewNotificationQuery, CountNewNotificationQueryVariables>;
export const UserNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationsWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countNotification"}},{"kind":"Field","name":{"kind":"Name","value":"Notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationsWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_en"}},{"kind":"Field","name":{"kind":"Name","value":"body_fr"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserNotificationQuery, UserNotificationQueryVariables>;
export const ViewNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"body_en"}},{"kind":"Field","name":{"kind":"Name","value":"body_fr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ViewNotificationMutation, ViewNotificationMutationVariables>;
export const NewNotificationSubcriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NewNotificationSubcription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"receiverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body_en"}},{"kind":"Field","name":{"kind":"Name","value":"body_fr"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<NewNotificationSubcriptionSubscription, NewNotificationSubcriptionSubscriptionVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userLoginInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userLoginInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userLoginInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const CreateOneMaterialTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneMaterialType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneMaterialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOneMaterialTypeMutation, CreateOneMaterialTypeMutationVariables>;
export const GetDetailMaterialTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDetailMaterialTypeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailMaterialTypeQueryQuery, GetDetailMaterialTypeQueryQueryVariables>;
export const EditMaterialTypeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editMaterialTypeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneMaterialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<EditMaterialTypeMutationMutation, EditMaterialTypeMutationMutationVariables>;
export const GetOneMaterialTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneMaterialTypeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneMaterialTypeQueryQuery, GetOneMaterialTypeQueryQueryVariables>;
export const MaterialTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMaterialType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<MaterialTypesQuery, MaterialTypesQueryVariables>;
export const DeleteOneMaterialTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneMaterialType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneMaterialType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<DeleteOneMaterialTypeMutation, DeleteOneMaterialTypeMutationVariables>;
export const CreateNewOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photos"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transporterCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photos"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"transporterCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transporterCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"craftmanCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"transporterCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewOrderMutation, CreateNewOrderMutationVariables>;
export const ChatMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatMessageOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"Order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ChatMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"senderId"}},{"kind":"Field","name":{"kind":"Name","value":"Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Receiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AskDeliveryMan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"codeTracking"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidOrderEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ChatMessages"}}]}}]}}]}}]} as unknown as DocumentNode<ChatMessagesQuery, ChatMessagesQueryVariables>;
export const SendNewMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendNewMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photos"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNewMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photos"}}},{"kind":"Argument","name":{"kind":"Name","value":"receiverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"senderId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Receiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AskDeliveryMan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"codeTracking"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidOrderEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendNewMessageMutation, SendNewMessageMutationVariables>;
export const NewMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NewMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"senderId"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Receiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderSize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AskDeliveryMan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"codeTracking"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ValidOrderEvidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewMessageSubscription, NewMessageSubscriptionVariables>;
export const ToogleArchiveOrderSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ToogleArchiveOrderSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toogleArchiveOrderSub"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ToogleArchiveOrderSubSubscription, ToogleArchiveOrderSubSubscriptionVariables>;
export const ValidPaimentSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ValidPaimentSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validPaimentSub"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ValidPaimentSubSubscription, ValidPaimentSubSubscriptionVariables>;
export const ValidOrderDelivrySubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ValidOrderDelivrySub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validOrderDelivrySub"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ValidOrderDelivrySubSubscription, ValidOrderDelivrySubSubscriptionVariables>;
export const DesArchiveOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesArchiveOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isToogle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toogleArchiveOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toogleArchiveOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isToogle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isToogle"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toogleArchiveOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DesArchiveOrderMutation, DesArchiveOrderMutationVariables>;
export const AskDeliveryManDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AskDeliveryMan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photos"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delivryDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askDeliveryMan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photos"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"delivryDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delivryDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"Chat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AskDeliveryManMutation, AskDeliveryManMutationVariables>;
export const AdviceNewOrderPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdviceNewOrderPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adviceNewOrderPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"receiverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"senderId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Receiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<AdviceNewOrderPriceMutation, AdviceNewOrderPriceMutationVariables>;
export const ToogleArchiveOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toogleArchiveOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toogleArchiveOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toogleArchiveOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toogleArchiveOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ToogleArchiveOrderMutation, ToogleArchiveOrderMutationVariables>;
export const ValidOrderPaimentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidOrderPaiment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validOrderPaiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ValidOrderPaimentMutation, ValidOrderPaimentMutationVariables>;
export const ValidOrderDelivryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidOrderDelivry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validOrderDelivry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}}]}}]}}]} as unknown as DocumentNode<ValidOrderDelivryMutation, ValidOrderDelivryMutationVariables>;
export const EditContentMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditContentMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDelete"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editContentMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatMessageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDelete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDelete"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}}]}}]}}]} as unknown as DocumentNode<EditContentMessageMutation, EditContentMessageMutationVariables>;
export const ValidAdviceOrderPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidAdviceOrderPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validAdviceOrderPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"receiverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receiverId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"receiverId"}},{"kind":"Field","name":{"kind":"Name","value":"senderId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"Files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Receiver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workshopName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"OrderPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<ValidAdviceOrderPriceMutation, ValidAdviceOrderPriceMutationVariables>;
export const GetOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPriceOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLastConnexion"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLastConnexion"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Chats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderQuery, GetOrderQueryVariables>;
export const SendEmailMessagePendingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEmailMessagePending"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailMessagePending"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<SendEmailMessagePendingMutation, SendEmailMessagePendingMutationVariables>;
export const SendEmailValidOrderDeliveryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEmailValidOrderDelivery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailValidOrderDelivery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}}]}]}}]} as unknown as DocumentNode<SendEmailValidOrderDeliveryMutation, SendEmailValidOrderDeliveryMutationVariables>;
export const UpdateCustomerOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photosDeleteIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photosOrders"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCustomerOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftmanCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transporterCustomPrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photosDeleteIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photosDeleteIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"photosOrders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photosOrders"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCustomerOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftmanCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftmanCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"transporterCustomPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transporterCustomPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"craftmanCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"transporterCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerOrderMutation, UpdateCustomerOrderMutationVariables>;
export const GetNewOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"craftmanCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"transporterCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"ceedowCommissionCustomPrice"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<GetNewOrderQuery, GetNewOrderQueryVariables>;
export const ActionOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionOrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionOrderOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateActionOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionOrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"fieldsEdited"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateActionOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateActionOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<ActionOrdersQuery, ActionOrdersQueryVariables>;
export const OrdersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricesOrderBy2"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPriceOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oldID"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"delivryDate"}},{"kind":"Field","name":{"kind":"Name","value":"NoticeOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"DeliveryAdress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cityName"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matiere"}},{"kind":"Field","name":{"kind":"Name","value":"materiale"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"craftsmanAmount"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCost"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCharge"}},{"kind":"Field","name":{"kind":"Name","value":"orderFee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paimenproPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricesOrderBy2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<OrdersListQuery, OrdersListQueryVariables>;
export const DeleteOneOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneOrderMutation, DeleteOneOrderMutationVariables>;
export const FiltersListOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"materialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FiltersListOrderQuery, FiltersListOrderQueryVariables>;
export const UpdateManyOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManyOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManyOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UpdateManyOrderMutation, UpdateManyOrderMutationVariables>;
export const PaimentHistoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaimentHistories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaimentHistoryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaimentHistoryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregatePaimentHistoryWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaimentHistoryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paimentHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userIP"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatePaimentHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregatePaimentHistoryWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<PaimentHistoriesQuery, PaimentHistoriesQueryVariables>;
export const AddSegmentationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addSegmentation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneSegmentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<AddSegmentationMutation, AddSegmentationMutationVariables>;
export const GetDetailCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDetailCategoriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoriesWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCategoryWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriesWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateCategoryWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailCategoriesQueryQuery, GetDetailCategoriesQueryQueryVariables>;
export const GetSegmentationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSegmentationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetSegmentationQueryQuery, GetSegmentationQueryQueryVariables>;
export const UpdateOneSegmentationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneSegmentation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneSegmentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<UpdateOneSegmentationMutation, UpdateOneSegmentationMutationVariables>;
export const GetOneSegmentationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneSegmentationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]} as unknown as DocumentNode<GetOneSegmentationQueryQuery, GetOneSegmentationQueryQueryVariables>;
export const DeleteOneSegmentationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneSegmentation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneSegmentation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]} as unknown as DocumentNode<DeleteOneSegmentationMutation, DeleteOneSegmentationMutationVariables>;
export const CreateNewTenderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewTender"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photos"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNewOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photos"}}},{"kind":"Argument","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Craftman"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewTenderMutation, CreateNewTenderMutationVariables>;
export const GetTenderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTender"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPriceOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haveAmountNotPaid"}},{"kind":"Field","name":{"kind":"Name","value":"haveAmountPaid"}},{"kind":"Field","name":{"kind":"Name","value":"notPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currenctUserPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenderQuery, GetTenderQueryVariables>;
export const UpdateCustomerTenderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerTender"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photosDeleteIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photosOrders"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewFileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCustomerOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTimeISO"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photosDeleteIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photosDeleteIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"photosOrders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photosOrders"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"materialId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCustomerOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deadline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deadline"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerTenderMutation, UpdateCustomerTenderMutationVariables>;
export const GetNewTenderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewTender"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<GetNewTenderQuery, GetNewTenderQueryVariables>;
export const TendersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TendersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricesOrderBy2"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPriceOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deadline"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"Customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ItemTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MaterialTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricesOrderBy2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<TendersListQuery, TendersListQueryVariables>;
export const AddTransporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTransporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTransporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"webSite"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddTransporterMutation, AddTransporterMutationVariables>;
export const UpdateOneTransporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTransporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTransporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"webSite"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneTransporterMutation, UpdateOneTransporterMutationVariables>;
export const GetOneTransporterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneTransporterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"webSite"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOneTransporterQueryQuery, GetOneTransporterQueryQueryVariables>;
export const Transporters_TotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transporters_total"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateTransporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"webSite"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"isLocal"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Transporters_TotalQuery, Transporters_TotalQueryVariables>;
export const DeleteOneTransporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTransporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTransporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTransporterMutation, DeleteOneTransporterMutationVariables>;
export const FiltersListTransportersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListTransporters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transporterZonesWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporterZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transporterZonesWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FiltersListTransportersQuery, FiltersListTransportersQueryVariables>;
export const AddTransporterPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTransporterPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTransporterPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weightMin"}},{"kind":"Field","name":{"kind":"Name","value":"weightMax"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Transporters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AddTransporterPriceMutation, AddTransporterPriceMutationVariables>;
export const UpdateOneTransporterPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTransporterPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTransporterPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weightMin"}},{"kind":"Field","name":{"kind":"Name","value":"weightMax"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Transporters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneTransporterPriceMutation, UpdateOneTransporterPriceMutationVariables>;
export const GetOneTransporterPriceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneTransporterPriceQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transporterPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weightMin"}},{"kind":"Field","name":{"kind":"Name","value":"weightMax"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Transporters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneTransporterPriceQueryQuery, GetOneTransporterPriceQueryQueryVariables>;
export const TransporterPrices_TotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transporterPrices_total"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateTransporterPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporterPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weightMin"}},{"kind":"Field","name":{"kind":"Name","value":"weightMax"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"TransporterZones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Transporters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<TransporterPrices_TotalQuery, TransporterPrices_TotalQueryVariables>;
export const DeleteOneTransporterPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTransporterPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterPriceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTransporterPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weightMin"}},{"kind":"Field","name":{"kind":"Name","value":"weightMax"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTransporterPriceMutation, DeleteOneTransporterPriceMutationVariables>;
export const FiltersListTransporterPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListTransporterPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transporterZonesWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transportersWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporterZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transporterZonesWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transportersWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FiltersListTransporterPriceQuery, FiltersListTransporterPriceQueryVariables>;
export const AddTransporterZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTransporterZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTransporterZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<AddTransporterZoneMutation, AddTransporterZoneMutationVariables>;
export const UpdateOneTransporterZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOneTransporterZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneTransporterZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneTransporterZoneMutation, UpdateOneTransporterZoneMutationVariables>;
export const GetOneTransporterZoneQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOneTransporterZoneQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transporterZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneTransporterZoneQueryQuery, GetOneTransporterZoneQueryQueryVariables>;
export const TransporterZones_TotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transporterZones_total"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateTransporterZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transporterZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}}]}}]}}]}}]} as unknown as DocumentNode<TransporterZones_TotalQuery, TransporterZones_TotalQueryVariables>;
export const DeleteOneTransporterZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneTransporterZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransporterZoneWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneTransporterZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneTransporterZoneMutation, DeleteOneTransporterZoneMutationVariables>;
export const FiltersListTransporterZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListTransporterZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"name_en"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FiltersListTransporterZoneQuery, FiltersListTransporterZoneQueryVariables>;
export const SignupCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignupCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"signupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignupCustomerMutation, SignupCustomerMutationVariables>;
export const GetDetailCustomerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDetailCustomerQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateOrderWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetailCustomerQueryQuery, GetDetailCustomerQueryQueryVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const GetOneCustomerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneCustomerQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<GetOneCustomerQueryQuery, GetOneCustomerQueryQueryVariables>;
export const CustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Customers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"customerRole"}},{"kind":"Field","name":{"kind":"Name","value":"customerNbOrderPaid"}},{"kind":"Field","name":{"kind":"Name","value":"customerNbOrder"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLastConnexion"}},{"kind":"Field","name":{"kind":"Name","value":"ProfilePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateUserWhere2"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersQuery, CustomersQueryVariables>;
export const DeleteOneCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCustomerMutation, DeleteOneCustomerMutationVariables>;
export const FiltersListCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"filtersListCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_fr"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FiltersListCustomerQuery, FiltersListCustomerQueryVariables>;